(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["alma-tokens"] = {}));
})(this, (function (exports) { 'use strict';

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:00 GMT
	 */

	const BorderRadiusNone$8 = "0px";
	const BorderRadiusXs$8 = "4px";
	const BorderRadiusSm$8 = "8px";
	const BorderRadiusMd$8 = "16px";
	const BorderRadiusLg$8 = "24px";
	const BorderRadiusPill$8 = "960px";
	const BorderRadiusCircle$8 = "50%";
	const BorderWidthNone$8 = "0px";
	const BorderWidthHairline$8 = "1px";
	const BorderWidthThin$8 = "2px";
	const BorderWidthThick$8 = "4px";
	const BorderWidthHeavy$8 = "8px";
	const ColorDatavizInfoText$8 = "#0F58EA";
	const ColorDatavizInfoShape01$8 = "#3F7BF2";
	const ColorDatavizInfoShape02$8 = "#D9E5FC";
	const ColorDatavizInfoShape03$8 = "#F1F5FE";
	const ColorDatavizNegativeText$8 = "#BC293A";
	const ColorDatavizNegativeShape01$8 = "#EA4356";
	const ColorDatavizNegativeShape02$8 = "#FDDDE1";
	const ColorDatavizNegativeShape03$8 = "#FEF1F2";
	const ColorDatavizWarningText$8 = "#A04C03";
	const ColorDatavizWarningShape01$8 = "#D26404";
	const ColorDatavizWarningShape02$8 = "#FEE1C8";
	const ColorDatavizWarningShape03$8 = "#FEF1E6";
	const ColorDatavizPositiveText$8 = "#22723A";
	const ColorDatavizPositiveShape01$8 = "#2D954C";
	const ColorDatavizPositiveShape02$8 = "#C8EED3";
	const ColorDatavizPositiveShape03$8 = "#E8F8EC";
	const ColorDatavizCatAText$8 = "#9B18DC";
	const ColorDatavizCatAShape01$8 = "#B851EC";
	const ColorDatavizCatAShape02$8 = "#F2DFFB";
	const ColorDatavizCatAShape03$8 = "#F9F1FD";
	const ColorDatavizCatBText$8 = "#BA267B";
	const ColorDatavizCatBShape01$8 = "#DA499B";
	const ColorDatavizCatBShape02$8 = "#F8DDEC";
	const ColorDatavizCatBShape03$8 = "#FCF2F8";
	const ColorDatavizCatCText$8 = "#546E21";
	const ColorDatavizCatCShape01$8 = "#6C8D2B";
	const ColorDatavizCatCShape02$8 = "#DBEBBD";
	const ColorDatavizCatCShape03$8 = "#F0F7E4";
	const ColorDatavizCatDText$8 = "#0D735E";
	const ColorDatavizCatDShape01$8 = "#109379";
	const ColorDatavizCatDShape02$8 = "#BCF0E6";
	const ColorDatavizCatDShape03$8 = "#DFFBF6";
	const ColorDatavizInverseInfoText$8 = "#5C8FF5";
	const ColorDatavizInverseInfoShape01$8 = "#286BF1";
	const ColorDatavizInverseInfoShape02$8 = "#062560";
	const ColorDatavizInverseInfoShape03$8 = "#051B48";
	const ColorDatavizInverseNegativeText$8 = "#F55C6E";
	const ColorDatavizInverseNegativeShape01$8 = "#D83145";
	const ColorDatavizInverseNegativeShape02$8 = "#4F1119";
	const ColorDatavizInverseNegativeShape03$8 = "#3B0D12";
	const ColorDatavizInverseWarningText$8 = "#EB7005";
	const ColorDatavizInverseWarningShape01$8 = "#B95804";
	const ColorDatavizInverseWarningShape02$8 = "#462101";
	const ColorDatavizInverseWarningShape03$8 = "#321701";
	const ColorDatavizInversePositiveText$8 = "#32A454";
	const ColorDatavizInversePositiveShape01$8 = "#278142";
	const ColorDatavizInversePositiveShape02$8 = "#0E2F18";
	const ColorDatavizInversePositiveShape03$8 = "#0B2312";
	const ColorDatavizInverseCatAText$8 = "#C36CEF";
	const ColorDatavizInverseCatAShape01$8 = "#AD35E9";
	const ColorDatavizInverseCatAShape02$8 = "#440B60";
	const ColorDatavizInverseCatAShape03$8 = "#340849";
	const ColorDatavizInverseCatBText$8 = "#E067AB";
	const ColorDatavizInverseCatBShape01$8 = "#D42B8C";
	const ColorDatavizInverseCatBShape02$8 = "#4C1032";
	const ColorDatavizInverseCatBShape03$8 = "#3B0C27";
	const ColorDatavizInverseCatCText$8 = "#789D2F";
	const ColorDatavizInverseCatCShape01$8 = "#607E26";
	const ColorDatavizInverseCatCShape02$8 = "#212B0D";
	const ColorDatavizInverseCatCShape03$8 = "#1B230B";
	const ColorDatavizInverseCatDText$8 = "#12A588";
	const ColorDatavizInverseCatDShape01$8 = "#0F856D";
	const ColorDatavizInverseCatDShape02$8 = "#052E26";
	const ColorDatavizInverseCatDShape03$8 = "#04251E";
	const ColorInteractionBlend01$8 = "#1616160A";
	const ColorInteractionBlend02$8 = "#16161614";
	const ColorInteractionBlend03$8 = "#1616161F";
	const ColorInteractionBlend04$8 = "#1616163D";
	const ColorInteractionBlend05$8 = "#161616A3";
	const ColorInteractionBlend06$8 = "#161616B8";
	const ColorInteractionBlend07$8 = "#161616E0";
	const ColorInteractionBlend08$8 = "#161616";
	const ColorInteractionInverseBlend01$8 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$8 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$8 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$8 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$8 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$8 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$8 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$8 = "#FEFEFE";
	const ColorInteractionInverseAccent01$8 = "#E580B9";
	const ColorInteractionInverseAccent02$8 = "#EA99C7";
	const ColorInteractionInverseAccent03$8 = "#EFAFD3";
	const ColorInteractionInverseSubtle01$8 = "#DA499B1F";
	const ColorInteractionInverseSubtle02$8 = "#DA499B3D";
	const ColorInteractionInverseSubtle03$8 = "#DA499B52";
	const ColorInteractionInverseSelectDefault$8 = "#919191";
	const ColorInteractionInverseSelectFocus$8 = "#D4D4D4";
	const ColorInteractionInverseSelectActive$8 = "#E580B9";
	const ColorInteractionInverseDanger01$8 = "#F55C6E";
	const ColorInteractionInverseDanger02$8 = "#F77E8C";
	const ColorInteractionInverseDanger03$8 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01$8 = "#661543";
	const ColorInteractionInverseOnBrandAccent02$8 = "#4C1032";
	const ColorInteractionInverseOnBrandAccent03$8 = "#3B0C27";
	const ColorInteractionInverseOnBrandSubtle01$8 = "#7F1A541F";
	const ColorInteractionInverseOnBrandSubtle02$8 = "#7F1A543D";
	const ColorInteractionInverseOnBrandSubtle03$8 = "#7F1A5452";
	const ColorInteractionInverseOnBrandSelectDefault$8 = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus$8 = "#363636";
	const ColorInteractionInverseOnBrandSelectActive$8 = "#661543";
	const ColorInteractionInverseOnBrandBlend01$8 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$8 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$8 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$8 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$8 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$8 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$8 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$8 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$8 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02$8 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03$8 = "#7E1B27";
	const ColorInteractionAccent01$8 = "#7F1A54";
	const ColorInteractionAccent02$8 = "#661543";
	const ColorInteractionAccent03$8 = "#4C1032";
	const ColorInteractionSubtle01$8 = "#D42B8C1F";
	const ColorInteractionSubtle02$8 = "#D42B8C3D";
	const ColorInteractionSubtle03$8 = "#D42B8C52";
	const ColorInteractionSelectDefault$8 = "#666666";
	const ColorInteractionSelectFocus$8 = "#363636";
	const ColorInteractionSelectActive$8 = "#7F1A54";
	const ColorInteractionDanger01$8 = "#BC293A";
	const ColorInteractionDanger02$8 = "#A72534";
	const ColorInteractionDanger03$8 = "#92202E";
	const ColorInteractionOnBrandAccent01$8 = "#FEFEFE";
	const ColorInteractionOnBrandAccent02$8 = "#F8DDEC";
	const ColorInteractionOnBrandAccent03$8 = "#EFAFD3";
	const ColorInteractionOnBrandSubtle01$8 = "#FEFEFE1F";
	const ColorInteractionOnBrandSubtle02$8 = "#FEFEFE3D";
	const ColorInteractionOnBrandSubtle03$8 = "#FEFEFE52";
	const ColorInteractionOnBrandSelectDefault$8 = "#F4C8E1";
	const ColorInteractionOnBrandSelectFocus$8 = "#F8DDEC";
	const ColorInteractionOnBrandSelectActive$8 = "#FEFEFE";
	const ColorInteractionOnBrandBlend01$8 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$8 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$8 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$8 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$8 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$8 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$8 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$8 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$8 = "#FEFEFE";
	const ColorInteractionOnBrandDanger02$8 = "#FDDDE1";
	const ColorInteractionOnBrandDanger03$8 = "#FAAEB6";
	const ColorNeutral10$8 = "#F5F5F5";
	const ColorNeutral20$8 = "#E6E6E6";
	const ColorNeutral30$8 = "#1616163D";
	const ColorNeutral00$8 = "#FEFEFE";
	const ColorNeutralInverse10$8 = "#1F1F1F";
	const ColorNeutralInverse20$8 = "#292929";
	const ColorNeutralInverse30$8 = "#FEFEFE3D";
	const ColorNeutralInverse00$8 = "#161616";
	const ColorNeutralInverseOnBrand10$8 = "#F8DDEC";
	const ColorNeutralInverseOnBrand20$8 = "#F4C8E1";
	const ColorNeutralInverseOnBrand30$8 = "#D42B8C7A";
	const ColorNeutralInverseOnBrand00$8 = "#FCF2F8";
	const ColorNeutralOnBrand10$8 = "#8B1D5B";
	const ColorNeutralOnBrand20$8 = "#A12169";
	const ColorNeutralOnBrand30$8 = "#DA499BA3";
	const ColorNeutralOnBrand00$8 = "#7F1A54";
	const ColorPaletteBlack$8 = "#161616";
	const ColorPaletteWhite$8 = "#FEFEFE";
	const ColorPaletteGray10$8 = "#1F1F1F";
	const ColorPaletteGray20$8 = "#292929";
	const ColorPaletteGray30$8 = "#363636";
	const ColorPaletteGray40$8 = "#404040";
	const ColorPaletteGray50$8 = "#4C4C4C";
	const ColorPaletteGray60$8 = "#595959";
	const ColorPaletteGray70$8 = "#666666";
	const ColorPaletteGray80$8 = "#737373";
	const ColorPaletteGray90$8 = "#828282";
	const ColorPaletteGray100$8 = "#919191";
	const ColorPaletteGray110$8 = "#A1A1A1";
	const ColorPaletteGray120$8 = "#B0B0B0";
	const ColorPaletteGray130$8 = "#C2C2C2";
	const ColorPaletteGray140$8 = "#D4D4D4";
	const ColorPaletteGray150$8 = "#E6E6E6";
	const ColorPaletteGray160$8 = "#F5F5F5";
	const ColorPaletteRed10$8 = "#3B0D12";
	const ColorPaletteRed20$8 = "#4F1119";
	const ColorPaletteRed30$8 = "#691721";
	const ColorPaletteRed40$8 = "#7E1B27";
	const ColorPaletteRed50$8 = "#92202E";
	const ColorPaletteRed60$8 = "#A72534";
	const ColorPaletteRed70$8 = "#BC293A";
	const ColorPaletteRed80$8 = "#D83145";
	const ColorPaletteRed90$8 = "#EA4356";
	const ColorPaletteRed100$8 = "#F55C6E";
	const ColorPaletteRed110$8 = "#F77E8C";
	const ColorPaletteRed120$8 = "#F895A1";
	const ColorPaletteRed130$8 = "#FAAEB6";
	const ColorPaletteRed140$8 = "#FBC5CC";
	const ColorPaletteRed150$8 = "#FDDDE1";
	const ColorPaletteRed160$8 = "#FEF1F2";
	const ColorPaletteYellow10$8 = "#321701";
	const ColorPaletteYellow20$8 = "#462101";
	const ColorPaletteYellow30$8 = "#552802";
	const ColorPaletteYellow40$8 = "#693102";
	const ColorPaletteYellow50$8 = "#7D3B03";
	const ColorPaletteYellow60$8 = "#914503";
	const ColorPaletteYellow70$8 = "#A04C03";
	const ColorPaletteYellow80$8 = "#B95804";
	const ColorPaletteYellow90$8 = "#D26404";
	const ColorPaletteYellow100$8 = "#EB7005";
	const ColorPaletteYellow110$8 = "#FA8219";
	const ColorPaletteYellow120$8 = "#FB9B46";
	const ColorPaletteYellow130$8 = "#FCB06E";
	const ColorPaletteYellow140$8 = "#FDC99B";
	const ColorPaletteYellow150$8 = "#FEE1C8";
	const ColorPaletteYellow160$8 = "#FEF1E6";
	const ColorPaletteLime10$8 = "#1B230B";
	const ColorPaletteLime20$8 = "#212B0D";
	const ColorPaletteLime30$8 = "#2D3B12";
	const ColorPaletteLime40$8 = "#364616";
	const ColorPaletteLime50$8 = "#3F5219";
	const ColorPaletteLime60$8 = "#485E1D";
	const ColorPaletteLime70$8 = "#546E21";
	const ColorPaletteLime80$8 = "#607E26";
	const ColorPaletteLime90$8 = "#6C8D2B";
	const ColorPaletteLime100$8 = "#789D2F";
	const ColorPaletteLime110$8 = "#84AC34";
	const ColorPaletteLime120$8 = "#93BF3A";
	const ColorPaletteLime130$8 = "#A9CF5E";
	const ColorPaletteLime140$8 = "#C2DD8D";
	const ColorPaletteLime150$8 = "#DBEBBD";
	const ColorPaletteLime160$8 = "#F0F7E4";
	const ColorPaletteGreen10$8 = "#0B2312";
	const ColorPaletteGreen20$8 = "#0E2F18";
	const ColorPaletteGreen30$8 = "#133E20";
	const ColorPaletteGreen40$8 = "#174A26";
	const ColorPaletteGreen50$8 = "#1A562C";
	const ColorPaletteGreen60$8 = "#1F6634";
	const ColorPaletteGreen70$8 = "#22723A";
	const ColorPaletteGreen80$8 = "#278142";
	const ColorPaletteGreen90$8 = "#2D954C";
	const ColorPaletteGreen100$8 = "#32A454";
	const ColorPaletteGreen110$8 = "#38B85E";
	const ColorPaletteGreen120$8 = "#4BC870";
	const ColorPaletteGreen130$8 = "#76D692";
	const ColorPaletteGreen140$8 = "#9DE2B1";
	const ColorPaletteGreen150$8 = "#C8EED3";
	const ColorPaletteGreen160$8 = "#E8F8EC";
	const ColorPaletteAcqua10$8 = "#04251E";
	const ColorPaletteAcqua20$8 = "#052E26";
	const ColorPaletteAcqua30$8 = "#073C31";
	const ColorPaletteAcqua40$8 = "#08493C";
	const ColorPaletteAcqua50$8 = "#0A5748";
	const ColorPaletteAcqua60$8 = "#0B6553";
	const ColorPaletteAcqua70$8 = "#0D735E";
	const ColorPaletteAcqua80$8 = "#0F856D";
	const ColorPaletteAcqua90$8 = "#109379";
	const ColorPaletteAcqua100$8 = "#12A588";
	const ColorPaletteAcqua110$8 = "#14B897";
	const ColorPaletteAcqua120$8 = "#31C4A6";
	const ColorPaletteAcqua130$8 = "#68D4BF";
	const ColorPaletteAcqua140$8 = "#8DE2D1";
	const ColorPaletteAcqua150$8 = "#BCF0E6";
	const ColorPaletteAcqua160$8 = "#DFFBF6";
	const ColorPaletteBlue10$8 = "#051B48";
	const ColorPaletteBlue20$8 = "#062560";
	const ColorPaletteBlue30$8 = "#082F7D";
	const ColorPaletteBlue40$8 = "#0A3A9A";
	const ColorPaletteBlue50$8 = "#0B43B1";
	const ColorPaletteBlue60$8 = "#0D4ECE";
	const ColorPaletteBlue70$8 = "#0F58EA";
	const ColorPaletteBlue80$8 = "#286BF1";
	const ColorPaletteBlue90$8 = "#3F7BF2";
	const ColorPaletteBlue100$8 = "#5C8FF5";
	const ColorPaletteBlue110$8 = "#73A0F7";
	const ColorPaletteBlue120$8 = "#8CB0F8";
	const ColorPaletteBlue130$8 = "#A9C4F9";
	const ColorPaletteBlue140$8 = "#C1D4FB";
	const ColorPaletteBlue150$8 = "#D9E5FC";
	const ColorPaletteBlue160$8 = "#F1F5FE";
	const ColorPalettePurple10$8 = "#340849";
	const ColorPalettePurple20$8 = "#440B60";
	const ColorPalettePurple30$8 = "#540D78";
	const ColorPalettePurple40$8 = "#671093";
	const ColorPalettePurple50$8 = "#7713AA";
	const ColorPalettePurple60$8 = "#8B16C5";
	const ColorPalettePurple70$8 = "#9B18DC";
	const ColorPalettePurple80$8 = "#AD35E9";
	const ColorPalettePurple90$8 = "#B851EC";
	const ColorPalettePurple100$8 = "#C36CEF";
	const ColorPalettePurple110$8 = "#CC83F1";
	const ColorPalettePurple120$8 = "#D69AF4";
	const ColorPalettePurple130$8 = "#DFB1F6";
	const ColorPalettePurple140$8 = "#E8C8F9";
	const ColorPalettePurple150$8 = "#F2DFFB";
	const ColorPalettePurple160$8 = "#F9F1FD";
	const ColorPalettePink10$8 = "#3B0C27";
	const ColorPalettePink20$8 = "#4C1032";
	const ColorPalettePink30$8 = "#661543";
	const ColorPalettePink40$8 = "#77184E";
	const ColorPalettePink50$8 = "#8C1C5D";
	const ColorPalettePink60$8 = "#A12169";
	const ColorPalettePink70$8 = "#BA267B";
	const ColorPalettePink80$8 = "#D42B8C";
	const ColorPalettePink90$8 = "#DA499B";
	const ColorPalettePink100$8 = "#E067AB";
	const ColorPalettePink110$8 = "#E580B9";
	const ColorPalettePink120$8 = "#EA99C7";
	const ColorPalettePink130$8 = "#EFAFD3";
	const ColorPalettePink140$8 = "#F4C8E1";
	const ColorPalettePink150$8 = "#F8DDEC";
	const ColorPalettePink160$8 = "#FCF2F8";
	const ColorTypefaceStrong$8 = "#161616";
	const ColorTypefacePure$8 = "#363636";
	const ColorTypefaceSmooth$8 = "#666666";
	const ColorTypefaceMeld$8 = "#1616163D";
	const ColorTypefaceInverseStrong$8 = "#FEFEFE";
	const ColorTypefaceInversePure$8 = "#D4D4D4";
	const ColorTypefaceInverseSmooth$8 = "#919191";
	const ColorTypefaceInverseMeld$8 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$8 = "#161616";
	const ColorTypefaceInverseOnBrandPure$8 = "#363636";
	const ColorTypefaceInverseOnBrandSmooth$8 = "#666666";
	const ColorTypefaceInverseOnBrandMeld$8 = "#1616163D";
	const ColorTypefaceOnBrandStrong$8 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$8 = "#F8DDEC";
	const ColorTypefaceOnBrandSmooth$8 = "#F4C8E1";
	const ColorTypefaceOnBrandMeld$8 = "#FEFEFE52";
	const ColorBrandPrimary10$8 = "#3B0C27";
	const ColorBrandPrimary20$8 = "#4C1032";
	const ColorBrandPrimary30$8 = "#661543";
	const ColorBrandPrimary40$8 = "#7F1A54";
	const ColorBrandPrimary50$8 = "#8B1D5B";
	const ColorBrandPrimary60$8 = "#A12169";
	const ColorBrandPrimary70$8 = "#BA267B";
	const ColorBrandPrimary80$8 = "#D42B8C";
	const ColorBrandPrimary90$8 = "#DA499B";
	const ColorBrandPrimary100$8 = "#E067AB";
	const ColorBrandPrimary110$8 = "#E580B9";
	const ColorBrandPrimary120$8 = "#EA99C7";
	const ColorBrandPrimary130$8 = "#EFAFD3";
	const ColorBrandPrimary140$8 = "#F4C8E1";
	const ColorBrandPrimary150$8 = "#F8DDEC";
	const ColorBrandPrimary160$8 = "#FCF2F8";
	const ColorBrandBase01$8 = "#7F1A54";
	const ColorBrandBase02$8 = "#EC2072";
	const ColorBrandBase03$7 = "#F47C7C";
	const ColorBrandBase04$7 = "#F78E26";
	const ColorBrandPalette0110$8 = "#3B0C27";
	const ColorBrandPalette0120$8 = "#4C1032";
	const ColorBrandPalette0130$8 = "#661543";
	const ColorBrandPalette0140$8 = "#7F1A54";
	const ColorBrandPalette0150$8 = "#8B1D5B";
	const ColorBrandPalette0160$8 = "#A12169";
	const ColorBrandPalette0170$8 = "#BA267B";
	const ColorBrandPalette0180$8 = "#D42B8C";
	const ColorBrandPalette0190$8 = "#DA499B";
	const ColorBrandPalette01100$8 = "#E067AB";
	const ColorBrandPalette01110$8 = "#E580B9";
	const ColorBrandPalette01120$8 = "#EA99C7";
	const ColorBrandPalette01130$8 = "#EFAFD3";
	const ColorBrandPalette01140$8 = "#F4C8E1";
	const ColorBrandPalette01150$8 = "#F8DDEC";
	const ColorBrandPalette01160$8 = "#FCF2F8";
	const ColorBrandPalette0210$8 = "#42051D";
	const ColorBrandPalette0220$8 = "#540727";
	const ColorBrandPalette0230$8 = "#6C0931";
	const ColorBrandPalette0240$8 = "#7F0B39";
	const ColorBrandPalette0250$8 = "#960D44";
	const ColorBrandPalette0260$8 = "#AE0F4F";
	const ColorBrandPalette0270$8 = "#C51159";
	const ColorBrandPalette0280$8 = "#EC2072";
	const ColorBrandPalette0290$8 = "#ED357F";
	const ColorBrandPalette02100$8 = "#F15B97";
	const ColorBrandPalette02110$8 = "#F377A9";
	const ColorBrandPalette02120$8 = "#F693BB";
	const ColorBrandPalette02130$8 = "#F8AFCC";
	const ColorBrandPalette02140$8 = "#FAC7DB";
	const ColorBrandPalette02150$8 = "#FCDEEA";
	const ColorBrandPalette02160$8 = "#FEF1F6";
	const ColorBrandPalette0310$6 = "#420606";
	const ColorBrandPalette0320$6 = "#590808";
	const ColorBrandPalette0330$6 = "#710A0A";
	const ColorBrandPalette0340$6 = "#830B0B";
	const ColorBrandPalette0350$6 = "#9B0D0E";
	const ColorBrandPalette0360$6 = "#B20F10";
	const ColorBrandPalette0370$6 = "#CA1113";
	const ColorBrandPalette0380$6 = "#E61415";
	const ColorBrandPalette0390$6 = "#EE3F40";
	const ColorBrandPalette03100$6 = "#F47C7C";
	const ColorBrandPalette03110$6 = "#FA8219";
	const ColorBrandPalette03120$6 = "#F69898";
	const ColorBrandPalette03130$6 = "#F8AFAF";
	const ColorBrandPalette03140$6 = "#FAC7C7";
	const ColorBrandPalette03150$6 = "#FCDEDE";
	const ColorBrandPalette03160$6 = "#FEF1F1";
	const ColorBrandPalette0410$7 = "#311902";
	const ColorBrandPalette0420$7 = "#402102";
	const ColorBrandPalette0430$7 = "#532B03";
	const ColorBrandPalette0440$7 = "#623304";
	const ColorBrandPalette0450$7 = "#763D04";
	const ColorBrandPalette0460$7 = "#894705";
	const ColorBrandPalette0470$7 = "#9D5106";
	const ColorBrandPalette0480$7 = "#B65E07";
	const ColorBrandPalette0490$7 = "#CA6807";
	const ColorBrandPalette04100$7 = "#E27508";
	const ColorBrandPalette04110$7 = "#F78E26";
	const ColorBrandPalette04120$7 = "#F89E44";
	const ColorBrandPalette04130$7 = "#FAB775";
	const ColorBrandPalette04140$7 = "#FBC998";
	const ColorBrandPalette04150$7 = "#FDE0C4";
	const ColorBrandPalette04160$7 = "#FEF2E6";
	const ColorFeedbackErrorText$8 = "#BC293A";
	const ColorFeedbackErrorShape$8 = "#EA4356";
	const ColorFeedbackSuccessText$8 = "#22723A";
	const ColorFeedbackSuccessShape$8 = "#2D954C";
	const ColorFeedbackOnBrandErrorText$8 = "#FBC5CC";
	const ColorFeedbackOnBrandErrorShape$8 = "#F895A1";
	const ColorFeedbackOnBrandSuccessText$8 = "#9DE2B1";
	const ColorFeedbackOnBrandSuccessShape$8 = "#4BC870";
	const ColorFeedbackInverseErrorText$8 = "#F55C6E";
	const ColorFeedbackInverseErrorShape$8 = "#D83145";
	const ColorFeedbackInverseSuccessText$8 = "#32A454";
	const ColorFeedbackInverseSuccessShape$8 = "#278142";
	const ColorFeedbackInverseOnBrandErrorText$8 = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape$8 = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText$8 = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape$8 = "#278142";
	const ColorSupport01$8 = "#EC2072";
	const ColorSupport02$8 = "#EC2072";
	const ColorSupportOnBrand01$8 = "#F78E26";
	const ColorSupportOnBrand02$8 = "#F78E26";
	const ColorSupportInverse01$8 = "#F78E26";
	const ColorSupportInverse02$8 = "#F78E26";
	const ColorSupportInverseOnBrand01$8 = "#7F1A54";
	const ColorSupportInverseOnBrand02$8 = "#7F1A54";
	const Opacity01$8 = "0.04";
	const Opacity02$8 = "0.08";
	const Opacity03$8 = "0.12";
	const Opacity04$8 = "0.24";
	const Opacity05$8 = "0.32";
	const Opacity06$8 = "0.56";
	const Opacity07$8 = "0.64";
	const Opacity08$8 = "0.72";
	const Opacity09$8 = "0.88";
	const Shadow01$8 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$8 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$8 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$8 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$8 = "4px";
	const SpacingInlineNano$8 = "8px";
	const SpacingInlineXxxs$8 = "16px";
	const SpacingInlineXxs$8 = "24px";
	const SpacingInlineXs$8 = "32px";
	const SpacingInlineSm$8 = "40px";
	const SpacingInlineMd$8 = "48px";
	const SpacingInlineLg$8 = "56px";
	const SpacingInlineXl$8 = "64px";
	const SpacingInlineXxl$8 = "80px";
	const SpacingInlineXxxl$8 = "120px";
	const SpacingInlineHuge$8 = "160px";
	const SpacingInlineGiant$8 = "200px";
	const SpacingInsetQuark$8 = "4px";
	const SpacingInsetNano$8 = "8px";
	const SpacingInsetXs$8 = "16px";
	const SpacingInsetSm$8 = "24px";
	const SpacingInsetMd$8 = "32px";
	const SpacingInsetLg$8 = "40px";
	const SpacingSquishQuark$8 = "4px 8px";
	const SpacingSquishNano$8 = "8px 16px";
	const SpacingSquishXs$8 = "16px 24px";
	const SpacingSquishSm$8 = "16px 32px";
	const SpacingStackQuark$8 = "4px";
	const SpacingStackNano$8 = "8px";
	const SpacingStackXxxs$8 = "16px";
	const SpacingStackXxs$8 = "24px";
	const SpacingStackXs$8 = "32px";
	const SpacingStackSm$8 = "40px";
	const SpacingStackMd$8 = "48px";
	const SpacingStackLg$8 = "56px";
	const SpacingStackXl$8 = "64px";
	const SpacingStackXxl$8 = "80px";
	const SpacingStackXxxl$8 = "120px";
	const SpacingStackHuge$8 = "160px";
	const SpacingStackGiant$8 = "200px";
	const FontFamilyBase$8 = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontSizeXxxs$8 = "0.75rem";
	const FontSizeXxs$8 = "0.875rem";
	const FontSizeXs$8 = "1rem";
	const FontSizeSm$8 = "1.25rem";
	const FontSizeMd$8 = "1.5rem";
	const FontSizeLg$8 = "2rem";
	const FontSizeXl$8 = "2.5rem";
	const FontSizeXxl$8 = "3rem";
	const FontSizeXxxl$8 = "4rem";
	const FontSizeDisplay$8 = "5rem";
	const FontSizeGiant$8 = "6rem";
	const FontWeightBold$8 = 700;
	const FontWeightSemibold$8 = 600;
	const FontWeightMedium$8 = 500;
	const FontWeightRegular$8 = 400;
	const FontWeightLight$8 = 300;
	const LetterSpacingStandard$8 = "0px";
	const LetterSpacingSmall$8 = "-1px";
	const LetterSpacingMedium$8 = "1.5px";
	const LineHeightStandard$8 = "100%";
	const LineHeightTiny$8 = "115%";
	const LineHeightMedium$8 = "120%";
	const LineHeightLarge$8 = "125%";
	const LineHeightDistant$8 = "133%";
	const LineHeightSuperdistant$8 = "150%";
	const LineHeightHuge$8 = "170%";
	const ZIndex0$8 = "0";
	const ZIndex100$8 = "100";
	const ZIndex200$8 = "200";
	const ZIndex300$8 = "300";
	const ZIndex400$8 = "400";
	const ZIndex500$8 = "500";
	const ZIndexAuto$8 = "auto";
	const ZIndexTop$8 = "99999";
	const ZIndexBottom$8 = "-100";

	var index$8 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$8,
		BorderRadiusXs: BorderRadiusXs$8,
		BorderRadiusSm: BorderRadiusSm$8,
		BorderRadiusMd: BorderRadiusMd$8,
		BorderRadiusLg: BorderRadiusLg$8,
		BorderRadiusPill: BorderRadiusPill$8,
		BorderRadiusCircle: BorderRadiusCircle$8,
		BorderWidthNone: BorderWidthNone$8,
		BorderWidthHairline: BorderWidthHairline$8,
		BorderWidthThin: BorderWidthThin$8,
		BorderWidthThick: BorderWidthThick$8,
		BorderWidthHeavy: BorderWidthHeavy$8,
		ColorDatavizInfoText: ColorDatavizInfoText$8,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01$8,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02$8,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03$8,
		ColorDatavizNegativeText: ColorDatavizNegativeText$8,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$8,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$8,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$8,
		ColorDatavizWarningText: ColorDatavizWarningText$8,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01$8,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02$8,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03$8,
		ColorDatavizPositiveText: ColorDatavizPositiveText$8,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$8,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$8,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$8,
		ColorDatavizCatAText: ColorDatavizCatAText$8,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01$8,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02$8,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03$8,
		ColorDatavizCatBText: ColorDatavizCatBText$8,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01$8,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02$8,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03$8,
		ColorDatavizCatCText: ColorDatavizCatCText$8,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01$8,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02$8,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03$8,
		ColorDatavizCatDText: ColorDatavizCatDText$8,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01$8,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02$8,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03$8,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$8,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$8,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$8,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$8,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$8,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$8,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$8,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$8,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$8,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$8,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$8,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$8,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$8,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$8,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$8,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$8,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$8,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$8,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$8,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$8,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$8,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$8,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$8,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$8,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$8,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$8,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$8,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$8,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$8,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$8,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$8,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$8,
		ColorInteractionBlend01: ColorInteractionBlend01$8,
		ColorInteractionBlend02: ColorInteractionBlend02$8,
		ColorInteractionBlend03: ColorInteractionBlend03$8,
		ColorInteractionBlend04: ColorInteractionBlend04$8,
		ColorInteractionBlend05: ColorInteractionBlend05$8,
		ColorInteractionBlend06: ColorInteractionBlend06$8,
		ColorInteractionBlend07: ColorInteractionBlend07$8,
		ColorInteractionBlend08: ColorInteractionBlend08$8,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$8,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$8,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$8,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$8,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$8,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$8,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$8,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$8,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$8,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$8,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$8,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$8,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$8,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$8,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$8,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$8,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$8,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$8,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$8,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$8,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$8,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$8,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$8,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$8,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$8,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$8,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$8,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$8,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$8,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$8,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$8,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$8,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$8,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$8,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$8,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$8,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$8,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$8,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$8,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$8,
		ColorInteractionAccent01: ColorInteractionAccent01$8,
		ColorInteractionAccent02: ColorInteractionAccent02$8,
		ColorInteractionAccent03: ColorInteractionAccent03$8,
		ColorInteractionSubtle01: ColorInteractionSubtle01$8,
		ColorInteractionSubtle02: ColorInteractionSubtle02$8,
		ColorInteractionSubtle03: ColorInteractionSubtle03$8,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$8,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$8,
		ColorInteractionSelectActive: ColorInteractionSelectActive$8,
		ColorInteractionDanger01: ColorInteractionDanger01$8,
		ColorInteractionDanger02: ColorInteractionDanger02$8,
		ColorInteractionDanger03: ColorInteractionDanger03$8,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$8,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$8,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$8,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$8,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$8,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$8,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$8,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$8,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$8,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$8,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$8,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$8,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$8,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$8,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$8,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$8,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$8,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$8,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$8,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$8,
		ColorNeutral10: ColorNeutral10$8,
		ColorNeutral20: ColorNeutral20$8,
		ColorNeutral30: ColorNeutral30$8,
		ColorNeutral00: ColorNeutral00$8,
		ColorNeutralInverse10: ColorNeutralInverse10$8,
		ColorNeutralInverse20: ColorNeutralInverse20$8,
		ColorNeutralInverse30: ColorNeutralInverse30$8,
		ColorNeutralInverse00: ColorNeutralInverse00$8,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$8,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$8,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$8,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$8,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$8,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$8,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$8,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$8,
		ColorPaletteBlack: ColorPaletteBlack$8,
		ColorPaletteWhite: ColorPaletteWhite$8,
		ColorPaletteGray10: ColorPaletteGray10$8,
		ColorPaletteGray20: ColorPaletteGray20$8,
		ColorPaletteGray30: ColorPaletteGray30$8,
		ColorPaletteGray40: ColorPaletteGray40$8,
		ColorPaletteGray50: ColorPaletteGray50$8,
		ColorPaletteGray60: ColorPaletteGray60$8,
		ColorPaletteGray70: ColorPaletteGray70$8,
		ColorPaletteGray80: ColorPaletteGray80$8,
		ColorPaletteGray90: ColorPaletteGray90$8,
		ColorPaletteGray100: ColorPaletteGray100$8,
		ColorPaletteGray110: ColorPaletteGray110$8,
		ColorPaletteGray120: ColorPaletteGray120$8,
		ColorPaletteGray130: ColorPaletteGray130$8,
		ColorPaletteGray140: ColorPaletteGray140$8,
		ColorPaletteGray150: ColorPaletteGray150$8,
		ColorPaletteGray160: ColorPaletteGray160$8,
		ColorPaletteRed10: ColorPaletteRed10$8,
		ColorPaletteRed20: ColorPaletteRed20$8,
		ColorPaletteRed30: ColorPaletteRed30$8,
		ColorPaletteRed40: ColorPaletteRed40$8,
		ColorPaletteRed50: ColorPaletteRed50$8,
		ColorPaletteRed60: ColorPaletteRed60$8,
		ColorPaletteRed70: ColorPaletteRed70$8,
		ColorPaletteRed80: ColorPaletteRed80$8,
		ColorPaletteRed90: ColorPaletteRed90$8,
		ColorPaletteRed100: ColorPaletteRed100$8,
		ColorPaletteRed110: ColorPaletteRed110$8,
		ColorPaletteRed120: ColorPaletteRed120$8,
		ColorPaletteRed130: ColorPaletteRed130$8,
		ColorPaletteRed140: ColorPaletteRed140$8,
		ColorPaletteRed150: ColorPaletteRed150$8,
		ColorPaletteRed160: ColorPaletteRed160$8,
		ColorPaletteYellow10: ColorPaletteYellow10$8,
		ColorPaletteYellow20: ColorPaletteYellow20$8,
		ColorPaletteYellow30: ColorPaletteYellow30$8,
		ColorPaletteYellow40: ColorPaletteYellow40$8,
		ColorPaletteYellow50: ColorPaletteYellow50$8,
		ColorPaletteYellow60: ColorPaletteYellow60$8,
		ColorPaletteYellow70: ColorPaletteYellow70$8,
		ColorPaletteYellow80: ColorPaletteYellow80$8,
		ColorPaletteYellow90: ColorPaletteYellow90$8,
		ColorPaletteYellow100: ColorPaletteYellow100$8,
		ColorPaletteYellow110: ColorPaletteYellow110$8,
		ColorPaletteYellow120: ColorPaletteYellow120$8,
		ColorPaletteYellow130: ColorPaletteYellow130$8,
		ColorPaletteYellow140: ColorPaletteYellow140$8,
		ColorPaletteYellow150: ColorPaletteYellow150$8,
		ColorPaletteYellow160: ColorPaletteYellow160$8,
		ColorPaletteLime10: ColorPaletteLime10$8,
		ColorPaletteLime20: ColorPaletteLime20$8,
		ColorPaletteLime30: ColorPaletteLime30$8,
		ColorPaletteLime40: ColorPaletteLime40$8,
		ColorPaletteLime50: ColorPaletteLime50$8,
		ColorPaletteLime60: ColorPaletteLime60$8,
		ColorPaletteLime70: ColorPaletteLime70$8,
		ColorPaletteLime80: ColorPaletteLime80$8,
		ColorPaletteLime90: ColorPaletteLime90$8,
		ColorPaletteLime100: ColorPaletteLime100$8,
		ColorPaletteLime110: ColorPaletteLime110$8,
		ColorPaletteLime120: ColorPaletteLime120$8,
		ColorPaletteLime130: ColorPaletteLime130$8,
		ColorPaletteLime140: ColorPaletteLime140$8,
		ColorPaletteLime150: ColorPaletteLime150$8,
		ColorPaletteLime160: ColorPaletteLime160$8,
		ColorPaletteGreen10: ColorPaletteGreen10$8,
		ColorPaletteGreen20: ColorPaletteGreen20$8,
		ColorPaletteGreen30: ColorPaletteGreen30$8,
		ColorPaletteGreen40: ColorPaletteGreen40$8,
		ColorPaletteGreen50: ColorPaletteGreen50$8,
		ColorPaletteGreen60: ColorPaletteGreen60$8,
		ColorPaletteGreen70: ColorPaletteGreen70$8,
		ColorPaletteGreen80: ColorPaletteGreen80$8,
		ColorPaletteGreen90: ColorPaletteGreen90$8,
		ColorPaletteGreen100: ColorPaletteGreen100$8,
		ColorPaletteGreen110: ColorPaletteGreen110$8,
		ColorPaletteGreen120: ColorPaletteGreen120$8,
		ColorPaletteGreen130: ColorPaletteGreen130$8,
		ColorPaletteGreen140: ColorPaletteGreen140$8,
		ColorPaletteGreen150: ColorPaletteGreen150$8,
		ColorPaletteGreen160: ColorPaletteGreen160$8,
		ColorPaletteAcqua10: ColorPaletteAcqua10$8,
		ColorPaletteAcqua20: ColorPaletteAcqua20$8,
		ColorPaletteAcqua30: ColorPaletteAcqua30$8,
		ColorPaletteAcqua40: ColorPaletteAcqua40$8,
		ColorPaletteAcqua50: ColorPaletteAcqua50$8,
		ColorPaletteAcqua60: ColorPaletteAcqua60$8,
		ColorPaletteAcqua70: ColorPaletteAcqua70$8,
		ColorPaletteAcqua80: ColorPaletteAcqua80$8,
		ColorPaletteAcqua90: ColorPaletteAcqua90$8,
		ColorPaletteAcqua100: ColorPaletteAcqua100$8,
		ColorPaletteAcqua110: ColorPaletteAcqua110$8,
		ColorPaletteAcqua120: ColorPaletteAcqua120$8,
		ColorPaletteAcqua130: ColorPaletteAcqua130$8,
		ColorPaletteAcqua140: ColorPaletteAcqua140$8,
		ColorPaletteAcqua150: ColorPaletteAcqua150$8,
		ColorPaletteAcqua160: ColorPaletteAcqua160$8,
		ColorPaletteBlue10: ColorPaletteBlue10$8,
		ColorPaletteBlue20: ColorPaletteBlue20$8,
		ColorPaletteBlue30: ColorPaletteBlue30$8,
		ColorPaletteBlue40: ColorPaletteBlue40$8,
		ColorPaletteBlue50: ColorPaletteBlue50$8,
		ColorPaletteBlue60: ColorPaletteBlue60$8,
		ColorPaletteBlue70: ColorPaletteBlue70$8,
		ColorPaletteBlue80: ColorPaletteBlue80$8,
		ColorPaletteBlue90: ColorPaletteBlue90$8,
		ColorPaletteBlue100: ColorPaletteBlue100$8,
		ColorPaletteBlue110: ColorPaletteBlue110$8,
		ColorPaletteBlue120: ColorPaletteBlue120$8,
		ColorPaletteBlue130: ColorPaletteBlue130$8,
		ColorPaletteBlue140: ColorPaletteBlue140$8,
		ColorPaletteBlue150: ColorPaletteBlue150$8,
		ColorPaletteBlue160: ColorPaletteBlue160$8,
		ColorPalettePurple10: ColorPalettePurple10$8,
		ColorPalettePurple20: ColorPalettePurple20$8,
		ColorPalettePurple30: ColorPalettePurple30$8,
		ColorPalettePurple40: ColorPalettePurple40$8,
		ColorPalettePurple50: ColorPalettePurple50$8,
		ColorPalettePurple60: ColorPalettePurple60$8,
		ColorPalettePurple70: ColorPalettePurple70$8,
		ColorPalettePurple80: ColorPalettePurple80$8,
		ColorPalettePurple90: ColorPalettePurple90$8,
		ColorPalettePurple100: ColorPalettePurple100$8,
		ColorPalettePurple110: ColorPalettePurple110$8,
		ColorPalettePurple120: ColorPalettePurple120$8,
		ColorPalettePurple130: ColorPalettePurple130$8,
		ColorPalettePurple140: ColorPalettePurple140$8,
		ColorPalettePurple150: ColorPalettePurple150$8,
		ColorPalettePurple160: ColorPalettePurple160$8,
		ColorPalettePink10: ColorPalettePink10$8,
		ColorPalettePink20: ColorPalettePink20$8,
		ColorPalettePink30: ColorPalettePink30$8,
		ColorPalettePink40: ColorPalettePink40$8,
		ColorPalettePink50: ColorPalettePink50$8,
		ColorPalettePink60: ColorPalettePink60$8,
		ColorPalettePink70: ColorPalettePink70$8,
		ColorPalettePink80: ColorPalettePink80$8,
		ColorPalettePink90: ColorPalettePink90$8,
		ColorPalettePink100: ColorPalettePink100$8,
		ColorPalettePink110: ColorPalettePink110$8,
		ColorPalettePink120: ColorPalettePink120$8,
		ColorPalettePink130: ColorPalettePink130$8,
		ColorPalettePink140: ColorPalettePink140$8,
		ColorPalettePink150: ColorPalettePink150$8,
		ColorPalettePink160: ColorPalettePink160$8,
		ColorTypefaceStrong: ColorTypefaceStrong$8,
		ColorTypefacePure: ColorTypefacePure$8,
		ColorTypefaceSmooth: ColorTypefaceSmooth$8,
		ColorTypefaceMeld: ColorTypefaceMeld$8,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$8,
		ColorTypefaceInversePure: ColorTypefaceInversePure$8,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$8,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$8,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$8,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$8,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$8,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$8,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$8,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$8,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$8,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$8,
		ColorBrandPrimary10: ColorBrandPrimary10$8,
		ColorBrandPrimary20: ColorBrandPrimary20$8,
		ColorBrandPrimary30: ColorBrandPrimary30$8,
		ColorBrandPrimary40: ColorBrandPrimary40$8,
		ColorBrandPrimary50: ColorBrandPrimary50$8,
		ColorBrandPrimary60: ColorBrandPrimary60$8,
		ColorBrandPrimary70: ColorBrandPrimary70$8,
		ColorBrandPrimary80: ColorBrandPrimary80$8,
		ColorBrandPrimary90: ColorBrandPrimary90$8,
		ColorBrandPrimary100: ColorBrandPrimary100$8,
		ColorBrandPrimary110: ColorBrandPrimary110$8,
		ColorBrandPrimary120: ColorBrandPrimary120$8,
		ColorBrandPrimary130: ColorBrandPrimary130$8,
		ColorBrandPrimary140: ColorBrandPrimary140$8,
		ColorBrandPrimary150: ColorBrandPrimary150$8,
		ColorBrandPrimary160: ColorBrandPrimary160$8,
		ColorBrandBase01: ColorBrandBase01$8,
		ColorBrandBase02: ColorBrandBase02$8,
		ColorBrandBase03: ColorBrandBase03$7,
		ColorBrandBase04: ColorBrandBase04$7,
		ColorBrandPalette0110: ColorBrandPalette0110$8,
		ColorBrandPalette0120: ColorBrandPalette0120$8,
		ColorBrandPalette0130: ColorBrandPalette0130$8,
		ColorBrandPalette0140: ColorBrandPalette0140$8,
		ColorBrandPalette0150: ColorBrandPalette0150$8,
		ColorBrandPalette0160: ColorBrandPalette0160$8,
		ColorBrandPalette0170: ColorBrandPalette0170$8,
		ColorBrandPalette0180: ColorBrandPalette0180$8,
		ColorBrandPalette0190: ColorBrandPalette0190$8,
		ColorBrandPalette01100: ColorBrandPalette01100$8,
		ColorBrandPalette01110: ColorBrandPalette01110$8,
		ColorBrandPalette01120: ColorBrandPalette01120$8,
		ColorBrandPalette01130: ColorBrandPalette01130$8,
		ColorBrandPalette01140: ColorBrandPalette01140$8,
		ColorBrandPalette01150: ColorBrandPalette01150$8,
		ColorBrandPalette01160: ColorBrandPalette01160$8,
		ColorBrandPalette0210: ColorBrandPalette0210$8,
		ColorBrandPalette0220: ColorBrandPalette0220$8,
		ColorBrandPalette0230: ColorBrandPalette0230$8,
		ColorBrandPalette0240: ColorBrandPalette0240$8,
		ColorBrandPalette0250: ColorBrandPalette0250$8,
		ColorBrandPalette0260: ColorBrandPalette0260$8,
		ColorBrandPalette0270: ColorBrandPalette0270$8,
		ColorBrandPalette0280: ColorBrandPalette0280$8,
		ColorBrandPalette0290: ColorBrandPalette0290$8,
		ColorBrandPalette02100: ColorBrandPalette02100$8,
		ColorBrandPalette02110: ColorBrandPalette02110$8,
		ColorBrandPalette02120: ColorBrandPalette02120$8,
		ColorBrandPalette02130: ColorBrandPalette02130$8,
		ColorBrandPalette02140: ColorBrandPalette02140$8,
		ColorBrandPalette02150: ColorBrandPalette02150$8,
		ColorBrandPalette02160: ColorBrandPalette02160$8,
		ColorBrandPalette0310: ColorBrandPalette0310$6,
		ColorBrandPalette0320: ColorBrandPalette0320$6,
		ColorBrandPalette0330: ColorBrandPalette0330$6,
		ColorBrandPalette0340: ColorBrandPalette0340$6,
		ColorBrandPalette0350: ColorBrandPalette0350$6,
		ColorBrandPalette0360: ColorBrandPalette0360$6,
		ColorBrandPalette0370: ColorBrandPalette0370$6,
		ColorBrandPalette0380: ColorBrandPalette0380$6,
		ColorBrandPalette0390: ColorBrandPalette0390$6,
		ColorBrandPalette03100: ColorBrandPalette03100$6,
		ColorBrandPalette03110: ColorBrandPalette03110$6,
		ColorBrandPalette03120: ColorBrandPalette03120$6,
		ColorBrandPalette03130: ColorBrandPalette03130$6,
		ColorBrandPalette03140: ColorBrandPalette03140$6,
		ColorBrandPalette03150: ColorBrandPalette03150$6,
		ColorBrandPalette03160: ColorBrandPalette03160$6,
		ColorBrandPalette0410: ColorBrandPalette0410$7,
		ColorBrandPalette0420: ColorBrandPalette0420$7,
		ColorBrandPalette0430: ColorBrandPalette0430$7,
		ColorBrandPalette0440: ColorBrandPalette0440$7,
		ColorBrandPalette0450: ColorBrandPalette0450$7,
		ColorBrandPalette0460: ColorBrandPalette0460$7,
		ColorBrandPalette0470: ColorBrandPalette0470$7,
		ColorBrandPalette0480: ColorBrandPalette0480$7,
		ColorBrandPalette0490: ColorBrandPalette0490$7,
		ColorBrandPalette04100: ColorBrandPalette04100$7,
		ColorBrandPalette04110: ColorBrandPalette04110$7,
		ColorBrandPalette04120: ColorBrandPalette04120$7,
		ColorBrandPalette04130: ColorBrandPalette04130$7,
		ColorBrandPalette04140: ColorBrandPalette04140$7,
		ColorBrandPalette04150: ColorBrandPalette04150$7,
		ColorBrandPalette04160: ColorBrandPalette04160$7,
		ColorFeedbackErrorText: ColorFeedbackErrorText$8,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$8,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$8,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$8,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$8,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$8,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$8,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$8,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$8,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$8,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$8,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$8,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$8,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$8,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$8,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$8,
		ColorSupport01: ColorSupport01$8,
		ColorSupport02: ColorSupport02$8,
		ColorSupportOnBrand01: ColorSupportOnBrand01$8,
		ColorSupportOnBrand02: ColorSupportOnBrand02$8,
		ColorSupportInverse01: ColorSupportInverse01$8,
		ColorSupportInverse02: ColorSupportInverse02$8,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$8,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$8,
		Opacity01: Opacity01$8,
		Opacity02: Opacity02$8,
		Opacity03: Opacity03$8,
		Opacity04: Opacity04$8,
		Opacity05: Opacity05$8,
		Opacity06: Opacity06$8,
		Opacity07: Opacity07$8,
		Opacity08: Opacity08$8,
		Opacity09: Opacity09$8,
		Shadow01: Shadow01$8,
		Shadow02: Shadow02$8,
		Shadow03: Shadow03$8,
		Shadow04: Shadow04$8,
		SpacingInlineQuark: SpacingInlineQuark$8,
		SpacingInlineNano: SpacingInlineNano$8,
		SpacingInlineXxxs: SpacingInlineXxxs$8,
		SpacingInlineXxs: SpacingInlineXxs$8,
		SpacingInlineXs: SpacingInlineXs$8,
		SpacingInlineSm: SpacingInlineSm$8,
		SpacingInlineMd: SpacingInlineMd$8,
		SpacingInlineLg: SpacingInlineLg$8,
		SpacingInlineXl: SpacingInlineXl$8,
		SpacingInlineXxl: SpacingInlineXxl$8,
		SpacingInlineXxxl: SpacingInlineXxxl$8,
		SpacingInlineHuge: SpacingInlineHuge$8,
		SpacingInlineGiant: SpacingInlineGiant$8,
		SpacingInsetQuark: SpacingInsetQuark$8,
		SpacingInsetNano: SpacingInsetNano$8,
		SpacingInsetXs: SpacingInsetXs$8,
		SpacingInsetSm: SpacingInsetSm$8,
		SpacingInsetMd: SpacingInsetMd$8,
		SpacingInsetLg: SpacingInsetLg$8,
		SpacingSquishQuark: SpacingSquishQuark$8,
		SpacingSquishNano: SpacingSquishNano$8,
		SpacingSquishXs: SpacingSquishXs$8,
		SpacingSquishSm: SpacingSquishSm$8,
		SpacingStackQuark: SpacingStackQuark$8,
		SpacingStackNano: SpacingStackNano$8,
		SpacingStackXxxs: SpacingStackXxxs$8,
		SpacingStackXxs: SpacingStackXxs$8,
		SpacingStackXs: SpacingStackXs$8,
		SpacingStackSm: SpacingStackSm$8,
		SpacingStackMd: SpacingStackMd$8,
		SpacingStackLg: SpacingStackLg$8,
		SpacingStackXl: SpacingStackXl$8,
		SpacingStackXxl: SpacingStackXxl$8,
		SpacingStackXxxl: SpacingStackXxxl$8,
		SpacingStackHuge: SpacingStackHuge$8,
		SpacingStackGiant: SpacingStackGiant$8,
		FontFamilyBase: FontFamilyBase$8,
		FontSizeXxxs: FontSizeXxxs$8,
		FontSizeXxs: FontSizeXxs$8,
		FontSizeXs: FontSizeXs$8,
		FontSizeSm: FontSizeSm$8,
		FontSizeMd: FontSizeMd$8,
		FontSizeLg: FontSizeLg$8,
		FontSizeXl: FontSizeXl$8,
		FontSizeXxl: FontSizeXxl$8,
		FontSizeXxxl: FontSizeXxxl$8,
		FontSizeDisplay: FontSizeDisplay$8,
		FontSizeGiant: FontSizeGiant$8,
		FontWeightBold: FontWeightBold$8,
		FontWeightSemibold: FontWeightSemibold$8,
		FontWeightMedium: FontWeightMedium$8,
		FontWeightRegular: FontWeightRegular$8,
		FontWeightLight: FontWeightLight$8,
		LetterSpacingStandard: LetterSpacingStandard$8,
		LetterSpacingSmall: LetterSpacingSmall$8,
		LetterSpacingMedium: LetterSpacingMedium$8,
		LineHeightStandard: LineHeightStandard$8,
		LineHeightTiny: LineHeightTiny$8,
		LineHeightMedium: LineHeightMedium$8,
		LineHeightLarge: LineHeightLarge$8,
		LineHeightDistant: LineHeightDistant$8,
		LineHeightSuperdistant: LineHeightSuperdistant$8,
		LineHeightHuge: LineHeightHuge$8,
		ZIndex0: ZIndex0$8,
		ZIndex100: ZIndex100$8,
		ZIndex200: ZIndex200$8,
		ZIndex300: ZIndex300$8,
		ZIndex400: ZIndex400$8,
		ZIndex500: ZIndex500$8,
		ZIndexAuto: ZIndexAuto$8,
		ZIndexTop: ZIndexTop$8,
		ZIndexBottom: ZIndexBottom$8
	});

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:01 GMT
	 */

	const BorderRadiusNone$7 = "0px";
	const BorderRadiusXs$7 = "4px";
	const BorderRadiusSm$7 = "8px";
	const BorderRadiusMd$7 = "16px";
	const BorderRadiusLg$7 = "24px";
	const BorderRadiusPill$7 = "960px";
	const BorderRadiusCircle$7 = "50%";
	const BorderWidthNone$7 = "0px";
	const BorderWidthHairline$7 = "1px";
	const BorderWidthThin$7 = "2px";
	const BorderWidthThick$7 = "4px";
	const BorderWidthHeavy$7 = "8px";
	const ColorDatavizInfoText$7 = "#0F58EA";
	const ColorDatavizInfoShape01$7 = "#3F7BF2";
	const ColorDatavizInfoShape02$7 = "#D9E5FC";
	const ColorDatavizInfoShape03$7 = "#F1F5FE";
	const ColorDatavizNegativeText$7 = "#BC293A";
	const ColorDatavizNegativeShape01$7 = "#EA4356";
	const ColorDatavizNegativeShape02$7 = "#FDDDE1";
	const ColorDatavizNegativeShape03$7 = "#FEF1F2";
	const ColorDatavizWarningText$7 = "#A04C03";
	const ColorDatavizWarningShape01$7 = "#D26404";
	const ColorDatavizWarningShape02$7 = "#FEE1C8";
	const ColorDatavizWarningShape03$7 = "#FEF1E6";
	const ColorDatavizPositiveText$7 = "#22723A";
	const ColorDatavizPositiveShape01$7 = "#2D954C";
	const ColorDatavizPositiveShape02$7 = "#C8EED3";
	const ColorDatavizPositiveShape03$7 = "#E8F8EC";
	const ColorDatavizCatAText$7 = "#9B18DC";
	const ColorDatavizCatAShape01$7 = "#B851EC";
	const ColorDatavizCatAShape02$7 = "#F2DFFB";
	const ColorDatavizCatAShape03$7 = "#F9F1FD";
	const ColorDatavizCatBText$7 = "#BA267B";
	const ColorDatavizCatBShape01$7 = "#DA499B";
	const ColorDatavizCatBShape02$7 = "#F8DDEC";
	const ColorDatavizCatBShape03$7 = "#FCF2F8";
	const ColorDatavizCatCText$7 = "#546E21";
	const ColorDatavizCatCShape01$7 = "#6C8D2B";
	const ColorDatavizCatCShape02$7 = "#DBEBBD";
	const ColorDatavizCatCShape03$7 = "#F0F7E4";
	const ColorDatavizCatDText$7 = "#0D735E";
	const ColorDatavizCatDShape01$7 = "#109379";
	const ColorDatavizCatDShape02$7 = "#BCF0E6";
	const ColorDatavizCatDShape03$7 = "#DFFBF6";
	const ColorDatavizInverseInfoText$7 = "#5C8FF5";
	const ColorDatavizInverseInfoShape01$7 = "#286BF1";
	const ColorDatavizInverseInfoShape02$7 = "#062560";
	const ColorDatavizInverseInfoShape03$7 = "#051B48";
	const ColorDatavizInverseNegativeText$7 = "#F55C6E";
	const ColorDatavizInverseNegativeShape01$7 = "#D83145";
	const ColorDatavizInverseNegativeShape02$7 = "#4F1119";
	const ColorDatavizInverseNegativeShape03$7 = "#3B0D12";
	const ColorDatavizInverseWarningText$7 = "#EB7005";
	const ColorDatavizInverseWarningShape01$7 = "#B95804";
	const ColorDatavizInverseWarningShape02$7 = "#462101";
	const ColorDatavizInverseWarningShape03$7 = "#321701";
	const ColorDatavizInversePositiveText$7 = "#32A454";
	const ColorDatavizInversePositiveShape01$7 = "#278142";
	const ColorDatavizInversePositiveShape02$7 = "#0E2F18";
	const ColorDatavizInversePositiveShape03$7 = "#0B2312";
	const ColorDatavizInverseCatAText$7 = "#C36CEF";
	const ColorDatavizInverseCatAShape01$7 = "#AD35E9";
	const ColorDatavizInverseCatAShape02$7 = "#440B60";
	const ColorDatavizInverseCatAShape03$7 = "#340849";
	const ColorDatavizInverseCatBText$7 = "#E067AB";
	const ColorDatavizInverseCatBShape01$7 = "#D42B8C";
	const ColorDatavizInverseCatBShape02$7 = "#4C1032";
	const ColorDatavizInverseCatBShape03$7 = "#3B0C27";
	const ColorDatavizInverseCatCText$7 = "#789D2F";
	const ColorDatavizInverseCatCShape01$7 = "#607E26";
	const ColorDatavizInverseCatCShape02$7 = "#212B0D";
	const ColorDatavizInverseCatCShape03$7 = "#1B230B";
	const ColorDatavizInverseCatDText$7 = "#12A588";
	const ColorDatavizInverseCatDShape01$7 = "#0F856D";
	const ColorDatavizInverseCatDShape02$7 = "#052E26";
	const ColorDatavizInverseCatDShape03$7 = "#04251E";
	const ColorInteractionBlend01$7 = "#1616160A";
	const ColorInteractionBlend02$7 = "#16161614";
	const ColorInteractionBlend03$7 = "#1616161F";
	const ColorInteractionBlend04$7 = "#1616163D";
	const ColorInteractionBlend05$7 = "#161616A3";
	const ColorInteractionBlend06$7 = "#161616B8";
	const ColorInteractionBlend07$7 = "#161616E0";
	const ColorInteractionBlend08$7 = "#161616";
	const ColorInteractionInverseBlend01$7 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$7 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$7 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$7 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$7 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$7 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$7 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$7 = "#FEFEFE";
	const ColorInteractionInverseAccent01$7 = "#6B8BFF";
	const ColorInteractionInverseAccent02$7 = "#809BFF";
	const ColorInteractionInverseAccent03$7 = "#99AFFF";
	const ColorInteractionInverseSubtle01$7 = "#5277FF1F";
	const ColorInteractionInverseSubtle02$7 = "#5277FF3D";
	const ColorInteractionInverseSubtle03$7 = "#5277FF52";
	const ColorInteractionInverseSelectDefault$7 = "#919191";
	const ColorInteractionInverseSelectFocus$7 = "#D4D4D4";
	const ColorInteractionInverseSelectActive$7 = "#6B8BFF";
	const ColorInteractionInverseDanger01$7 = "#F55C6E";
	const ColorInteractionInverseDanger02$7 = "#F77E8C";
	const ColorInteractionInverseDanger03$7 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01$7 = "#000E40";
	const ColorInteractionInverseOnBrandAccent02$7 = "#001A7A";
	const ColorInteractionInverseOnBrandAccent03$7 = "#00229E";
	const ColorInteractionInverseOnBrandSubtle01$7 = "#002FDB14";
	const ColorInteractionInverseOnBrandSubtle02$7 = "#002FDB1F";
	const ColorInteractionInverseOnBrandSubtle03$7 = "#002FDB3D";
	const ColorInteractionInverseOnBrandSelectDefault$7 = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus$7 = "#404040";
	const ColorInteractionInverseOnBrandSelectActive$7 = "#00229E";
	const ColorInteractionInverseOnBrandBlend01$7 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$7 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$7 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$7 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$7 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$7 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$7 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$7 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$7 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02$7 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03$7 = "#7E1B27";
	const ColorInteractionAccent01$7 = "#000E40";
	const ColorInteractionAccent02$7 = "#001A7A";
	const ColorInteractionAccent03$7 = "#00229E";
	const ColorInteractionSubtle01$7 = "#0029BD1F";
	const ColorInteractionSubtle02$7 = "#0029BD3D";
	const ColorInteractionSubtle03$7 = "#0029BD52";
	const ColorInteractionSelectDefault$7 = "#666666";
	const ColorInteractionSelectFocus$7 = "#363636";
	const ColorInteractionSelectActive$7 = "#00229E";
	const ColorInteractionDanger01$7 = "#BC293A";
	const ColorInteractionDanger02$7 = "#A72534";
	const ColorInteractionDanger03$7 = "#92202E";
	const ColorInteractionOnBrandAccent01$7 = "#ADBFFF";
	const ColorInteractionOnBrandAccent02$7 = "#99AFFF";
	const ColorInteractionOnBrandAccent03$7 = "#809BFF";
	const ColorInteractionOnBrandSubtle01$7 = "#5277FF1F";
	const ColorInteractionOnBrandSubtle02$7 = "#5277FF3D";
	const ColorInteractionOnBrandSubtle03$7 = "#5277FF52";
	const ColorInteractionOnBrandSelectDefault$7 = "#B0B0B0";
	const ColorInteractionOnBrandSelectFocus$7 = "#D4D4D4";
	const ColorInteractionOnBrandSelectActive$7 = "#ADBFFF";
	const ColorInteractionOnBrandBlend01$7 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$7 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$7 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$7 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$7 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$7 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$7 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$7 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$7 = "#F77E8C";
	const ColorInteractionOnBrandDanger02$7 = "#F895A1";
	const ColorInteractionOnBrandDanger03$7 = "#FAAEB6";
	const ColorNeutral10$7 = "#F5F5F5";
	const ColorNeutral20$7 = "#E6E6E6";
	const ColorNeutral30$7 = "#1616163D";
	const ColorNeutral00$7 = "#FEFEFE";
	const ColorNeutralInverse10$7 = "#1F1F1F";
	const ColorNeutralInverse20$7 = "#292929";
	const ColorNeutralInverse30$7 = "#FEFEFE3D";
	const ColorNeutralInverse00$7 = "#161616";
	const ColorNeutralInverseOnBrand10$7 = "#DBE3FF";
	const ColorNeutralInverseOnBrand20$7 = "#C7D3FF";
	const ColorNeutralInverseOnBrand30$7 = "#0029BD52";
	const ColorNeutralInverseOnBrand00$7 = "#F0F3FF";
	const ColorNeutralOnBrand10$7 = "#001A7A";
	const ColorNeutralOnBrand20$7 = "#00229E";
	const ColorNeutralOnBrand30$7 = "#5277FFA3";
	const ColorNeutralOnBrand00$7 = "#000E40";
	const ColorPaletteBlack$7 = "#161616";
	const ColorPaletteWhite$7 = "#FEFEFE";
	const ColorPaletteGray10$7 = "#1F1F1F";
	const ColorPaletteGray20$7 = "#292929";
	const ColorPaletteGray30$7 = "#363636";
	const ColorPaletteGray40$7 = "#404040";
	const ColorPaletteGray50$7 = "#4C4C4C";
	const ColorPaletteGray60$7 = "#595959";
	const ColorPaletteGray70$7 = "#666666";
	const ColorPaletteGray80$7 = "#737373";
	const ColorPaletteGray90$7 = "#828282";
	const ColorPaletteGray100$7 = "#919191";
	const ColorPaletteGray110$7 = "#A1A1A1";
	const ColorPaletteGray120$7 = "#B0B0B0";
	const ColorPaletteGray130$7 = "#C2C2C2";
	const ColorPaletteGray140$7 = "#D4D4D4";
	const ColorPaletteGray150$7 = "#E6E6E6";
	const ColorPaletteGray160$7 = "#F5F5F5";
	const ColorPaletteRed10$7 = "#3B0D12";
	const ColorPaletteRed20$7 = "#4F1119";
	const ColorPaletteRed30$7 = "#691721";
	const ColorPaletteRed40$7 = "#7E1B27";
	const ColorPaletteRed50$7 = "#92202E";
	const ColorPaletteRed60$7 = "#A72534";
	const ColorPaletteRed70$7 = "#BC293A";
	const ColorPaletteRed80$7 = "#D83145";
	const ColorPaletteRed90$7 = "#EA4356";
	const ColorPaletteRed100$7 = "#F55C6E";
	const ColorPaletteRed110$7 = "#F77E8C";
	const ColorPaletteRed120$7 = "#F895A1";
	const ColorPaletteRed130$7 = "#FAAEB6";
	const ColorPaletteRed140$7 = "#FBC5CC";
	const ColorPaletteRed150$7 = "#FDDDE1";
	const ColorPaletteRed160$7 = "#FEF1F2";
	const ColorPaletteYellow10$7 = "#321701";
	const ColorPaletteYellow20$7 = "#462101";
	const ColorPaletteYellow30$7 = "#552802";
	const ColorPaletteYellow40$7 = "#693102";
	const ColorPaletteYellow50$7 = "#7D3B03";
	const ColorPaletteYellow60$7 = "#914503";
	const ColorPaletteYellow70$7 = "#A04C03";
	const ColorPaletteYellow80$7 = "#B95804";
	const ColorPaletteYellow90$7 = "#D26404";
	const ColorPaletteYellow100$7 = "#EB7005";
	const ColorPaletteYellow110$7 = "#FA8219";
	const ColorPaletteYellow120$7 = "#FB9B46";
	const ColorPaletteYellow130$7 = "#FCB06E";
	const ColorPaletteYellow140$7 = "#FDC99B";
	const ColorPaletteYellow150$7 = "#FEE1C8";
	const ColorPaletteYellow160$7 = "#FEF1E6";
	const ColorPaletteLime10$7 = "#1B230B";
	const ColorPaletteLime20$7 = "#212B0D";
	const ColorPaletteLime30$7 = "#2D3B12";
	const ColorPaletteLime40$7 = "#364616";
	const ColorPaletteLime50$7 = "#3F5219";
	const ColorPaletteLime60$7 = "#485E1D";
	const ColorPaletteLime70$7 = "#546E21";
	const ColorPaletteLime80$7 = "#607E26";
	const ColorPaletteLime90$7 = "#6C8D2B";
	const ColorPaletteLime100$7 = "#789D2F";
	const ColorPaletteLime110$7 = "#84AC34";
	const ColorPaletteLime120$7 = "#93BF3A";
	const ColorPaletteLime130$7 = "#A9CF5E";
	const ColorPaletteLime140$7 = "#C2DD8D";
	const ColorPaletteLime150$7 = "#DBEBBD";
	const ColorPaletteLime160$7 = "#F0F7E4";
	const ColorPaletteGreen10$7 = "#0B2312";
	const ColorPaletteGreen20$7 = "#0E2F18";
	const ColorPaletteGreen30$7 = "#133E20";
	const ColorPaletteGreen40$7 = "#174A26";
	const ColorPaletteGreen50$7 = "#1A562C";
	const ColorPaletteGreen60$7 = "#1F6634";
	const ColorPaletteGreen70$7 = "#22723A";
	const ColorPaletteGreen80$7 = "#278142";
	const ColorPaletteGreen90$7 = "#2D954C";
	const ColorPaletteGreen100$7 = "#32A454";
	const ColorPaletteGreen110$7 = "#38B85E";
	const ColorPaletteGreen120$7 = "#4BC870";
	const ColorPaletteGreen130$7 = "#76D692";
	const ColorPaletteGreen140$7 = "#9DE2B1";
	const ColorPaletteGreen150$7 = "#C8EED3";
	const ColorPaletteGreen160$7 = "#E8F8EC";
	const ColorPaletteAcqua10$7 = "#04251E";
	const ColorPaletteAcqua20$7 = "#052E26";
	const ColorPaletteAcqua30$7 = "#073C31";
	const ColorPaletteAcqua40$7 = "#08493C";
	const ColorPaletteAcqua50$7 = "#0A5748";
	const ColorPaletteAcqua60$7 = "#0B6553";
	const ColorPaletteAcqua70$7 = "#0D735E";
	const ColorPaletteAcqua80$7 = "#0F856D";
	const ColorPaletteAcqua90$7 = "#109379";
	const ColorPaletteAcqua100$7 = "#12A588";
	const ColorPaletteAcqua110$7 = "#14B897";
	const ColorPaletteAcqua120$7 = "#31C4A6";
	const ColorPaletteAcqua130$7 = "#68D4BF";
	const ColorPaletteAcqua140$7 = "#8DE2D1";
	const ColorPaletteAcqua150$7 = "#BCF0E6";
	const ColorPaletteAcqua160$7 = "#DFFBF6";
	const ColorPaletteBlue10$7 = "#051B48";
	const ColorPaletteBlue20$7 = "#062560";
	const ColorPaletteBlue30$7 = "#082F7D";
	const ColorPaletteBlue40$7 = "#0A3A9A";
	const ColorPaletteBlue50$7 = "#0B43B1";
	const ColorPaletteBlue60$7 = "#0D4ECE";
	const ColorPaletteBlue70$7 = "#0F58EA";
	const ColorPaletteBlue80$7 = "#286BF1";
	const ColorPaletteBlue90$7 = "#3F7BF2";
	const ColorPaletteBlue100$7 = "#5C8FF5";
	const ColorPaletteBlue110$7 = "#73A0F7";
	const ColorPaletteBlue120$7 = "#8CB0F8";
	const ColorPaletteBlue130$7 = "#A9C4F9";
	const ColorPaletteBlue140$7 = "#C1D4FB";
	const ColorPaletteBlue150$7 = "#D9E5FC";
	const ColorPaletteBlue160$7 = "#F1F5FE";
	const ColorPalettePurple10$7 = "#340849";
	const ColorPalettePurple20$7 = "#440B60";
	const ColorPalettePurple30$7 = "#540D78";
	const ColorPalettePurple40$7 = "#671093";
	const ColorPalettePurple50$7 = "#7713AA";
	const ColorPalettePurple60$7 = "#8B16C5";
	const ColorPalettePurple70$7 = "#9B18DC";
	const ColorPalettePurple80$7 = "#AD35E9";
	const ColorPalettePurple90$7 = "#B851EC";
	const ColorPalettePurple100$7 = "#C36CEF";
	const ColorPalettePurple110$7 = "#CC83F1";
	const ColorPalettePurple120$7 = "#D69AF4";
	const ColorPalettePurple130$7 = "#DFB1F6";
	const ColorPalettePurple140$7 = "#E8C8F9";
	const ColorPalettePurple150$7 = "#F2DFFB";
	const ColorPalettePurple160$7 = "#F9F1FD";
	const ColorPalettePink10$7 = "#3B0C27";
	const ColorPalettePink20$7 = "#4C1032";
	const ColorPalettePink30$7 = "#661543";
	const ColorPalettePink40$7 = "#77184E";
	const ColorPalettePink50$7 = "#8C1C5D";
	const ColorPalettePink60$7 = "#A12169";
	const ColorPalettePink70$7 = "#BA267B";
	const ColorPalettePink80$7 = "#D42B8C";
	const ColorPalettePink90$7 = "#DA499B";
	const ColorPalettePink100$7 = "#E067AB";
	const ColorPalettePink110$7 = "#E580B9";
	const ColorPalettePink120$7 = "#EA99C7";
	const ColorPalettePink130$7 = "#EFAFD3";
	const ColorPalettePink140$7 = "#F4C8E1";
	const ColorPalettePink150$7 = "#F8DDEC";
	const ColorPalettePink160$7 = "#FCF2F8";
	const ColorTypefaceStrong$7 = "#161616";
	const ColorTypefacePure$7 = "#363636";
	const ColorTypefaceSmooth$7 = "#666666";
	const ColorTypefaceMeld$7 = "#1616163D";
	const ColorTypefaceInverseStrong$7 = "#FEFEFE";
	const ColorTypefaceInversePure$7 = "#D4D4D4";
	const ColorTypefaceInverseSmooth$7 = "#919191";
	const ColorTypefaceInverseMeld$7 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$7 = "#161616";
	const ColorTypefaceInverseOnBrandPure$7 = "#363636";
	const ColorTypefaceInverseOnBrandSmooth$7 = "#595959";
	const ColorTypefaceInverseOnBrandMeld$7 = "#1616163D";
	const ColorTypefaceOnBrandStrong$7 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$7 = "#DBE3FF";
	const ColorTypefaceOnBrandSmooth$7 = "#C7D3FF";
	const ColorTypefaceOnBrandMeld$7 = "#FEFEFE52";
	const ColorBrandPrimary10$7 = "#000E40";
	const ColorBrandPrimary20$7 = "#001A7A";
	const ColorBrandPrimary30$7 = "#00229E";
	const ColorBrandPrimary40$7 = "#0029BD";
	const ColorBrandPrimary50$7 = "#002FDB";
	const ColorBrandPrimary60$7 = "#0037FF";
	const ColorBrandPrimary70$7 = "#1F4FFF";
	const ColorBrandPrimary80$7 = "#3863FF";
	const ColorBrandPrimary90$7 = "#5277FF";
	const ColorBrandPrimary100$7 = "#6B8BFF";
	const ColorBrandPrimary110$7 = "#809BFF";
	const ColorBrandPrimary120$7 = "#99AFFF";
	const ColorBrandPrimary130$7 = "#ADBFFF";
	const ColorBrandPrimary140$7 = "#C7D3FF";
	const ColorBrandPrimary150$7 = "#DBE3FF";
	const ColorBrandPrimary160$7 = "#F0F3FF";
	const ColorBrandBase01$7 = "#000E40";
	const ColorBrandBase02$7 = "#A6E1FF";
	const ColorBrandBase03$6 = "#0037FF";
	const ColorBrandBase04$6 = "#FF4E33";
	const ColorBrandBase05$6 = "#D8BD97";
	const ColorBrandBase06$5 = "#E5FF00";
	const ColorBrandPalette0110$7 = "#000E40";
	const ColorBrandPalette0120$7 = "#001A7A";
	const ColorBrandPalette0130$7 = "#00229E";
	const ColorBrandPalette0140$7 = "#0029BD";
	const ColorBrandPalette0150$7 = "#002FDB";
	const ColorBrandPalette0160$7 = "#0037FF";
	const ColorBrandPalette0170$7 = "#1F4FFF";
	const ColorBrandPalette0180$7 = "#3863FF";
	const ColorBrandPalette0190$7 = "#5277FF";
	const ColorBrandPalette01100$7 = "#6B8BFF";
	const ColorBrandPalette01110$7 = "#809BFF";
	const ColorBrandPalette01120$7 = "#99AFFF";
	const ColorBrandPalette01130$7 = "#ADBFFF";
	const ColorBrandPalette01140$7 = "#C7D3FF";
	const ColorBrandPalette01150$7 = "#DBE3FF";
	const ColorBrandPalette01160$7 = "#F0F3FF";
	const ColorBrandPalette0210$7 = "#002233";
	const ColorBrandPalette0220$7 = "#002C42";
	const ColorBrandPalette0230$7 = "#073B54";
	const ColorBrandPalette0240$7 = "#004466";
	const ColorBrandPalette0250$7 = "#00527A";
	const ColorBrandPalette0260$7 = "#005F8F";
	const ColorBrandPalette0270$7 = "#00699E";
	const ColorBrandPalette0280$7 = "#007AB8";
	const ColorBrandPalette0290$7 = "#0088CC";
	const ColorBrandPalette02100$7 = "#0099E5";
	const ColorBrandPalette02110$7 = "#00AAFF";
	const ColorBrandPalette02120$7 = "#38BDFF";
	const ColorBrandPalette02130$7 = "#6BCEFF";
	const ColorBrandPalette02140$7 = "#A6E1FF";
	const ColorBrandPalette02150$7 = "#C7ECFF";
	const ColorBrandPalette02160$7 = "#EBF8FF";
	const ColorBrandPalette0310$5 = "#001561";
	const ColorBrandPalette0320$5 = "#001A7A";
	const ColorBrandPalette0330$5 = "#00229E";
	const ColorBrandPalette0340$5 = "#0029BD";
	const ColorBrandPalette0350$5 = "#002FDB";
	const ColorBrandPalette0360$5 = "#0037FF";
	const ColorBrandPalette0370$5 = "#1F4FFF";
	const ColorBrandPalette0380$5 = "#3863FF";
	const ColorBrandPalette0390$5 = "#5277FF";
	const ColorBrandPalette03100$5 = "#6B8BFF";
	const ColorBrandPalette03110$5 = "#809BFF";
	const ColorBrandPalette03120$5 = "#99AFFF";
	const ColorBrandPalette03130$5 = "#ADBFFF";
	const ColorBrandPalette03140$5 = "#C7D3FF";
	const ColorBrandPalette03150$5 = "#DBE3FF";
	const ColorBrandPalette03160$5 = "#F0F3FF";
	const ColorBrandPalette0410$6 = "#420900";
	const ColorBrandPalette0420$6 = "#510F05";
	const ColorBrandPalette0430$6 = "#691407";
	const ColorBrandPalette0440$6 = "#7D1808";
	const ColorBrandPalette0450$6 = "#901B09";
	const ColorBrandPalette0460$6 = "#A8200B";
	const ColorBrandPalette0470$6 = "#BB230C";
	const ColorBrandPalette0480$6 = "#DD2A0E";
	const ColorBrandPalette0490$6 = "#F13E22";
	const ColorBrandPalette04100$6 = "#FF4E33";
	const ColorBrandPalette04110$6 = "#FF7661";
	const ColorBrandPalette04120$6 = "#FF9585";
	const ColorBrandPalette04130$6 = "#FFAB9E";
	const ColorBrandPalette04140$6 = "#FFC6BD";
	const ColorBrandPalette04150$6 = "#FFE0DB";
	const ColorBrandPalette04160$6 = "#FFF2F0";
	const ColorBrandPalette0510$5 = "#251B0E";
	const ColorBrandPalette0520$5 = "#342614";
	const ColorBrandPalette0530$5 = "#433119";
	const ColorBrandPalette0540$5 = "#513C1F";
	const ColorBrandPalette0550$5 = "#604724";
	const ColorBrandPalette0560$5 = "#73552B";
	const ColorBrandPalette0570$5 = "#816031";
	const ColorBrandPalette0580$5 = "#946E38";
	const ColorBrandPalette0590$5 = "#A3793E";
	const ColorBrandPalette05100$5 = "#B98946";
	const ColorBrandPalette05110$5 = "#C39A60";
	const ColorBrandPalette05120$5 = "#CEAC7E";
	const ColorBrandPalette05130$5 = "#D8BD97";
	const ColorBrandPalette05140$5 = "#E3D0B5";
	const ColorBrandPalette05150$5 = "#EEE3D3";
	const ColorBrandPalette05160$5 = "#F8F3EC";
	const ColorBrandPalette0610$5 = "#1C1F00";
	const ColorBrandPalette0620$5 = "#252900";
	const ColorBrandPalette0630$5 = "#323800";
	const ColorBrandPalette0640$5 = "#404700";
	const ColorBrandPalette0650$5 = "#495200";
	const ColorBrandPalette0660$5 = "#535C00";
	const ColorBrandPalette0670$5 = "#606B00";
	const ColorBrandPalette0680$5 = "#6E7A00";
	const ColorBrandPalette0690$5 = "#7C8A00";
	const ColorBrandPalette06100$5 = "#8A9900";
	const ColorBrandPalette06110$5 = "#97A800";
	const ColorBrandPalette06120$5 = "#AABD00";
	const ColorBrandPalette06130$5 = "#B8CC00";
	const ColorBrandPalette06140$5 = "#CAE000";
	const ColorBrandPalette06150$5 = "#DCF500";
	const ColorBrandPalette06160$5 = "#E5FF00";
	const ColorFeedbackErrorText$7 = "#BC293A";
	const ColorFeedbackErrorShape$7 = "#EA4356";
	const ColorFeedbackSuccessText$7 = "#22723A";
	const ColorFeedbackSuccessShape$7 = "#2D954C";
	const ColorFeedbackOnBrandErrorText$7 = "#F77E8C";
	const ColorFeedbackOnBrandErrorShape$7 = "#EA4356";
	const ColorFeedbackOnBrandSuccessText$7 = "#38B85E";
	const ColorFeedbackOnBrandSuccessShape$7 = "#2D954C";
	const ColorFeedbackInverseErrorText$7 = "#F55C6E";
	const ColorFeedbackInverseErrorShape$7 = "#D83145";
	const ColorFeedbackInverseSuccessText$7 = "#32A454";
	const ColorFeedbackInverseSuccessShape$7 = "#278142";
	const ColorFeedbackInverseOnBrandErrorText$7 = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape$7 = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText$7 = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape$7 = "#278142";
	const ColorSupport01$7 = "#FF4E33";
	const ColorSupport02$7 = "#F13E22";
	const ColorSupportOnBrand01$7 = "#A6E1FF";
	const ColorSupportOnBrand02$7 = "#A6E1FF";
	const ColorSupportInverse01$7 = "#A6E1FF";
	const ColorSupportInverse02$7 = "#A6E1FF";
	const ColorSupportInverseOnBrand01$7 = "#F13E22";
	const ColorSupportInverseOnBrand02$7 = "#DD2A0E";
	const Opacity01$7 = "0.04";
	const Opacity02$7 = "0.08";
	const Opacity03$7 = "0.12";
	const Opacity04$7 = "0.24";
	const Opacity05$7 = "0.32";
	const Opacity06$7 = "0.56";
	const Opacity07$7 = "0.64";
	const Opacity08$7 = "0.72";
	const Opacity09$7 = "0.88";
	const Shadow01$7 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$7 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$7 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$7 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$7 = "4px";
	const SpacingInlineNano$7 = "8px";
	const SpacingInlineXxxs$7 = "16px";
	const SpacingInlineXxs$7 = "24px";
	const SpacingInlineXs$7 = "32px";
	const SpacingInlineSm$7 = "40px";
	const SpacingInlineMd$7 = "48px";
	const SpacingInlineLg$7 = "56px";
	const SpacingInlineXl$7 = "64px";
	const SpacingInlineXxl$7 = "80px";
	const SpacingInlineXxxl$7 = "120px";
	const SpacingInlineHuge$7 = "160px";
	const SpacingInlineGiant$7 = "200px";
	const SpacingInsetQuark$7 = "4px";
	const SpacingInsetNano$7 = "8px";
	const SpacingInsetXs$7 = "16px";
	const SpacingInsetSm$7 = "24px";
	const SpacingInsetMd$7 = "32px";
	const SpacingInsetLg$7 = "40px";
	const SpacingSquishQuark$7 = "4px 8px";
	const SpacingSquishNano$7 = "8px 16px";
	const SpacingSquishXs$7 = "16px 24px";
	const SpacingSquishSm$7 = "16px 32px";
	const SpacingStackQuark$7 = "4px";
	const SpacingStackNano$7 = "8px";
	const SpacingStackXxxs$7 = "16px";
	const SpacingStackXxs$7 = "24px";
	const SpacingStackXs$7 = "32px";
	const SpacingStackSm$7 = "40px";
	const SpacingStackMd$7 = "48px";
	const SpacingStackLg$7 = "56px";
	const SpacingStackXl$7 = "64px";
	const SpacingStackXxl$7 = "80px";
	const SpacingStackXxxl$7 = "120px";
	const SpacingStackHuge$7 = "160px";
	const SpacingStackGiant$7 = "200px";
	const FontFamilyBase$7 = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontSizeXxxs$7 = "0.75rem";
	const FontSizeXxs$7 = "0.875rem";
	const FontSizeXs$7 = "1rem";
	const FontSizeSm$7 = "1.25rem";
	const FontSizeMd$7 = "1.5rem";
	const FontSizeLg$7 = "2rem";
	const FontSizeXl$7 = "2.5rem";
	const FontSizeXxl$7 = "3rem";
	const FontSizeXxxl$7 = "4rem";
	const FontSizeDisplay$7 = "5rem";
	const FontSizeGiant$7 = "6rem";
	const FontWeightBold$7 = 700;
	const FontWeightSemibold$7 = 600;
	const FontWeightMedium$7 = 500;
	const FontWeightRegular$7 = 400;
	const FontWeightLight$7 = 300;
	const LetterSpacingStandard$7 = "0px";
	const LetterSpacingSmall$7 = "-1px";
	const LetterSpacingMedium$7 = "1.5px";
	const LineHeightStandard$7 = "100%";
	const LineHeightTiny$7 = "115%";
	const LineHeightMedium$7 = "120%";
	const LineHeightLarge$7 = "125%";
	const LineHeightDistant$7 = "133%";
	const LineHeightSuperdistant$7 = "150%";
	const LineHeightHuge$7 = "170%";
	const ZIndex0$7 = "0";
	const ZIndex100$7 = "100";
	const ZIndex200$7 = "200";
	const ZIndex300$7 = "300";
	const ZIndex400$7 = "400";
	const ZIndex500$7 = "500";
	const ZIndexAuto$7 = "auto";
	const ZIndexTop$7 = "99999";
	const ZIndexBottom$7 = "-100";

	var index$7 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$7,
		BorderRadiusXs: BorderRadiusXs$7,
		BorderRadiusSm: BorderRadiusSm$7,
		BorderRadiusMd: BorderRadiusMd$7,
		BorderRadiusLg: BorderRadiusLg$7,
		BorderRadiusPill: BorderRadiusPill$7,
		BorderRadiusCircle: BorderRadiusCircle$7,
		BorderWidthNone: BorderWidthNone$7,
		BorderWidthHairline: BorderWidthHairline$7,
		BorderWidthThin: BorderWidthThin$7,
		BorderWidthThick: BorderWidthThick$7,
		BorderWidthHeavy: BorderWidthHeavy$7,
		ColorDatavizInfoText: ColorDatavizInfoText$7,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01$7,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02$7,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03$7,
		ColorDatavizNegativeText: ColorDatavizNegativeText$7,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$7,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$7,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$7,
		ColorDatavizWarningText: ColorDatavizWarningText$7,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01$7,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02$7,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03$7,
		ColorDatavizPositiveText: ColorDatavizPositiveText$7,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$7,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$7,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$7,
		ColorDatavizCatAText: ColorDatavizCatAText$7,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01$7,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02$7,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03$7,
		ColorDatavizCatBText: ColorDatavizCatBText$7,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01$7,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02$7,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03$7,
		ColorDatavizCatCText: ColorDatavizCatCText$7,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01$7,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02$7,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03$7,
		ColorDatavizCatDText: ColorDatavizCatDText$7,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01$7,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02$7,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03$7,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$7,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$7,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$7,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$7,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$7,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$7,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$7,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$7,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$7,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$7,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$7,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$7,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$7,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$7,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$7,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$7,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$7,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$7,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$7,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$7,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$7,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$7,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$7,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$7,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$7,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$7,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$7,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$7,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$7,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$7,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$7,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$7,
		ColorInteractionBlend01: ColorInteractionBlend01$7,
		ColorInteractionBlend02: ColorInteractionBlend02$7,
		ColorInteractionBlend03: ColorInteractionBlend03$7,
		ColorInteractionBlend04: ColorInteractionBlend04$7,
		ColorInteractionBlend05: ColorInteractionBlend05$7,
		ColorInteractionBlend06: ColorInteractionBlend06$7,
		ColorInteractionBlend07: ColorInteractionBlend07$7,
		ColorInteractionBlend08: ColorInteractionBlend08$7,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$7,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$7,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$7,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$7,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$7,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$7,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$7,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$7,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$7,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$7,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$7,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$7,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$7,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$7,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$7,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$7,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$7,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$7,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$7,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$7,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$7,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$7,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$7,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$7,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$7,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$7,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$7,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$7,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$7,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$7,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$7,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$7,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$7,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$7,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$7,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$7,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$7,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$7,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$7,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$7,
		ColorInteractionAccent01: ColorInteractionAccent01$7,
		ColorInteractionAccent02: ColorInteractionAccent02$7,
		ColorInteractionAccent03: ColorInteractionAccent03$7,
		ColorInteractionSubtle01: ColorInteractionSubtle01$7,
		ColorInteractionSubtle02: ColorInteractionSubtle02$7,
		ColorInteractionSubtle03: ColorInteractionSubtle03$7,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$7,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$7,
		ColorInteractionSelectActive: ColorInteractionSelectActive$7,
		ColorInteractionDanger01: ColorInteractionDanger01$7,
		ColorInteractionDanger02: ColorInteractionDanger02$7,
		ColorInteractionDanger03: ColorInteractionDanger03$7,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$7,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$7,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$7,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$7,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$7,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$7,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$7,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$7,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$7,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$7,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$7,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$7,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$7,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$7,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$7,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$7,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$7,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$7,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$7,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$7,
		ColorNeutral10: ColorNeutral10$7,
		ColorNeutral20: ColorNeutral20$7,
		ColorNeutral30: ColorNeutral30$7,
		ColorNeutral00: ColorNeutral00$7,
		ColorNeutralInverse10: ColorNeutralInverse10$7,
		ColorNeutralInverse20: ColorNeutralInverse20$7,
		ColorNeutralInverse30: ColorNeutralInverse30$7,
		ColorNeutralInverse00: ColorNeutralInverse00$7,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$7,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$7,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$7,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$7,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$7,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$7,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$7,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$7,
		ColorPaletteBlack: ColorPaletteBlack$7,
		ColorPaletteWhite: ColorPaletteWhite$7,
		ColorPaletteGray10: ColorPaletteGray10$7,
		ColorPaletteGray20: ColorPaletteGray20$7,
		ColorPaletteGray30: ColorPaletteGray30$7,
		ColorPaletteGray40: ColorPaletteGray40$7,
		ColorPaletteGray50: ColorPaletteGray50$7,
		ColorPaletteGray60: ColorPaletteGray60$7,
		ColorPaletteGray70: ColorPaletteGray70$7,
		ColorPaletteGray80: ColorPaletteGray80$7,
		ColorPaletteGray90: ColorPaletteGray90$7,
		ColorPaletteGray100: ColorPaletteGray100$7,
		ColorPaletteGray110: ColorPaletteGray110$7,
		ColorPaletteGray120: ColorPaletteGray120$7,
		ColorPaletteGray130: ColorPaletteGray130$7,
		ColorPaletteGray140: ColorPaletteGray140$7,
		ColorPaletteGray150: ColorPaletteGray150$7,
		ColorPaletteGray160: ColorPaletteGray160$7,
		ColorPaletteRed10: ColorPaletteRed10$7,
		ColorPaletteRed20: ColorPaletteRed20$7,
		ColorPaletteRed30: ColorPaletteRed30$7,
		ColorPaletteRed40: ColorPaletteRed40$7,
		ColorPaletteRed50: ColorPaletteRed50$7,
		ColorPaletteRed60: ColorPaletteRed60$7,
		ColorPaletteRed70: ColorPaletteRed70$7,
		ColorPaletteRed80: ColorPaletteRed80$7,
		ColorPaletteRed90: ColorPaletteRed90$7,
		ColorPaletteRed100: ColorPaletteRed100$7,
		ColorPaletteRed110: ColorPaletteRed110$7,
		ColorPaletteRed120: ColorPaletteRed120$7,
		ColorPaletteRed130: ColorPaletteRed130$7,
		ColorPaletteRed140: ColorPaletteRed140$7,
		ColorPaletteRed150: ColorPaletteRed150$7,
		ColorPaletteRed160: ColorPaletteRed160$7,
		ColorPaletteYellow10: ColorPaletteYellow10$7,
		ColorPaletteYellow20: ColorPaletteYellow20$7,
		ColorPaletteYellow30: ColorPaletteYellow30$7,
		ColorPaletteYellow40: ColorPaletteYellow40$7,
		ColorPaletteYellow50: ColorPaletteYellow50$7,
		ColorPaletteYellow60: ColorPaletteYellow60$7,
		ColorPaletteYellow70: ColorPaletteYellow70$7,
		ColorPaletteYellow80: ColorPaletteYellow80$7,
		ColorPaletteYellow90: ColorPaletteYellow90$7,
		ColorPaletteYellow100: ColorPaletteYellow100$7,
		ColorPaletteYellow110: ColorPaletteYellow110$7,
		ColorPaletteYellow120: ColorPaletteYellow120$7,
		ColorPaletteYellow130: ColorPaletteYellow130$7,
		ColorPaletteYellow140: ColorPaletteYellow140$7,
		ColorPaletteYellow150: ColorPaletteYellow150$7,
		ColorPaletteYellow160: ColorPaletteYellow160$7,
		ColorPaletteLime10: ColorPaletteLime10$7,
		ColorPaletteLime20: ColorPaletteLime20$7,
		ColorPaletteLime30: ColorPaletteLime30$7,
		ColorPaletteLime40: ColorPaletteLime40$7,
		ColorPaletteLime50: ColorPaletteLime50$7,
		ColorPaletteLime60: ColorPaletteLime60$7,
		ColorPaletteLime70: ColorPaletteLime70$7,
		ColorPaletteLime80: ColorPaletteLime80$7,
		ColorPaletteLime90: ColorPaletteLime90$7,
		ColorPaletteLime100: ColorPaletteLime100$7,
		ColorPaletteLime110: ColorPaletteLime110$7,
		ColorPaletteLime120: ColorPaletteLime120$7,
		ColorPaletteLime130: ColorPaletteLime130$7,
		ColorPaletteLime140: ColorPaletteLime140$7,
		ColorPaletteLime150: ColorPaletteLime150$7,
		ColorPaletteLime160: ColorPaletteLime160$7,
		ColorPaletteGreen10: ColorPaletteGreen10$7,
		ColorPaletteGreen20: ColorPaletteGreen20$7,
		ColorPaletteGreen30: ColorPaletteGreen30$7,
		ColorPaletteGreen40: ColorPaletteGreen40$7,
		ColorPaletteGreen50: ColorPaletteGreen50$7,
		ColorPaletteGreen60: ColorPaletteGreen60$7,
		ColorPaletteGreen70: ColorPaletteGreen70$7,
		ColorPaletteGreen80: ColorPaletteGreen80$7,
		ColorPaletteGreen90: ColorPaletteGreen90$7,
		ColorPaletteGreen100: ColorPaletteGreen100$7,
		ColorPaletteGreen110: ColorPaletteGreen110$7,
		ColorPaletteGreen120: ColorPaletteGreen120$7,
		ColorPaletteGreen130: ColorPaletteGreen130$7,
		ColorPaletteGreen140: ColorPaletteGreen140$7,
		ColorPaletteGreen150: ColorPaletteGreen150$7,
		ColorPaletteGreen160: ColorPaletteGreen160$7,
		ColorPaletteAcqua10: ColorPaletteAcqua10$7,
		ColorPaletteAcqua20: ColorPaletteAcqua20$7,
		ColorPaletteAcqua30: ColorPaletteAcqua30$7,
		ColorPaletteAcqua40: ColorPaletteAcqua40$7,
		ColorPaletteAcqua50: ColorPaletteAcqua50$7,
		ColorPaletteAcqua60: ColorPaletteAcqua60$7,
		ColorPaletteAcqua70: ColorPaletteAcqua70$7,
		ColorPaletteAcqua80: ColorPaletteAcqua80$7,
		ColorPaletteAcqua90: ColorPaletteAcqua90$7,
		ColorPaletteAcqua100: ColorPaletteAcqua100$7,
		ColorPaletteAcqua110: ColorPaletteAcqua110$7,
		ColorPaletteAcqua120: ColorPaletteAcqua120$7,
		ColorPaletteAcqua130: ColorPaletteAcqua130$7,
		ColorPaletteAcqua140: ColorPaletteAcqua140$7,
		ColorPaletteAcqua150: ColorPaletteAcqua150$7,
		ColorPaletteAcqua160: ColorPaletteAcqua160$7,
		ColorPaletteBlue10: ColorPaletteBlue10$7,
		ColorPaletteBlue20: ColorPaletteBlue20$7,
		ColorPaletteBlue30: ColorPaletteBlue30$7,
		ColorPaletteBlue40: ColorPaletteBlue40$7,
		ColorPaletteBlue50: ColorPaletteBlue50$7,
		ColorPaletteBlue60: ColorPaletteBlue60$7,
		ColorPaletteBlue70: ColorPaletteBlue70$7,
		ColorPaletteBlue80: ColorPaletteBlue80$7,
		ColorPaletteBlue90: ColorPaletteBlue90$7,
		ColorPaletteBlue100: ColorPaletteBlue100$7,
		ColorPaletteBlue110: ColorPaletteBlue110$7,
		ColorPaletteBlue120: ColorPaletteBlue120$7,
		ColorPaletteBlue130: ColorPaletteBlue130$7,
		ColorPaletteBlue140: ColorPaletteBlue140$7,
		ColorPaletteBlue150: ColorPaletteBlue150$7,
		ColorPaletteBlue160: ColorPaletteBlue160$7,
		ColorPalettePurple10: ColorPalettePurple10$7,
		ColorPalettePurple20: ColorPalettePurple20$7,
		ColorPalettePurple30: ColorPalettePurple30$7,
		ColorPalettePurple40: ColorPalettePurple40$7,
		ColorPalettePurple50: ColorPalettePurple50$7,
		ColorPalettePurple60: ColorPalettePurple60$7,
		ColorPalettePurple70: ColorPalettePurple70$7,
		ColorPalettePurple80: ColorPalettePurple80$7,
		ColorPalettePurple90: ColorPalettePurple90$7,
		ColorPalettePurple100: ColorPalettePurple100$7,
		ColorPalettePurple110: ColorPalettePurple110$7,
		ColorPalettePurple120: ColorPalettePurple120$7,
		ColorPalettePurple130: ColorPalettePurple130$7,
		ColorPalettePurple140: ColorPalettePurple140$7,
		ColorPalettePurple150: ColorPalettePurple150$7,
		ColorPalettePurple160: ColorPalettePurple160$7,
		ColorPalettePink10: ColorPalettePink10$7,
		ColorPalettePink20: ColorPalettePink20$7,
		ColorPalettePink30: ColorPalettePink30$7,
		ColorPalettePink40: ColorPalettePink40$7,
		ColorPalettePink50: ColorPalettePink50$7,
		ColorPalettePink60: ColorPalettePink60$7,
		ColorPalettePink70: ColorPalettePink70$7,
		ColorPalettePink80: ColorPalettePink80$7,
		ColorPalettePink90: ColorPalettePink90$7,
		ColorPalettePink100: ColorPalettePink100$7,
		ColorPalettePink110: ColorPalettePink110$7,
		ColorPalettePink120: ColorPalettePink120$7,
		ColorPalettePink130: ColorPalettePink130$7,
		ColorPalettePink140: ColorPalettePink140$7,
		ColorPalettePink150: ColorPalettePink150$7,
		ColorPalettePink160: ColorPalettePink160$7,
		ColorTypefaceStrong: ColorTypefaceStrong$7,
		ColorTypefacePure: ColorTypefacePure$7,
		ColorTypefaceSmooth: ColorTypefaceSmooth$7,
		ColorTypefaceMeld: ColorTypefaceMeld$7,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$7,
		ColorTypefaceInversePure: ColorTypefaceInversePure$7,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$7,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$7,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$7,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$7,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$7,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$7,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$7,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$7,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$7,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$7,
		ColorBrandPrimary10: ColorBrandPrimary10$7,
		ColorBrandPrimary20: ColorBrandPrimary20$7,
		ColorBrandPrimary30: ColorBrandPrimary30$7,
		ColorBrandPrimary40: ColorBrandPrimary40$7,
		ColorBrandPrimary50: ColorBrandPrimary50$7,
		ColorBrandPrimary60: ColorBrandPrimary60$7,
		ColorBrandPrimary70: ColorBrandPrimary70$7,
		ColorBrandPrimary80: ColorBrandPrimary80$7,
		ColorBrandPrimary90: ColorBrandPrimary90$7,
		ColorBrandPrimary100: ColorBrandPrimary100$7,
		ColorBrandPrimary110: ColorBrandPrimary110$7,
		ColorBrandPrimary120: ColorBrandPrimary120$7,
		ColorBrandPrimary130: ColorBrandPrimary130$7,
		ColorBrandPrimary140: ColorBrandPrimary140$7,
		ColorBrandPrimary150: ColorBrandPrimary150$7,
		ColorBrandPrimary160: ColorBrandPrimary160$7,
		ColorBrandBase01: ColorBrandBase01$7,
		ColorBrandBase02: ColorBrandBase02$7,
		ColorBrandBase03: ColorBrandBase03$6,
		ColorBrandBase04: ColorBrandBase04$6,
		ColorBrandBase05: ColorBrandBase05$6,
		ColorBrandBase06: ColorBrandBase06$5,
		ColorBrandPalette0110: ColorBrandPalette0110$7,
		ColorBrandPalette0120: ColorBrandPalette0120$7,
		ColorBrandPalette0130: ColorBrandPalette0130$7,
		ColorBrandPalette0140: ColorBrandPalette0140$7,
		ColorBrandPalette0150: ColorBrandPalette0150$7,
		ColorBrandPalette0160: ColorBrandPalette0160$7,
		ColorBrandPalette0170: ColorBrandPalette0170$7,
		ColorBrandPalette0180: ColorBrandPalette0180$7,
		ColorBrandPalette0190: ColorBrandPalette0190$7,
		ColorBrandPalette01100: ColorBrandPalette01100$7,
		ColorBrandPalette01110: ColorBrandPalette01110$7,
		ColorBrandPalette01120: ColorBrandPalette01120$7,
		ColorBrandPalette01130: ColorBrandPalette01130$7,
		ColorBrandPalette01140: ColorBrandPalette01140$7,
		ColorBrandPalette01150: ColorBrandPalette01150$7,
		ColorBrandPalette01160: ColorBrandPalette01160$7,
		ColorBrandPalette0210: ColorBrandPalette0210$7,
		ColorBrandPalette0220: ColorBrandPalette0220$7,
		ColorBrandPalette0230: ColorBrandPalette0230$7,
		ColorBrandPalette0240: ColorBrandPalette0240$7,
		ColorBrandPalette0250: ColorBrandPalette0250$7,
		ColorBrandPalette0260: ColorBrandPalette0260$7,
		ColorBrandPalette0270: ColorBrandPalette0270$7,
		ColorBrandPalette0280: ColorBrandPalette0280$7,
		ColorBrandPalette0290: ColorBrandPalette0290$7,
		ColorBrandPalette02100: ColorBrandPalette02100$7,
		ColorBrandPalette02110: ColorBrandPalette02110$7,
		ColorBrandPalette02120: ColorBrandPalette02120$7,
		ColorBrandPalette02130: ColorBrandPalette02130$7,
		ColorBrandPalette02140: ColorBrandPalette02140$7,
		ColorBrandPalette02150: ColorBrandPalette02150$7,
		ColorBrandPalette02160: ColorBrandPalette02160$7,
		ColorBrandPalette0310: ColorBrandPalette0310$5,
		ColorBrandPalette0320: ColorBrandPalette0320$5,
		ColorBrandPalette0330: ColorBrandPalette0330$5,
		ColorBrandPalette0340: ColorBrandPalette0340$5,
		ColorBrandPalette0350: ColorBrandPalette0350$5,
		ColorBrandPalette0360: ColorBrandPalette0360$5,
		ColorBrandPalette0370: ColorBrandPalette0370$5,
		ColorBrandPalette0380: ColorBrandPalette0380$5,
		ColorBrandPalette0390: ColorBrandPalette0390$5,
		ColorBrandPalette03100: ColorBrandPalette03100$5,
		ColorBrandPalette03110: ColorBrandPalette03110$5,
		ColorBrandPalette03120: ColorBrandPalette03120$5,
		ColorBrandPalette03130: ColorBrandPalette03130$5,
		ColorBrandPalette03140: ColorBrandPalette03140$5,
		ColorBrandPalette03150: ColorBrandPalette03150$5,
		ColorBrandPalette03160: ColorBrandPalette03160$5,
		ColorBrandPalette0410: ColorBrandPalette0410$6,
		ColorBrandPalette0420: ColorBrandPalette0420$6,
		ColorBrandPalette0430: ColorBrandPalette0430$6,
		ColorBrandPalette0440: ColorBrandPalette0440$6,
		ColorBrandPalette0450: ColorBrandPalette0450$6,
		ColorBrandPalette0460: ColorBrandPalette0460$6,
		ColorBrandPalette0470: ColorBrandPalette0470$6,
		ColorBrandPalette0480: ColorBrandPalette0480$6,
		ColorBrandPalette0490: ColorBrandPalette0490$6,
		ColorBrandPalette04100: ColorBrandPalette04100$6,
		ColorBrandPalette04110: ColorBrandPalette04110$6,
		ColorBrandPalette04120: ColorBrandPalette04120$6,
		ColorBrandPalette04130: ColorBrandPalette04130$6,
		ColorBrandPalette04140: ColorBrandPalette04140$6,
		ColorBrandPalette04150: ColorBrandPalette04150$6,
		ColorBrandPalette04160: ColorBrandPalette04160$6,
		ColorBrandPalette0510: ColorBrandPalette0510$5,
		ColorBrandPalette0520: ColorBrandPalette0520$5,
		ColorBrandPalette0530: ColorBrandPalette0530$5,
		ColorBrandPalette0540: ColorBrandPalette0540$5,
		ColorBrandPalette0550: ColorBrandPalette0550$5,
		ColorBrandPalette0560: ColorBrandPalette0560$5,
		ColorBrandPalette0570: ColorBrandPalette0570$5,
		ColorBrandPalette0580: ColorBrandPalette0580$5,
		ColorBrandPalette0590: ColorBrandPalette0590$5,
		ColorBrandPalette05100: ColorBrandPalette05100$5,
		ColorBrandPalette05110: ColorBrandPalette05110$5,
		ColorBrandPalette05120: ColorBrandPalette05120$5,
		ColorBrandPalette05130: ColorBrandPalette05130$5,
		ColorBrandPalette05140: ColorBrandPalette05140$5,
		ColorBrandPalette05150: ColorBrandPalette05150$5,
		ColorBrandPalette05160: ColorBrandPalette05160$5,
		ColorBrandPalette0610: ColorBrandPalette0610$5,
		ColorBrandPalette0620: ColorBrandPalette0620$5,
		ColorBrandPalette0630: ColorBrandPalette0630$5,
		ColorBrandPalette0640: ColorBrandPalette0640$5,
		ColorBrandPalette0650: ColorBrandPalette0650$5,
		ColorBrandPalette0660: ColorBrandPalette0660$5,
		ColorBrandPalette0670: ColorBrandPalette0670$5,
		ColorBrandPalette0680: ColorBrandPalette0680$5,
		ColorBrandPalette0690: ColorBrandPalette0690$5,
		ColorBrandPalette06100: ColorBrandPalette06100$5,
		ColorBrandPalette06110: ColorBrandPalette06110$5,
		ColorBrandPalette06120: ColorBrandPalette06120$5,
		ColorBrandPalette06130: ColorBrandPalette06130$5,
		ColorBrandPalette06140: ColorBrandPalette06140$5,
		ColorBrandPalette06150: ColorBrandPalette06150$5,
		ColorBrandPalette06160: ColorBrandPalette06160$5,
		ColorFeedbackErrorText: ColorFeedbackErrorText$7,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$7,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$7,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$7,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$7,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$7,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$7,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$7,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$7,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$7,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$7,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$7,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$7,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$7,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$7,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$7,
		ColorSupport01: ColorSupport01$7,
		ColorSupport02: ColorSupport02$7,
		ColorSupportOnBrand01: ColorSupportOnBrand01$7,
		ColorSupportOnBrand02: ColorSupportOnBrand02$7,
		ColorSupportInverse01: ColorSupportInverse01$7,
		ColorSupportInverse02: ColorSupportInverse02$7,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$7,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$7,
		Opacity01: Opacity01$7,
		Opacity02: Opacity02$7,
		Opacity03: Opacity03$7,
		Opacity04: Opacity04$7,
		Opacity05: Opacity05$7,
		Opacity06: Opacity06$7,
		Opacity07: Opacity07$7,
		Opacity08: Opacity08$7,
		Opacity09: Opacity09$7,
		Shadow01: Shadow01$7,
		Shadow02: Shadow02$7,
		Shadow03: Shadow03$7,
		Shadow04: Shadow04$7,
		SpacingInlineQuark: SpacingInlineQuark$7,
		SpacingInlineNano: SpacingInlineNano$7,
		SpacingInlineXxxs: SpacingInlineXxxs$7,
		SpacingInlineXxs: SpacingInlineXxs$7,
		SpacingInlineXs: SpacingInlineXs$7,
		SpacingInlineSm: SpacingInlineSm$7,
		SpacingInlineMd: SpacingInlineMd$7,
		SpacingInlineLg: SpacingInlineLg$7,
		SpacingInlineXl: SpacingInlineXl$7,
		SpacingInlineXxl: SpacingInlineXxl$7,
		SpacingInlineXxxl: SpacingInlineXxxl$7,
		SpacingInlineHuge: SpacingInlineHuge$7,
		SpacingInlineGiant: SpacingInlineGiant$7,
		SpacingInsetQuark: SpacingInsetQuark$7,
		SpacingInsetNano: SpacingInsetNano$7,
		SpacingInsetXs: SpacingInsetXs$7,
		SpacingInsetSm: SpacingInsetSm$7,
		SpacingInsetMd: SpacingInsetMd$7,
		SpacingInsetLg: SpacingInsetLg$7,
		SpacingSquishQuark: SpacingSquishQuark$7,
		SpacingSquishNano: SpacingSquishNano$7,
		SpacingSquishXs: SpacingSquishXs$7,
		SpacingSquishSm: SpacingSquishSm$7,
		SpacingStackQuark: SpacingStackQuark$7,
		SpacingStackNano: SpacingStackNano$7,
		SpacingStackXxxs: SpacingStackXxxs$7,
		SpacingStackXxs: SpacingStackXxs$7,
		SpacingStackXs: SpacingStackXs$7,
		SpacingStackSm: SpacingStackSm$7,
		SpacingStackMd: SpacingStackMd$7,
		SpacingStackLg: SpacingStackLg$7,
		SpacingStackXl: SpacingStackXl$7,
		SpacingStackXxl: SpacingStackXxl$7,
		SpacingStackXxxl: SpacingStackXxxl$7,
		SpacingStackHuge: SpacingStackHuge$7,
		SpacingStackGiant: SpacingStackGiant$7,
		FontFamilyBase: FontFamilyBase$7,
		FontSizeXxxs: FontSizeXxxs$7,
		FontSizeXxs: FontSizeXxs$7,
		FontSizeXs: FontSizeXs$7,
		FontSizeSm: FontSizeSm$7,
		FontSizeMd: FontSizeMd$7,
		FontSizeLg: FontSizeLg$7,
		FontSizeXl: FontSizeXl$7,
		FontSizeXxl: FontSizeXxl$7,
		FontSizeXxxl: FontSizeXxxl$7,
		FontSizeDisplay: FontSizeDisplay$7,
		FontSizeGiant: FontSizeGiant$7,
		FontWeightBold: FontWeightBold$7,
		FontWeightSemibold: FontWeightSemibold$7,
		FontWeightMedium: FontWeightMedium$7,
		FontWeightRegular: FontWeightRegular$7,
		FontWeightLight: FontWeightLight$7,
		LetterSpacingStandard: LetterSpacingStandard$7,
		LetterSpacingSmall: LetterSpacingSmall$7,
		LetterSpacingMedium: LetterSpacingMedium$7,
		LineHeightStandard: LineHeightStandard$7,
		LineHeightTiny: LineHeightTiny$7,
		LineHeightMedium: LineHeightMedium$7,
		LineHeightLarge: LineHeightLarge$7,
		LineHeightDistant: LineHeightDistant$7,
		LineHeightSuperdistant: LineHeightSuperdistant$7,
		LineHeightHuge: LineHeightHuge$7,
		ZIndex0: ZIndex0$7,
		ZIndex100: ZIndex100$7,
		ZIndex200: ZIndex200$7,
		ZIndex300: ZIndex300$7,
		ZIndex400: ZIndex400$7,
		ZIndex500: ZIndex500$7,
		ZIndexAuto: ZIndexAuto$7,
		ZIndexTop: ZIndexTop$7,
		ZIndexBottom: ZIndexBottom$7
	});

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:01 GMT
	 */

	const BorderRadiusNone$6 = "0px";
	const BorderRadiusXs$6 = "4px";
	const BorderRadiusSm$6 = "8px";
	const BorderRadiusMd$6 = "16px";
	const BorderRadiusLg$6 = "24px";
	const BorderRadiusPill$6 = "960px";
	const BorderRadiusCircle$6 = "50%";
	const BorderWidthNone$6 = "0px";
	const BorderWidthHairline$6 = "1px";
	const BorderWidthThin$6 = "2px";
	const BorderWidthThick$6 = "4px";
	const BorderWidthHeavy$6 = "8px";
	const ColorDatavizInfoText$6 = "#0F58EA";
	const ColorDatavizInfoShape01$6 = "#3F7BF2";
	const ColorDatavizInfoShape02$6 = "#D9E5FC";
	const ColorDatavizInfoShape03$6 = "#F1F5FE";
	const ColorDatavizNegativeText$6 = "#BC293A";
	const ColorDatavizNegativeShape01$6 = "#EA4356";
	const ColorDatavizNegativeShape02$6 = "#FDDDE1";
	const ColorDatavizNegativeShape03$6 = "#FEF1F2";
	const ColorDatavizWarningText$6 = "#A04C03";
	const ColorDatavizWarningShape01$6 = "#D26404";
	const ColorDatavizWarningShape02$6 = "#FEE1C8";
	const ColorDatavizWarningShape03$6 = "#FEF1E6";
	const ColorDatavizPositiveText$6 = "#22723A";
	const ColorDatavizPositiveShape01$6 = "#2D954C";
	const ColorDatavizPositiveShape02$6 = "#C8EED3";
	const ColorDatavizPositiveShape03$6 = "#E8F8EC";
	const ColorDatavizCatAText$6 = "#9B18DC";
	const ColorDatavizCatAShape01$6 = "#B851EC";
	const ColorDatavizCatAShape02$6 = "#F2DFFB";
	const ColorDatavizCatAShape03$6 = "#F9F1FD";
	const ColorDatavizCatBText$6 = "#BA267B";
	const ColorDatavizCatBShape01$6 = "#DA499B";
	const ColorDatavizCatBShape02$6 = "#F8DDEC";
	const ColorDatavizCatBShape03$6 = "#FCF2F8";
	const ColorDatavizCatCText$6 = "#546E21";
	const ColorDatavizCatCShape01$6 = "#6C8D2B";
	const ColorDatavizCatCShape02$6 = "#DBEBBD";
	const ColorDatavizCatCShape03$6 = "#F0F7E4";
	const ColorDatavizCatDText$6 = "#0D735E";
	const ColorDatavizCatDShape01$6 = "#109379";
	const ColorDatavizCatDShape02$6 = "#BCF0E6";
	const ColorDatavizCatDShape03$6 = "#DFFBF6";
	const ColorDatavizInverseInfoText$6 = "#5C8FF5";
	const ColorDatavizInverseInfoShape01$6 = "#286BF1";
	const ColorDatavizInverseInfoShape02$6 = "#062560";
	const ColorDatavizInverseInfoShape03$6 = "#051B48";
	const ColorDatavizInverseNegativeText$6 = "#F55C6E";
	const ColorDatavizInverseNegativeShape01$6 = "#D83145";
	const ColorDatavizInverseNegativeShape02$6 = "#4F1119";
	const ColorDatavizInverseNegativeShape03$6 = "#3B0D12";
	const ColorDatavizInverseWarningText$6 = "#EB7005";
	const ColorDatavizInverseWarningShape01$6 = "#B95804";
	const ColorDatavizInverseWarningShape02$6 = "#462101";
	const ColorDatavizInverseWarningShape03$6 = "#321701";
	const ColorDatavizInversePositiveText$6 = "#32A454";
	const ColorDatavizInversePositiveShape01$6 = "#278142";
	const ColorDatavizInversePositiveShape02$6 = "#0E2F18";
	const ColorDatavizInversePositiveShape03$6 = "#0B2312";
	const ColorDatavizInverseCatAText$6 = "#C36CEF";
	const ColorDatavizInverseCatAShape01$6 = "#AD35E9";
	const ColorDatavizInverseCatAShape02$6 = "#440B60";
	const ColorDatavizInverseCatAShape03$6 = "#340849";
	const ColorDatavizInverseCatBText$6 = "#E067AB";
	const ColorDatavizInverseCatBShape01$6 = "#D42B8C";
	const ColorDatavizInverseCatBShape02$6 = "#4C1032";
	const ColorDatavizInverseCatBShape03$6 = "#3B0C27";
	const ColorDatavizInverseCatCText$6 = "#789D2F";
	const ColorDatavizInverseCatCShape01$6 = "#607E26";
	const ColorDatavizInverseCatCShape02$6 = "#212B0D";
	const ColorDatavizInverseCatCShape03$6 = "#1B230B";
	const ColorDatavizInverseCatDText$6 = "#12A588";
	const ColorDatavizInverseCatDShape01$6 = "#0F856D";
	const ColorDatavizInverseCatDShape02$6 = "#052E26";
	const ColorDatavizInverseCatDShape03$6 = "#04251E";
	const ColorInteractionBlend01$6 = "#1616160A";
	const ColorInteractionBlend02$6 = "#16161614";
	const ColorInteractionBlend03$6 = "#1616161F";
	const ColorInteractionBlend04$6 = "#1616163D";
	const ColorInteractionBlend05$6 = "#161616A3";
	const ColorInteractionBlend06$6 = "#161616B8";
	const ColorInteractionBlend07$6 = "#161616E0";
	const ColorInteractionBlend08$6 = "#161616";
	const ColorInteractionInverseBlend01$6 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$6 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$6 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$6 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$6 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$6 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$6 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$6 = "#FEFEFE";
	const ColorInteractionInverseAccent01$6 = "#6B8BFF";
	const ColorInteractionInverseAccent02$6 = "#809BFF";
	const ColorInteractionInverseAccent03$6 = "#99AFFF";
	const ColorInteractionInverseSubtle01$6 = "#5277FF1F";
	const ColorInteractionInverseSubtle02$6 = "#5277FF3D";
	const ColorInteractionInverseSubtle03$6 = "#5277FF52";
	const ColorInteractionInverseSelectDefault$6 = "#919191";
	const ColorInteractionInverseSelectFocus$6 = "#D4D4D4";
	const ColorInteractionInverseSelectActive$6 = "#A996E4";
	const ColorInteractionInverseDanger01$6 = "#F55C6E";
	const ColorInteractionInverseDanger02$6 = "#F77E8C";
	const ColorInteractionInverseDanger03$6 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01$6 = "#000E40";
	const ColorInteractionInverseOnBrandAccent02$6 = "#001A7A";
	const ColorInteractionInverseOnBrandAccent03$6 = "#00229E";
	const ColorInteractionInverseOnBrandSubtle01$6 = "#002FDB14";
	const ColorInteractionInverseOnBrandSubtle02$6 = "#002FDB1F";
	const ColorInteractionInverseOnBrandSubtle03$6 = "#002FDB3D";
	const ColorInteractionInverseOnBrandSelectDefault$6 = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus$6 = "#4C4C4C";
	const ColorInteractionInverseOnBrandSelectActive$6 = "#3A2182";
	const ColorInteractionInverseOnBrandBlend01$6 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$6 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$6 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$6 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$6 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$6 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$6 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$6 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$6 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02$6 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03$6 = "#7E1B27";
	const ColorInteractionAccent01$6 = "#000E40";
	const ColorInteractionAccent02$6 = "#001A7A";
	const ColorInteractionAccent03$6 = "#00229E";
	const ColorInteractionSubtle01$6 = "#0029BD1F";
	const ColorInteractionSubtle02$6 = "#0029BD3D";
	const ColorInteractionSubtle03$6 = "#0029BD52";
	const ColorInteractionSelectDefault$6 = "#666666";
	const ColorInteractionSelectFocus$6 = "#4C4C4C";
	const ColorInteractionSelectActive$6 = "#3A2182";
	const ColorInteractionDanger01$6 = "#BC293A";
	const ColorInteractionDanger02$6 = "#A72534";
	const ColorInteractionDanger03$6 = "#92202E";
	const ColorInteractionOnBrandAccent01$6 = "#ADBFFF";
	const ColorInteractionOnBrandAccent02$6 = "#99AFFF";
	const ColorInteractionOnBrandAccent03$6 = "#809BFF";
	const ColorInteractionOnBrandSubtle01$6 = "#5277FF1F";
	const ColorInteractionOnBrandSubtle02$6 = "#5277FF3D";
	const ColorInteractionOnBrandSubtle03$6 = "#5277FF52";
	const ColorInteractionOnBrandSelectDefault$6 = "#B0B0B0";
	const ColorInteractionOnBrandSelectFocus$6 = "#D4D4D4";
	const ColorInteractionOnBrandSelectActive$6 = "#809BFF";
	const ColorInteractionOnBrandBlend01$6 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$6 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$6 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$6 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$6 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$6 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$6 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$6 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$6 = "#F77E8C";
	const ColorInteractionOnBrandDanger02$6 = "#F895A1";
	const ColorInteractionOnBrandDanger03$6 = "#FAAEB6";
	const ColorNeutral10$6 = "#F5F5F5";
	const ColorNeutral20$6 = "#E6E6E6";
	const ColorNeutral30$6 = "#1616163D";
	const ColorNeutral00$6 = "#FEFEFE";
	const ColorNeutralInverse10$6 = "#1F1F1F";
	const ColorNeutralInverse20$6 = "#292929";
	const ColorNeutralInverse30$6 = "#FEFEFE3D";
	const ColorNeutralInverse00$6 = "#161616";
	const ColorNeutralInverseOnBrand10$6 = "#DBE3FF";
	const ColorNeutralInverseOnBrand20$6 = "#C7D3FF";
	const ColorNeutralInverseOnBrand30$6 = "#0029BD52";
	const ColorNeutralInverseOnBrand00$6 = "#F0F3FF";
	const ColorNeutralOnBrand10$6 = "#001A7A";
	const ColorNeutralOnBrand20$6 = "#00229E";
	const ColorNeutralOnBrand30$6 = "#5277FFA3";
	const ColorNeutralOnBrand00$6 = "#000E40";
	const ColorPaletteBlack$6 = "#161616";
	const ColorPaletteWhite$6 = "#FEFEFE";
	const ColorPaletteGray10$6 = "#1F1F1F";
	const ColorPaletteGray20$6 = "#292929";
	const ColorPaletteGray30$6 = "#363636";
	const ColorPaletteGray40$6 = "#404040";
	const ColorPaletteGray50$6 = "#4C4C4C";
	const ColorPaletteGray60$6 = "#595959";
	const ColorPaletteGray70$6 = "#666666";
	const ColorPaletteGray80$6 = "#737373";
	const ColorPaletteGray90$6 = "#828282";
	const ColorPaletteGray100$6 = "#919191";
	const ColorPaletteGray110$6 = "#A1A1A1";
	const ColorPaletteGray120$6 = "#B0B0B0";
	const ColorPaletteGray130$6 = "#C2C2C2";
	const ColorPaletteGray140$6 = "#D4D4D4";
	const ColorPaletteGray150$6 = "#E6E6E6";
	const ColorPaletteGray160$6 = "#F5F5F5";
	const ColorPaletteRed10$6 = "#3B0D12";
	const ColorPaletteRed20$6 = "#4F1119";
	const ColorPaletteRed30$6 = "#691721";
	const ColorPaletteRed40$6 = "#7E1B27";
	const ColorPaletteRed50$6 = "#92202E";
	const ColorPaletteRed60$6 = "#A72534";
	const ColorPaletteRed70$6 = "#BC293A";
	const ColorPaletteRed80$6 = "#D83145";
	const ColorPaletteRed90$6 = "#EA4356";
	const ColorPaletteRed100$6 = "#F55C6E";
	const ColorPaletteRed110$6 = "#F77E8C";
	const ColorPaletteRed120$6 = "#F895A1";
	const ColorPaletteRed130$6 = "#FAAEB6";
	const ColorPaletteRed140$6 = "#FBC5CC";
	const ColorPaletteRed150$6 = "#FDDDE1";
	const ColorPaletteRed160$6 = "#FEF1F2";
	const ColorPaletteYellow10$6 = "#321701";
	const ColorPaletteYellow20$6 = "#462101";
	const ColorPaletteYellow30$6 = "#552802";
	const ColorPaletteYellow40$6 = "#693102";
	const ColorPaletteYellow50$6 = "#7D3B03";
	const ColorPaletteYellow60$6 = "#914503";
	const ColorPaletteYellow70$6 = "#A04C03";
	const ColorPaletteYellow80$6 = "#B95804";
	const ColorPaletteYellow90$6 = "#D26404";
	const ColorPaletteYellow100$6 = "#EB7005";
	const ColorPaletteYellow110$6 = "#FA8219";
	const ColorPaletteYellow120$6 = "#FB9B46";
	const ColorPaletteYellow130$6 = "#FCB06E";
	const ColorPaletteYellow140$6 = "#FDC99B";
	const ColorPaletteYellow150$6 = "#FEE1C8";
	const ColorPaletteYellow160$6 = "#FEF1E6";
	const ColorPaletteLime10$6 = "#1B230B";
	const ColorPaletteLime20$6 = "#212B0D";
	const ColorPaletteLime30$6 = "#2D3B12";
	const ColorPaletteLime40$6 = "#364616";
	const ColorPaletteLime50$6 = "#3F5219";
	const ColorPaletteLime60$6 = "#485E1D";
	const ColorPaletteLime70$6 = "#546E21";
	const ColorPaletteLime80$6 = "#607E26";
	const ColorPaletteLime90$6 = "#6C8D2B";
	const ColorPaletteLime100$6 = "#789D2F";
	const ColorPaletteLime110$6 = "#84AC34";
	const ColorPaletteLime120$6 = "#93BF3A";
	const ColorPaletteLime130$6 = "#A9CF5E";
	const ColorPaletteLime140$6 = "#C2DD8D";
	const ColorPaletteLime150$6 = "#DBEBBD";
	const ColorPaletteLime160$6 = "#F0F7E4";
	const ColorPaletteGreen10$6 = "#0B2312";
	const ColorPaletteGreen20$6 = "#0E2F18";
	const ColorPaletteGreen30$6 = "#133E20";
	const ColorPaletteGreen40$6 = "#174A26";
	const ColorPaletteGreen50$6 = "#1A562C";
	const ColorPaletteGreen60$6 = "#1F6634";
	const ColorPaletteGreen70$6 = "#22723A";
	const ColorPaletteGreen80$6 = "#278142";
	const ColorPaletteGreen90$6 = "#2D954C";
	const ColorPaletteGreen100$6 = "#32A454";
	const ColorPaletteGreen110$6 = "#38B85E";
	const ColorPaletteGreen120$6 = "#4BC870";
	const ColorPaletteGreen130$6 = "#76D692";
	const ColorPaletteGreen140$6 = "#9DE2B1";
	const ColorPaletteGreen150$6 = "#C8EED3";
	const ColorPaletteGreen160$6 = "#E8F8EC";
	const ColorPaletteAcqua10$6 = "#04251E";
	const ColorPaletteAcqua20$6 = "#052E26";
	const ColorPaletteAcqua30$6 = "#073C31";
	const ColorPaletteAcqua40$6 = "#08493C";
	const ColorPaletteAcqua50$6 = "#0A5748";
	const ColorPaletteAcqua60$6 = "#0B6553";
	const ColorPaletteAcqua70$6 = "#0D735E";
	const ColorPaletteAcqua80$6 = "#0F856D";
	const ColorPaletteAcqua90$6 = "#109379";
	const ColorPaletteAcqua100$6 = "#12A588";
	const ColorPaletteAcqua110$6 = "#14B897";
	const ColorPaletteAcqua120$6 = "#31C4A6";
	const ColorPaletteAcqua130$6 = "#68D4BF";
	const ColorPaletteAcqua140$6 = "#8DE2D1";
	const ColorPaletteAcqua150$6 = "#BCF0E6";
	const ColorPaletteAcqua160$6 = "#DFFBF6";
	const ColorPaletteBlue10$6 = "#051B48";
	const ColorPaletteBlue20$6 = "#062560";
	const ColorPaletteBlue30$6 = "#082F7D";
	const ColorPaletteBlue40$6 = "#0A3A9A";
	const ColorPaletteBlue50$6 = "#0B43B1";
	const ColorPaletteBlue60$6 = "#0D4ECE";
	const ColorPaletteBlue70$6 = "#0F58EA";
	const ColorPaletteBlue80$6 = "#286BF1";
	const ColorPaletteBlue90$6 = "#3F7BF2";
	const ColorPaletteBlue100$6 = "#5C8FF5";
	const ColorPaletteBlue110$6 = "#73A0F7";
	const ColorPaletteBlue120$6 = "#8CB0F8";
	const ColorPaletteBlue130$6 = "#A9C4F9";
	const ColorPaletteBlue140$6 = "#C1D4FB";
	const ColorPaletteBlue150$6 = "#D9E5FC";
	const ColorPaletteBlue160$6 = "#F1F5FE";
	const ColorPalettePurple10$6 = "#340849";
	const ColorPalettePurple20$6 = "#440B60";
	const ColorPalettePurple30$6 = "#540D78";
	const ColorPalettePurple40$6 = "#671093";
	const ColorPalettePurple50$6 = "#7713AA";
	const ColorPalettePurple60$6 = "#8B16C5";
	const ColorPalettePurple70$6 = "#9B18DC";
	const ColorPalettePurple80$6 = "#AD35E9";
	const ColorPalettePurple90$6 = "#B851EC";
	const ColorPalettePurple100$6 = "#C36CEF";
	const ColorPalettePurple110$6 = "#CC83F1";
	const ColorPalettePurple120$6 = "#D69AF4";
	const ColorPalettePurple130$6 = "#DFB1F6";
	const ColorPalettePurple140$6 = "#E8C8F9";
	const ColorPalettePurple150$6 = "#F2DFFB";
	const ColorPalettePurple160$6 = "#F9F1FD";
	const ColorPalettePink10$6 = "#3B0C27";
	const ColorPalettePink20$6 = "#4C1032";
	const ColorPalettePink30$6 = "#661543";
	const ColorPalettePink40$6 = "#77184E";
	const ColorPalettePink50$6 = "#8C1C5D";
	const ColorPalettePink60$6 = "#A12169";
	const ColorPalettePink70$6 = "#BA267B";
	const ColorPalettePink80$6 = "#D42B8C";
	const ColorPalettePink90$6 = "#DA499B";
	const ColorPalettePink100$6 = "#E067AB";
	const ColorPalettePink110$6 = "#E580B9";
	const ColorPalettePink120$6 = "#EA99C7";
	const ColorPalettePink130$6 = "#EFAFD3";
	const ColorPalettePink140$6 = "#F4C8E1";
	const ColorPalettePink150$6 = "#F8DDEC";
	const ColorPalettePink160$6 = "#FCF2F8";
	const ColorTypefaceStrong$6 = "#161616";
	const ColorTypefacePure$6 = "#363636";
	const ColorTypefaceSmooth$6 = "#666666";
	const ColorTypefaceMeld$6 = "#1616163D";
	const ColorTypefaceInverseStrong$6 = "#FEFEFE";
	const ColorTypefaceInversePure$6 = "#D4D4D4";
	const ColorTypefaceInverseSmooth$6 = "#919191";
	const ColorTypefaceInverseMeld$6 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$6 = "#161616";
	const ColorTypefaceInverseOnBrandPure$6 = "#363636";
	const ColorTypefaceInverseOnBrandSmooth$6 = "#595959";
	const ColorTypefaceInverseOnBrandMeld$6 = "#1616163D";
	const ColorTypefaceOnBrandStrong$6 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$6 = "#DBE3FF";
	const ColorTypefaceOnBrandSmooth$6 = "#C7D3FF";
	const ColorTypefaceOnBrandMeld$6 = "#FEFEFE52";
	const ColorBrandPrimary10$6 = "#000E40";
	const ColorBrandPrimary20$6 = "#001A7A";
	const ColorBrandPrimary30$6 = "#00229E";
	const ColorBrandPrimary40$6 = "#0029BD";
	const ColorBrandPrimary50$6 = "#002FDB";
	const ColorBrandPrimary60$6 = "#0037FF";
	const ColorBrandPrimary70$6 = "#1F4FFF";
	const ColorBrandPrimary80$6 = "#3863FF";
	const ColorBrandPrimary90$6 = "#5277FF";
	const ColorBrandPrimary100$6 = "#6B8BFF";
	const ColorBrandPrimary110$6 = "#809BFF";
	const ColorBrandPrimary120$6 = "#99AFFF";
	const ColorBrandPrimary130$6 = "#ADBFFF";
	const ColorBrandPrimary140$6 = "#C7D3FF";
	const ColorBrandPrimary150$6 = "#DBE3FF";
	const ColorBrandPrimary160$6 = "#F0F3FF";
	const ColorBrandBase01$6 = "#000E40";
	const ColorBrandBase02$6 = "#CF0F40";
	const ColorBrandBase03$5 = "#E84273";
	const ColorBrandBase04$5 = "#9C86E0";
	const ColorBrandBase05$5 = "#D8BD97";
	const ColorBrandBase06$4 = "#F6F4F4";
	const ColorBrandPalette0110$6 = "#000E40";
	const ColorBrandPalette0120$6 = "#001A7A";
	const ColorBrandPalette0130$6 = "#00229E";
	const ColorBrandPalette0140$6 = "#0029BD";
	const ColorBrandPalette0150$6 = "#002FDB";
	const ColorBrandPalette0160$6 = "#0037FF";
	const ColorBrandPalette0170$6 = "#1F4FFF";
	const ColorBrandPalette0180$6 = "#3863FF";
	const ColorBrandPalette0190$6 = "#5277FF";
	const ColorBrandPalette01100$6 = "#6B8BFF";
	const ColorBrandPalette01110$6 = "#809BFF";
	const ColorBrandPalette01120$6 = "#99AFFF";
	const ColorBrandPalette01130$6 = "#ADBFFF";
	const ColorBrandPalette01140$6 = "#C7D3FF";
	const ColorBrandPalette01150$6 = "#DBE3FF";
	const ColorBrandPalette01160$6 = "#F0F3FF";
	const ColorBrandPalette0210$6 = "#420514";
	const ColorBrandPalette0220$6 = "#55061A";
	const ColorBrandPalette0230$6 = "#6D0821";
	const ColorBrandPalette0240$6 = "#850A29";
	const ColorBrandPalette0250$6 = "#980B2F";
	const ColorBrandPalette0260$6 = "#AF0D36";
	const ColorBrandPalette0270$6 = "#CF0F40";
	const ColorBrandPalette0280$6 = "#E41146";
	const ColorBrandPalette0290$6 = "#F03866";
	const ColorBrandPalette02100$6 = "#F35E83";
	const ColorBrandPalette02110$6 = "#F57A99";
	const ColorBrandPalette02120$6 = "#F797AF";
	const ColorBrandPalette02130$6 = "#F9AEC1";
	const ColorBrandPalette02140$6 = "#FBC6D3";
	const ColorBrandPalette02150$6 = "#FDDEE5";
	const ColorBrandPalette02160$6 = "#FEF1F4";
	const ColorBrandPalette0310$4 = "#400819";
	const ColorBrandPalette0320$4 = "#560B21";
	const ColorBrandPalette0330$4 = "#6D0D2A";
	const ColorBrandPalette0340$4 = "#7F1031";
	const ColorBrandPalette0350$4 = "#96133A";
	const ColorBrandPalette0360$4 = "#AC1543";
	const ColorBrandPalette0370$4 = "#C3184B";
	const ColorBrandPalette0380$4 = "#DE1B56";
	const ColorBrandPalette0390$4 = "#E84273";
	const ColorBrandPalette03100$4 = "#EC658D";
	const ColorBrandPalette03110$4 = "#EF7B9E";
	const ColorBrandPalette03120$4 = "#F297B2";
	const ColorBrandPalette03130$4 = "#F5ADC3";
	const ColorBrandPalette03140$4 = "#F8C9D7";
	const ColorBrandPalette03150$4 = "#FBDFE8";
	const ColorBrandPalette03160$4 = "#FDF2F5";
	const ColorBrandPalette0410$5 = "#22144D";
	const ColorBrandPalette0420$5 = "#2D1A65";
	const ColorBrandPalette0430$5 = "#3A2182";
	const ColorBrandPalette0440$5 = "#46299E";
	const ColorBrandPalette0450$5 = "#5330BB";
	const ColorBrandPalette0460$5 = "#603CCD";
	const ColorBrandPalette0470$5 = "#6E4DD1";
	const ColorBrandPalette0480$5 = "#7E61D6";
	const ColorBrandPalette0490$5 = "#8B71DA";
	const ColorBrandPalette04100$5 = "#9C86E0";
	const ColorBrandPalette04110$5 = "#A996E4";
	const ColorBrandPalette04120$5 = "#BAAAE9";
	const ColorBrandPalette04130$5 = "#C7BAED";
	const ColorBrandPalette04140$5 = "#D7CEF2";
	const ColorBrandPalette04150$5 = "#E8E3F8";
	const ColorBrandPalette04160$5 = "#F5F3FC";
	const ColorBrandPalette0510$4 = "#251B0E";
	const ColorBrandPalette0520$4 = "#342614";
	const ColorBrandPalette0530$4 = "#433119";
	const ColorBrandPalette0540$4 = "#513C1F";
	const ColorBrandPalette0550$4 = "#604724";
	const ColorBrandPalette0560$4 = "#73552B";
	const ColorBrandPalette0570$4 = "#816031";
	const ColorBrandPalette0580$4 = "#946E38";
	const ColorBrandPalette0590$4 = "#A3793E";
	const ColorBrandPalette05100$4 = "#B98946";
	const ColorBrandPalette05110$4 = "#C39A60";
	const ColorBrandPalette05120$4 = "#CEAC7E";
	const ColorBrandPalette05130$4 = "#D8BD97";
	const ColorBrandPalette05140$4 = "#E3D0B5";
	const ColorBrandPalette05150$4 = "#EEE3D3";
	const ColorBrandPalette05160$4 = "#F8F3EC";
	const ColorBrandPalette0610$4 = "#1A1514";
	const ColorBrandPalette0620$4 = "#312826";
	const ColorBrandPalette0630$4 = "#3F3431";
	const ColorBrandPalette0640$4 = "#4A3D3A";
	const ColorBrandPalette0650$4 = "#594946";
	const ColorBrandPalette0660$4 = "#675451";
	const ColorBrandPalette0670$4 = "#75605C";
	const ColorBrandPalette0680$4 = "#866E69";
	const ColorBrandPalette0690$4 = "#967E79";
	const ColorBrandPalette06100$4 = "#A38E8A";
	const ColorBrandPalette06110$4 = "#AE9C98";
	const ColorBrandPalette06120$4 = "#BEAFAC";
	const ColorBrandPalette06130$4 = "#CBC0BD";
	const ColorBrandPalette06140$4 = "#D9D0CE";
	const ColorBrandPalette06150$4 = "#E9E4E3";
	const ColorBrandPalette06160$4 = "#F6F4F4";
	const ColorFeedbackErrorText$6 = "#BC293A";
	const ColorFeedbackErrorShape$6 = "#EA4356";
	const ColorFeedbackSuccessText$6 = "#22723A";
	const ColorFeedbackSuccessShape$6 = "#2D954C";
	const ColorFeedbackOnBrandErrorText$6 = "#F77E8C";
	const ColorFeedbackOnBrandErrorShape$6 = "#EA4356";
	const ColorFeedbackOnBrandSuccessText$6 = "#38B85E";
	const ColorFeedbackOnBrandSuccessShape$6 = "#2D954C";
	const ColorFeedbackInverseErrorText$6 = "#F55C6E";
	const ColorFeedbackInverseErrorShape$6 = "#D83145";
	const ColorFeedbackInverseSuccessText$6 = "#32A454";
	const ColorFeedbackInverseSuccessShape$6 = "#278142";
	const ColorFeedbackInverseOnBrandErrorText$6 = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape$6 = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText$6 = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape$6 = "#278142";
	const ColorSupport01$6 = "#CF0F40";
	const ColorSupport02$6 = "#CF0F40";
	const ColorSupportOnBrand01$6 = "#9C86E0";
	const ColorSupportOnBrand02$6 = "#9C86E0";
	const ColorSupportInverse01$6 = "#E84273";
	const ColorSupportInverse02$6 = "#E84273";
	const ColorSupportInverseOnBrand01$6 = "#CF0F40";
	const ColorSupportInverseOnBrand02$6 = "#CF0F40";
	const Opacity01$6 = "0.04";
	const Opacity02$6 = "0.08";
	const Opacity03$6 = "0.12";
	const Opacity04$6 = "0.24";
	const Opacity05$6 = "0.32";
	const Opacity06$6 = "0.56";
	const Opacity07$6 = "0.64";
	const Opacity08$6 = "0.72";
	const Opacity09$6 = "0.88";
	const Shadow01$6 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$6 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$6 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$6 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$6 = "4px";
	const SpacingInlineNano$6 = "8px";
	const SpacingInlineXxxs$6 = "16px";
	const SpacingInlineXxs$6 = "24px";
	const SpacingInlineXs$6 = "32px";
	const SpacingInlineSm$6 = "40px";
	const SpacingInlineMd$6 = "48px";
	const SpacingInlineLg$6 = "56px";
	const SpacingInlineXl$6 = "64px";
	const SpacingInlineXxl$6 = "80px";
	const SpacingInlineXxxl$6 = "120px";
	const SpacingInlineHuge$6 = "160px";
	const SpacingInlineGiant$6 = "200px";
	const SpacingInsetQuark$6 = "4px";
	const SpacingInsetNano$6 = "8px";
	const SpacingInsetXs$6 = "16px";
	const SpacingInsetSm$6 = "24px";
	const SpacingInsetMd$6 = "32px";
	const SpacingInsetLg$6 = "40px";
	const SpacingSquishQuark$6 = "4px 8px";
	const SpacingSquishNano$6 = "8px 16px";
	const SpacingSquishXs$6 = "16px 24px";
	const SpacingSquishSm$6 = "16px 32px";
	const SpacingStackQuark$6 = "4px";
	const SpacingStackNano$6 = "8px";
	const SpacingStackXxxs$6 = "16px";
	const SpacingStackXxs$6 = "24px";
	const SpacingStackXs$6 = "32px";
	const SpacingStackSm$6 = "40px";
	const SpacingStackMd$6 = "48px";
	const SpacingStackLg$6 = "56px";
	const SpacingStackXl$6 = "64px";
	const SpacingStackXxl$6 = "80px";
	const SpacingStackXxxl$6 = "120px";
	const SpacingStackHuge$6 = "160px";
	const SpacingStackGiant$6 = "200px";
	const FontFamilyBase$6 = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontSizeXxxs$6 = "0.75rem";
	const FontSizeXxs$6 = "0.875rem";
	const FontSizeXs$6 = "1rem";
	const FontSizeSm$6 = "1.25rem";
	const FontSizeMd$6 = "1.5rem";
	const FontSizeLg$6 = "2rem";
	const FontSizeXl$6 = "2.5rem";
	const FontSizeXxl$6 = "3rem";
	const FontSizeXxxl$6 = "4rem";
	const FontSizeDisplay$6 = "5rem";
	const FontSizeGiant$6 = "6rem";
	const FontWeightBold$6 = 700;
	const FontWeightSemibold$6 = 600;
	const FontWeightMedium$6 = 500;
	const FontWeightRegular$6 = 400;
	const FontWeightLight$6 = 300;
	const LetterSpacingStandard$6 = "0px";
	const LetterSpacingSmall$6 = "-1px";
	const LetterSpacingMedium$6 = "1.5px";
	const LineHeightStandard$6 = "100%";
	const LineHeightTiny$6 = "115%";
	const LineHeightMedium$6 = "120%";
	const LineHeightLarge$6 = "125%";
	const LineHeightDistant$6 = "133%";
	const LineHeightSuperdistant$6 = "150%";
	const LineHeightHuge$6 = "170%";
	const ZIndex0$6 = "0";
	const ZIndex100$6 = "100";
	const ZIndex200$6 = "200";
	const ZIndex300$6 = "300";
	const ZIndex400$6 = "400";
	const ZIndex500$6 = "500";
	const ZIndexAuto$6 = "auto";
	const ZIndexTop$6 = "99999";
	const ZIndexBottom$6 = "-100";

	var index$6 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$6,
		BorderRadiusXs: BorderRadiusXs$6,
		BorderRadiusSm: BorderRadiusSm$6,
		BorderRadiusMd: BorderRadiusMd$6,
		BorderRadiusLg: BorderRadiusLg$6,
		BorderRadiusPill: BorderRadiusPill$6,
		BorderRadiusCircle: BorderRadiusCircle$6,
		BorderWidthNone: BorderWidthNone$6,
		BorderWidthHairline: BorderWidthHairline$6,
		BorderWidthThin: BorderWidthThin$6,
		BorderWidthThick: BorderWidthThick$6,
		BorderWidthHeavy: BorderWidthHeavy$6,
		ColorDatavizInfoText: ColorDatavizInfoText$6,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01$6,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02$6,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03$6,
		ColorDatavizNegativeText: ColorDatavizNegativeText$6,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$6,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$6,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$6,
		ColorDatavizWarningText: ColorDatavizWarningText$6,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01$6,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02$6,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03$6,
		ColorDatavizPositiveText: ColorDatavizPositiveText$6,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$6,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$6,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$6,
		ColorDatavizCatAText: ColorDatavizCatAText$6,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01$6,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02$6,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03$6,
		ColorDatavizCatBText: ColorDatavizCatBText$6,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01$6,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02$6,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03$6,
		ColorDatavizCatCText: ColorDatavizCatCText$6,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01$6,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02$6,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03$6,
		ColorDatavizCatDText: ColorDatavizCatDText$6,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01$6,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02$6,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03$6,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$6,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$6,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$6,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$6,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$6,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$6,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$6,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$6,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$6,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$6,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$6,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$6,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$6,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$6,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$6,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$6,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$6,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$6,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$6,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$6,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$6,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$6,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$6,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$6,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$6,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$6,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$6,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$6,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$6,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$6,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$6,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$6,
		ColorInteractionBlend01: ColorInteractionBlend01$6,
		ColorInteractionBlend02: ColorInteractionBlend02$6,
		ColorInteractionBlend03: ColorInteractionBlend03$6,
		ColorInteractionBlend04: ColorInteractionBlend04$6,
		ColorInteractionBlend05: ColorInteractionBlend05$6,
		ColorInteractionBlend06: ColorInteractionBlend06$6,
		ColorInteractionBlend07: ColorInteractionBlend07$6,
		ColorInteractionBlend08: ColorInteractionBlend08$6,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$6,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$6,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$6,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$6,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$6,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$6,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$6,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$6,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$6,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$6,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$6,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$6,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$6,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$6,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$6,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$6,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$6,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$6,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$6,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$6,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$6,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$6,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$6,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$6,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$6,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$6,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$6,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$6,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$6,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$6,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$6,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$6,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$6,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$6,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$6,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$6,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$6,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$6,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$6,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$6,
		ColorInteractionAccent01: ColorInteractionAccent01$6,
		ColorInteractionAccent02: ColorInteractionAccent02$6,
		ColorInteractionAccent03: ColorInteractionAccent03$6,
		ColorInteractionSubtle01: ColorInteractionSubtle01$6,
		ColorInteractionSubtle02: ColorInteractionSubtle02$6,
		ColorInteractionSubtle03: ColorInteractionSubtle03$6,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$6,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$6,
		ColorInteractionSelectActive: ColorInteractionSelectActive$6,
		ColorInteractionDanger01: ColorInteractionDanger01$6,
		ColorInteractionDanger02: ColorInteractionDanger02$6,
		ColorInteractionDanger03: ColorInteractionDanger03$6,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$6,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$6,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$6,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$6,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$6,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$6,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$6,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$6,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$6,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$6,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$6,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$6,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$6,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$6,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$6,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$6,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$6,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$6,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$6,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$6,
		ColorNeutral10: ColorNeutral10$6,
		ColorNeutral20: ColorNeutral20$6,
		ColorNeutral30: ColorNeutral30$6,
		ColorNeutral00: ColorNeutral00$6,
		ColorNeutralInverse10: ColorNeutralInverse10$6,
		ColorNeutralInverse20: ColorNeutralInverse20$6,
		ColorNeutralInverse30: ColorNeutralInverse30$6,
		ColorNeutralInverse00: ColorNeutralInverse00$6,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$6,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$6,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$6,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$6,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$6,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$6,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$6,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$6,
		ColorPaletteBlack: ColorPaletteBlack$6,
		ColorPaletteWhite: ColorPaletteWhite$6,
		ColorPaletteGray10: ColorPaletteGray10$6,
		ColorPaletteGray20: ColorPaletteGray20$6,
		ColorPaletteGray30: ColorPaletteGray30$6,
		ColorPaletteGray40: ColorPaletteGray40$6,
		ColorPaletteGray50: ColorPaletteGray50$6,
		ColorPaletteGray60: ColorPaletteGray60$6,
		ColorPaletteGray70: ColorPaletteGray70$6,
		ColorPaletteGray80: ColorPaletteGray80$6,
		ColorPaletteGray90: ColorPaletteGray90$6,
		ColorPaletteGray100: ColorPaletteGray100$6,
		ColorPaletteGray110: ColorPaletteGray110$6,
		ColorPaletteGray120: ColorPaletteGray120$6,
		ColorPaletteGray130: ColorPaletteGray130$6,
		ColorPaletteGray140: ColorPaletteGray140$6,
		ColorPaletteGray150: ColorPaletteGray150$6,
		ColorPaletteGray160: ColorPaletteGray160$6,
		ColorPaletteRed10: ColorPaletteRed10$6,
		ColorPaletteRed20: ColorPaletteRed20$6,
		ColorPaletteRed30: ColorPaletteRed30$6,
		ColorPaletteRed40: ColorPaletteRed40$6,
		ColorPaletteRed50: ColorPaletteRed50$6,
		ColorPaletteRed60: ColorPaletteRed60$6,
		ColorPaletteRed70: ColorPaletteRed70$6,
		ColorPaletteRed80: ColorPaletteRed80$6,
		ColorPaletteRed90: ColorPaletteRed90$6,
		ColorPaletteRed100: ColorPaletteRed100$6,
		ColorPaletteRed110: ColorPaletteRed110$6,
		ColorPaletteRed120: ColorPaletteRed120$6,
		ColorPaletteRed130: ColorPaletteRed130$6,
		ColorPaletteRed140: ColorPaletteRed140$6,
		ColorPaletteRed150: ColorPaletteRed150$6,
		ColorPaletteRed160: ColorPaletteRed160$6,
		ColorPaletteYellow10: ColorPaletteYellow10$6,
		ColorPaletteYellow20: ColorPaletteYellow20$6,
		ColorPaletteYellow30: ColorPaletteYellow30$6,
		ColorPaletteYellow40: ColorPaletteYellow40$6,
		ColorPaletteYellow50: ColorPaletteYellow50$6,
		ColorPaletteYellow60: ColorPaletteYellow60$6,
		ColorPaletteYellow70: ColorPaletteYellow70$6,
		ColorPaletteYellow80: ColorPaletteYellow80$6,
		ColorPaletteYellow90: ColorPaletteYellow90$6,
		ColorPaletteYellow100: ColorPaletteYellow100$6,
		ColorPaletteYellow110: ColorPaletteYellow110$6,
		ColorPaletteYellow120: ColorPaletteYellow120$6,
		ColorPaletteYellow130: ColorPaletteYellow130$6,
		ColorPaletteYellow140: ColorPaletteYellow140$6,
		ColorPaletteYellow150: ColorPaletteYellow150$6,
		ColorPaletteYellow160: ColorPaletteYellow160$6,
		ColorPaletteLime10: ColorPaletteLime10$6,
		ColorPaletteLime20: ColorPaletteLime20$6,
		ColorPaletteLime30: ColorPaletteLime30$6,
		ColorPaletteLime40: ColorPaletteLime40$6,
		ColorPaletteLime50: ColorPaletteLime50$6,
		ColorPaletteLime60: ColorPaletteLime60$6,
		ColorPaletteLime70: ColorPaletteLime70$6,
		ColorPaletteLime80: ColorPaletteLime80$6,
		ColorPaletteLime90: ColorPaletteLime90$6,
		ColorPaletteLime100: ColorPaletteLime100$6,
		ColorPaletteLime110: ColorPaletteLime110$6,
		ColorPaletteLime120: ColorPaletteLime120$6,
		ColorPaletteLime130: ColorPaletteLime130$6,
		ColorPaletteLime140: ColorPaletteLime140$6,
		ColorPaletteLime150: ColorPaletteLime150$6,
		ColorPaletteLime160: ColorPaletteLime160$6,
		ColorPaletteGreen10: ColorPaletteGreen10$6,
		ColorPaletteGreen20: ColorPaletteGreen20$6,
		ColorPaletteGreen30: ColorPaletteGreen30$6,
		ColorPaletteGreen40: ColorPaletteGreen40$6,
		ColorPaletteGreen50: ColorPaletteGreen50$6,
		ColorPaletteGreen60: ColorPaletteGreen60$6,
		ColorPaletteGreen70: ColorPaletteGreen70$6,
		ColorPaletteGreen80: ColorPaletteGreen80$6,
		ColorPaletteGreen90: ColorPaletteGreen90$6,
		ColorPaletteGreen100: ColorPaletteGreen100$6,
		ColorPaletteGreen110: ColorPaletteGreen110$6,
		ColorPaletteGreen120: ColorPaletteGreen120$6,
		ColorPaletteGreen130: ColorPaletteGreen130$6,
		ColorPaletteGreen140: ColorPaletteGreen140$6,
		ColorPaletteGreen150: ColorPaletteGreen150$6,
		ColorPaletteGreen160: ColorPaletteGreen160$6,
		ColorPaletteAcqua10: ColorPaletteAcqua10$6,
		ColorPaletteAcqua20: ColorPaletteAcqua20$6,
		ColorPaletteAcqua30: ColorPaletteAcqua30$6,
		ColorPaletteAcqua40: ColorPaletteAcqua40$6,
		ColorPaletteAcqua50: ColorPaletteAcqua50$6,
		ColorPaletteAcqua60: ColorPaletteAcqua60$6,
		ColorPaletteAcqua70: ColorPaletteAcqua70$6,
		ColorPaletteAcqua80: ColorPaletteAcqua80$6,
		ColorPaletteAcqua90: ColorPaletteAcqua90$6,
		ColorPaletteAcqua100: ColorPaletteAcqua100$6,
		ColorPaletteAcqua110: ColorPaletteAcqua110$6,
		ColorPaletteAcqua120: ColorPaletteAcqua120$6,
		ColorPaletteAcqua130: ColorPaletteAcqua130$6,
		ColorPaletteAcqua140: ColorPaletteAcqua140$6,
		ColorPaletteAcqua150: ColorPaletteAcqua150$6,
		ColorPaletteAcqua160: ColorPaletteAcqua160$6,
		ColorPaletteBlue10: ColorPaletteBlue10$6,
		ColorPaletteBlue20: ColorPaletteBlue20$6,
		ColorPaletteBlue30: ColorPaletteBlue30$6,
		ColorPaletteBlue40: ColorPaletteBlue40$6,
		ColorPaletteBlue50: ColorPaletteBlue50$6,
		ColorPaletteBlue60: ColorPaletteBlue60$6,
		ColorPaletteBlue70: ColorPaletteBlue70$6,
		ColorPaletteBlue80: ColorPaletteBlue80$6,
		ColorPaletteBlue90: ColorPaletteBlue90$6,
		ColorPaletteBlue100: ColorPaletteBlue100$6,
		ColorPaletteBlue110: ColorPaletteBlue110$6,
		ColorPaletteBlue120: ColorPaletteBlue120$6,
		ColorPaletteBlue130: ColorPaletteBlue130$6,
		ColorPaletteBlue140: ColorPaletteBlue140$6,
		ColorPaletteBlue150: ColorPaletteBlue150$6,
		ColorPaletteBlue160: ColorPaletteBlue160$6,
		ColorPalettePurple10: ColorPalettePurple10$6,
		ColorPalettePurple20: ColorPalettePurple20$6,
		ColorPalettePurple30: ColorPalettePurple30$6,
		ColorPalettePurple40: ColorPalettePurple40$6,
		ColorPalettePurple50: ColorPalettePurple50$6,
		ColorPalettePurple60: ColorPalettePurple60$6,
		ColorPalettePurple70: ColorPalettePurple70$6,
		ColorPalettePurple80: ColorPalettePurple80$6,
		ColorPalettePurple90: ColorPalettePurple90$6,
		ColorPalettePurple100: ColorPalettePurple100$6,
		ColorPalettePurple110: ColorPalettePurple110$6,
		ColorPalettePurple120: ColorPalettePurple120$6,
		ColorPalettePurple130: ColorPalettePurple130$6,
		ColorPalettePurple140: ColorPalettePurple140$6,
		ColorPalettePurple150: ColorPalettePurple150$6,
		ColorPalettePurple160: ColorPalettePurple160$6,
		ColorPalettePink10: ColorPalettePink10$6,
		ColorPalettePink20: ColorPalettePink20$6,
		ColorPalettePink30: ColorPalettePink30$6,
		ColorPalettePink40: ColorPalettePink40$6,
		ColorPalettePink50: ColorPalettePink50$6,
		ColorPalettePink60: ColorPalettePink60$6,
		ColorPalettePink70: ColorPalettePink70$6,
		ColorPalettePink80: ColorPalettePink80$6,
		ColorPalettePink90: ColorPalettePink90$6,
		ColorPalettePink100: ColorPalettePink100$6,
		ColorPalettePink110: ColorPalettePink110$6,
		ColorPalettePink120: ColorPalettePink120$6,
		ColorPalettePink130: ColorPalettePink130$6,
		ColorPalettePink140: ColorPalettePink140$6,
		ColorPalettePink150: ColorPalettePink150$6,
		ColorPalettePink160: ColorPalettePink160$6,
		ColorTypefaceStrong: ColorTypefaceStrong$6,
		ColorTypefacePure: ColorTypefacePure$6,
		ColorTypefaceSmooth: ColorTypefaceSmooth$6,
		ColorTypefaceMeld: ColorTypefaceMeld$6,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$6,
		ColorTypefaceInversePure: ColorTypefaceInversePure$6,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$6,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$6,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$6,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$6,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$6,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$6,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$6,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$6,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$6,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$6,
		ColorBrandPrimary10: ColorBrandPrimary10$6,
		ColorBrandPrimary20: ColorBrandPrimary20$6,
		ColorBrandPrimary30: ColorBrandPrimary30$6,
		ColorBrandPrimary40: ColorBrandPrimary40$6,
		ColorBrandPrimary50: ColorBrandPrimary50$6,
		ColorBrandPrimary60: ColorBrandPrimary60$6,
		ColorBrandPrimary70: ColorBrandPrimary70$6,
		ColorBrandPrimary80: ColorBrandPrimary80$6,
		ColorBrandPrimary90: ColorBrandPrimary90$6,
		ColorBrandPrimary100: ColorBrandPrimary100$6,
		ColorBrandPrimary110: ColorBrandPrimary110$6,
		ColorBrandPrimary120: ColorBrandPrimary120$6,
		ColorBrandPrimary130: ColorBrandPrimary130$6,
		ColorBrandPrimary140: ColorBrandPrimary140$6,
		ColorBrandPrimary150: ColorBrandPrimary150$6,
		ColorBrandPrimary160: ColorBrandPrimary160$6,
		ColorBrandBase01: ColorBrandBase01$6,
		ColorBrandBase02: ColorBrandBase02$6,
		ColorBrandBase03: ColorBrandBase03$5,
		ColorBrandBase04: ColorBrandBase04$5,
		ColorBrandBase05: ColorBrandBase05$5,
		ColorBrandBase06: ColorBrandBase06$4,
		ColorBrandPalette0110: ColorBrandPalette0110$6,
		ColorBrandPalette0120: ColorBrandPalette0120$6,
		ColorBrandPalette0130: ColorBrandPalette0130$6,
		ColorBrandPalette0140: ColorBrandPalette0140$6,
		ColorBrandPalette0150: ColorBrandPalette0150$6,
		ColorBrandPalette0160: ColorBrandPalette0160$6,
		ColorBrandPalette0170: ColorBrandPalette0170$6,
		ColorBrandPalette0180: ColorBrandPalette0180$6,
		ColorBrandPalette0190: ColorBrandPalette0190$6,
		ColorBrandPalette01100: ColorBrandPalette01100$6,
		ColorBrandPalette01110: ColorBrandPalette01110$6,
		ColorBrandPalette01120: ColorBrandPalette01120$6,
		ColorBrandPalette01130: ColorBrandPalette01130$6,
		ColorBrandPalette01140: ColorBrandPalette01140$6,
		ColorBrandPalette01150: ColorBrandPalette01150$6,
		ColorBrandPalette01160: ColorBrandPalette01160$6,
		ColorBrandPalette0210: ColorBrandPalette0210$6,
		ColorBrandPalette0220: ColorBrandPalette0220$6,
		ColorBrandPalette0230: ColorBrandPalette0230$6,
		ColorBrandPalette0240: ColorBrandPalette0240$6,
		ColorBrandPalette0250: ColorBrandPalette0250$6,
		ColorBrandPalette0260: ColorBrandPalette0260$6,
		ColorBrandPalette0270: ColorBrandPalette0270$6,
		ColorBrandPalette0280: ColorBrandPalette0280$6,
		ColorBrandPalette0290: ColorBrandPalette0290$6,
		ColorBrandPalette02100: ColorBrandPalette02100$6,
		ColorBrandPalette02110: ColorBrandPalette02110$6,
		ColorBrandPalette02120: ColorBrandPalette02120$6,
		ColorBrandPalette02130: ColorBrandPalette02130$6,
		ColorBrandPalette02140: ColorBrandPalette02140$6,
		ColorBrandPalette02150: ColorBrandPalette02150$6,
		ColorBrandPalette02160: ColorBrandPalette02160$6,
		ColorBrandPalette0310: ColorBrandPalette0310$4,
		ColorBrandPalette0320: ColorBrandPalette0320$4,
		ColorBrandPalette0330: ColorBrandPalette0330$4,
		ColorBrandPalette0340: ColorBrandPalette0340$4,
		ColorBrandPalette0350: ColorBrandPalette0350$4,
		ColorBrandPalette0360: ColorBrandPalette0360$4,
		ColorBrandPalette0370: ColorBrandPalette0370$4,
		ColorBrandPalette0380: ColorBrandPalette0380$4,
		ColorBrandPalette0390: ColorBrandPalette0390$4,
		ColorBrandPalette03100: ColorBrandPalette03100$4,
		ColorBrandPalette03110: ColorBrandPalette03110$4,
		ColorBrandPalette03120: ColorBrandPalette03120$4,
		ColorBrandPalette03130: ColorBrandPalette03130$4,
		ColorBrandPalette03140: ColorBrandPalette03140$4,
		ColorBrandPalette03150: ColorBrandPalette03150$4,
		ColorBrandPalette03160: ColorBrandPalette03160$4,
		ColorBrandPalette0410: ColorBrandPalette0410$5,
		ColorBrandPalette0420: ColorBrandPalette0420$5,
		ColorBrandPalette0430: ColorBrandPalette0430$5,
		ColorBrandPalette0440: ColorBrandPalette0440$5,
		ColorBrandPalette0450: ColorBrandPalette0450$5,
		ColorBrandPalette0460: ColorBrandPalette0460$5,
		ColorBrandPalette0470: ColorBrandPalette0470$5,
		ColorBrandPalette0480: ColorBrandPalette0480$5,
		ColorBrandPalette0490: ColorBrandPalette0490$5,
		ColorBrandPalette04100: ColorBrandPalette04100$5,
		ColorBrandPalette04110: ColorBrandPalette04110$5,
		ColorBrandPalette04120: ColorBrandPalette04120$5,
		ColorBrandPalette04130: ColorBrandPalette04130$5,
		ColorBrandPalette04140: ColorBrandPalette04140$5,
		ColorBrandPalette04150: ColorBrandPalette04150$5,
		ColorBrandPalette04160: ColorBrandPalette04160$5,
		ColorBrandPalette0510: ColorBrandPalette0510$4,
		ColorBrandPalette0520: ColorBrandPalette0520$4,
		ColorBrandPalette0530: ColorBrandPalette0530$4,
		ColorBrandPalette0540: ColorBrandPalette0540$4,
		ColorBrandPalette0550: ColorBrandPalette0550$4,
		ColorBrandPalette0560: ColorBrandPalette0560$4,
		ColorBrandPalette0570: ColorBrandPalette0570$4,
		ColorBrandPalette0580: ColorBrandPalette0580$4,
		ColorBrandPalette0590: ColorBrandPalette0590$4,
		ColorBrandPalette05100: ColorBrandPalette05100$4,
		ColorBrandPalette05110: ColorBrandPalette05110$4,
		ColorBrandPalette05120: ColorBrandPalette05120$4,
		ColorBrandPalette05130: ColorBrandPalette05130$4,
		ColorBrandPalette05140: ColorBrandPalette05140$4,
		ColorBrandPalette05150: ColorBrandPalette05150$4,
		ColorBrandPalette05160: ColorBrandPalette05160$4,
		ColorBrandPalette0610: ColorBrandPalette0610$4,
		ColorBrandPalette0620: ColorBrandPalette0620$4,
		ColorBrandPalette0630: ColorBrandPalette0630$4,
		ColorBrandPalette0640: ColorBrandPalette0640$4,
		ColorBrandPalette0650: ColorBrandPalette0650$4,
		ColorBrandPalette0660: ColorBrandPalette0660$4,
		ColorBrandPalette0670: ColorBrandPalette0670$4,
		ColorBrandPalette0680: ColorBrandPalette0680$4,
		ColorBrandPalette0690: ColorBrandPalette0690$4,
		ColorBrandPalette06100: ColorBrandPalette06100$4,
		ColorBrandPalette06110: ColorBrandPalette06110$4,
		ColorBrandPalette06120: ColorBrandPalette06120$4,
		ColorBrandPalette06130: ColorBrandPalette06130$4,
		ColorBrandPalette06140: ColorBrandPalette06140$4,
		ColorBrandPalette06150: ColorBrandPalette06150$4,
		ColorBrandPalette06160: ColorBrandPalette06160$4,
		ColorFeedbackErrorText: ColorFeedbackErrorText$6,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$6,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$6,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$6,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$6,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$6,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$6,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$6,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$6,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$6,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$6,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$6,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$6,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$6,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$6,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$6,
		ColorSupport01: ColorSupport01$6,
		ColorSupport02: ColorSupport02$6,
		ColorSupportOnBrand01: ColorSupportOnBrand01$6,
		ColorSupportOnBrand02: ColorSupportOnBrand02$6,
		ColorSupportInverse01: ColorSupportInverse01$6,
		ColorSupportInverse02: ColorSupportInverse02$6,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$6,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$6,
		Opacity01: Opacity01$6,
		Opacity02: Opacity02$6,
		Opacity03: Opacity03$6,
		Opacity04: Opacity04$6,
		Opacity05: Opacity05$6,
		Opacity06: Opacity06$6,
		Opacity07: Opacity07$6,
		Opacity08: Opacity08$6,
		Opacity09: Opacity09$6,
		Shadow01: Shadow01$6,
		Shadow02: Shadow02$6,
		Shadow03: Shadow03$6,
		Shadow04: Shadow04$6,
		SpacingInlineQuark: SpacingInlineQuark$6,
		SpacingInlineNano: SpacingInlineNano$6,
		SpacingInlineXxxs: SpacingInlineXxxs$6,
		SpacingInlineXxs: SpacingInlineXxs$6,
		SpacingInlineXs: SpacingInlineXs$6,
		SpacingInlineSm: SpacingInlineSm$6,
		SpacingInlineMd: SpacingInlineMd$6,
		SpacingInlineLg: SpacingInlineLg$6,
		SpacingInlineXl: SpacingInlineXl$6,
		SpacingInlineXxl: SpacingInlineXxl$6,
		SpacingInlineXxxl: SpacingInlineXxxl$6,
		SpacingInlineHuge: SpacingInlineHuge$6,
		SpacingInlineGiant: SpacingInlineGiant$6,
		SpacingInsetQuark: SpacingInsetQuark$6,
		SpacingInsetNano: SpacingInsetNano$6,
		SpacingInsetXs: SpacingInsetXs$6,
		SpacingInsetSm: SpacingInsetSm$6,
		SpacingInsetMd: SpacingInsetMd$6,
		SpacingInsetLg: SpacingInsetLg$6,
		SpacingSquishQuark: SpacingSquishQuark$6,
		SpacingSquishNano: SpacingSquishNano$6,
		SpacingSquishXs: SpacingSquishXs$6,
		SpacingSquishSm: SpacingSquishSm$6,
		SpacingStackQuark: SpacingStackQuark$6,
		SpacingStackNano: SpacingStackNano$6,
		SpacingStackXxxs: SpacingStackXxxs$6,
		SpacingStackXxs: SpacingStackXxs$6,
		SpacingStackXs: SpacingStackXs$6,
		SpacingStackSm: SpacingStackSm$6,
		SpacingStackMd: SpacingStackMd$6,
		SpacingStackLg: SpacingStackLg$6,
		SpacingStackXl: SpacingStackXl$6,
		SpacingStackXxl: SpacingStackXxl$6,
		SpacingStackXxxl: SpacingStackXxxl$6,
		SpacingStackHuge: SpacingStackHuge$6,
		SpacingStackGiant: SpacingStackGiant$6,
		FontFamilyBase: FontFamilyBase$6,
		FontSizeXxxs: FontSizeXxxs$6,
		FontSizeXxs: FontSizeXxs$6,
		FontSizeXs: FontSizeXs$6,
		FontSizeSm: FontSizeSm$6,
		FontSizeMd: FontSizeMd$6,
		FontSizeLg: FontSizeLg$6,
		FontSizeXl: FontSizeXl$6,
		FontSizeXxl: FontSizeXxl$6,
		FontSizeXxxl: FontSizeXxxl$6,
		FontSizeDisplay: FontSizeDisplay$6,
		FontSizeGiant: FontSizeGiant$6,
		FontWeightBold: FontWeightBold$6,
		FontWeightSemibold: FontWeightSemibold$6,
		FontWeightMedium: FontWeightMedium$6,
		FontWeightRegular: FontWeightRegular$6,
		FontWeightLight: FontWeightLight$6,
		LetterSpacingStandard: LetterSpacingStandard$6,
		LetterSpacingSmall: LetterSpacingSmall$6,
		LetterSpacingMedium: LetterSpacingMedium$6,
		LineHeightStandard: LineHeightStandard$6,
		LineHeightTiny: LineHeightTiny$6,
		LineHeightMedium: LineHeightMedium$6,
		LineHeightLarge: LineHeightLarge$6,
		LineHeightDistant: LineHeightDistant$6,
		LineHeightSuperdistant: LineHeightSuperdistant$6,
		LineHeightHuge: LineHeightHuge$6,
		ZIndex0: ZIndex0$6,
		ZIndex100: ZIndex100$6,
		ZIndex200: ZIndex200$6,
		ZIndex300: ZIndex300$6,
		ZIndex400: ZIndex400$6,
		ZIndex500: ZIndex500$6,
		ZIndexAuto: ZIndexAuto$6,
		ZIndexTop: ZIndexTop$6,
		ZIndexBottom: ZIndexBottom$6
	});

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:01 GMT
	 */

	const BorderRadiusNone$5 = "0px";
	const BorderRadiusXs$5 = "4px";
	const BorderRadiusSm$5 = "8px";
	const BorderRadiusMd$5 = "16px";
	const BorderRadiusLg$5 = "24px";
	const BorderRadiusPill$5 = "960px";
	const BorderRadiusCircle$5 = "50%";
	const BorderWidthNone$5 = "0px";
	const BorderWidthHairline$5 = "1px";
	const BorderWidthThin$5 = "2px";
	const BorderWidthThick$5 = "4px";
	const BorderWidthHeavy$5 = "8px";
	const ColorDatavizInfoText$5 = "#0F58EA";
	const ColorDatavizInfoShape01$5 = "#3F7BF2";
	const ColorDatavizInfoShape02$5 = "#D9E5FC";
	const ColorDatavizInfoShape03$5 = "#F1F5FE";
	const ColorDatavizNegativeText$5 = "#BC293A";
	const ColorDatavizNegativeShape01$5 = "#EA4356";
	const ColorDatavizNegativeShape02$5 = "#FDDDE1";
	const ColorDatavizNegativeShape03$5 = "#FEF1F2";
	const ColorDatavizWarningText$5 = "#A04C03";
	const ColorDatavizWarningShape01$5 = "#D26404";
	const ColorDatavizWarningShape02$5 = "#FEE1C8";
	const ColorDatavizWarningShape03$5 = "#FEF1E6";
	const ColorDatavizPositiveText$5 = "#22723A";
	const ColorDatavizPositiveShape01$5 = "#2D954C";
	const ColorDatavizPositiveShape02$5 = "#C8EED3";
	const ColorDatavizPositiveShape03$5 = "#E8F8EC";
	const ColorDatavizCatAText$5 = "#9B18DC";
	const ColorDatavizCatAShape01$5 = "#B851EC";
	const ColorDatavizCatAShape02$5 = "#F2DFFB";
	const ColorDatavizCatAShape03$5 = "#F9F1FD";
	const ColorDatavizCatBText$5 = "#BA267B";
	const ColorDatavizCatBShape01$5 = "#DA499B";
	const ColorDatavizCatBShape02$5 = "#F8DDEC";
	const ColorDatavizCatBShape03$5 = "#FCF2F8";
	const ColorDatavizCatCText$5 = "#546E21";
	const ColorDatavizCatCShape01$5 = "#6C8D2B";
	const ColorDatavizCatCShape02$5 = "#DBEBBD";
	const ColorDatavizCatCShape03$5 = "#F0F7E4";
	const ColorDatavizCatDText$5 = "#0D735E";
	const ColorDatavizCatDShape01$5 = "#109379";
	const ColorDatavizCatDShape02$5 = "#BCF0E6";
	const ColorDatavizCatDShape03$5 = "#DFFBF6";
	const ColorDatavizInverseInfoText$5 = "#5C8FF5";
	const ColorDatavizInverseInfoShape01$5 = "#286BF1";
	const ColorDatavizInverseInfoShape02$5 = "#062560";
	const ColorDatavizInverseInfoShape03$5 = "#051B48";
	const ColorDatavizInverseNegativeText$5 = "#F55C6E";
	const ColorDatavizInverseNegativeShape01$5 = "#D83145";
	const ColorDatavizInverseNegativeShape02$5 = "#4F1119";
	const ColorDatavizInverseNegativeShape03$5 = "#3B0D12";
	const ColorDatavizInverseWarningText$5 = "#EB7005";
	const ColorDatavizInverseWarningShape01$5 = "#B95804";
	const ColorDatavizInverseWarningShape02$5 = "#462101";
	const ColorDatavizInverseWarningShape03$5 = "#321701";
	const ColorDatavizInversePositiveText$5 = "#32A454";
	const ColorDatavizInversePositiveShape01$5 = "#278142";
	const ColorDatavizInversePositiveShape02$5 = "#0E2F18";
	const ColorDatavizInversePositiveShape03$5 = "#0B2312";
	const ColorDatavizInverseCatAText$5 = "#C36CEF";
	const ColorDatavizInverseCatAShape01$5 = "#AD35E9";
	const ColorDatavizInverseCatAShape02$5 = "#440B60";
	const ColorDatavizInverseCatAShape03$5 = "#340849";
	const ColorDatavizInverseCatBText$5 = "#E067AB";
	const ColorDatavizInverseCatBShape01$5 = "#D42B8C";
	const ColorDatavizInverseCatBShape02$5 = "#4C1032";
	const ColorDatavizInverseCatBShape03$5 = "#3B0C27";
	const ColorDatavizInverseCatCText$5 = "#789D2F";
	const ColorDatavizInverseCatCShape01$5 = "#607E26";
	const ColorDatavizInverseCatCShape02$5 = "#212B0D";
	const ColorDatavizInverseCatCShape03$5 = "#1B230B";
	const ColorDatavizInverseCatDText$5 = "#12A588";
	const ColorDatavizInverseCatDShape01$5 = "#0F856D";
	const ColorDatavizInverseCatDShape02$5 = "#052E26";
	const ColorDatavizInverseCatDShape03$5 = "#04251E";
	const ColorInteractionBlend01$5 = "#1616160A";
	const ColorInteractionBlend02$5 = "#16161614";
	const ColorInteractionBlend03$5 = "#1616161F";
	const ColorInteractionBlend04$5 = "#1616163D";
	const ColorInteractionBlend05$5 = "#161616A3";
	const ColorInteractionBlend06$5 = "#161616B8";
	const ColorInteractionBlend07$5 = "#161616E0";
	const ColorInteractionBlend08$5 = "#161616";
	const ColorInteractionInverseBlend01$5 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$5 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$5 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$5 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$5 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$5 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$5 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$5 = "#FEFEFE";
	const ColorInteractionInverseAccent01$5 = "#6B8BFF";
	const ColorInteractionInverseAccent02$5 = "#809BFF";
	const ColorInteractionInverseAccent03$5 = "#99AFFF";
	const ColorInteractionInverseSubtle01$5 = "#5277FF1F";
	const ColorInteractionInverseSubtle02$5 = "#5277FF3D";
	const ColorInteractionInverseSubtle03$5 = "#5277FF52";
	const ColorInteractionInverseSelectDefault$5 = "#919191";
	const ColorInteractionInverseSelectFocus$5 = "#D4D4D4";
	const ColorInteractionInverseSelectActive$5 = "#F57A99";
	const ColorInteractionInverseDanger01$5 = "#F55C6E";
	const ColorInteractionInverseDanger02$5 = "#F77E8C";
	const ColorInteractionInverseDanger03$5 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01$5 = "#000E40";
	const ColorInteractionInverseOnBrandAccent02$5 = "#001A7A";
	const ColorInteractionInverseOnBrandAccent03$5 = "#00229E";
	const ColorInteractionInverseOnBrandSubtle01$5 = "#002FDB14";
	const ColorInteractionInverseOnBrandSubtle02$5 = "#002FDB1F";
	const ColorInteractionInverseOnBrandSubtle03$5 = "#002FDB3D";
	const ColorInteractionInverseOnBrandSelectDefault$5 = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus$5 = "#4C4C4C";
	const ColorInteractionInverseOnBrandSelectActive$5 = "#6D0821";
	const ColorInteractionInverseOnBrandBlend01$5 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$5 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$5 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$5 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$5 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$5 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$5 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$5 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$5 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02$5 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03$5 = "#7E1B27";
	const ColorInteractionAccent01$5 = "#000E40";
	const ColorInteractionAccent02$5 = "#001A7A";
	const ColorInteractionAccent03$5 = "#00229E";
	const ColorInteractionSubtle01$5 = "#0029BD1F";
	const ColorInteractionSubtle02$5 = "#0029BD3D";
	const ColorInteractionSubtle03$5 = "#0029BD52";
	const ColorInteractionSelectDefault$5 = "#666666";
	const ColorInteractionSelectFocus$5 = "#4C4C4C";
	const ColorInteractionSelectActive$5 = "#6D0821";
	const ColorInteractionDanger01$5 = "#BC293A";
	const ColorInteractionDanger02$5 = "#A72534";
	const ColorInteractionDanger03$5 = "#92202E";
	const ColorInteractionOnBrandAccent01$5 = "#ADBFFF";
	const ColorInteractionOnBrandAccent02$5 = "#99AFFF";
	const ColorInteractionOnBrandAccent03$5 = "#809BFF";
	const ColorInteractionOnBrandSubtle01$5 = "#5277FF1F";
	const ColorInteractionOnBrandSubtle02$5 = "#5277FF3D";
	const ColorInteractionOnBrandSubtle03$5 = "#5277FF52";
	const ColorInteractionOnBrandSelectDefault$5 = "#B0B0B0";
	const ColorInteractionOnBrandSelectFocus$5 = "#D4D4D4";
	const ColorInteractionOnBrandSelectActive$5 = "#F57A99";
	const ColorInteractionOnBrandBlend01$5 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$5 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$5 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$5 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$5 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$5 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$5 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$5 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$5 = "#F77E8C";
	const ColorInteractionOnBrandDanger02$5 = "#F895A1";
	const ColorInteractionOnBrandDanger03$5 = "#FAAEB6";
	const ColorNeutral10$5 = "#F5F5F5";
	const ColorNeutral20$5 = "#E6E6E6";
	const ColorNeutral30$5 = "#1616163D";
	const ColorNeutral00$5 = "#FEFEFE";
	const ColorNeutralInverse10$5 = "#1F1F1F";
	const ColorNeutralInverse20$5 = "#292929";
	const ColorNeutralInverse30$5 = "#FEFEFE3D";
	const ColorNeutralInverse00$5 = "#161616";
	const ColorNeutralInverseOnBrand10$5 = "#DBE3FF";
	const ColorNeutralInverseOnBrand20$5 = "#C7D3FF";
	const ColorNeutralInverseOnBrand30$5 = "#0029BD52";
	const ColorNeutralInverseOnBrand00$5 = "#F0F3FF";
	const ColorNeutralOnBrand10$5 = "#001A7A";
	const ColorNeutralOnBrand20$5 = "#00229E";
	const ColorNeutralOnBrand30$5 = "#5277FFA3";
	const ColorNeutralOnBrand00$5 = "#000E40";
	const ColorPaletteBlack$5 = "#161616";
	const ColorPaletteWhite$5 = "#FEFEFE";
	const ColorPaletteGray10$5 = "#1F1F1F";
	const ColorPaletteGray20$5 = "#292929";
	const ColorPaletteGray30$5 = "#363636";
	const ColorPaletteGray40$5 = "#404040";
	const ColorPaletteGray50$5 = "#4C4C4C";
	const ColorPaletteGray60$5 = "#595959";
	const ColorPaletteGray70$5 = "#666666";
	const ColorPaletteGray80$5 = "#737373";
	const ColorPaletteGray90$5 = "#828282";
	const ColorPaletteGray100$5 = "#919191";
	const ColorPaletteGray110$5 = "#A1A1A1";
	const ColorPaletteGray120$5 = "#B0B0B0";
	const ColorPaletteGray130$5 = "#C2C2C2";
	const ColorPaletteGray140$5 = "#D4D4D4";
	const ColorPaletteGray150$5 = "#E6E6E6";
	const ColorPaletteGray160$5 = "#F5F5F5";
	const ColorPaletteRed10$5 = "#3B0D12";
	const ColorPaletteRed20$5 = "#4F1119";
	const ColorPaletteRed30$5 = "#691721";
	const ColorPaletteRed40$5 = "#7E1B27";
	const ColorPaletteRed50$5 = "#92202E";
	const ColorPaletteRed60$5 = "#A72534";
	const ColorPaletteRed70$5 = "#BC293A";
	const ColorPaletteRed80$5 = "#D83145";
	const ColorPaletteRed90$5 = "#EA4356";
	const ColorPaletteRed100$5 = "#F55C6E";
	const ColorPaletteRed110$5 = "#F77E8C";
	const ColorPaletteRed120$5 = "#F895A1";
	const ColorPaletteRed130$5 = "#FAAEB6";
	const ColorPaletteRed140$5 = "#FBC5CC";
	const ColorPaletteRed150$5 = "#FDDDE1";
	const ColorPaletteRed160$5 = "#FEF1F2";
	const ColorPaletteYellow10$5 = "#321701";
	const ColorPaletteYellow20$5 = "#462101";
	const ColorPaletteYellow30$5 = "#552802";
	const ColorPaletteYellow40$5 = "#693102";
	const ColorPaletteYellow50$5 = "#7D3B03";
	const ColorPaletteYellow60$5 = "#914503";
	const ColorPaletteYellow70$5 = "#A04C03";
	const ColorPaletteYellow80$5 = "#B95804";
	const ColorPaletteYellow90$5 = "#D26404";
	const ColorPaletteYellow100$5 = "#EB7005";
	const ColorPaletteYellow110$5 = "#FA8219";
	const ColorPaletteYellow120$5 = "#FB9B46";
	const ColorPaletteYellow130$5 = "#FCB06E";
	const ColorPaletteYellow140$5 = "#FDC99B";
	const ColorPaletteYellow150$5 = "#FEE1C8";
	const ColorPaletteYellow160$5 = "#FEF1E6";
	const ColorPaletteLime10$5 = "#1B230B";
	const ColorPaletteLime20$5 = "#212B0D";
	const ColorPaletteLime30$5 = "#2D3B12";
	const ColorPaletteLime40$5 = "#364616";
	const ColorPaletteLime50$5 = "#3F5219";
	const ColorPaletteLime60$5 = "#485E1D";
	const ColorPaletteLime70$5 = "#546E21";
	const ColorPaletteLime80$5 = "#607E26";
	const ColorPaletteLime90$5 = "#6C8D2B";
	const ColorPaletteLime100$5 = "#789D2F";
	const ColorPaletteLime110$5 = "#84AC34";
	const ColorPaletteLime120$5 = "#93BF3A";
	const ColorPaletteLime130$5 = "#A9CF5E";
	const ColorPaletteLime140$5 = "#C2DD8D";
	const ColorPaletteLime150$5 = "#DBEBBD";
	const ColorPaletteLime160$5 = "#F0F7E4";
	const ColorPaletteGreen10$5 = "#0B2312";
	const ColorPaletteGreen20$5 = "#0E2F18";
	const ColorPaletteGreen30$5 = "#133E20";
	const ColorPaletteGreen40$5 = "#174A26";
	const ColorPaletteGreen50$5 = "#1A562C";
	const ColorPaletteGreen60$5 = "#1F6634";
	const ColorPaletteGreen70$5 = "#22723A";
	const ColorPaletteGreen80$5 = "#278142";
	const ColorPaletteGreen90$5 = "#2D954C";
	const ColorPaletteGreen100$5 = "#32A454";
	const ColorPaletteGreen110$5 = "#38B85E";
	const ColorPaletteGreen120$5 = "#4BC870";
	const ColorPaletteGreen130$5 = "#76D692";
	const ColorPaletteGreen140$5 = "#9DE2B1";
	const ColorPaletteGreen150$5 = "#C8EED3";
	const ColorPaletteGreen160$5 = "#E8F8EC";
	const ColorPaletteAcqua10$5 = "#04251E";
	const ColorPaletteAcqua20$5 = "#052E26";
	const ColorPaletteAcqua30$5 = "#073C31";
	const ColorPaletteAcqua40$5 = "#08493C";
	const ColorPaletteAcqua50$5 = "#0A5748";
	const ColorPaletteAcqua60$5 = "#0B6553";
	const ColorPaletteAcqua70$5 = "#0D735E";
	const ColorPaletteAcqua80$5 = "#0F856D";
	const ColorPaletteAcqua90$5 = "#109379";
	const ColorPaletteAcqua100$5 = "#12A588";
	const ColorPaletteAcqua110$5 = "#14B897";
	const ColorPaletteAcqua120$5 = "#31C4A6";
	const ColorPaletteAcqua130$5 = "#68D4BF";
	const ColorPaletteAcqua140$5 = "#8DE2D1";
	const ColorPaletteAcqua150$5 = "#BCF0E6";
	const ColorPaletteAcqua160$5 = "#DFFBF6";
	const ColorPaletteBlue10$5 = "#051B48";
	const ColorPaletteBlue20$5 = "#062560";
	const ColorPaletteBlue30$5 = "#082F7D";
	const ColorPaletteBlue40$5 = "#0A3A9A";
	const ColorPaletteBlue50$5 = "#0B43B1";
	const ColorPaletteBlue60$5 = "#0D4ECE";
	const ColorPaletteBlue70$5 = "#0F58EA";
	const ColorPaletteBlue80$5 = "#286BF1";
	const ColorPaletteBlue90$5 = "#3F7BF2";
	const ColorPaletteBlue100$5 = "#5C8FF5";
	const ColorPaletteBlue110$5 = "#73A0F7";
	const ColorPaletteBlue120$5 = "#8CB0F8";
	const ColorPaletteBlue130$5 = "#A9C4F9";
	const ColorPaletteBlue140$5 = "#C1D4FB";
	const ColorPaletteBlue150$5 = "#D9E5FC";
	const ColorPaletteBlue160$5 = "#F1F5FE";
	const ColorPalettePurple10$5 = "#340849";
	const ColorPalettePurple20$5 = "#440B60";
	const ColorPalettePurple30$5 = "#540D78";
	const ColorPalettePurple40$5 = "#671093";
	const ColorPalettePurple50$5 = "#7713AA";
	const ColorPalettePurple60$5 = "#8B16C5";
	const ColorPalettePurple70$5 = "#9B18DC";
	const ColorPalettePurple80$5 = "#AD35E9";
	const ColorPalettePurple90$5 = "#B851EC";
	const ColorPalettePurple100$5 = "#C36CEF";
	const ColorPalettePurple110$5 = "#CC83F1";
	const ColorPalettePurple120$5 = "#D69AF4";
	const ColorPalettePurple130$5 = "#DFB1F6";
	const ColorPalettePurple140$5 = "#E8C8F9";
	const ColorPalettePurple150$5 = "#F2DFFB";
	const ColorPalettePurple160$5 = "#F9F1FD";
	const ColorPalettePink10$5 = "#3B0C27";
	const ColorPalettePink20$5 = "#4C1032";
	const ColorPalettePink30$5 = "#661543";
	const ColorPalettePink40$5 = "#77184E";
	const ColorPalettePink50$5 = "#8C1C5D";
	const ColorPalettePink60$5 = "#A12169";
	const ColorPalettePink70$5 = "#BA267B";
	const ColorPalettePink80$5 = "#D42B8C";
	const ColorPalettePink90$5 = "#DA499B";
	const ColorPalettePink100$5 = "#E067AB";
	const ColorPalettePink110$5 = "#E580B9";
	const ColorPalettePink120$5 = "#EA99C7";
	const ColorPalettePink130$5 = "#EFAFD3";
	const ColorPalettePink140$5 = "#F4C8E1";
	const ColorPalettePink150$5 = "#F8DDEC";
	const ColorPalettePink160$5 = "#FCF2F8";
	const ColorTypefaceStrong$5 = "#161616";
	const ColorTypefacePure$5 = "#363636";
	const ColorTypefaceSmooth$5 = "#666666";
	const ColorTypefaceMeld$5 = "#1616163D";
	const ColorTypefaceInverseStrong$5 = "#FEFEFE";
	const ColorTypefaceInversePure$5 = "#D4D4D4";
	const ColorTypefaceInverseSmooth$5 = "#919191";
	const ColorTypefaceInverseMeld$5 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$5 = "#161616";
	const ColorTypefaceInverseOnBrandPure$5 = "#363636";
	const ColorTypefaceInverseOnBrandSmooth$5 = "#595959";
	const ColorTypefaceInverseOnBrandMeld$5 = "#1616163D";
	const ColorTypefaceOnBrandStrong$5 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$5 = "#DBE3FF";
	const ColorTypefaceOnBrandSmooth$5 = "#C7D3FF";
	const ColorTypefaceOnBrandMeld$5 = "#FEFEFE52";
	const ColorBrandPrimary10$5 = "#000E40";
	const ColorBrandPrimary20$5 = "#001A7A";
	const ColorBrandPrimary30$5 = "#00229E";
	const ColorBrandPrimary40$5 = "#0029BD";
	const ColorBrandPrimary50$5 = "#002FDB";
	const ColorBrandPrimary60$5 = "#0037FF";
	const ColorBrandPrimary70$5 = "#1F4FFF";
	const ColorBrandPrimary80$5 = "#3863FF";
	const ColorBrandPrimary90$5 = "#5277FF";
	const ColorBrandPrimary100$5 = "#6B8BFF";
	const ColorBrandPrimary110$5 = "#809BFF";
	const ColorBrandPrimary120$5 = "#99AFFF";
	const ColorBrandPrimary130$5 = "#ADBFFF";
	const ColorBrandPrimary140$5 = "#C7D3FF";
	const ColorBrandPrimary150$5 = "#DBE3FF";
	const ColorBrandPrimary160$5 = "#F0F3FF";
	const ColorBrandBase01$5 = "#000E40";
	const ColorBrandBase02$5 = "#CF0F40";
	const ColorBrandBase03$4 = "#E84273";
	const ColorBrandBase04$4 = "#769D34";
	const ColorBrandBase05$4 = "#DBF49D";
	const ColorBrandBase06$3 = "#F6F4F4";
	const ColorBrandPalette0110$5 = "#000E40";
	const ColorBrandPalette0120$5 = "#001A7A";
	const ColorBrandPalette0130$5 = "#00229E";
	const ColorBrandPalette0140$5 = "#0029BD";
	const ColorBrandPalette0150$5 = "#002FDB";
	const ColorBrandPalette0160$5 = "#0037FF";
	const ColorBrandPalette0170$5 = "#1F4FFF";
	const ColorBrandPalette0180$5 = "#3863FF";
	const ColorBrandPalette0190$5 = "#5277FF";
	const ColorBrandPalette01100$5 = "#6B8BFF";
	const ColorBrandPalette01110$5 = "#809BFF";
	const ColorBrandPalette01120$5 = "#99AFFF";
	const ColorBrandPalette01130$5 = "#ADBFFF";
	const ColorBrandPalette01140$5 = "#C7D3FF";
	const ColorBrandPalette01150$5 = "#DBE3FF";
	const ColorBrandPalette01160$5 = "#F0F3FF";
	const ColorBrandPalette0210$5 = "#420514";
	const ColorBrandPalette0220$5 = "#55061A";
	const ColorBrandPalette0230$5 = "#6D0821";
	const ColorBrandPalette0240$5 = "#850A29";
	const ColorBrandPalette0250$5 = "#980B2F";
	const ColorBrandPalette0260$5 = "#AF0D36";
	const ColorBrandPalette0270$5 = "#CF0F40";
	const ColorBrandPalette0280$5 = "#E41146";
	const ColorBrandPalette0290$5 = "#F03866";
	const ColorBrandPalette02100$5 = "#F35E83";
	const ColorBrandPalette02110$5 = "#F57A99";
	const ColorBrandPalette02120$5 = "#F797AF";
	const ColorBrandPalette02130$5 = "#F9AEC1";
	const ColorBrandPalette02140$5 = "#FBC6D3";
	const ColorBrandPalette02150$5 = "#FDDEE5";
	const ColorBrandPalette02160$5 = "#FEF1F4";
	const ColorBrandPalette0310$3 = "#400819";
	const ColorBrandPalette0320$3 = "#560B21";
	const ColorBrandPalette0330$3 = "#6D0D2A";
	const ColorBrandPalette0340$3 = "#7F1031";
	const ColorBrandPalette0350$3 = "#96133A";
	const ColorBrandPalette0360$3 = "#AC1543";
	const ColorBrandPalette0370$3 = "#C3184B";
	const ColorBrandPalette0380$3 = "#DE1B56";
	const ColorBrandPalette0390$3 = "#E84273";
	const ColorBrandPalette03100$3 = "#EC658D";
	const ColorBrandPalette03110$3 = "#EF7B9E";
	const ColorBrandPalette03120$3 = "#F297B2";
	const ColorBrandPalette03130$3 = "#F5ADC3";
	const ColorBrandPalette03140$3 = "#F8C9D7";
	const ColorBrandPalette03150$3 = "#FBDFE8";
	const ColorBrandPalette03160$3 = "#FDF2F5";
	const ColorBrandPalette0410$4 = "#1A220B";
	const ColorBrandPalette0420$4 = "#232E0F";
	const ColorBrandPalette0430$4 = "#2B3913";
	const ColorBrandPalette0440$4 = "#344517";
	const ColorBrandPalette0450$4 = "#40541C";
	const ColorBrandPalette0460$4 = "#486020";
	const ColorBrandPalette0470$4 = "#546F25";
	const ColorBrandPalette0480$4 = "#5F7E2A";
	const ColorBrandPalette0490$4 = "#6B8E2F";
	const ColorBrandPalette04100$4 = "#769D34";
	const ColorBrandPalette04110$4 = "#85B03B";
	const ColorBrandPalette04120$4 = "#91BF40";
	const ColorBrandPalette04130$4 = "#A3CA60";
	const ColorBrandPalette04140$4 = "#C3DD98";
	const ColorBrandPalette04150$4 = "#DBF49D";
	const ColorBrandPalette04160$4 = "#F2F7E8";
	const ColorBrandPalette0610$3 = "#1A1514";
	const ColorBrandPalette0620$3 = "#312826";
	const ColorBrandPalette0630$3 = "#3F3431";
	const ColorBrandPalette0640$3 = "#4A3D3A";
	const ColorBrandPalette0650$3 = "#594946";
	const ColorBrandPalette0660$3 = "#675451";
	const ColorBrandPalette0670$3 = "#75605C";
	const ColorBrandPalette0680$3 = "#866E69";
	const ColorBrandPalette0690$3 = "#967E79";
	const ColorBrandPalette06100$3 = "#A38E8A";
	const ColorBrandPalette06110$3 = "#AE9C98";
	const ColorBrandPalette06120$3 = "#BEAFAC";
	const ColorBrandPalette06130$3 = "#CBC0BD";
	const ColorBrandPalette06140$3 = "#D9D0CE";
	const ColorBrandPalette06150$3 = "#E9E4E3";
	const ColorBrandPalette06160$3 = "#F6F4F4";
	const ColorFeedbackErrorText$5 = "#BC293A";
	const ColorFeedbackErrorShape$5 = "#EA4356";
	const ColorFeedbackSuccessText$5 = "#22723A";
	const ColorFeedbackSuccessShape$5 = "#2D954C";
	const ColorFeedbackOnBrandErrorText$5 = "#F77E8C";
	const ColorFeedbackOnBrandErrorShape$5 = "#EA4356";
	const ColorFeedbackOnBrandSuccessText$5 = "#38B85E";
	const ColorFeedbackOnBrandSuccessShape$5 = "#2D954C";
	const ColorFeedbackInverseErrorText$5 = "#F55C6E";
	const ColorFeedbackInverseErrorShape$5 = "#D83145";
	const ColorFeedbackInverseSuccessText$5 = "#32A454";
	const ColorFeedbackInverseSuccessShape$5 = "#278142";
	const ColorFeedbackInverseOnBrandErrorText$5 = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape$5 = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText$5 = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape$5 = "#278142";
	const ColorSupport01$5 = "#CF0F40";
	const ColorSupport02$5 = "#CF0F40";
	const ColorSupportOnBrand01$5 = "#A3CA60";
	const ColorSupportOnBrand02$5 = "#A3CA60";
	const ColorSupportInverse01$5 = "#E84273";
	const ColorSupportInverse02$5 = "#E84273";
	const ColorSupportInverseOnBrand01$5 = "#CF0F40";
	const ColorSupportInverseOnBrand02$5 = "#CF0F40";
	const Opacity01$5 = "0.04";
	const Opacity02$5 = "0.08";
	const Opacity03$5 = "0.12";
	const Opacity04$5 = "0.24";
	const Opacity05$5 = "0.32";
	const Opacity06$5 = "0.56";
	const Opacity07$5 = "0.64";
	const Opacity08$5 = "0.72";
	const Opacity09$5 = "0.88";
	const Shadow01$5 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$5 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$5 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$5 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$5 = "4px";
	const SpacingInlineNano$5 = "8px";
	const SpacingInlineXxxs$5 = "16px";
	const SpacingInlineXxs$5 = "24px";
	const SpacingInlineXs$5 = "32px";
	const SpacingInlineSm$5 = "40px";
	const SpacingInlineMd$5 = "48px";
	const SpacingInlineLg$5 = "56px";
	const SpacingInlineXl$5 = "64px";
	const SpacingInlineXxl$5 = "80px";
	const SpacingInlineXxxl$5 = "120px";
	const SpacingInlineHuge$5 = "160px";
	const SpacingInlineGiant$5 = "200px";
	const SpacingInsetQuark$5 = "4px";
	const SpacingInsetNano$5 = "8px";
	const SpacingInsetXs$5 = "16px";
	const SpacingInsetSm$5 = "24px";
	const SpacingInsetMd$5 = "32px";
	const SpacingInsetLg$5 = "40px";
	const SpacingSquishQuark$5 = "4px 8px";
	const SpacingSquishNano$5 = "8px 16px";
	const SpacingSquishXs$5 = "16px 24px";
	const SpacingSquishSm$5 = "16px 32px";
	const SpacingStackQuark$5 = "4px";
	const SpacingStackNano$5 = "8px";
	const SpacingStackXxxs$5 = "16px";
	const SpacingStackXxs$5 = "24px";
	const SpacingStackXs$5 = "32px";
	const SpacingStackSm$5 = "40px";
	const SpacingStackMd$5 = "48px";
	const SpacingStackLg$5 = "56px";
	const SpacingStackXl$5 = "64px";
	const SpacingStackXxl$5 = "80px";
	const SpacingStackXxxl$5 = "120px";
	const SpacingStackHuge$5 = "160px";
	const SpacingStackGiant$5 = "200px";
	const FontFamilyBase$5 = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontSizeXxxs$5 = "0.75rem";
	const FontSizeXxs$5 = "0.875rem";
	const FontSizeXs$5 = "1rem";
	const FontSizeSm$5 = "1.25rem";
	const FontSizeMd$5 = "1.5rem";
	const FontSizeLg$5 = "2rem";
	const FontSizeXl$5 = "2.5rem";
	const FontSizeXxl$5 = "3rem";
	const FontSizeXxxl$5 = "4rem";
	const FontSizeDisplay$5 = "5rem";
	const FontSizeGiant$5 = "6rem";
	const FontWeightBold$5 = 700;
	const FontWeightSemibold$5 = 600;
	const FontWeightMedium$5 = 500;
	const FontWeightRegular$5 = 400;
	const FontWeightLight$5 = 300;
	const LetterSpacingStandard$5 = "0px";
	const LetterSpacingSmall$5 = "-1px";
	const LetterSpacingMedium$5 = "1.5px";
	const LineHeightStandard$5 = "100%";
	const LineHeightTiny$5 = "115%";
	const LineHeightMedium$5 = "120%";
	const LineHeightLarge$5 = "125%";
	const LineHeightDistant$5 = "133%";
	const LineHeightSuperdistant$5 = "150%";
	const LineHeightHuge$5 = "170%";
	const ZIndex0$5 = "0";
	const ZIndex100$5 = "100";
	const ZIndex200$5 = "200";
	const ZIndex300$5 = "300";
	const ZIndex400$5 = "400";
	const ZIndex500$5 = "500";
	const ZIndexAuto$5 = "auto";
	const ZIndexTop$5 = "99999";
	const ZIndexBottom$5 = "-100";

	var index$5 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$5,
		BorderRadiusXs: BorderRadiusXs$5,
		BorderRadiusSm: BorderRadiusSm$5,
		BorderRadiusMd: BorderRadiusMd$5,
		BorderRadiusLg: BorderRadiusLg$5,
		BorderRadiusPill: BorderRadiusPill$5,
		BorderRadiusCircle: BorderRadiusCircle$5,
		BorderWidthNone: BorderWidthNone$5,
		BorderWidthHairline: BorderWidthHairline$5,
		BorderWidthThin: BorderWidthThin$5,
		BorderWidthThick: BorderWidthThick$5,
		BorderWidthHeavy: BorderWidthHeavy$5,
		ColorDatavizInfoText: ColorDatavizInfoText$5,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01$5,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02$5,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03$5,
		ColorDatavizNegativeText: ColorDatavizNegativeText$5,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$5,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$5,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$5,
		ColorDatavizWarningText: ColorDatavizWarningText$5,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01$5,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02$5,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03$5,
		ColorDatavizPositiveText: ColorDatavizPositiveText$5,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$5,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$5,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$5,
		ColorDatavizCatAText: ColorDatavizCatAText$5,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01$5,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02$5,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03$5,
		ColorDatavizCatBText: ColorDatavizCatBText$5,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01$5,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02$5,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03$5,
		ColorDatavizCatCText: ColorDatavizCatCText$5,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01$5,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02$5,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03$5,
		ColorDatavizCatDText: ColorDatavizCatDText$5,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01$5,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02$5,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03$5,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$5,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$5,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$5,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$5,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$5,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$5,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$5,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$5,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$5,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$5,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$5,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$5,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$5,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$5,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$5,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$5,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$5,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$5,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$5,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$5,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$5,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$5,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$5,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$5,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$5,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$5,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$5,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$5,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$5,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$5,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$5,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$5,
		ColorInteractionBlend01: ColorInteractionBlend01$5,
		ColorInteractionBlend02: ColorInteractionBlend02$5,
		ColorInteractionBlend03: ColorInteractionBlend03$5,
		ColorInteractionBlend04: ColorInteractionBlend04$5,
		ColorInteractionBlend05: ColorInteractionBlend05$5,
		ColorInteractionBlend06: ColorInteractionBlend06$5,
		ColorInteractionBlend07: ColorInteractionBlend07$5,
		ColorInteractionBlend08: ColorInteractionBlend08$5,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$5,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$5,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$5,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$5,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$5,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$5,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$5,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$5,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$5,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$5,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$5,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$5,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$5,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$5,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$5,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$5,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$5,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$5,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$5,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$5,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$5,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$5,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$5,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$5,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$5,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$5,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$5,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$5,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$5,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$5,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$5,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$5,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$5,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$5,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$5,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$5,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$5,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$5,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$5,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$5,
		ColorInteractionAccent01: ColorInteractionAccent01$5,
		ColorInteractionAccent02: ColorInteractionAccent02$5,
		ColorInteractionAccent03: ColorInteractionAccent03$5,
		ColorInteractionSubtle01: ColorInteractionSubtle01$5,
		ColorInteractionSubtle02: ColorInteractionSubtle02$5,
		ColorInteractionSubtle03: ColorInteractionSubtle03$5,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$5,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$5,
		ColorInteractionSelectActive: ColorInteractionSelectActive$5,
		ColorInteractionDanger01: ColorInteractionDanger01$5,
		ColorInteractionDanger02: ColorInteractionDanger02$5,
		ColorInteractionDanger03: ColorInteractionDanger03$5,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$5,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$5,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$5,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$5,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$5,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$5,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$5,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$5,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$5,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$5,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$5,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$5,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$5,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$5,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$5,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$5,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$5,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$5,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$5,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$5,
		ColorNeutral10: ColorNeutral10$5,
		ColorNeutral20: ColorNeutral20$5,
		ColorNeutral30: ColorNeutral30$5,
		ColorNeutral00: ColorNeutral00$5,
		ColorNeutralInverse10: ColorNeutralInverse10$5,
		ColorNeutralInverse20: ColorNeutralInverse20$5,
		ColorNeutralInverse30: ColorNeutralInverse30$5,
		ColorNeutralInverse00: ColorNeutralInverse00$5,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$5,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$5,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$5,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$5,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$5,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$5,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$5,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$5,
		ColorPaletteBlack: ColorPaletteBlack$5,
		ColorPaletteWhite: ColorPaletteWhite$5,
		ColorPaletteGray10: ColorPaletteGray10$5,
		ColorPaletteGray20: ColorPaletteGray20$5,
		ColorPaletteGray30: ColorPaletteGray30$5,
		ColorPaletteGray40: ColorPaletteGray40$5,
		ColorPaletteGray50: ColorPaletteGray50$5,
		ColorPaletteGray60: ColorPaletteGray60$5,
		ColorPaletteGray70: ColorPaletteGray70$5,
		ColorPaletteGray80: ColorPaletteGray80$5,
		ColorPaletteGray90: ColorPaletteGray90$5,
		ColorPaletteGray100: ColorPaletteGray100$5,
		ColorPaletteGray110: ColorPaletteGray110$5,
		ColorPaletteGray120: ColorPaletteGray120$5,
		ColorPaletteGray130: ColorPaletteGray130$5,
		ColorPaletteGray140: ColorPaletteGray140$5,
		ColorPaletteGray150: ColorPaletteGray150$5,
		ColorPaletteGray160: ColorPaletteGray160$5,
		ColorPaletteRed10: ColorPaletteRed10$5,
		ColorPaletteRed20: ColorPaletteRed20$5,
		ColorPaletteRed30: ColorPaletteRed30$5,
		ColorPaletteRed40: ColorPaletteRed40$5,
		ColorPaletteRed50: ColorPaletteRed50$5,
		ColorPaletteRed60: ColorPaletteRed60$5,
		ColorPaletteRed70: ColorPaletteRed70$5,
		ColorPaletteRed80: ColorPaletteRed80$5,
		ColorPaletteRed90: ColorPaletteRed90$5,
		ColorPaletteRed100: ColorPaletteRed100$5,
		ColorPaletteRed110: ColorPaletteRed110$5,
		ColorPaletteRed120: ColorPaletteRed120$5,
		ColorPaletteRed130: ColorPaletteRed130$5,
		ColorPaletteRed140: ColorPaletteRed140$5,
		ColorPaletteRed150: ColorPaletteRed150$5,
		ColorPaletteRed160: ColorPaletteRed160$5,
		ColorPaletteYellow10: ColorPaletteYellow10$5,
		ColorPaletteYellow20: ColorPaletteYellow20$5,
		ColorPaletteYellow30: ColorPaletteYellow30$5,
		ColorPaletteYellow40: ColorPaletteYellow40$5,
		ColorPaletteYellow50: ColorPaletteYellow50$5,
		ColorPaletteYellow60: ColorPaletteYellow60$5,
		ColorPaletteYellow70: ColorPaletteYellow70$5,
		ColorPaletteYellow80: ColorPaletteYellow80$5,
		ColorPaletteYellow90: ColorPaletteYellow90$5,
		ColorPaletteYellow100: ColorPaletteYellow100$5,
		ColorPaletteYellow110: ColorPaletteYellow110$5,
		ColorPaletteYellow120: ColorPaletteYellow120$5,
		ColorPaletteYellow130: ColorPaletteYellow130$5,
		ColorPaletteYellow140: ColorPaletteYellow140$5,
		ColorPaletteYellow150: ColorPaletteYellow150$5,
		ColorPaletteYellow160: ColorPaletteYellow160$5,
		ColorPaletteLime10: ColorPaletteLime10$5,
		ColorPaletteLime20: ColorPaletteLime20$5,
		ColorPaletteLime30: ColorPaletteLime30$5,
		ColorPaletteLime40: ColorPaletteLime40$5,
		ColorPaletteLime50: ColorPaletteLime50$5,
		ColorPaletteLime60: ColorPaletteLime60$5,
		ColorPaletteLime70: ColorPaletteLime70$5,
		ColorPaletteLime80: ColorPaletteLime80$5,
		ColorPaletteLime90: ColorPaletteLime90$5,
		ColorPaletteLime100: ColorPaletteLime100$5,
		ColorPaletteLime110: ColorPaletteLime110$5,
		ColorPaletteLime120: ColorPaletteLime120$5,
		ColorPaletteLime130: ColorPaletteLime130$5,
		ColorPaletteLime140: ColorPaletteLime140$5,
		ColorPaletteLime150: ColorPaletteLime150$5,
		ColorPaletteLime160: ColorPaletteLime160$5,
		ColorPaletteGreen10: ColorPaletteGreen10$5,
		ColorPaletteGreen20: ColorPaletteGreen20$5,
		ColorPaletteGreen30: ColorPaletteGreen30$5,
		ColorPaletteGreen40: ColorPaletteGreen40$5,
		ColorPaletteGreen50: ColorPaletteGreen50$5,
		ColorPaletteGreen60: ColorPaletteGreen60$5,
		ColorPaletteGreen70: ColorPaletteGreen70$5,
		ColorPaletteGreen80: ColorPaletteGreen80$5,
		ColorPaletteGreen90: ColorPaletteGreen90$5,
		ColorPaletteGreen100: ColorPaletteGreen100$5,
		ColorPaletteGreen110: ColorPaletteGreen110$5,
		ColorPaletteGreen120: ColorPaletteGreen120$5,
		ColorPaletteGreen130: ColorPaletteGreen130$5,
		ColorPaletteGreen140: ColorPaletteGreen140$5,
		ColorPaletteGreen150: ColorPaletteGreen150$5,
		ColorPaletteGreen160: ColorPaletteGreen160$5,
		ColorPaletteAcqua10: ColorPaletteAcqua10$5,
		ColorPaletteAcqua20: ColorPaletteAcqua20$5,
		ColorPaletteAcqua30: ColorPaletteAcqua30$5,
		ColorPaletteAcqua40: ColorPaletteAcqua40$5,
		ColorPaletteAcqua50: ColorPaletteAcqua50$5,
		ColorPaletteAcqua60: ColorPaletteAcqua60$5,
		ColorPaletteAcqua70: ColorPaletteAcqua70$5,
		ColorPaletteAcqua80: ColorPaletteAcqua80$5,
		ColorPaletteAcqua90: ColorPaletteAcqua90$5,
		ColorPaletteAcqua100: ColorPaletteAcqua100$5,
		ColorPaletteAcqua110: ColorPaletteAcqua110$5,
		ColorPaletteAcqua120: ColorPaletteAcqua120$5,
		ColorPaletteAcqua130: ColorPaletteAcqua130$5,
		ColorPaletteAcqua140: ColorPaletteAcqua140$5,
		ColorPaletteAcqua150: ColorPaletteAcqua150$5,
		ColorPaletteAcqua160: ColorPaletteAcqua160$5,
		ColorPaletteBlue10: ColorPaletteBlue10$5,
		ColorPaletteBlue20: ColorPaletteBlue20$5,
		ColorPaletteBlue30: ColorPaletteBlue30$5,
		ColorPaletteBlue40: ColorPaletteBlue40$5,
		ColorPaletteBlue50: ColorPaletteBlue50$5,
		ColorPaletteBlue60: ColorPaletteBlue60$5,
		ColorPaletteBlue70: ColorPaletteBlue70$5,
		ColorPaletteBlue80: ColorPaletteBlue80$5,
		ColorPaletteBlue90: ColorPaletteBlue90$5,
		ColorPaletteBlue100: ColorPaletteBlue100$5,
		ColorPaletteBlue110: ColorPaletteBlue110$5,
		ColorPaletteBlue120: ColorPaletteBlue120$5,
		ColorPaletteBlue130: ColorPaletteBlue130$5,
		ColorPaletteBlue140: ColorPaletteBlue140$5,
		ColorPaletteBlue150: ColorPaletteBlue150$5,
		ColorPaletteBlue160: ColorPaletteBlue160$5,
		ColorPalettePurple10: ColorPalettePurple10$5,
		ColorPalettePurple20: ColorPalettePurple20$5,
		ColorPalettePurple30: ColorPalettePurple30$5,
		ColorPalettePurple40: ColorPalettePurple40$5,
		ColorPalettePurple50: ColorPalettePurple50$5,
		ColorPalettePurple60: ColorPalettePurple60$5,
		ColorPalettePurple70: ColorPalettePurple70$5,
		ColorPalettePurple80: ColorPalettePurple80$5,
		ColorPalettePurple90: ColorPalettePurple90$5,
		ColorPalettePurple100: ColorPalettePurple100$5,
		ColorPalettePurple110: ColorPalettePurple110$5,
		ColorPalettePurple120: ColorPalettePurple120$5,
		ColorPalettePurple130: ColorPalettePurple130$5,
		ColorPalettePurple140: ColorPalettePurple140$5,
		ColorPalettePurple150: ColorPalettePurple150$5,
		ColorPalettePurple160: ColorPalettePurple160$5,
		ColorPalettePink10: ColorPalettePink10$5,
		ColorPalettePink20: ColorPalettePink20$5,
		ColorPalettePink30: ColorPalettePink30$5,
		ColorPalettePink40: ColorPalettePink40$5,
		ColorPalettePink50: ColorPalettePink50$5,
		ColorPalettePink60: ColorPalettePink60$5,
		ColorPalettePink70: ColorPalettePink70$5,
		ColorPalettePink80: ColorPalettePink80$5,
		ColorPalettePink90: ColorPalettePink90$5,
		ColorPalettePink100: ColorPalettePink100$5,
		ColorPalettePink110: ColorPalettePink110$5,
		ColorPalettePink120: ColorPalettePink120$5,
		ColorPalettePink130: ColorPalettePink130$5,
		ColorPalettePink140: ColorPalettePink140$5,
		ColorPalettePink150: ColorPalettePink150$5,
		ColorPalettePink160: ColorPalettePink160$5,
		ColorTypefaceStrong: ColorTypefaceStrong$5,
		ColorTypefacePure: ColorTypefacePure$5,
		ColorTypefaceSmooth: ColorTypefaceSmooth$5,
		ColorTypefaceMeld: ColorTypefaceMeld$5,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$5,
		ColorTypefaceInversePure: ColorTypefaceInversePure$5,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$5,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$5,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$5,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$5,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$5,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$5,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$5,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$5,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$5,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$5,
		ColorBrandPrimary10: ColorBrandPrimary10$5,
		ColorBrandPrimary20: ColorBrandPrimary20$5,
		ColorBrandPrimary30: ColorBrandPrimary30$5,
		ColorBrandPrimary40: ColorBrandPrimary40$5,
		ColorBrandPrimary50: ColorBrandPrimary50$5,
		ColorBrandPrimary60: ColorBrandPrimary60$5,
		ColorBrandPrimary70: ColorBrandPrimary70$5,
		ColorBrandPrimary80: ColorBrandPrimary80$5,
		ColorBrandPrimary90: ColorBrandPrimary90$5,
		ColorBrandPrimary100: ColorBrandPrimary100$5,
		ColorBrandPrimary110: ColorBrandPrimary110$5,
		ColorBrandPrimary120: ColorBrandPrimary120$5,
		ColorBrandPrimary130: ColorBrandPrimary130$5,
		ColorBrandPrimary140: ColorBrandPrimary140$5,
		ColorBrandPrimary150: ColorBrandPrimary150$5,
		ColorBrandPrimary160: ColorBrandPrimary160$5,
		ColorBrandBase01: ColorBrandBase01$5,
		ColorBrandBase02: ColorBrandBase02$5,
		ColorBrandBase03: ColorBrandBase03$4,
		ColorBrandBase04: ColorBrandBase04$4,
		ColorBrandBase05: ColorBrandBase05$4,
		ColorBrandBase06: ColorBrandBase06$3,
		ColorBrandPalette0110: ColorBrandPalette0110$5,
		ColorBrandPalette0120: ColorBrandPalette0120$5,
		ColorBrandPalette0130: ColorBrandPalette0130$5,
		ColorBrandPalette0140: ColorBrandPalette0140$5,
		ColorBrandPalette0150: ColorBrandPalette0150$5,
		ColorBrandPalette0160: ColorBrandPalette0160$5,
		ColorBrandPalette0170: ColorBrandPalette0170$5,
		ColorBrandPalette0180: ColorBrandPalette0180$5,
		ColorBrandPalette0190: ColorBrandPalette0190$5,
		ColorBrandPalette01100: ColorBrandPalette01100$5,
		ColorBrandPalette01110: ColorBrandPalette01110$5,
		ColorBrandPalette01120: ColorBrandPalette01120$5,
		ColorBrandPalette01130: ColorBrandPalette01130$5,
		ColorBrandPalette01140: ColorBrandPalette01140$5,
		ColorBrandPalette01150: ColorBrandPalette01150$5,
		ColorBrandPalette01160: ColorBrandPalette01160$5,
		ColorBrandPalette0210: ColorBrandPalette0210$5,
		ColorBrandPalette0220: ColorBrandPalette0220$5,
		ColorBrandPalette0230: ColorBrandPalette0230$5,
		ColorBrandPalette0240: ColorBrandPalette0240$5,
		ColorBrandPalette0250: ColorBrandPalette0250$5,
		ColorBrandPalette0260: ColorBrandPalette0260$5,
		ColorBrandPalette0270: ColorBrandPalette0270$5,
		ColorBrandPalette0280: ColorBrandPalette0280$5,
		ColorBrandPalette0290: ColorBrandPalette0290$5,
		ColorBrandPalette02100: ColorBrandPalette02100$5,
		ColorBrandPalette02110: ColorBrandPalette02110$5,
		ColorBrandPalette02120: ColorBrandPalette02120$5,
		ColorBrandPalette02130: ColorBrandPalette02130$5,
		ColorBrandPalette02140: ColorBrandPalette02140$5,
		ColorBrandPalette02150: ColorBrandPalette02150$5,
		ColorBrandPalette02160: ColorBrandPalette02160$5,
		ColorBrandPalette0310: ColorBrandPalette0310$3,
		ColorBrandPalette0320: ColorBrandPalette0320$3,
		ColorBrandPalette0330: ColorBrandPalette0330$3,
		ColorBrandPalette0340: ColorBrandPalette0340$3,
		ColorBrandPalette0350: ColorBrandPalette0350$3,
		ColorBrandPalette0360: ColorBrandPalette0360$3,
		ColorBrandPalette0370: ColorBrandPalette0370$3,
		ColorBrandPalette0380: ColorBrandPalette0380$3,
		ColorBrandPalette0390: ColorBrandPalette0390$3,
		ColorBrandPalette03100: ColorBrandPalette03100$3,
		ColorBrandPalette03110: ColorBrandPalette03110$3,
		ColorBrandPalette03120: ColorBrandPalette03120$3,
		ColorBrandPalette03130: ColorBrandPalette03130$3,
		ColorBrandPalette03140: ColorBrandPalette03140$3,
		ColorBrandPalette03150: ColorBrandPalette03150$3,
		ColorBrandPalette03160: ColorBrandPalette03160$3,
		ColorBrandPalette0410: ColorBrandPalette0410$4,
		ColorBrandPalette0420: ColorBrandPalette0420$4,
		ColorBrandPalette0430: ColorBrandPalette0430$4,
		ColorBrandPalette0440: ColorBrandPalette0440$4,
		ColorBrandPalette0450: ColorBrandPalette0450$4,
		ColorBrandPalette0460: ColorBrandPalette0460$4,
		ColorBrandPalette0470: ColorBrandPalette0470$4,
		ColorBrandPalette0480: ColorBrandPalette0480$4,
		ColorBrandPalette0490: ColorBrandPalette0490$4,
		ColorBrandPalette04100: ColorBrandPalette04100$4,
		ColorBrandPalette04110: ColorBrandPalette04110$4,
		ColorBrandPalette04120: ColorBrandPalette04120$4,
		ColorBrandPalette04130: ColorBrandPalette04130$4,
		ColorBrandPalette04140: ColorBrandPalette04140$4,
		ColorBrandPalette04150: ColorBrandPalette04150$4,
		ColorBrandPalette04160: ColorBrandPalette04160$4,
		ColorBrandPalette0610: ColorBrandPalette0610$3,
		ColorBrandPalette0620: ColorBrandPalette0620$3,
		ColorBrandPalette0630: ColorBrandPalette0630$3,
		ColorBrandPalette0640: ColorBrandPalette0640$3,
		ColorBrandPalette0650: ColorBrandPalette0650$3,
		ColorBrandPalette0660: ColorBrandPalette0660$3,
		ColorBrandPalette0670: ColorBrandPalette0670$3,
		ColorBrandPalette0680: ColorBrandPalette0680$3,
		ColorBrandPalette0690: ColorBrandPalette0690$3,
		ColorBrandPalette06100: ColorBrandPalette06100$3,
		ColorBrandPalette06110: ColorBrandPalette06110$3,
		ColorBrandPalette06120: ColorBrandPalette06120$3,
		ColorBrandPalette06130: ColorBrandPalette06130$3,
		ColorBrandPalette06140: ColorBrandPalette06140$3,
		ColorBrandPalette06150: ColorBrandPalette06150$3,
		ColorBrandPalette06160: ColorBrandPalette06160$3,
		ColorFeedbackErrorText: ColorFeedbackErrorText$5,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$5,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$5,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$5,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$5,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$5,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$5,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$5,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$5,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$5,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$5,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$5,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$5,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$5,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$5,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$5,
		ColorSupport01: ColorSupport01$5,
		ColorSupport02: ColorSupport02$5,
		ColorSupportOnBrand01: ColorSupportOnBrand01$5,
		ColorSupportOnBrand02: ColorSupportOnBrand02$5,
		ColorSupportInverse01: ColorSupportInverse01$5,
		ColorSupportInverse02: ColorSupportInverse02$5,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$5,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$5,
		Opacity01: Opacity01$5,
		Opacity02: Opacity02$5,
		Opacity03: Opacity03$5,
		Opacity04: Opacity04$5,
		Opacity05: Opacity05$5,
		Opacity06: Opacity06$5,
		Opacity07: Opacity07$5,
		Opacity08: Opacity08$5,
		Opacity09: Opacity09$5,
		Shadow01: Shadow01$5,
		Shadow02: Shadow02$5,
		Shadow03: Shadow03$5,
		Shadow04: Shadow04$5,
		SpacingInlineQuark: SpacingInlineQuark$5,
		SpacingInlineNano: SpacingInlineNano$5,
		SpacingInlineXxxs: SpacingInlineXxxs$5,
		SpacingInlineXxs: SpacingInlineXxs$5,
		SpacingInlineXs: SpacingInlineXs$5,
		SpacingInlineSm: SpacingInlineSm$5,
		SpacingInlineMd: SpacingInlineMd$5,
		SpacingInlineLg: SpacingInlineLg$5,
		SpacingInlineXl: SpacingInlineXl$5,
		SpacingInlineXxl: SpacingInlineXxl$5,
		SpacingInlineXxxl: SpacingInlineXxxl$5,
		SpacingInlineHuge: SpacingInlineHuge$5,
		SpacingInlineGiant: SpacingInlineGiant$5,
		SpacingInsetQuark: SpacingInsetQuark$5,
		SpacingInsetNano: SpacingInsetNano$5,
		SpacingInsetXs: SpacingInsetXs$5,
		SpacingInsetSm: SpacingInsetSm$5,
		SpacingInsetMd: SpacingInsetMd$5,
		SpacingInsetLg: SpacingInsetLg$5,
		SpacingSquishQuark: SpacingSquishQuark$5,
		SpacingSquishNano: SpacingSquishNano$5,
		SpacingSquishXs: SpacingSquishXs$5,
		SpacingSquishSm: SpacingSquishSm$5,
		SpacingStackQuark: SpacingStackQuark$5,
		SpacingStackNano: SpacingStackNano$5,
		SpacingStackXxxs: SpacingStackXxxs$5,
		SpacingStackXxs: SpacingStackXxs$5,
		SpacingStackXs: SpacingStackXs$5,
		SpacingStackSm: SpacingStackSm$5,
		SpacingStackMd: SpacingStackMd$5,
		SpacingStackLg: SpacingStackLg$5,
		SpacingStackXl: SpacingStackXl$5,
		SpacingStackXxl: SpacingStackXxl$5,
		SpacingStackXxxl: SpacingStackXxxl$5,
		SpacingStackHuge: SpacingStackHuge$5,
		SpacingStackGiant: SpacingStackGiant$5,
		FontFamilyBase: FontFamilyBase$5,
		FontSizeXxxs: FontSizeXxxs$5,
		FontSizeXxs: FontSizeXxs$5,
		FontSizeXs: FontSizeXs$5,
		FontSizeSm: FontSizeSm$5,
		FontSizeMd: FontSizeMd$5,
		FontSizeLg: FontSizeLg$5,
		FontSizeXl: FontSizeXl$5,
		FontSizeXxl: FontSizeXxl$5,
		FontSizeXxxl: FontSizeXxxl$5,
		FontSizeDisplay: FontSizeDisplay$5,
		FontSizeGiant: FontSizeGiant$5,
		FontWeightBold: FontWeightBold$5,
		FontWeightSemibold: FontWeightSemibold$5,
		FontWeightMedium: FontWeightMedium$5,
		FontWeightRegular: FontWeightRegular$5,
		FontWeightLight: FontWeightLight$5,
		LetterSpacingStandard: LetterSpacingStandard$5,
		LetterSpacingSmall: LetterSpacingSmall$5,
		LetterSpacingMedium: LetterSpacingMedium$5,
		LineHeightStandard: LineHeightStandard$5,
		LineHeightTiny: LineHeightTiny$5,
		LineHeightMedium: LineHeightMedium$5,
		LineHeightLarge: LineHeightLarge$5,
		LineHeightDistant: LineHeightDistant$5,
		LineHeightSuperdistant: LineHeightSuperdistant$5,
		LineHeightHuge: LineHeightHuge$5,
		ZIndex0: ZIndex0$5,
		ZIndex100: ZIndex100$5,
		ZIndex200: ZIndex200$5,
		ZIndex300: ZIndex300$5,
		ZIndex400: ZIndex400$5,
		ZIndex500: ZIndex500$5,
		ZIndexAuto: ZIndexAuto$5,
		ZIndexTop: ZIndexTop$5,
		ZIndexBottom: ZIndexBottom$5
	});

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:01 GMT
	 */

	const BorderRadiusNone$4 = "0px";
	const BorderRadiusXs$4 = "4px";
	const BorderRadiusSm$4 = "8px";
	const BorderRadiusMd$4 = "16px";
	const BorderRadiusLg$4 = "24px";
	const BorderRadiusPill$4 = "960px";
	const BorderRadiusCircle$4 = "50%";
	const BorderWidthNone$4 = "0px";
	const BorderWidthHairline$4 = "1px";
	const BorderWidthThin$4 = "2px";
	const BorderWidthThick$4 = "4px";
	const BorderWidthHeavy$4 = "8px";
	const ColorDatavizInfoText$4 = "#0F58EA";
	const ColorDatavizInfoShape01$4 = "#3F7BF2";
	const ColorDatavizInfoShape02$4 = "#D9E5FC";
	const ColorDatavizInfoShape03$4 = "#F1F5FE";
	const ColorDatavizNegativeText$4 = "#BC293A";
	const ColorDatavizNegativeShape01$4 = "#EA4356";
	const ColorDatavizNegativeShape02$4 = "#FDDDE1";
	const ColorDatavizNegativeShape03$4 = "#FEF1F2";
	const ColorDatavizWarningText$4 = "#A04C03";
	const ColorDatavizWarningShape01$4 = "#D26404";
	const ColorDatavizWarningShape02$4 = "#FEE1C8";
	const ColorDatavizWarningShape03$4 = "#FEF1E6";
	const ColorDatavizPositiveText$4 = "#22723A";
	const ColorDatavizPositiveShape01$4 = "#2D954C";
	const ColorDatavizPositiveShape02$4 = "#C8EED3";
	const ColorDatavizPositiveShape03$4 = "#E8F8EC";
	const ColorDatavizCatAText$4 = "#9B18DC";
	const ColorDatavizCatAShape01$4 = "#B851EC";
	const ColorDatavizCatAShape02$4 = "#F2DFFB";
	const ColorDatavizCatAShape03$4 = "#F9F1FD";
	const ColorDatavizCatBText$4 = "#BA267B";
	const ColorDatavizCatBShape01$4 = "#DA499B";
	const ColorDatavizCatBShape02$4 = "#F8DDEC";
	const ColorDatavizCatBShape03$4 = "#FCF2F8";
	const ColorDatavizCatCText$4 = "#546E21";
	const ColorDatavizCatCShape01$4 = "#6C8D2B";
	const ColorDatavizCatCShape02$4 = "#DBEBBD";
	const ColorDatavizCatCShape03$4 = "#F0F7E4";
	const ColorDatavizCatDText$4 = "#0D735E";
	const ColorDatavizCatDShape01$4 = "#109379";
	const ColorDatavizCatDShape02$4 = "#BCF0E6";
	const ColorDatavizCatDShape03$4 = "#DFFBF6";
	const ColorDatavizInverseInfoText$4 = "#5C8FF5";
	const ColorDatavizInverseInfoShape01$4 = "#286BF1";
	const ColorDatavizInverseInfoShape02$4 = "#062560";
	const ColorDatavizInverseInfoShape03$4 = "#051B48";
	const ColorDatavizInverseNegativeText$4 = "#F55C6E";
	const ColorDatavizInverseNegativeShape01$4 = "#D83145";
	const ColorDatavizInverseNegativeShape02$4 = "#4F1119";
	const ColorDatavizInverseNegativeShape03$4 = "#3B0D12";
	const ColorDatavizInverseWarningText$4 = "#EB7005";
	const ColorDatavizInverseWarningShape01$4 = "#B95804";
	const ColorDatavizInverseWarningShape02$4 = "#462101";
	const ColorDatavizInverseWarningShape03$4 = "#321701";
	const ColorDatavizInversePositiveText$4 = "#32A454";
	const ColorDatavizInversePositiveShape01$4 = "#278142";
	const ColorDatavizInversePositiveShape02$4 = "#0E2F18";
	const ColorDatavizInversePositiveShape03$4 = "#0B2312";
	const ColorDatavizInverseCatAText$4 = "#C36CEF";
	const ColorDatavizInverseCatAShape01$4 = "#AD35E9";
	const ColorDatavizInverseCatAShape02$4 = "#440B60";
	const ColorDatavizInverseCatAShape03$4 = "#340849";
	const ColorDatavizInverseCatBText$4 = "#E067AB";
	const ColorDatavizInverseCatBShape01$4 = "#D42B8C";
	const ColorDatavizInverseCatBShape02$4 = "#4C1032";
	const ColorDatavizInverseCatBShape03$4 = "#3B0C27";
	const ColorDatavizInverseCatCText$4 = "#789D2F";
	const ColorDatavizInverseCatCShape01$4 = "#607E26";
	const ColorDatavizInverseCatCShape02$4 = "#212B0D";
	const ColorDatavizInverseCatCShape03$4 = "#1B230B";
	const ColorDatavizInverseCatDText$4 = "#12A588";
	const ColorDatavizInverseCatDShape01$4 = "#0F856D";
	const ColorDatavizInverseCatDShape02$4 = "#052E26";
	const ColorDatavizInverseCatDShape03$4 = "#04251E";
	const ColorInteractionBlend01$4 = "#1616160A";
	const ColorInteractionBlend02$4 = "#16161614";
	const ColorInteractionBlend03$4 = "#1616161F";
	const ColorInteractionBlend04$4 = "#1616163D";
	const ColorInteractionBlend05$4 = "#161616A3";
	const ColorInteractionBlend06$4 = "#161616B8";
	const ColorInteractionBlend07$4 = "#161616E0";
	const ColorInteractionBlend08$4 = "#161616";
	const ColorInteractionInverseBlend01$4 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$4 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$4 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$4 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$4 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$4 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$4 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$4 = "#FEFEFE";
	const ColorInteractionInverseAccent01$4 = "#6B8BFF";
	const ColorInteractionInverseAccent02$4 = "#809BFF";
	const ColorInteractionInverseAccent03$4 = "#99AFFF";
	const ColorInteractionInverseSubtle01$4 = "#5277FF1F";
	const ColorInteractionInverseSubtle02$4 = "#5277FF3D";
	const ColorInteractionInverseSubtle03$4 = "#5277FF52";
	const ColorInteractionInverseSelectDefault$4 = "#919191";
	const ColorInteractionInverseSelectFocus$4 = "#D4D4D4";
	const ColorInteractionInverseSelectActive$4 = "#E368A0";
	const ColorInteractionInverseDanger01$4 = "#F55C6E";
	const ColorInteractionInverseDanger02$4 = "#F77E8C";
	const ColorInteractionInverseDanger03$4 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01$4 = "#000E40";
	const ColorInteractionInverseOnBrandAccent02$4 = "#001A7A";
	const ColorInteractionInverseOnBrandAccent03$4 = "#00229E";
	const ColorInteractionInverseOnBrandSubtle01$4 = "#002FDB14";
	const ColorInteractionInverseOnBrandSubtle02$4 = "#002FDB1F";
	const ColorInteractionInverseOnBrandSubtle03$4 = "#002FDB3D";
	const ColorInteractionInverseOnBrandSelectDefault$4 = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus$4 = "#404040";
	const ColorInteractionInverseOnBrandSelectActive$4 = "#A81F5D";
	const ColorInteractionInverseOnBrandBlend01$4 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$4 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$4 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$4 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$4 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$4 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$4 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$4 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$4 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02$4 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03$4 = "#7E1B27";
	const ColorInteractionAccent01$4 = "#000E40";
	const ColorInteractionAccent02$4 = "#001A7A";
	const ColorInteractionAccent03$4 = "#00229E";
	const ColorInteractionSubtle01$4 = "#0029BD1F";
	const ColorInteractionSubtle02$4 = "#0029BD3D";
	const ColorInteractionSubtle03$4 = "#0029BD52";
	const ColorInteractionSelectDefault$4 = "#666666";
	const ColorInteractionSelectFocus$4 = "#363636";
	const ColorInteractionSelectActive$4 = "#BE2368";
	const ColorInteractionDanger01$4 = "#BC293A";
	const ColorInteractionDanger02$4 = "#A72534";
	const ColorInteractionDanger03$4 = "#92202E";
	const ColorInteractionOnBrandAccent01$4 = "#ADBFFF";
	const ColorInteractionOnBrandAccent02$4 = "#99AFFF";
	const ColorInteractionOnBrandAccent03$4 = "#809BFF";
	const ColorInteractionOnBrandSubtle01$4 = "#5277FF1F";
	const ColorInteractionOnBrandSubtle02$4 = "#5277FF3D";
	const ColorInteractionOnBrandSubtle03$4 = "#5277FF52";
	const ColorInteractionOnBrandSelectDefault$4 = "#B0B0B0";
	const ColorInteractionOnBrandSelectFocus$4 = "#D4D4D4";
	const ColorInteractionOnBrandSelectActive$4 = "#F9DDE9";
	const ColorInteractionOnBrandBlend01$4 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$4 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$4 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$4 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$4 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$4 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$4 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$4 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$4 = "#F77E8C";
	const ColorInteractionOnBrandDanger02$4 = "#F895A1";
	const ColorInteractionOnBrandDanger03$4 = "#FAAEB6";
	const ColorNeutral10$4 = "#F5F5F5";
	const ColorNeutral20$4 = "#E6E6E6";
	const ColorNeutral30$4 = "#1616163D";
	const ColorNeutral00$4 = "#FEFEFE";
	const ColorNeutralInverse10$4 = "#1F1F1F";
	const ColorNeutralInverse20$4 = "#292929";
	const ColorNeutralInverse30$4 = "#FEFEFE3D";
	const ColorNeutralInverse00$4 = "#161616";
	const ColorNeutralInverseOnBrand10$4 = "#DBE3FF";
	const ColorNeutralInverseOnBrand20$4 = "#C7D3FF";
	const ColorNeutralInverseOnBrand30$4 = "#0029BD52";
	const ColorNeutralInverseOnBrand00$4 = "#F0F3FF";
	const ColorNeutralOnBrand10$4 = "#001A7A";
	const ColorNeutralOnBrand20$4 = "#00229E";
	const ColorNeutralOnBrand30$4 = "#5277FFA3";
	const ColorNeutralOnBrand00$4 = "#000E40";
	const ColorPaletteBlack$4 = "#161616";
	const ColorPaletteWhite$4 = "#FEFEFE";
	const ColorPaletteGray10$4 = "#1F1F1F";
	const ColorPaletteGray20$4 = "#292929";
	const ColorPaletteGray30$4 = "#363636";
	const ColorPaletteGray40$4 = "#404040";
	const ColorPaletteGray50$4 = "#4C4C4C";
	const ColorPaletteGray60$4 = "#595959";
	const ColorPaletteGray70$4 = "#666666";
	const ColorPaletteGray80$4 = "#737373";
	const ColorPaletteGray90$4 = "#828282";
	const ColorPaletteGray100$4 = "#919191";
	const ColorPaletteGray110$4 = "#A1A1A1";
	const ColorPaletteGray120$4 = "#B0B0B0";
	const ColorPaletteGray130$4 = "#C2C2C2";
	const ColorPaletteGray140$4 = "#D4D4D4";
	const ColorPaletteGray150$4 = "#E6E6E6";
	const ColorPaletteGray160$4 = "#F5F5F5";
	const ColorPaletteRed10$4 = "#3B0D12";
	const ColorPaletteRed20$4 = "#4F1119";
	const ColorPaletteRed30$4 = "#691721";
	const ColorPaletteRed40$4 = "#7E1B27";
	const ColorPaletteRed50$4 = "#92202E";
	const ColorPaletteRed60$4 = "#A72534";
	const ColorPaletteRed70$4 = "#BC293A";
	const ColorPaletteRed80$4 = "#D83145";
	const ColorPaletteRed90$4 = "#EA4356";
	const ColorPaletteRed100$4 = "#F55C6E";
	const ColorPaletteRed110$4 = "#F77E8C";
	const ColorPaletteRed120$4 = "#F895A1";
	const ColorPaletteRed130$4 = "#FAAEB6";
	const ColorPaletteRed140$4 = "#FBC5CC";
	const ColorPaletteRed150$4 = "#FDDDE1";
	const ColorPaletteRed160$4 = "#FEF1F2";
	const ColorPaletteYellow10$4 = "#321701";
	const ColorPaletteYellow20$4 = "#462101";
	const ColorPaletteYellow30$4 = "#552802";
	const ColorPaletteYellow40$4 = "#693102";
	const ColorPaletteYellow50$4 = "#7D3B03";
	const ColorPaletteYellow60$4 = "#914503";
	const ColorPaletteYellow70$4 = "#A04C03";
	const ColorPaletteYellow80$4 = "#B95804";
	const ColorPaletteYellow90$4 = "#D26404";
	const ColorPaletteYellow100$4 = "#EB7005";
	const ColorPaletteYellow110$4 = "#FA8219";
	const ColorPaletteYellow120$4 = "#FB9B46";
	const ColorPaletteYellow130$4 = "#FCB06E";
	const ColorPaletteYellow140$4 = "#FDC99B";
	const ColorPaletteYellow150$4 = "#FEE1C8";
	const ColorPaletteYellow160$4 = "#FEF1E6";
	const ColorPaletteLime10$4 = "#1B230B";
	const ColorPaletteLime20$4 = "#212B0D";
	const ColorPaletteLime30$4 = "#2D3B12";
	const ColorPaletteLime40$4 = "#364616";
	const ColorPaletteLime50$4 = "#3F5219";
	const ColorPaletteLime60$4 = "#485E1D";
	const ColorPaletteLime70$4 = "#546E21";
	const ColorPaletteLime80$4 = "#607E26";
	const ColorPaletteLime90$4 = "#6C8D2B";
	const ColorPaletteLime100$4 = "#789D2F";
	const ColorPaletteLime110$4 = "#84AC34";
	const ColorPaletteLime120$4 = "#93BF3A";
	const ColorPaletteLime130$4 = "#A9CF5E";
	const ColorPaletteLime140$4 = "#C2DD8D";
	const ColorPaletteLime150$4 = "#DBEBBD";
	const ColorPaletteLime160$4 = "#F0F7E4";
	const ColorPaletteGreen10$4 = "#0B2312";
	const ColorPaletteGreen20$4 = "#0E2F18";
	const ColorPaletteGreen30$4 = "#133E20";
	const ColorPaletteGreen40$4 = "#174A26";
	const ColorPaletteGreen50$4 = "#1A562C";
	const ColorPaletteGreen60$4 = "#1F6634";
	const ColorPaletteGreen70$4 = "#22723A";
	const ColorPaletteGreen80$4 = "#278142";
	const ColorPaletteGreen90$4 = "#2D954C";
	const ColorPaletteGreen100$4 = "#32A454";
	const ColorPaletteGreen110$4 = "#38B85E";
	const ColorPaletteGreen120$4 = "#4BC870";
	const ColorPaletteGreen130$4 = "#76D692";
	const ColorPaletteGreen140$4 = "#9DE2B1";
	const ColorPaletteGreen150$4 = "#C8EED3";
	const ColorPaletteGreen160$4 = "#E8F8EC";
	const ColorPaletteAcqua10$4 = "#04251E";
	const ColorPaletteAcqua20$4 = "#052E26";
	const ColorPaletteAcqua30$4 = "#073C31";
	const ColorPaletteAcqua40$4 = "#08493C";
	const ColorPaletteAcqua50$4 = "#0A5748";
	const ColorPaletteAcqua60$4 = "#0B6553";
	const ColorPaletteAcqua70$4 = "#0D735E";
	const ColorPaletteAcqua80$4 = "#0F856D";
	const ColorPaletteAcqua90$4 = "#109379";
	const ColorPaletteAcqua100$4 = "#12A588";
	const ColorPaletteAcqua110$4 = "#14B897";
	const ColorPaletteAcqua120$4 = "#31C4A6";
	const ColorPaletteAcqua130$4 = "#68D4BF";
	const ColorPaletteAcqua140$4 = "#8DE2D1";
	const ColorPaletteAcqua150$4 = "#BCF0E6";
	const ColorPaletteAcqua160$4 = "#DFFBF6";
	const ColorPaletteBlue10$4 = "#051B48";
	const ColorPaletteBlue20$4 = "#062560";
	const ColorPaletteBlue30$4 = "#082F7D";
	const ColorPaletteBlue40$4 = "#0A3A9A";
	const ColorPaletteBlue50$4 = "#0B43B1";
	const ColorPaletteBlue60$4 = "#0D4ECE";
	const ColorPaletteBlue70$4 = "#0F58EA";
	const ColorPaletteBlue80$4 = "#286BF1";
	const ColorPaletteBlue90$4 = "#3F7BF2";
	const ColorPaletteBlue100$4 = "#5C8FF5";
	const ColorPaletteBlue110$4 = "#73A0F7";
	const ColorPaletteBlue120$4 = "#8CB0F8";
	const ColorPaletteBlue130$4 = "#A9C4F9";
	const ColorPaletteBlue140$4 = "#C1D4FB";
	const ColorPaletteBlue150$4 = "#D9E5FC";
	const ColorPaletteBlue160$4 = "#F1F5FE";
	const ColorPalettePurple10$4 = "#340849";
	const ColorPalettePurple20$4 = "#440B60";
	const ColorPalettePurple30$4 = "#540D78";
	const ColorPalettePurple40$4 = "#671093";
	const ColorPalettePurple50$4 = "#7713AA";
	const ColorPalettePurple60$4 = "#8B16C5";
	const ColorPalettePurple70$4 = "#9B18DC";
	const ColorPalettePurple80$4 = "#AD35E9";
	const ColorPalettePurple90$4 = "#B851EC";
	const ColorPalettePurple100$4 = "#C36CEF";
	const ColorPalettePurple110$4 = "#CC83F1";
	const ColorPalettePurple120$4 = "#D69AF4";
	const ColorPalettePurple130$4 = "#DFB1F6";
	const ColorPalettePurple140$4 = "#E8C8F9";
	const ColorPalettePurple150$4 = "#F2DFFB";
	const ColorPalettePurple160$4 = "#F9F1FD";
	const ColorPalettePink10$4 = "#3B0C27";
	const ColorPalettePink20$4 = "#4C1032";
	const ColorPalettePink30$4 = "#661543";
	const ColorPalettePink40$4 = "#77184E";
	const ColorPalettePink50$4 = "#8C1C5D";
	const ColorPalettePink60$4 = "#A12169";
	const ColorPalettePink70$4 = "#BA267B";
	const ColorPalettePink80$4 = "#D42B8C";
	const ColorPalettePink90$4 = "#DA499B";
	const ColorPalettePink100$4 = "#E067AB";
	const ColorPalettePink110$4 = "#E580B9";
	const ColorPalettePink120$4 = "#EA99C7";
	const ColorPalettePink130$4 = "#EFAFD3";
	const ColorPalettePink140$4 = "#F4C8E1";
	const ColorPalettePink150$4 = "#F8DDEC";
	const ColorPalettePink160$4 = "#FCF2F8";
	const ColorTypefaceStrong$4 = "#161616";
	const ColorTypefacePure$4 = "#363636";
	const ColorTypefaceSmooth$4 = "#666666";
	const ColorTypefaceMeld$4 = "#1616163D";
	const ColorTypefaceInverseStrong$4 = "#FEFEFE";
	const ColorTypefaceInversePure$4 = "#D4D4D4";
	const ColorTypefaceInverseSmooth$4 = "#919191";
	const ColorTypefaceInverseMeld$4 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$4 = "#161616";
	const ColorTypefaceInverseOnBrandPure$4 = "#363636";
	const ColorTypefaceInverseOnBrandSmooth$4 = "#595959";
	const ColorTypefaceInverseOnBrandMeld$4 = "#1616163D";
	const ColorTypefaceOnBrandStrong$4 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$4 = "#DBE3FF";
	const ColorTypefaceOnBrandSmooth$4 = "#C7D3FF";
	const ColorTypefaceOnBrandMeld$4 = "#FEFEFE52";
	const ColorBrandPrimary10$4 = "#000E40";
	const ColorBrandPrimary20$4 = "#001A7A";
	const ColorBrandPrimary30$4 = "#00229E";
	const ColorBrandPrimary40$4 = "#0029BD";
	const ColorBrandPrimary50$4 = "#002FDB";
	const ColorBrandPrimary60$4 = "#0037FF";
	const ColorBrandPrimary70$4 = "#1F4FFF";
	const ColorBrandPrimary80$4 = "#3863FF";
	const ColorBrandPrimary90$4 = "#5277FF";
	const ColorBrandPrimary100$4 = "#6B8BFF";
	const ColorBrandPrimary110$4 = "#809BFF";
	const ColorBrandPrimary120$4 = "#99AFFF";
	const ColorBrandPrimary130$4 = "#ADBFFF";
	const ColorBrandPrimary140$4 = "#C7D3FF";
	const ColorBrandPrimary150$4 = "#DBE3FF";
	const ColorBrandPrimary160$4 = "#F0F3FF";
	const ColorBrandBase01$4 = "#000E40";
	const ColorBrandBase02$4 = "#D82777";
	const ColorBrandBase03$3 = "#A6E1FF";
	const ColorBrandBase04$3 = "#0037FF";
	const ColorBrandBase05$3 = "#D8BD97";
	const ColorBrandPalette0110$4 = "#000E40";
	const ColorBrandPalette0120$4 = "#001A7A";
	const ColorBrandPalette0130$4 = "#00229E";
	const ColorBrandPalette0140$4 = "#0029BD";
	const ColorBrandPalette0150$4 = "#002FDB";
	const ColorBrandPalette0160$4 = "#0037FF";
	const ColorBrandPalette0170$4 = "#1F4FFF";
	const ColorBrandPalette0180$4 = "#3863FF";
	const ColorBrandPalette0190$4 = "#5277FF";
	const ColorBrandPalette01100$4 = "#6B8BFF";
	const ColorBrandPalette01110$4 = "#809BFF";
	const ColorBrandPalette01120$4 = "#99AFFF";
	const ColorBrandPalette01130$4 = "#ADBFFF";
	const ColorBrandPalette01140$4 = "#C7D3FF";
	const ColorBrandPalette01150$4 = "#DBE3FF";
	const ColorBrandPalette01160$4 = "#F0F3FF";
	const ColorBrandPalette0210$4 = "#3C0B21";
	const ColorBrandPalette0220$4 = "#520F2D";
	const ColorBrandPalette0230$4 = "#671339";
	const ColorBrandPalette0240$4 = "#7D1745";
	const ColorBrandPalette0250$4 = "#931B51";
	const ColorBrandPalette0260$4 = "#A81F5D";
	const ColorBrandPalette0270$4 = "#BE2368";
	const ColorBrandPalette0280$4 = "#D82777";
	const ColorBrandPalette0290$4 = "#DE4A8C";
	const ColorBrandPalette02100$4 = "#E368A0";
	const ColorBrandPalette02110$4 = "#E882B0";
	const ColorBrandPalette02120$4 = "#EC98BE";
	const ColorBrandPalette02130$4 = "#F1B1CE";
	const ColorBrandPalette02140$4 = "#F5C7DC";
	const ColorBrandPalette02150$4 = "#F9DDE9";
	const ColorBrandPalette02160$4 = "#FDF2F7";
	const ColorBrandPalette0310$2 = "#002233";
	const ColorBrandPalette0320$2 = "#002C42";
	const ColorBrandPalette0330$2 = "#073B54";
	const ColorBrandPalette0340$2 = "#004466";
	const ColorBrandPalette0350$2 = "#00527A";
	const ColorBrandPalette0360$2 = "#005F8F";
	const ColorBrandPalette0370$2 = "#00699E";
	const ColorBrandPalette0380$2 = "#007AB8";
	const ColorBrandPalette0390$2 = "#0088CC";
	const ColorBrandPalette03100$2 = "#0099E5";
	const ColorBrandPalette03110$2 = "#00AAFF";
	const ColorBrandPalette03120$2 = "#38BDFF";
	const ColorBrandPalette03130$2 = "#6BCEFF";
	const ColorBrandPalette03140$2 = "#A6E1FF";
	const ColorBrandPalette03150$2 = "#C7ECFF";
	const ColorBrandPalette03160$2 = "#EBF8FF";
	const ColorBrandPalette0410$3 = "#001561";
	const ColorBrandPalette0420$3 = "#001A7A";
	const ColorBrandPalette0430$3 = "#00229E";
	const ColorBrandPalette0440$3 = "#0029BD";
	const ColorBrandPalette0450$3 = "#002FDB";
	const ColorBrandPalette0460$3 = "#0037FF";
	const ColorBrandPalette0470$3 = "#1F4FFF";
	const ColorBrandPalette0480$3 = "#3863FF";
	const ColorBrandPalette0490$3 = "#5277FF";
	const ColorBrandPalette04100$3 = "#6B8BFF";
	const ColorBrandPalette04110$3 = "#809BFF";
	const ColorBrandPalette04120$3 = "#99AFFF";
	const ColorBrandPalette04130$3 = "#ADBFFF";
	const ColorBrandPalette04140$3 = "#C7D3FF";
	const ColorBrandPalette04150$3 = "#DBE3FF";
	const ColorBrandPalette04160$3 = "#F0F3FF";
	const ColorBrandPalette0510$3 = "#251B0E";
	const ColorBrandPalette0520$3 = "#342614";
	const ColorBrandPalette0530$3 = "#433119";
	const ColorBrandPalette0540$3 = "#513C1F";
	const ColorBrandPalette0550$3 = "#604724";
	const ColorBrandPalette0560$3 = "#73552B";
	const ColorBrandPalette0570$3 = "#816031";
	const ColorBrandPalette0580$3 = "#946E38";
	const ColorBrandPalette0590$3 = "#A3793E";
	const ColorBrandPalette05100$3 = "#B98946";
	const ColorBrandPalette05110$3 = "#C39A60";
	const ColorBrandPalette05120$3 = "#CEAC7E";
	const ColorBrandPalette05130$3 = "#D8BD97";
	const ColorBrandPalette05140$3 = "#E3D0B5";
	const ColorBrandPalette05150$3 = "#EEE3D3";
	const ColorBrandPalette05160$3 = "#F8F3EC";
	const ColorFeedbackErrorText$4 = "#BC293A";
	const ColorFeedbackErrorShape$4 = "#EA4356";
	const ColorFeedbackSuccessText$4 = "#22723A";
	const ColorFeedbackSuccessShape$4 = "#2D954C";
	const ColorFeedbackOnBrandErrorText$4 = "#F77E8C";
	const ColorFeedbackOnBrandErrorShape$4 = "#EA4356";
	const ColorFeedbackOnBrandSuccessText$4 = "#38B85E";
	const ColorFeedbackOnBrandSuccessShape$4 = "#2D954C";
	const ColorFeedbackInverseErrorText$4 = "#F55C6E";
	const ColorFeedbackInverseErrorShape$4 = "#D83145";
	const ColorFeedbackInverseSuccessText$4 = "#32A454";
	const ColorFeedbackInverseSuccessShape$4 = "#278142";
	const ColorFeedbackInverseOnBrandErrorText$4 = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape$4 = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText$4 = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape$4 = "#278142";
	const ColorSupport01$4 = "#D82777";
	const ColorSupport02$4 = "#D82777";
	const ColorSupportOnBrand01$4 = "#D82777";
	const ColorSupportOnBrand02$4 = "#DE4A8C";
	const ColorSupportInverse01$4 = "#D82777";
	const ColorSupportInverse02$4 = "#D82777";
	const ColorSupportInverseOnBrand01$4 = "#D82777";
	const ColorSupportInverseOnBrand02$4 = "#D82777";
	const Opacity01$4 = "0.04";
	const Opacity02$4 = "0.08";
	const Opacity03$4 = "0.12";
	const Opacity04$4 = "0.24";
	const Opacity05$4 = "0.32";
	const Opacity06$4 = "0.56";
	const Opacity07$4 = "0.64";
	const Opacity08$4 = "0.72";
	const Opacity09$4 = "0.88";
	const Shadow01$4 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$4 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$4 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$4 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$4 = "4px";
	const SpacingInlineNano$4 = "8px";
	const SpacingInlineXxxs$4 = "16px";
	const SpacingInlineXxs$4 = "24px";
	const SpacingInlineXs$4 = "32px";
	const SpacingInlineSm$4 = "40px";
	const SpacingInlineMd$4 = "48px";
	const SpacingInlineLg$4 = "56px";
	const SpacingInlineXl$4 = "64px";
	const SpacingInlineXxl$4 = "80px";
	const SpacingInlineXxxl$4 = "120px";
	const SpacingInlineHuge$4 = "160px";
	const SpacingInlineGiant$4 = "200px";
	const SpacingInsetQuark$4 = "4px";
	const SpacingInsetNano$4 = "8px";
	const SpacingInsetXs$4 = "16px";
	const SpacingInsetSm$4 = "24px";
	const SpacingInsetMd$4 = "32px";
	const SpacingInsetLg$4 = "40px";
	const SpacingSquishQuark$4 = "4px 8px";
	const SpacingSquishNano$4 = "8px 16px";
	const SpacingSquishXs$4 = "16px 24px";
	const SpacingSquishSm$4 = "16px 32px";
	const SpacingStackQuark$4 = "4px";
	const SpacingStackNano$4 = "8px";
	const SpacingStackXxxs$4 = "16px";
	const SpacingStackXxs$4 = "24px";
	const SpacingStackXs$4 = "32px";
	const SpacingStackSm$4 = "40px";
	const SpacingStackMd$4 = "48px";
	const SpacingStackLg$4 = "56px";
	const SpacingStackXl$4 = "64px";
	const SpacingStackXxl$4 = "80px";
	const SpacingStackXxxl$4 = "120px";
	const SpacingStackHuge$4 = "160px";
	const SpacingStackGiant$4 = "200px";
	const FontFamilyBase$4 = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontSizeXxxs$4 = "0.75rem";
	const FontSizeXxs$4 = "0.875rem";
	const FontSizeXs$4 = "1rem";
	const FontSizeSm$4 = "1.25rem";
	const FontSizeMd$4 = "1.5rem";
	const FontSizeLg$4 = "2rem";
	const FontSizeXl$4 = "2.5rem";
	const FontSizeXxl$4 = "3rem";
	const FontSizeXxxl$4 = "4rem";
	const FontSizeDisplay$4 = "5rem";
	const FontSizeGiant$4 = "6rem";
	const FontWeightBold$4 = 700;
	const FontWeightSemibold$4 = 600;
	const FontWeightMedium$4 = 500;
	const FontWeightRegular$4 = 400;
	const FontWeightLight$4 = 300;
	const LetterSpacingStandard$4 = "0px";
	const LetterSpacingSmall$4 = "-1px";
	const LetterSpacingMedium$4 = "1.5px";
	const LineHeightStandard$4 = "100%";
	const LineHeightTiny$4 = "115%";
	const LineHeightMedium$4 = "120%";
	const LineHeightLarge$4 = "125%";
	const LineHeightDistant$4 = "133%";
	const LineHeightSuperdistant$4 = "150%";
	const LineHeightHuge$4 = "170%";
	const ZIndex0$4 = "0";
	const ZIndex100$4 = "100";
	const ZIndex200$4 = "200";
	const ZIndex300$4 = "300";
	const ZIndex400$4 = "400";
	const ZIndex500$4 = "500";
	const ZIndexAuto$4 = "auto";
	const ZIndexTop$4 = "99999";
	const ZIndexBottom$4 = "-100";

	var index$4 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$4,
		BorderRadiusXs: BorderRadiusXs$4,
		BorderRadiusSm: BorderRadiusSm$4,
		BorderRadiusMd: BorderRadiusMd$4,
		BorderRadiusLg: BorderRadiusLg$4,
		BorderRadiusPill: BorderRadiusPill$4,
		BorderRadiusCircle: BorderRadiusCircle$4,
		BorderWidthNone: BorderWidthNone$4,
		BorderWidthHairline: BorderWidthHairline$4,
		BorderWidthThin: BorderWidthThin$4,
		BorderWidthThick: BorderWidthThick$4,
		BorderWidthHeavy: BorderWidthHeavy$4,
		ColorDatavizInfoText: ColorDatavizInfoText$4,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01$4,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02$4,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03$4,
		ColorDatavizNegativeText: ColorDatavizNegativeText$4,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$4,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$4,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$4,
		ColorDatavizWarningText: ColorDatavizWarningText$4,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01$4,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02$4,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03$4,
		ColorDatavizPositiveText: ColorDatavizPositiveText$4,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$4,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$4,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$4,
		ColorDatavizCatAText: ColorDatavizCatAText$4,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01$4,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02$4,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03$4,
		ColorDatavizCatBText: ColorDatavizCatBText$4,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01$4,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02$4,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03$4,
		ColorDatavizCatCText: ColorDatavizCatCText$4,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01$4,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02$4,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03$4,
		ColorDatavizCatDText: ColorDatavizCatDText$4,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01$4,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02$4,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03$4,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$4,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$4,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$4,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$4,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$4,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$4,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$4,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$4,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$4,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$4,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$4,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$4,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$4,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$4,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$4,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$4,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$4,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$4,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$4,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$4,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$4,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$4,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$4,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$4,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$4,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$4,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$4,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$4,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$4,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$4,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$4,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$4,
		ColorInteractionBlend01: ColorInteractionBlend01$4,
		ColorInteractionBlend02: ColorInteractionBlend02$4,
		ColorInteractionBlend03: ColorInteractionBlend03$4,
		ColorInteractionBlend04: ColorInteractionBlend04$4,
		ColorInteractionBlend05: ColorInteractionBlend05$4,
		ColorInteractionBlend06: ColorInteractionBlend06$4,
		ColorInteractionBlend07: ColorInteractionBlend07$4,
		ColorInteractionBlend08: ColorInteractionBlend08$4,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$4,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$4,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$4,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$4,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$4,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$4,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$4,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$4,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$4,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$4,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$4,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$4,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$4,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$4,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$4,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$4,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$4,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$4,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$4,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$4,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$4,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$4,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$4,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$4,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$4,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$4,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$4,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$4,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$4,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$4,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$4,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$4,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$4,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$4,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$4,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$4,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$4,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$4,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$4,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$4,
		ColorInteractionAccent01: ColorInteractionAccent01$4,
		ColorInteractionAccent02: ColorInteractionAccent02$4,
		ColorInteractionAccent03: ColorInteractionAccent03$4,
		ColorInteractionSubtle01: ColorInteractionSubtle01$4,
		ColorInteractionSubtle02: ColorInteractionSubtle02$4,
		ColorInteractionSubtle03: ColorInteractionSubtle03$4,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$4,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$4,
		ColorInteractionSelectActive: ColorInteractionSelectActive$4,
		ColorInteractionDanger01: ColorInteractionDanger01$4,
		ColorInteractionDanger02: ColorInteractionDanger02$4,
		ColorInteractionDanger03: ColorInteractionDanger03$4,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$4,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$4,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$4,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$4,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$4,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$4,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$4,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$4,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$4,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$4,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$4,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$4,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$4,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$4,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$4,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$4,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$4,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$4,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$4,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$4,
		ColorNeutral10: ColorNeutral10$4,
		ColorNeutral20: ColorNeutral20$4,
		ColorNeutral30: ColorNeutral30$4,
		ColorNeutral00: ColorNeutral00$4,
		ColorNeutralInverse10: ColorNeutralInverse10$4,
		ColorNeutralInverse20: ColorNeutralInverse20$4,
		ColorNeutralInverse30: ColorNeutralInverse30$4,
		ColorNeutralInverse00: ColorNeutralInverse00$4,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$4,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$4,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$4,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$4,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$4,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$4,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$4,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$4,
		ColorPaletteBlack: ColorPaletteBlack$4,
		ColorPaletteWhite: ColorPaletteWhite$4,
		ColorPaletteGray10: ColorPaletteGray10$4,
		ColorPaletteGray20: ColorPaletteGray20$4,
		ColorPaletteGray30: ColorPaletteGray30$4,
		ColorPaletteGray40: ColorPaletteGray40$4,
		ColorPaletteGray50: ColorPaletteGray50$4,
		ColorPaletteGray60: ColorPaletteGray60$4,
		ColorPaletteGray70: ColorPaletteGray70$4,
		ColorPaletteGray80: ColorPaletteGray80$4,
		ColorPaletteGray90: ColorPaletteGray90$4,
		ColorPaletteGray100: ColorPaletteGray100$4,
		ColorPaletteGray110: ColorPaletteGray110$4,
		ColorPaletteGray120: ColorPaletteGray120$4,
		ColorPaletteGray130: ColorPaletteGray130$4,
		ColorPaletteGray140: ColorPaletteGray140$4,
		ColorPaletteGray150: ColorPaletteGray150$4,
		ColorPaletteGray160: ColorPaletteGray160$4,
		ColorPaletteRed10: ColorPaletteRed10$4,
		ColorPaletteRed20: ColorPaletteRed20$4,
		ColorPaletteRed30: ColorPaletteRed30$4,
		ColorPaletteRed40: ColorPaletteRed40$4,
		ColorPaletteRed50: ColorPaletteRed50$4,
		ColorPaletteRed60: ColorPaletteRed60$4,
		ColorPaletteRed70: ColorPaletteRed70$4,
		ColorPaletteRed80: ColorPaletteRed80$4,
		ColorPaletteRed90: ColorPaletteRed90$4,
		ColorPaletteRed100: ColorPaletteRed100$4,
		ColorPaletteRed110: ColorPaletteRed110$4,
		ColorPaletteRed120: ColorPaletteRed120$4,
		ColorPaletteRed130: ColorPaletteRed130$4,
		ColorPaletteRed140: ColorPaletteRed140$4,
		ColorPaletteRed150: ColorPaletteRed150$4,
		ColorPaletteRed160: ColorPaletteRed160$4,
		ColorPaletteYellow10: ColorPaletteYellow10$4,
		ColorPaletteYellow20: ColorPaletteYellow20$4,
		ColorPaletteYellow30: ColorPaletteYellow30$4,
		ColorPaletteYellow40: ColorPaletteYellow40$4,
		ColorPaletteYellow50: ColorPaletteYellow50$4,
		ColorPaletteYellow60: ColorPaletteYellow60$4,
		ColorPaletteYellow70: ColorPaletteYellow70$4,
		ColorPaletteYellow80: ColorPaletteYellow80$4,
		ColorPaletteYellow90: ColorPaletteYellow90$4,
		ColorPaletteYellow100: ColorPaletteYellow100$4,
		ColorPaletteYellow110: ColorPaletteYellow110$4,
		ColorPaletteYellow120: ColorPaletteYellow120$4,
		ColorPaletteYellow130: ColorPaletteYellow130$4,
		ColorPaletteYellow140: ColorPaletteYellow140$4,
		ColorPaletteYellow150: ColorPaletteYellow150$4,
		ColorPaletteYellow160: ColorPaletteYellow160$4,
		ColorPaletteLime10: ColorPaletteLime10$4,
		ColorPaletteLime20: ColorPaletteLime20$4,
		ColorPaletteLime30: ColorPaletteLime30$4,
		ColorPaletteLime40: ColorPaletteLime40$4,
		ColorPaletteLime50: ColorPaletteLime50$4,
		ColorPaletteLime60: ColorPaletteLime60$4,
		ColorPaletteLime70: ColorPaletteLime70$4,
		ColorPaletteLime80: ColorPaletteLime80$4,
		ColorPaletteLime90: ColorPaletteLime90$4,
		ColorPaletteLime100: ColorPaletteLime100$4,
		ColorPaletteLime110: ColorPaletteLime110$4,
		ColorPaletteLime120: ColorPaletteLime120$4,
		ColorPaletteLime130: ColorPaletteLime130$4,
		ColorPaletteLime140: ColorPaletteLime140$4,
		ColorPaletteLime150: ColorPaletteLime150$4,
		ColorPaletteLime160: ColorPaletteLime160$4,
		ColorPaletteGreen10: ColorPaletteGreen10$4,
		ColorPaletteGreen20: ColorPaletteGreen20$4,
		ColorPaletteGreen30: ColorPaletteGreen30$4,
		ColorPaletteGreen40: ColorPaletteGreen40$4,
		ColorPaletteGreen50: ColorPaletteGreen50$4,
		ColorPaletteGreen60: ColorPaletteGreen60$4,
		ColorPaletteGreen70: ColorPaletteGreen70$4,
		ColorPaletteGreen80: ColorPaletteGreen80$4,
		ColorPaletteGreen90: ColorPaletteGreen90$4,
		ColorPaletteGreen100: ColorPaletteGreen100$4,
		ColorPaletteGreen110: ColorPaletteGreen110$4,
		ColorPaletteGreen120: ColorPaletteGreen120$4,
		ColorPaletteGreen130: ColorPaletteGreen130$4,
		ColorPaletteGreen140: ColorPaletteGreen140$4,
		ColorPaletteGreen150: ColorPaletteGreen150$4,
		ColorPaletteGreen160: ColorPaletteGreen160$4,
		ColorPaletteAcqua10: ColorPaletteAcqua10$4,
		ColorPaletteAcqua20: ColorPaletteAcqua20$4,
		ColorPaletteAcqua30: ColorPaletteAcqua30$4,
		ColorPaletteAcqua40: ColorPaletteAcqua40$4,
		ColorPaletteAcqua50: ColorPaletteAcqua50$4,
		ColorPaletteAcqua60: ColorPaletteAcqua60$4,
		ColorPaletteAcqua70: ColorPaletteAcqua70$4,
		ColorPaletteAcqua80: ColorPaletteAcqua80$4,
		ColorPaletteAcqua90: ColorPaletteAcqua90$4,
		ColorPaletteAcqua100: ColorPaletteAcqua100$4,
		ColorPaletteAcqua110: ColorPaletteAcqua110$4,
		ColorPaletteAcqua120: ColorPaletteAcqua120$4,
		ColorPaletteAcqua130: ColorPaletteAcqua130$4,
		ColorPaletteAcqua140: ColorPaletteAcqua140$4,
		ColorPaletteAcqua150: ColorPaletteAcqua150$4,
		ColorPaletteAcqua160: ColorPaletteAcqua160$4,
		ColorPaletteBlue10: ColorPaletteBlue10$4,
		ColorPaletteBlue20: ColorPaletteBlue20$4,
		ColorPaletteBlue30: ColorPaletteBlue30$4,
		ColorPaletteBlue40: ColorPaletteBlue40$4,
		ColorPaletteBlue50: ColorPaletteBlue50$4,
		ColorPaletteBlue60: ColorPaletteBlue60$4,
		ColorPaletteBlue70: ColorPaletteBlue70$4,
		ColorPaletteBlue80: ColorPaletteBlue80$4,
		ColorPaletteBlue90: ColorPaletteBlue90$4,
		ColorPaletteBlue100: ColorPaletteBlue100$4,
		ColorPaletteBlue110: ColorPaletteBlue110$4,
		ColorPaletteBlue120: ColorPaletteBlue120$4,
		ColorPaletteBlue130: ColorPaletteBlue130$4,
		ColorPaletteBlue140: ColorPaletteBlue140$4,
		ColorPaletteBlue150: ColorPaletteBlue150$4,
		ColorPaletteBlue160: ColorPaletteBlue160$4,
		ColorPalettePurple10: ColorPalettePurple10$4,
		ColorPalettePurple20: ColorPalettePurple20$4,
		ColorPalettePurple30: ColorPalettePurple30$4,
		ColorPalettePurple40: ColorPalettePurple40$4,
		ColorPalettePurple50: ColorPalettePurple50$4,
		ColorPalettePurple60: ColorPalettePurple60$4,
		ColorPalettePurple70: ColorPalettePurple70$4,
		ColorPalettePurple80: ColorPalettePurple80$4,
		ColorPalettePurple90: ColorPalettePurple90$4,
		ColorPalettePurple100: ColorPalettePurple100$4,
		ColorPalettePurple110: ColorPalettePurple110$4,
		ColorPalettePurple120: ColorPalettePurple120$4,
		ColorPalettePurple130: ColorPalettePurple130$4,
		ColorPalettePurple140: ColorPalettePurple140$4,
		ColorPalettePurple150: ColorPalettePurple150$4,
		ColorPalettePurple160: ColorPalettePurple160$4,
		ColorPalettePink10: ColorPalettePink10$4,
		ColorPalettePink20: ColorPalettePink20$4,
		ColorPalettePink30: ColorPalettePink30$4,
		ColorPalettePink40: ColorPalettePink40$4,
		ColorPalettePink50: ColorPalettePink50$4,
		ColorPalettePink60: ColorPalettePink60$4,
		ColorPalettePink70: ColorPalettePink70$4,
		ColorPalettePink80: ColorPalettePink80$4,
		ColorPalettePink90: ColorPalettePink90$4,
		ColorPalettePink100: ColorPalettePink100$4,
		ColorPalettePink110: ColorPalettePink110$4,
		ColorPalettePink120: ColorPalettePink120$4,
		ColorPalettePink130: ColorPalettePink130$4,
		ColorPalettePink140: ColorPalettePink140$4,
		ColorPalettePink150: ColorPalettePink150$4,
		ColorPalettePink160: ColorPalettePink160$4,
		ColorTypefaceStrong: ColorTypefaceStrong$4,
		ColorTypefacePure: ColorTypefacePure$4,
		ColorTypefaceSmooth: ColorTypefaceSmooth$4,
		ColorTypefaceMeld: ColorTypefaceMeld$4,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$4,
		ColorTypefaceInversePure: ColorTypefaceInversePure$4,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$4,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$4,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$4,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$4,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$4,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$4,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$4,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$4,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$4,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$4,
		ColorBrandPrimary10: ColorBrandPrimary10$4,
		ColorBrandPrimary20: ColorBrandPrimary20$4,
		ColorBrandPrimary30: ColorBrandPrimary30$4,
		ColorBrandPrimary40: ColorBrandPrimary40$4,
		ColorBrandPrimary50: ColorBrandPrimary50$4,
		ColorBrandPrimary60: ColorBrandPrimary60$4,
		ColorBrandPrimary70: ColorBrandPrimary70$4,
		ColorBrandPrimary80: ColorBrandPrimary80$4,
		ColorBrandPrimary90: ColorBrandPrimary90$4,
		ColorBrandPrimary100: ColorBrandPrimary100$4,
		ColorBrandPrimary110: ColorBrandPrimary110$4,
		ColorBrandPrimary120: ColorBrandPrimary120$4,
		ColorBrandPrimary130: ColorBrandPrimary130$4,
		ColorBrandPrimary140: ColorBrandPrimary140$4,
		ColorBrandPrimary150: ColorBrandPrimary150$4,
		ColorBrandPrimary160: ColorBrandPrimary160$4,
		ColorBrandBase01: ColorBrandBase01$4,
		ColorBrandBase02: ColorBrandBase02$4,
		ColorBrandBase03: ColorBrandBase03$3,
		ColorBrandBase04: ColorBrandBase04$3,
		ColorBrandBase05: ColorBrandBase05$3,
		ColorBrandPalette0110: ColorBrandPalette0110$4,
		ColorBrandPalette0120: ColorBrandPalette0120$4,
		ColorBrandPalette0130: ColorBrandPalette0130$4,
		ColorBrandPalette0140: ColorBrandPalette0140$4,
		ColorBrandPalette0150: ColorBrandPalette0150$4,
		ColorBrandPalette0160: ColorBrandPalette0160$4,
		ColorBrandPalette0170: ColorBrandPalette0170$4,
		ColorBrandPalette0180: ColorBrandPalette0180$4,
		ColorBrandPalette0190: ColorBrandPalette0190$4,
		ColorBrandPalette01100: ColorBrandPalette01100$4,
		ColorBrandPalette01110: ColorBrandPalette01110$4,
		ColorBrandPalette01120: ColorBrandPalette01120$4,
		ColorBrandPalette01130: ColorBrandPalette01130$4,
		ColorBrandPalette01140: ColorBrandPalette01140$4,
		ColorBrandPalette01150: ColorBrandPalette01150$4,
		ColorBrandPalette01160: ColorBrandPalette01160$4,
		ColorBrandPalette0210: ColorBrandPalette0210$4,
		ColorBrandPalette0220: ColorBrandPalette0220$4,
		ColorBrandPalette0230: ColorBrandPalette0230$4,
		ColorBrandPalette0240: ColorBrandPalette0240$4,
		ColorBrandPalette0250: ColorBrandPalette0250$4,
		ColorBrandPalette0260: ColorBrandPalette0260$4,
		ColorBrandPalette0270: ColorBrandPalette0270$4,
		ColorBrandPalette0280: ColorBrandPalette0280$4,
		ColorBrandPalette0290: ColorBrandPalette0290$4,
		ColorBrandPalette02100: ColorBrandPalette02100$4,
		ColorBrandPalette02110: ColorBrandPalette02110$4,
		ColorBrandPalette02120: ColorBrandPalette02120$4,
		ColorBrandPalette02130: ColorBrandPalette02130$4,
		ColorBrandPalette02140: ColorBrandPalette02140$4,
		ColorBrandPalette02150: ColorBrandPalette02150$4,
		ColorBrandPalette02160: ColorBrandPalette02160$4,
		ColorBrandPalette0310: ColorBrandPalette0310$2,
		ColorBrandPalette0320: ColorBrandPalette0320$2,
		ColorBrandPalette0330: ColorBrandPalette0330$2,
		ColorBrandPalette0340: ColorBrandPalette0340$2,
		ColorBrandPalette0350: ColorBrandPalette0350$2,
		ColorBrandPalette0360: ColorBrandPalette0360$2,
		ColorBrandPalette0370: ColorBrandPalette0370$2,
		ColorBrandPalette0380: ColorBrandPalette0380$2,
		ColorBrandPalette0390: ColorBrandPalette0390$2,
		ColorBrandPalette03100: ColorBrandPalette03100$2,
		ColorBrandPalette03110: ColorBrandPalette03110$2,
		ColorBrandPalette03120: ColorBrandPalette03120$2,
		ColorBrandPalette03130: ColorBrandPalette03130$2,
		ColorBrandPalette03140: ColorBrandPalette03140$2,
		ColorBrandPalette03150: ColorBrandPalette03150$2,
		ColorBrandPalette03160: ColorBrandPalette03160$2,
		ColorBrandPalette0410: ColorBrandPalette0410$3,
		ColorBrandPalette0420: ColorBrandPalette0420$3,
		ColorBrandPalette0430: ColorBrandPalette0430$3,
		ColorBrandPalette0440: ColorBrandPalette0440$3,
		ColorBrandPalette0450: ColorBrandPalette0450$3,
		ColorBrandPalette0460: ColorBrandPalette0460$3,
		ColorBrandPalette0470: ColorBrandPalette0470$3,
		ColorBrandPalette0480: ColorBrandPalette0480$3,
		ColorBrandPalette0490: ColorBrandPalette0490$3,
		ColorBrandPalette04100: ColorBrandPalette04100$3,
		ColorBrandPalette04110: ColorBrandPalette04110$3,
		ColorBrandPalette04120: ColorBrandPalette04120$3,
		ColorBrandPalette04130: ColorBrandPalette04130$3,
		ColorBrandPalette04140: ColorBrandPalette04140$3,
		ColorBrandPalette04150: ColorBrandPalette04150$3,
		ColorBrandPalette04160: ColorBrandPalette04160$3,
		ColorBrandPalette0510: ColorBrandPalette0510$3,
		ColorBrandPalette0520: ColorBrandPalette0520$3,
		ColorBrandPalette0530: ColorBrandPalette0530$3,
		ColorBrandPalette0540: ColorBrandPalette0540$3,
		ColorBrandPalette0550: ColorBrandPalette0550$3,
		ColorBrandPalette0560: ColorBrandPalette0560$3,
		ColorBrandPalette0570: ColorBrandPalette0570$3,
		ColorBrandPalette0580: ColorBrandPalette0580$3,
		ColorBrandPalette0590: ColorBrandPalette0590$3,
		ColorBrandPalette05100: ColorBrandPalette05100$3,
		ColorBrandPalette05110: ColorBrandPalette05110$3,
		ColorBrandPalette05120: ColorBrandPalette05120$3,
		ColorBrandPalette05130: ColorBrandPalette05130$3,
		ColorBrandPalette05140: ColorBrandPalette05140$3,
		ColorBrandPalette05150: ColorBrandPalette05150$3,
		ColorBrandPalette05160: ColorBrandPalette05160$3,
		ColorFeedbackErrorText: ColorFeedbackErrorText$4,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$4,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$4,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$4,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$4,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$4,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$4,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$4,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$4,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$4,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$4,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$4,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$4,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$4,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$4,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$4,
		ColorSupport01: ColorSupport01$4,
		ColorSupport02: ColorSupport02$4,
		ColorSupportOnBrand01: ColorSupportOnBrand01$4,
		ColorSupportOnBrand02: ColorSupportOnBrand02$4,
		ColorSupportInverse01: ColorSupportInverse01$4,
		ColorSupportInverse02: ColorSupportInverse02$4,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$4,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$4,
		Opacity01: Opacity01$4,
		Opacity02: Opacity02$4,
		Opacity03: Opacity03$4,
		Opacity04: Opacity04$4,
		Opacity05: Opacity05$4,
		Opacity06: Opacity06$4,
		Opacity07: Opacity07$4,
		Opacity08: Opacity08$4,
		Opacity09: Opacity09$4,
		Shadow01: Shadow01$4,
		Shadow02: Shadow02$4,
		Shadow03: Shadow03$4,
		Shadow04: Shadow04$4,
		SpacingInlineQuark: SpacingInlineQuark$4,
		SpacingInlineNano: SpacingInlineNano$4,
		SpacingInlineXxxs: SpacingInlineXxxs$4,
		SpacingInlineXxs: SpacingInlineXxs$4,
		SpacingInlineXs: SpacingInlineXs$4,
		SpacingInlineSm: SpacingInlineSm$4,
		SpacingInlineMd: SpacingInlineMd$4,
		SpacingInlineLg: SpacingInlineLg$4,
		SpacingInlineXl: SpacingInlineXl$4,
		SpacingInlineXxl: SpacingInlineXxl$4,
		SpacingInlineXxxl: SpacingInlineXxxl$4,
		SpacingInlineHuge: SpacingInlineHuge$4,
		SpacingInlineGiant: SpacingInlineGiant$4,
		SpacingInsetQuark: SpacingInsetQuark$4,
		SpacingInsetNano: SpacingInsetNano$4,
		SpacingInsetXs: SpacingInsetXs$4,
		SpacingInsetSm: SpacingInsetSm$4,
		SpacingInsetMd: SpacingInsetMd$4,
		SpacingInsetLg: SpacingInsetLg$4,
		SpacingSquishQuark: SpacingSquishQuark$4,
		SpacingSquishNano: SpacingSquishNano$4,
		SpacingSquishXs: SpacingSquishXs$4,
		SpacingSquishSm: SpacingSquishSm$4,
		SpacingStackQuark: SpacingStackQuark$4,
		SpacingStackNano: SpacingStackNano$4,
		SpacingStackXxxs: SpacingStackXxxs$4,
		SpacingStackXxs: SpacingStackXxs$4,
		SpacingStackXs: SpacingStackXs$4,
		SpacingStackSm: SpacingStackSm$4,
		SpacingStackMd: SpacingStackMd$4,
		SpacingStackLg: SpacingStackLg$4,
		SpacingStackXl: SpacingStackXl$4,
		SpacingStackXxl: SpacingStackXxl$4,
		SpacingStackXxxl: SpacingStackXxxl$4,
		SpacingStackHuge: SpacingStackHuge$4,
		SpacingStackGiant: SpacingStackGiant$4,
		FontFamilyBase: FontFamilyBase$4,
		FontSizeXxxs: FontSizeXxxs$4,
		FontSizeXxs: FontSizeXxs$4,
		FontSizeXs: FontSizeXs$4,
		FontSizeSm: FontSizeSm$4,
		FontSizeMd: FontSizeMd$4,
		FontSizeLg: FontSizeLg$4,
		FontSizeXl: FontSizeXl$4,
		FontSizeXxl: FontSizeXxl$4,
		FontSizeXxxl: FontSizeXxxl$4,
		FontSizeDisplay: FontSizeDisplay$4,
		FontSizeGiant: FontSizeGiant$4,
		FontWeightBold: FontWeightBold$4,
		FontWeightSemibold: FontWeightSemibold$4,
		FontWeightMedium: FontWeightMedium$4,
		FontWeightRegular: FontWeightRegular$4,
		FontWeightLight: FontWeightLight$4,
		LetterSpacingStandard: LetterSpacingStandard$4,
		LetterSpacingSmall: LetterSpacingSmall$4,
		LetterSpacingMedium: LetterSpacingMedium$4,
		LineHeightStandard: LineHeightStandard$4,
		LineHeightTiny: LineHeightTiny$4,
		LineHeightMedium: LineHeightMedium$4,
		LineHeightLarge: LineHeightLarge$4,
		LineHeightDistant: LineHeightDistant$4,
		LineHeightSuperdistant: LineHeightSuperdistant$4,
		LineHeightHuge: LineHeightHuge$4,
		ZIndex0: ZIndex0$4,
		ZIndex100: ZIndex100$4,
		ZIndex200: ZIndex200$4,
		ZIndex300: ZIndex300$4,
		ZIndex400: ZIndex400$4,
		ZIndex500: ZIndex500$4,
		ZIndexAuto: ZIndexAuto$4,
		ZIndexTop: ZIndexTop$4,
		ZIndexBottom: ZIndexBottom$4
	});

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:01 GMT
	 */

	const BorderRadiusNone$3 = "0px";
	const BorderRadiusXs$3 = "4px";
	const BorderRadiusSm$3 = "8px";
	const BorderRadiusMd$3 = "16px";
	const BorderRadiusLg$3 = "24px";
	const BorderRadiusPill$3 = "960px";
	const BorderRadiusCircle$3 = "50%";
	const BorderWidthNone$3 = "0px";
	const BorderWidthHairline$3 = "1px";
	const BorderWidthThin$3 = "2px";
	const BorderWidthThick$3 = "4px";
	const BorderWidthHeavy$3 = "8px";
	const ColorDatavizInfoText$3 = "#0F58EA";
	const ColorDatavizInfoShape01$3 = "#3F7BF2";
	const ColorDatavizInfoShape02$3 = "#D9E5FC";
	const ColorDatavizInfoShape03$3 = "#F1F5FE";
	const ColorDatavizNegativeText$3 = "#BC293A";
	const ColorDatavizNegativeShape01$3 = "#EA4356";
	const ColorDatavizNegativeShape02$3 = "#FDDDE1";
	const ColorDatavizNegativeShape03$3 = "#FEF1F2";
	const ColorDatavizWarningText$3 = "#A04C03";
	const ColorDatavizWarningShape01$3 = "#D26404";
	const ColorDatavizWarningShape02$3 = "#FEE1C8";
	const ColorDatavizWarningShape03$3 = "#FEF1E6";
	const ColorDatavizPositiveText$3 = "#22723A";
	const ColorDatavizPositiveShape01$3 = "#2D954C";
	const ColorDatavizPositiveShape02$3 = "#C8EED3";
	const ColorDatavizPositiveShape03$3 = "#E8F8EC";
	const ColorDatavizCatAText$3 = "#9B18DC";
	const ColorDatavizCatAShape01$3 = "#B851EC";
	const ColorDatavizCatAShape02$3 = "#F2DFFB";
	const ColorDatavizCatAShape03$3 = "#F9F1FD";
	const ColorDatavizCatBText$3 = "#BA267B";
	const ColorDatavizCatBShape01$3 = "#DA499B";
	const ColorDatavizCatBShape02$3 = "#F8DDEC";
	const ColorDatavizCatBShape03$3 = "#FCF2F8";
	const ColorDatavizCatCText$3 = "#546E21";
	const ColorDatavizCatCShape01$3 = "#6C8D2B";
	const ColorDatavizCatCShape02$3 = "#DBEBBD";
	const ColorDatavizCatCShape03$3 = "#F0F7E4";
	const ColorDatavizCatDText$3 = "#0D735E";
	const ColorDatavizCatDShape01$3 = "#109379";
	const ColorDatavizCatDShape02$3 = "#BCF0E6";
	const ColorDatavizCatDShape03$3 = "#DFFBF6";
	const ColorDatavizInverseInfoText$3 = "#5C8FF5";
	const ColorDatavizInverseInfoShape01$3 = "#286BF1";
	const ColorDatavizInverseInfoShape02$3 = "#062560";
	const ColorDatavizInverseInfoShape03$3 = "#051B48";
	const ColorDatavizInverseNegativeText$3 = "#F55C6E";
	const ColorDatavizInverseNegativeShape01$3 = "#D83145";
	const ColorDatavizInverseNegativeShape02$3 = "#4F1119";
	const ColorDatavizInverseNegativeShape03$3 = "#3B0D12";
	const ColorDatavizInverseWarningText$3 = "#EB7005";
	const ColorDatavizInverseWarningShape01$3 = "#B95804";
	const ColorDatavizInverseWarningShape02$3 = "#462101";
	const ColorDatavizInverseWarningShape03$3 = "#321701";
	const ColorDatavizInversePositiveText$3 = "#32A454";
	const ColorDatavizInversePositiveShape01$3 = "#278142";
	const ColorDatavizInversePositiveShape02$3 = "#0E2F18";
	const ColorDatavizInversePositiveShape03$3 = "#0B2312";
	const ColorDatavizInverseCatAText$3 = "#C36CEF";
	const ColorDatavizInverseCatAShape01$3 = "#AD35E9";
	const ColorDatavizInverseCatAShape02$3 = "#440B60";
	const ColorDatavizInverseCatAShape03$3 = "#340849";
	const ColorDatavizInverseCatBText$3 = "#E067AB";
	const ColorDatavizInverseCatBShape01$3 = "#D42B8C";
	const ColorDatavizInverseCatBShape02$3 = "#4C1032";
	const ColorDatavizInverseCatBShape03$3 = "#3B0C27";
	const ColorDatavizInverseCatCText$3 = "#789D2F";
	const ColorDatavizInverseCatCShape01$3 = "#607E26";
	const ColorDatavizInverseCatCShape02$3 = "#212B0D";
	const ColorDatavizInverseCatCShape03$3 = "#1B230B";
	const ColorDatavizInverseCatDText$3 = "#12A588";
	const ColorDatavizInverseCatDShape01$3 = "#0F856D";
	const ColorDatavizInverseCatDShape02$3 = "#052E26";
	const ColorDatavizInverseCatDShape03$3 = "#04251E";
	const ColorInteractionBlend01$3 = "#1616160A";
	const ColorInteractionBlend02$3 = "#16161614";
	const ColorInteractionBlend03$3 = "#1616161F";
	const ColorInteractionBlend04$3 = "#1616163D";
	const ColorInteractionBlend05$3 = "#161616A3";
	const ColorInteractionBlend06$3 = "#161616B8";
	const ColorInteractionBlend07$3 = "#161616E0";
	const ColorInteractionBlend08$3 = "#161616";
	const ColorInteractionInverseBlend01$3 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$3 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$3 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$3 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$3 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$3 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$3 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$3 = "#FEFEFE";
	const ColorInteractionInverseAccent01$3 = "#D661E5";
	const ColorInteractionInverseAccent02$3 = "#DE80EA";
	const ColorInteractionInverseAccent03$3 = "#E59AEF";
	const ColorInteractionInverseSubtle01$3 = "#CE42E01F";
	const ColorInteractionInverseSubtle02$3 = "#CE42E03D";
	const ColorInteractionInverseSubtle03$3 = "#CE42E052";
	const ColorInteractionInverseSelectDefault$3 = "#919191";
	const ColorInteractionInverseSelectFocus$3 = "#D4D4D4";
	const ColorInteractionInverseSelectActive$3 = "#E59AEF";
	const ColorInteractionInverseDanger01$3 = "#F55C6E";
	const ColorInteractionInverseDanger02$3 = "#F77E8C";
	const ColorInteractionInverseDanger03$3 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01$3 = "#4C0056";
	const ColorInteractionInverseOnBrandAccent02$3 = "#5F006B";
	const ColorInteractionInverseOnBrandAccent03$3 = "#730382";
	const ColorInteractionInverseOnBrandSubtle01$3 = "#AD15C11F";
	const ColorInteractionInverseOnBrandSubtle02$3 = "#AD15C13D";
	const ColorInteractionInverseOnBrandSubtle03$3 = "#AD15C152";
	const ColorInteractionInverseOnBrandSelectDefault$3 = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus$3 = "#363636";
	const ColorInteractionInverseOnBrandSelectActive$3 = "#5F006B";
	const ColorInteractionInverseOnBrandBlend01$3 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$3 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$3 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$3 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$3 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$3 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$3 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$3 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$3 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02$3 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03$3 = "#7E1B27";
	const ColorInteractionAccent01$3 = "#4C0056";
	const ColorInteractionAccent02$3 = "#5F006B";
	const ColorInteractionAccent03$3 = "#730382";
	const ColorInteractionSubtle01$3 = "#C223D71F";
	const ColorInteractionSubtle02$3 = "#C223D73D";
	const ColorInteractionSubtle03$3 = "#C223D752";
	const ColorInteractionSelectDefault$3 = "#666666";
	const ColorInteractionSelectFocus$3 = "#363636";
	const ColorInteractionSelectActive$3 = "#730382";
	const ColorInteractionDanger01$3 = "#BC293A";
	const ColorInteractionDanger02$3 = "#A72534";
	const ColorInteractionDanger03$3 = "#92202E";
	const ColorInteractionOnBrandAccent01$3 = "#FEFEFE";
	const ColorInteractionOnBrandAccent02$3 = "#FCF2FD";
	const ColorInteractionOnBrandAccent03$3 = "#ECB4F3";
	const ColorInteractionOnBrandSubtle01$3 = "#DE80EA1F";
	const ColorInteractionOnBrandSubtle02$3 = "#DE80EA3D";
	const ColorInteractionOnBrandSubtle03$3 = "#DE80EA52";
	const ColorInteractionOnBrandSelectDefault$3 = "#E6E6E6";
	const ColorInteractionOnBrandSelectFocus$3 = "#FEFEFE";
	const ColorInteractionOnBrandSelectActive$3 = "#ECB4F3";
	const ColorInteractionOnBrandBlend01$3 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$3 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$3 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$3 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$3 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$3 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$3 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$3 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$3 = "#F895A1";
	const ColorInteractionOnBrandDanger02$3 = "#FAAEB6";
	const ColorInteractionOnBrandDanger03$3 = "#FBC5CC";
	const ColorNeutral10$3 = "#F5F5F5";
	const ColorNeutral20$3 = "#E6E6E6";
	const ColorNeutral30$3 = "#1616163D";
	const ColorNeutral00$3 = "#FEFEFE";
	const ColorNeutralInverse10$3 = "#1F1F1F";
	const ColorNeutralInverse20$3 = "#292929";
	const ColorNeutralInverse30$3 = "#FEFEFE3D";
	const ColorNeutralInverse00$3 = "#161616";
	const ColorNeutralInverseOnBrand10$3 = "#FCF2FD";
	const ColorNeutralInverseOnBrand20$3 = "#F1CAF6";
	const ColorNeutralInverseOnBrand30$3 = "#C223D77A";
	const ColorNeutralInverseOnBrand00$3 = "#FCF2FD";
	const ColorNeutralOnBrand10$3 = "#5F006B";
	const ColorNeutralOnBrand20$3 = "#730382";
	const ColorNeutralOnBrand30$3 = "#CE42E0A3";
	const ColorNeutralOnBrand00$3 = "#4C0056";
	const ColorPaletteBlack$3 = "#161616";
	const ColorPaletteWhite$3 = "#FEFEFE";
	const ColorPaletteGray10$3 = "#1F1F1F";
	const ColorPaletteGray20$3 = "#292929";
	const ColorPaletteGray30$3 = "#363636";
	const ColorPaletteGray40$3 = "#404040";
	const ColorPaletteGray50$3 = "#4C4C4C";
	const ColorPaletteGray60$3 = "#595959";
	const ColorPaletteGray70$3 = "#666666";
	const ColorPaletteGray80$3 = "#737373";
	const ColorPaletteGray90$3 = "#828282";
	const ColorPaletteGray100$3 = "#919191";
	const ColorPaletteGray110$3 = "#A1A1A1";
	const ColorPaletteGray120$3 = "#B0B0B0";
	const ColorPaletteGray130$3 = "#C2C2C2";
	const ColorPaletteGray140$3 = "#D4D4D4";
	const ColorPaletteGray150$3 = "#E6E6E6";
	const ColorPaletteGray160$3 = "#F5F5F5";
	const ColorPaletteRed10$3 = "#3B0D12";
	const ColorPaletteRed20$3 = "#4F1119";
	const ColorPaletteRed30$3 = "#691721";
	const ColorPaletteRed40$3 = "#7E1B27";
	const ColorPaletteRed50$3 = "#92202E";
	const ColorPaletteRed60$3 = "#A72534";
	const ColorPaletteRed70$3 = "#BC293A";
	const ColorPaletteRed80$3 = "#D83145";
	const ColorPaletteRed90$3 = "#EA4356";
	const ColorPaletteRed100$3 = "#F55C6E";
	const ColorPaletteRed110$3 = "#F77E8C";
	const ColorPaletteRed120$3 = "#F895A1";
	const ColorPaletteRed130$3 = "#FAAEB6";
	const ColorPaletteRed140$3 = "#FBC5CC";
	const ColorPaletteRed150$3 = "#FDDDE1";
	const ColorPaletteRed160$3 = "#FEF1F2";
	const ColorPaletteYellow10$3 = "#321701";
	const ColorPaletteYellow20$3 = "#462101";
	const ColorPaletteYellow30$3 = "#552802";
	const ColorPaletteYellow40$3 = "#693102";
	const ColorPaletteYellow50$3 = "#7D3B03";
	const ColorPaletteYellow60$3 = "#914503";
	const ColorPaletteYellow70$3 = "#A04C03";
	const ColorPaletteYellow80$3 = "#B95804";
	const ColorPaletteYellow90$3 = "#D26404";
	const ColorPaletteYellow100$3 = "#EB7005";
	const ColorPaletteYellow110$3 = "#FA8219";
	const ColorPaletteYellow120$3 = "#FB9B46";
	const ColorPaletteYellow130$3 = "#FCB06E";
	const ColorPaletteYellow140$3 = "#FDC99B";
	const ColorPaletteYellow150$3 = "#FEE1C8";
	const ColorPaletteYellow160$3 = "#FEF1E6";
	const ColorPaletteLime10$3 = "#1B230B";
	const ColorPaletteLime20$3 = "#212B0D";
	const ColorPaletteLime30$3 = "#2D3B12";
	const ColorPaletteLime40$3 = "#364616";
	const ColorPaletteLime50$3 = "#3F5219";
	const ColorPaletteLime60$3 = "#485E1D";
	const ColorPaletteLime70$3 = "#546E21";
	const ColorPaletteLime80$3 = "#607E26";
	const ColorPaletteLime90$3 = "#6C8D2B";
	const ColorPaletteLime100$3 = "#789D2F";
	const ColorPaletteLime110$3 = "#84AC34";
	const ColorPaletteLime120$3 = "#93BF3A";
	const ColorPaletteLime130$3 = "#A9CF5E";
	const ColorPaletteLime140$3 = "#C2DD8D";
	const ColorPaletteLime150$3 = "#DBEBBD";
	const ColorPaletteLime160$3 = "#F0F7E4";
	const ColorPaletteGreen10$3 = "#0B2312";
	const ColorPaletteGreen20$3 = "#0E2F18";
	const ColorPaletteGreen30$3 = "#133E20";
	const ColorPaletteGreen40$3 = "#174A26";
	const ColorPaletteGreen50$3 = "#1A562C";
	const ColorPaletteGreen60$3 = "#1F6634";
	const ColorPaletteGreen70$3 = "#22723A";
	const ColorPaletteGreen80$3 = "#278142";
	const ColorPaletteGreen90$3 = "#2D954C";
	const ColorPaletteGreen100$3 = "#32A454";
	const ColorPaletteGreen110$3 = "#38B85E";
	const ColorPaletteGreen120$3 = "#4BC870";
	const ColorPaletteGreen130$3 = "#76D692";
	const ColorPaletteGreen140$3 = "#9DE2B1";
	const ColorPaletteGreen150$3 = "#C8EED3";
	const ColorPaletteGreen160$3 = "#E8F8EC";
	const ColorPaletteAcqua10$3 = "#04251E";
	const ColorPaletteAcqua20$3 = "#052E26";
	const ColorPaletteAcqua30$3 = "#073C31";
	const ColorPaletteAcqua40$3 = "#08493C";
	const ColorPaletteAcqua50$3 = "#0A5748";
	const ColorPaletteAcqua60$3 = "#0B6553";
	const ColorPaletteAcqua70$3 = "#0D735E";
	const ColorPaletteAcqua80$3 = "#0F856D";
	const ColorPaletteAcqua90$3 = "#109379";
	const ColorPaletteAcqua100$3 = "#12A588";
	const ColorPaletteAcqua110$3 = "#14B897";
	const ColorPaletteAcqua120$3 = "#31C4A6";
	const ColorPaletteAcqua130$3 = "#68D4BF";
	const ColorPaletteAcqua140$3 = "#8DE2D1";
	const ColorPaletteAcqua150$3 = "#BCF0E6";
	const ColorPaletteAcqua160$3 = "#DFFBF6";
	const ColorPaletteBlue10$3 = "#051B48";
	const ColorPaletteBlue20$3 = "#062560";
	const ColorPaletteBlue30$3 = "#082F7D";
	const ColorPaletteBlue40$3 = "#0A3A9A";
	const ColorPaletteBlue50$3 = "#0B43B1";
	const ColorPaletteBlue60$3 = "#0D4ECE";
	const ColorPaletteBlue70$3 = "#0F58EA";
	const ColorPaletteBlue80$3 = "#286BF1";
	const ColorPaletteBlue90$3 = "#3F7BF2";
	const ColorPaletteBlue100$3 = "#5C8FF5";
	const ColorPaletteBlue110$3 = "#73A0F7";
	const ColorPaletteBlue120$3 = "#8CB0F8";
	const ColorPaletteBlue130$3 = "#A9C4F9";
	const ColorPaletteBlue140$3 = "#C1D4FB";
	const ColorPaletteBlue150$3 = "#D9E5FC";
	const ColorPaletteBlue160$3 = "#F1F5FE";
	const ColorPalettePurple10$3 = "#340849";
	const ColorPalettePurple20$3 = "#440B60";
	const ColorPalettePurple30$3 = "#540D78";
	const ColorPalettePurple40$3 = "#671093";
	const ColorPalettePurple50$3 = "#7713AA";
	const ColorPalettePurple60$3 = "#8B16C5";
	const ColorPalettePurple70$3 = "#9B18DC";
	const ColorPalettePurple80$3 = "#AD35E9";
	const ColorPalettePurple90$3 = "#B851EC";
	const ColorPalettePurple100$3 = "#C36CEF";
	const ColorPalettePurple110$3 = "#CC83F1";
	const ColorPalettePurple120$3 = "#D69AF4";
	const ColorPalettePurple130$3 = "#DFB1F6";
	const ColorPalettePurple140$3 = "#E8C8F9";
	const ColorPalettePurple150$3 = "#F2DFFB";
	const ColorPalettePurple160$3 = "#F9F1FD";
	const ColorPalettePink10$3 = "#3B0C27";
	const ColorPalettePink20$3 = "#4C1032";
	const ColorPalettePink30$3 = "#661543";
	const ColorPalettePink40$3 = "#77184E";
	const ColorPalettePink50$3 = "#8C1C5D";
	const ColorPalettePink60$3 = "#A12169";
	const ColorPalettePink70$3 = "#BA267B";
	const ColorPalettePink80$3 = "#D42B8C";
	const ColorPalettePink90$3 = "#DA499B";
	const ColorPalettePink100$3 = "#E067AB";
	const ColorPalettePink110$3 = "#E580B9";
	const ColorPalettePink120$3 = "#EA99C7";
	const ColorPalettePink130$3 = "#EFAFD3";
	const ColorPalettePink140$3 = "#F4C8E1";
	const ColorPalettePink150$3 = "#F8DDEC";
	const ColorPalettePink160$3 = "#FCF2F8";
	const ColorTypefaceStrong$3 = "#161616";
	const ColorTypefacePure$3 = "#363636";
	const ColorTypefaceSmooth$3 = "#666666";
	const ColorTypefaceMeld$3 = "#1616163D";
	const ColorTypefaceInverseStrong$3 = "#FEFEFE";
	const ColorTypefaceInversePure$3 = "#D4D4D4";
	const ColorTypefaceInverseSmooth$3 = "#919191";
	const ColorTypefaceInverseMeld$3 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$3 = "#161616";
	const ColorTypefaceInverseOnBrandPure$3 = "#363636";
	const ColorTypefaceInverseOnBrandSmooth$3 = "#666666";
	const ColorTypefaceInverseOnBrandMeld$3 = "#1616163D";
	const ColorTypefaceOnBrandStrong$3 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$3 = "#FCF2FD";
	const ColorTypefaceOnBrandSmooth$3 = "#F1CAF6";
	const ColorTypefaceOnBrandMeld$3 = "#FEFEFE52";
	const ColorBrandPrimary10$3 = "#3B0042";
	const ColorBrandPrimary20$3 = "#4C0056";
	const ColorBrandPrimary30$3 = "#5F006B";
	const ColorBrandPrimary40$3 = "#730382";
	const ColorBrandPrimary50$3 = "#850396";
	const ColorBrandPrimary60$3 = "#9A0BAD";
	const ColorBrandPrimary70$3 = "#AD15C1";
	const ColorBrandPrimary80$3 = "#C223D7";
	const ColorBrandPrimary90$3 = "#CE42E0";
	const ColorBrandPrimary100$3 = "#D661E5";
	const ColorBrandPrimary110$3 = "#DE80EA";
	const ColorBrandPrimary120$3 = "#E59AEF";
	const ColorBrandPrimary130$3 = "#ECB4F3";
	const ColorBrandPrimary140$3 = "#F1CAF6";
	const ColorBrandPrimary150$3 = "#FCF2FD";
	const ColorBrandPrimary160$3 = "#FCF2FD";
	const ColorBrandBase01$3 = "#4C0056";
	const ColorBrandBase02$3 = "#3C698B";
	const ColorBrandPalette0110$3 = "#3B0042";
	const ColorBrandPalette0120$3 = "#4C0056";
	const ColorBrandPalette0130$3 = "#5F006B";
	const ColorBrandPalette0140$3 = "#730382";
	const ColorBrandPalette0150$3 = "#850396";
	const ColorBrandPalette0160$3 = "#9A0BAD";
	const ColorBrandPalette0170$3 = "#AD15C1";
	const ColorBrandPalette0180$3 = "#C223D7";
	const ColorBrandPalette0190$3 = "#CE42E0";
	const ColorBrandPalette01100$3 = "#D661E5";
	const ColorBrandPalette01110$3 = "#DE80EA";
	const ColorBrandPalette01120$3 = "#E59AEF";
	const ColorBrandPalette01130$3 = "#ECB4F3";
	const ColorBrandPalette01140$3 = "#F1CAF6";
	const ColorBrandPalette01150$3 = "#FCF2FD";
	const ColorBrandPalette01160$3 = "#FCF2FD";
	const ColorBrandPalette0210$3 = "#12202B";
	const ColorBrandPalette0220$3 = "#182B39";
	const ColorBrandPalette0230$3 = "#20384B";
	const ColorBrandPalette0240$3 = "#264359";
	const ColorBrandPalette0250$3 = "#2E516B";
	const ColorBrandPalette0260$3 = "#345B79";
	const ColorBrandPalette0270$3 = "#3C698B";
	const ColorBrandPalette0280$3 = "#4579A1";
	const ColorBrandPalette0290$3 = "#4D86B2";
	const ColorBrandPalette02100$3 = "#6597BD";
	const ColorBrandPalette02110$3 = "#7BA5C6";
	const ColorBrandPalette02120$3 = "#90B4D0";
	const ColorBrandPalette02130$3 = "#A9C5DA";
	const ColorBrandPalette02140$3 = "#C2D6E5";
	const ColorBrandPalette02150$3 = "#DBE7F0";
	const ColorBrandPalette02160$3 = "#F1F5F9";
	const ColorFeedbackErrorText$3 = "#BC293A";
	const ColorFeedbackErrorShape$3 = "#EA4356";
	const ColorFeedbackSuccessText$3 = "#22723A";
	const ColorFeedbackSuccessShape$3 = "#2D954C";
	const ColorFeedbackOnBrandErrorText$3 = "#F895A1";
	const ColorFeedbackOnBrandErrorShape$3 = "#F55C6E";
	const ColorFeedbackOnBrandSuccessText$3 = "#4BC870";
	const ColorFeedbackOnBrandSuccessShape$3 = "#32A454";
	const ColorFeedbackInverseErrorText$3 = "#F55C6E";
	const ColorFeedbackInverseErrorShape$3 = "#D83145";
	const ColorFeedbackInverseSuccessText$3 = "#32A454";
	const ColorFeedbackInverseSuccessShape$3 = "#278142";
	const ColorFeedbackInverseOnBrandErrorText$3 = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape$3 = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText$3 = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape$3 = "#278142";
	const ColorSupport01$3 = "#3C698B";
	const ColorSupport02$3 = "#3C698B";
	const ColorSupportOnBrand01$3 = "#6597BD";
	const ColorSupportOnBrand02$3 = "#6597BD";
	const ColorSupportInverse01$3 = "#4579A1";
	const ColorSupportInverse02$3 = "#4579A1";
	const ColorSupportInverseOnBrand01$3 = "#4579A1";
	const ColorSupportInverseOnBrand02$3 = "#4579A1";
	const Opacity01$3 = "0.04";
	const Opacity02$3 = "0.08";
	const Opacity03$3 = "0.12";
	const Opacity04$3 = "0.24";
	const Opacity05$3 = "0.32";
	const Opacity06$3 = "0.56";
	const Opacity07$3 = "0.64";
	const Opacity08$3 = "0.72";
	const Opacity09$3 = "0.88";
	const Shadow01$3 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$3 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$3 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$3 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$3 = "4px";
	const SpacingInlineNano$3 = "8px";
	const SpacingInlineXxxs$3 = "16px";
	const SpacingInlineXxs$3 = "24px";
	const SpacingInlineXs$3 = "32px";
	const SpacingInlineSm$3 = "40px";
	const SpacingInlineMd$3 = "48px";
	const SpacingInlineLg$3 = "56px";
	const SpacingInlineXl$3 = "64px";
	const SpacingInlineXxl$3 = "80px";
	const SpacingInlineXxxl$3 = "120px";
	const SpacingInlineHuge$3 = "160px";
	const SpacingInlineGiant$3 = "200px";
	const SpacingInsetQuark$3 = "4px";
	const SpacingInsetNano$3 = "8px";
	const SpacingInsetXs$3 = "16px";
	const SpacingInsetSm$3 = "24px";
	const SpacingInsetMd$3 = "32px";
	const SpacingInsetLg$3 = "40px";
	const SpacingSquishQuark$3 = "4px 8px";
	const SpacingSquishNano$3 = "8px 16px";
	const SpacingSquishXs$3 = "16px 24px";
	const SpacingSquishSm$3 = "16px 32px";
	const SpacingStackQuark$3 = "4px";
	const SpacingStackNano$3 = "8px";
	const SpacingStackXxxs$3 = "16px";
	const SpacingStackXxs$3 = "24px";
	const SpacingStackXs$3 = "32px";
	const SpacingStackSm$3 = "40px";
	const SpacingStackMd$3 = "48px";
	const SpacingStackLg$3 = "56px";
	const SpacingStackXl$3 = "64px";
	const SpacingStackXxl$3 = "80px";
	const SpacingStackXxxl$3 = "120px";
	const SpacingStackHuge$3 = "160px";
	const SpacingStackGiant$3 = "200px";
	const FontFamilyBase$3 = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontSizeXxxs$3 = "0.75rem";
	const FontSizeXxs$3 = "0.875rem";
	const FontSizeXs$3 = "1rem";
	const FontSizeSm$3 = "1.25rem";
	const FontSizeMd$3 = "1.5rem";
	const FontSizeLg$3 = "2rem";
	const FontSizeXl$3 = "2.5rem";
	const FontSizeXxl$3 = "3rem";
	const FontSizeXxxl$3 = "4rem";
	const FontSizeDisplay$3 = "5rem";
	const FontSizeGiant$3 = "6rem";
	const FontWeightBold$3 = 700;
	const FontWeightSemibold$3 = 600;
	const FontWeightMedium$3 = 500;
	const FontWeightRegular$3 = 400;
	const FontWeightLight$3 = 300;
	const LetterSpacingStandard$3 = "0px";
	const LetterSpacingSmall$3 = "-1px";
	const LetterSpacingMedium$3 = "1.5px";
	const LineHeightStandard$3 = "100%";
	const LineHeightTiny$3 = "115%";
	const LineHeightMedium$3 = "120%";
	const LineHeightLarge$3 = "125%";
	const LineHeightDistant$3 = "133%";
	const LineHeightSuperdistant$3 = "150%";
	const LineHeightHuge$3 = "170%";
	const ZIndex0$3 = "0";
	const ZIndex100$3 = "100";
	const ZIndex200$3 = "200";
	const ZIndex300$3 = "300";
	const ZIndex400$3 = "400";
	const ZIndex500$3 = "500";
	const ZIndexAuto$3 = "auto";
	const ZIndexTop$3 = "99999";
	const ZIndexBottom$3 = "-100";

	var index$3 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$3,
		BorderRadiusXs: BorderRadiusXs$3,
		BorderRadiusSm: BorderRadiusSm$3,
		BorderRadiusMd: BorderRadiusMd$3,
		BorderRadiusLg: BorderRadiusLg$3,
		BorderRadiusPill: BorderRadiusPill$3,
		BorderRadiusCircle: BorderRadiusCircle$3,
		BorderWidthNone: BorderWidthNone$3,
		BorderWidthHairline: BorderWidthHairline$3,
		BorderWidthThin: BorderWidthThin$3,
		BorderWidthThick: BorderWidthThick$3,
		BorderWidthHeavy: BorderWidthHeavy$3,
		ColorDatavizInfoText: ColorDatavizInfoText$3,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01$3,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02$3,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03$3,
		ColorDatavizNegativeText: ColorDatavizNegativeText$3,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$3,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$3,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$3,
		ColorDatavizWarningText: ColorDatavizWarningText$3,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01$3,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02$3,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03$3,
		ColorDatavizPositiveText: ColorDatavizPositiveText$3,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$3,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$3,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$3,
		ColorDatavizCatAText: ColorDatavizCatAText$3,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01$3,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02$3,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03$3,
		ColorDatavizCatBText: ColorDatavizCatBText$3,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01$3,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02$3,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03$3,
		ColorDatavizCatCText: ColorDatavizCatCText$3,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01$3,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02$3,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03$3,
		ColorDatavizCatDText: ColorDatavizCatDText$3,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01$3,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02$3,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03$3,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$3,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$3,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$3,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$3,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$3,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$3,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$3,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$3,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$3,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$3,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$3,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$3,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$3,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$3,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$3,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$3,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$3,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$3,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$3,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$3,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$3,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$3,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$3,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$3,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$3,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$3,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$3,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$3,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$3,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$3,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$3,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$3,
		ColorInteractionBlend01: ColorInteractionBlend01$3,
		ColorInteractionBlend02: ColorInteractionBlend02$3,
		ColorInteractionBlend03: ColorInteractionBlend03$3,
		ColorInteractionBlend04: ColorInteractionBlend04$3,
		ColorInteractionBlend05: ColorInteractionBlend05$3,
		ColorInteractionBlend06: ColorInteractionBlend06$3,
		ColorInteractionBlend07: ColorInteractionBlend07$3,
		ColorInteractionBlend08: ColorInteractionBlend08$3,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$3,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$3,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$3,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$3,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$3,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$3,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$3,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$3,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$3,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$3,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$3,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$3,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$3,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$3,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$3,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$3,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$3,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$3,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$3,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$3,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$3,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$3,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$3,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$3,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$3,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$3,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$3,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$3,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$3,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$3,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$3,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$3,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$3,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$3,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$3,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$3,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$3,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$3,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$3,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$3,
		ColorInteractionAccent01: ColorInteractionAccent01$3,
		ColorInteractionAccent02: ColorInteractionAccent02$3,
		ColorInteractionAccent03: ColorInteractionAccent03$3,
		ColorInteractionSubtle01: ColorInteractionSubtle01$3,
		ColorInteractionSubtle02: ColorInteractionSubtle02$3,
		ColorInteractionSubtle03: ColorInteractionSubtle03$3,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$3,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$3,
		ColorInteractionSelectActive: ColorInteractionSelectActive$3,
		ColorInteractionDanger01: ColorInteractionDanger01$3,
		ColorInteractionDanger02: ColorInteractionDanger02$3,
		ColorInteractionDanger03: ColorInteractionDanger03$3,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$3,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$3,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$3,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$3,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$3,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$3,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$3,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$3,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$3,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$3,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$3,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$3,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$3,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$3,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$3,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$3,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$3,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$3,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$3,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$3,
		ColorNeutral10: ColorNeutral10$3,
		ColorNeutral20: ColorNeutral20$3,
		ColorNeutral30: ColorNeutral30$3,
		ColorNeutral00: ColorNeutral00$3,
		ColorNeutralInverse10: ColorNeutralInverse10$3,
		ColorNeutralInverse20: ColorNeutralInverse20$3,
		ColorNeutralInverse30: ColorNeutralInverse30$3,
		ColorNeutralInverse00: ColorNeutralInverse00$3,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$3,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$3,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$3,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$3,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$3,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$3,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$3,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$3,
		ColorPaletteBlack: ColorPaletteBlack$3,
		ColorPaletteWhite: ColorPaletteWhite$3,
		ColorPaletteGray10: ColorPaletteGray10$3,
		ColorPaletteGray20: ColorPaletteGray20$3,
		ColorPaletteGray30: ColorPaletteGray30$3,
		ColorPaletteGray40: ColorPaletteGray40$3,
		ColorPaletteGray50: ColorPaletteGray50$3,
		ColorPaletteGray60: ColorPaletteGray60$3,
		ColorPaletteGray70: ColorPaletteGray70$3,
		ColorPaletteGray80: ColorPaletteGray80$3,
		ColorPaletteGray90: ColorPaletteGray90$3,
		ColorPaletteGray100: ColorPaletteGray100$3,
		ColorPaletteGray110: ColorPaletteGray110$3,
		ColorPaletteGray120: ColorPaletteGray120$3,
		ColorPaletteGray130: ColorPaletteGray130$3,
		ColorPaletteGray140: ColorPaletteGray140$3,
		ColorPaletteGray150: ColorPaletteGray150$3,
		ColorPaletteGray160: ColorPaletteGray160$3,
		ColorPaletteRed10: ColorPaletteRed10$3,
		ColorPaletteRed20: ColorPaletteRed20$3,
		ColorPaletteRed30: ColorPaletteRed30$3,
		ColorPaletteRed40: ColorPaletteRed40$3,
		ColorPaletteRed50: ColorPaletteRed50$3,
		ColorPaletteRed60: ColorPaletteRed60$3,
		ColorPaletteRed70: ColorPaletteRed70$3,
		ColorPaletteRed80: ColorPaletteRed80$3,
		ColorPaletteRed90: ColorPaletteRed90$3,
		ColorPaletteRed100: ColorPaletteRed100$3,
		ColorPaletteRed110: ColorPaletteRed110$3,
		ColorPaletteRed120: ColorPaletteRed120$3,
		ColorPaletteRed130: ColorPaletteRed130$3,
		ColorPaletteRed140: ColorPaletteRed140$3,
		ColorPaletteRed150: ColorPaletteRed150$3,
		ColorPaletteRed160: ColorPaletteRed160$3,
		ColorPaletteYellow10: ColorPaletteYellow10$3,
		ColorPaletteYellow20: ColorPaletteYellow20$3,
		ColorPaletteYellow30: ColorPaletteYellow30$3,
		ColorPaletteYellow40: ColorPaletteYellow40$3,
		ColorPaletteYellow50: ColorPaletteYellow50$3,
		ColorPaletteYellow60: ColorPaletteYellow60$3,
		ColorPaletteYellow70: ColorPaletteYellow70$3,
		ColorPaletteYellow80: ColorPaletteYellow80$3,
		ColorPaletteYellow90: ColorPaletteYellow90$3,
		ColorPaletteYellow100: ColorPaletteYellow100$3,
		ColorPaletteYellow110: ColorPaletteYellow110$3,
		ColorPaletteYellow120: ColorPaletteYellow120$3,
		ColorPaletteYellow130: ColorPaletteYellow130$3,
		ColorPaletteYellow140: ColorPaletteYellow140$3,
		ColorPaletteYellow150: ColorPaletteYellow150$3,
		ColorPaletteYellow160: ColorPaletteYellow160$3,
		ColorPaletteLime10: ColorPaletteLime10$3,
		ColorPaletteLime20: ColorPaletteLime20$3,
		ColorPaletteLime30: ColorPaletteLime30$3,
		ColorPaletteLime40: ColorPaletteLime40$3,
		ColorPaletteLime50: ColorPaletteLime50$3,
		ColorPaletteLime60: ColorPaletteLime60$3,
		ColorPaletteLime70: ColorPaletteLime70$3,
		ColorPaletteLime80: ColorPaletteLime80$3,
		ColorPaletteLime90: ColorPaletteLime90$3,
		ColorPaletteLime100: ColorPaletteLime100$3,
		ColorPaletteLime110: ColorPaletteLime110$3,
		ColorPaletteLime120: ColorPaletteLime120$3,
		ColorPaletteLime130: ColorPaletteLime130$3,
		ColorPaletteLime140: ColorPaletteLime140$3,
		ColorPaletteLime150: ColorPaletteLime150$3,
		ColorPaletteLime160: ColorPaletteLime160$3,
		ColorPaletteGreen10: ColorPaletteGreen10$3,
		ColorPaletteGreen20: ColorPaletteGreen20$3,
		ColorPaletteGreen30: ColorPaletteGreen30$3,
		ColorPaletteGreen40: ColorPaletteGreen40$3,
		ColorPaletteGreen50: ColorPaletteGreen50$3,
		ColorPaletteGreen60: ColorPaletteGreen60$3,
		ColorPaletteGreen70: ColorPaletteGreen70$3,
		ColorPaletteGreen80: ColorPaletteGreen80$3,
		ColorPaletteGreen90: ColorPaletteGreen90$3,
		ColorPaletteGreen100: ColorPaletteGreen100$3,
		ColorPaletteGreen110: ColorPaletteGreen110$3,
		ColorPaletteGreen120: ColorPaletteGreen120$3,
		ColorPaletteGreen130: ColorPaletteGreen130$3,
		ColorPaletteGreen140: ColorPaletteGreen140$3,
		ColorPaletteGreen150: ColorPaletteGreen150$3,
		ColorPaletteGreen160: ColorPaletteGreen160$3,
		ColorPaletteAcqua10: ColorPaletteAcqua10$3,
		ColorPaletteAcqua20: ColorPaletteAcqua20$3,
		ColorPaletteAcqua30: ColorPaletteAcqua30$3,
		ColorPaletteAcqua40: ColorPaletteAcqua40$3,
		ColorPaletteAcqua50: ColorPaletteAcqua50$3,
		ColorPaletteAcqua60: ColorPaletteAcqua60$3,
		ColorPaletteAcqua70: ColorPaletteAcqua70$3,
		ColorPaletteAcqua80: ColorPaletteAcqua80$3,
		ColorPaletteAcqua90: ColorPaletteAcqua90$3,
		ColorPaletteAcqua100: ColorPaletteAcqua100$3,
		ColorPaletteAcqua110: ColorPaletteAcqua110$3,
		ColorPaletteAcqua120: ColorPaletteAcqua120$3,
		ColorPaletteAcqua130: ColorPaletteAcqua130$3,
		ColorPaletteAcqua140: ColorPaletteAcqua140$3,
		ColorPaletteAcqua150: ColorPaletteAcqua150$3,
		ColorPaletteAcqua160: ColorPaletteAcqua160$3,
		ColorPaletteBlue10: ColorPaletteBlue10$3,
		ColorPaletteBlue20: ColorPaletteBlue20$3,
		ColorPaletteBlue30: ColorPaletteBlue30$3,
		ColorPaletteBlue40: ColorPaletteBlue40$3,
		ColorPaletteBlue50: ColorPaletteBlue50$3,
		ColorPaletteBlue60: ColorPaletteBlue60$3,
		ColorPaletteBlue70: ColorPaletteBlue70$3,
		ColorPaletteBlue80: ColorPaletteBlue80$3,
		ColorPaletteBlue90: ColorPaletteBlue90$3,
		ColorPaletteBlue100: ColorPaletteBlue100$3,
		ColorPaletteBlue110: ColorPaletteBlue110$3,
		ColorPaletteBlue120: ColorPaletteBlue120$3,
		ColorPaletteBlue130: ColorPaletteBlue130$3,
		ColorPaletteBlue140: ColorPaletteBlue140$3,
		ColorPaletteBlue150: ColorPaletteBlue150$3,
		ColorPaletteBlue160: ColorPaletteBlue160$3,
		ColorPalettePurple10: ColorPalettePurple10$3,
		ColorPalettePurple20: ColorPalettePurple20$3,
		ColorPalettePurple30: ColorPalettePurple30$3,
		ColorPalettePurple40: ColorPalettePurple40$3,
		ColorPalettePurple50: ColorPalettePurple50$3,
		ColorPalettePurple60: ColorPalettePurple60$3,
		ColorPalettePurple70: ColorPalettePurple70$3,
		ColorPalettePurple80: ColorPalettePurple80$3,
		ColorPalettePurple90: ColorPalettePurple90$3,
		ColorPalettePurple100: ColorPalettePurple100$3,
		ColorPalettePurple110: ColorPalettePurple110$3,
		ColorPalettePurple120: ColorPalettePurple120$3,
		ColorPalettePurple130: ColorPalettePurple130$3,
		ColorPalettePurple140: ColorPalettePurple140$3,
		ColorPalettePurple150: ColorPalettePurple150$3,
		ColorPalettePurple160: ColorPalettePurple160$3,
		ColorPalettePink10: ColorPalettePink10$3,
		ColorPalettePink20: ColorPalettePink20$3,
		ColorPalettePink30: ColorPalettePink30$3,
		ColorPalettePink40: ColorPalettePink40$3,
		ColorPalettePink50: ColorPalettePink50$3,
		ColorPalettePink60: ColorPalettePink60$3,
		ColorPalettePink70: ColorPalettePink70$3,
		ColorPalettePink80: ColorPalettePink80$3,
		ColorPalettePink90: ColorPalettePink90$3,
		ColorPalettePink100: ColorPalettePink100$3,
		ColorPalettePink110: ColorPalettePink110$3,
		ColorPalettePink120: ColorPalettePink120$3,
		ColorPalettePink130: ColorPalettePink130$3,
		ColorPalettePink140: ColorPalettePink140$3,
		ColorPalettePink150: ColorPalettePink150$3,
		ColorPalettePink160: ColorPalettePink160$3,
		ColorTypefaceStrong: ColorTypefaceStrong$3,
		ColorTypefacePure: ColorTypefacePure$3,
		ColorTypefaceSmooth: ColorTypefaceSmooth$3,
		ColorTypefaceMeld: ColorTypefaceMeld$3,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$3,
		ColorTypefaceInversePure: ColorTypefaceInversePure$3,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$3,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$3,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$3,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$3,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$3,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$3,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$3,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$3,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$3,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$3,
		ColorBrandPrimary10: ColorBrandPrimary10$3,
		ColorBrandPrimary20: ColorBrandPrimary20$3,
		ColorBrandPrimary30: ColorBrandPrimary30$3,
		ColorBrandPrimary40: ColorBrandPrimary40$3,
		ColorBrandPrimary50: ColorBrandPrimary50$3,
		ColorBrandPrimary60: ColorBrandPrimary60$3,
		ColorBrandPrimary70: ColorBrandPrimary70$3,
		ColorBrandPrimary80: ColorBrandPrimary80$3,
		ColorBrandPrimary90: ColorBrandPrimary90$3,
		ColorBrandPrimary100: ColorBrandPrimary100$3,
		ColorBrandPrimary110: ColorBrandPrimary110$3,
		ColorBrandPrimary120: ColorBrandPrimary120$3,
		ColorBrandPrimary130: ColorBrandPrimary130$3,
		ColorBrandPrimary140: ColorBrandPrimary140$3,
		ColorBrandPrimary150: ColorBrandPrimary150$3,
		ColorBrandPrimary160: ColorBrandPrimary160$3,
		ColorBrandBase01: ColorBrandBase01$3,
		ColorBrandBase02: ColorBrandBase02$3,
		ColorBrandPalette0110: ColorBrandPalette0110$3,
		ColorBrandPalette0120: ColorBrandPalette0120$3,
		ColorBrandPalette0130: ColorBrandPalette0130$3,
		ColorBrandPalette0140: ColorBrandPalette0140$3,
		ColorBrandPalette0150: ColorBrandPalette0150$3,
		ColorBrandPalette0160: ColorBrandPalette0160$3,
		ColorBrandPalette0170: ColorBrandPalette0170$3,
		ColorBrandPalette0180: ColorBrandPalette0180$3,
		ColorBrandPalette0190: ColorBrandPalette0190$3,
		ColorBrandPalette01100: ColorBrandPalette01100$3,
		ColorBrandPalette01110: ColorBrandPalette01110$3,
		ColorBrandPalette01120: ColorBrandPalette01120$3,
		ColorBrandPalette01130: ColorBrandPalette01130$3,
		ColorBrandPalette01140: ColorBrandPalette01140$3,
		ColorBrandPalette01150: ColorBrandPalette01150$3,
		ColorBrandPalette01160: ColorBrandPalette01160$3,
		ColorBrandPalette0210: ColorBrandPalette0210$3,
		ColorBrandPalette0220: ColorBrandPalette0220$3,
		ColorBrandPalette0230: ColorBrandPalette0230$3,
		ColorBrandPalette0240: ColorBrandPalette0240$3,
		ColorBrandPalette0250: ColorBrandPalette0250$3,
		ColorBrandPalette0260: ColorBrandPalette0260$3,
		ColorBrandPalette0270: ColorBrandPalette0270$3,
		ColorBrandPalette0280: ColorBrandPalette0280$3,
		ColorBrandPalette0290: ColorBrandPalette0290$3,
		ColorBrandPalette02100: ColorBrandPalette02100$3,
		ColorBrandPalette02110: ColorBrandPalette02110$3,
		ColorBrandPalette02120: ColorBrandPalette02120$3,
		ColorBrandPalette02130: ColorBrandPalette02130$3,
		ColorBrandPalette02140: ColorBrandPalette02140$3,
		ColorBrandPalette02150: ColorBrandPalette02150$3,
		ColorBrandPalette02160: ColorBrandPalette02160$3,
		ColorFeedbackErrorText: ColorFeedbackErrorText$3,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$3,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$3,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$3,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$3,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$3,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$3,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$3,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$3,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$3,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$3,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$3,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$3,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$3,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$3,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$3,
		ColorSupport01: ColorSupport01$3,
		ColorSupport02: ColorSupport02$3,
		ColorSupportOnBrand01: ColorSupportOnBrand01$3,
		ColorSupportOnBrand02: ColorSupportOnBrand02$3,
		ColorSupportInverse01: ColorSupportInverse01$3,
		ColorSupportInverse02: ColorSupportInverse02$3,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$3,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$3,
		Opacity01: Opacity01$3,
		Opacity02: Opacity02$3,
		Opacity03: Opacity03$3,
		Opacity04: Opacity04$3,
		Opacity05: Opacity05$3,
		Opacity06: Opacity06$3,
		Opacity07: Opacity07$3,
		Opacity08: Opacity08$3,
		Opacity09: Opacity09$3,
		Shadow01: Shadow01$3,
		Shadow02: Shadow02$3,
		Shadow03: Shadow03$3,
		Shadow04: Shadow04$3,
		SpacingInlineQuark: SpacingInlineQuark$3,
		SpacingInlineNano: SpacingInlineNano$3,
		SpacingInlineXxxs: SpacingInlineXxxs$3,
		SpacingInlineXxs: SpacingInlineXxs$3,
		SpacingInlineXs: SpacingInlineXs$3,
		SpacingInlineSm: SpacingInlineSm$3,
		SpacingInlineMd: SpacingInlineMd$3,
		SpacingInlineLg: SpacingInlineLg$3,
		SpacingInlineXl: SpacingInlineXl$3,
		SpacingInlineXxl: SpacingInlineXxl$3,
		SpacingInlineXxxl: SpacingInlineXxxl$3,
		SpacingInlineHuge: SpacingInlineHuge$3,
		SpacingInlineGiant: SpacingInlineGiant$3,
		SpacingInsetQuark: SpacingInsetQuark$3,
		SpacingInsetNano: SpacingInsetNano$3,
		SpacingInsetXs: SpacingInsetXs$3,
		SpacingInsetSm: SpacingInsetSm$3,
		SpacingInsetMd: SpacingInsetMd$3,
		SpacingInsetLg: SpacingInsetLg$3,
		SpacingSquishQuark: SpacingSquishQuark$3,
		SpacingSquishNano: SpacingSquishNano$3,
		SpacingSquishXs: SpacingSquishXs$3,
		SpacingSquishSm: SpacingSquishSm$3,
		SpacingStackQuark: SpacingStackQuark$3,
		SpacingStackNano: SpacingStackNano$3,
		SpacingStackXxxs: SpacingStackXxxs$3,
		SpacingStackXxs: SpacingStackXxs$3,
		SpacingStackXs: SpacingStackXs$3,
		SpacingStackSm: SpacingStackSm$3,
		SpacingStackMd: SpacingStackMd$3,
		SpacingStackLg: SpacingStackLg$3,
		SpacingStackXl: SpacingStackXl$3,
		SpacingStackXxl: SpacingStackXxl$3,
		SpacingStackXxxl: SpacingStackXxxl$3,
		SpacingStackHuge: SpacingStackHuge$3,
		SpacingStackGiant: SpacingStackGiant$3,
		FontFamilyBase: FontFamilyBase$3,
		FontSizeXxxs: FontSizeXxxs$3,
		FontSizeXxs: FontSizeXxs$3,
		FontSizeXs: FontSizeXs$3,
		FontSizeSm: FontSizeSm$3,
		FontSizeMd: FontSizeMd$3,
		FontSizeLg: FontSizeLg$3,
		FontSizeXl: FontSizeXl$3,
		FontSizeXxl: FontSizeXxl$3,
		FontSizeXxxl: FontSizeXxxl$3,
		FontSizeDisplay: FontSizeDisplay$3,
		FontSizeGiant: FontSizeGiant$3,
		FontWeightBold: FontWeightBold$3,
		FontWeightSemibold: FontWeightSemibold$3,
		FontWeightMedium: FontWeightMedium$3,
		FontWeightRegular: FontWeightRegular$3,
		FontWeightLight: FontWeightLight$3,
		LetterSpacingStandard: LetterSpacingStandard$3,
		LetterSpacingSmall: LetterSpacingSmall$3,
		LetterSpacingMedium: LetterSpacingMedium$3,
		LineHeightStandard: LineHeightStandard$3,
		LineHeightTiny: LineHeightTiny$3,
		LineHeightMedium: LineHeightMedium$3,
		LineHeightLarge: LineHeightLarge$3,
		LineHeightDistant: LineHeightDistant$3,
		LineHeightSuperdistant: LineHeightSuperdistant$3,
		LineHeightHuge: LineHeightHuge$3,
		ZIndex0: ZIndex0$3,
		ZIndex100: ZIndex100$3,
		ZIndex200: ZIndex200$3,
		ZIndex300: ZIndex300$3,
		ZIndex400: ZIndex400$3,
		ZIndex500: ZIndex500$3,
		ZIndexAuto: ZIndexAuto$3,
		ZIndexTop: ZIndexTop$3,
		ZIndexBottom: ZIndexBottom$3
	});

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:01 GMT
	 */

	const BorderRadiusNone$2 = "0px";
	const BorderRadiusXs$2 = "4px";
	const BorderRadiusSm$2 = "8px";
	const BorderRadiusMd$2 = "16px";
	const BorderRadiusLg$2 = "24px";
	const BorderRadiusPill$2 = "960px";
	const BorderRadiusCircle$2 = "50%";
	const BorderWidthNone$2 = "0px";
	const BorderWidthHairline$2 = "1px";
	const BorderWidthThin$2 = "2px";
	const BorderWidthThick$2 = "4px";
	const BorderWidthHeavy$2 = "8px";
	const ColorDatavizInfoText$2 = "#0F58EA";
	const ColorDatavizInfoShape01$2 = "#3F7BF2";
	const ColorDatavizInfoShape02$2 = "#D9E5FC";
	const ColorDatavizInfoShape03$2 = "#F1F5FE";
	const ColorDatavizNegativeText$2 = "#BC293A";
	const ColorDatavizNegativeShape01$2 = "#EA4356";
	const ColorDatavizNegativeShape02$2 = "#FDDDE1";
	const ColorDatavizNegativeShape03$2 = "#FEF1F2";
	const ColorDatavizWarningText$2 = "#A04C03";
	const ColorDatavizWarningShape01$2 = "#D26404";
	const ColorDatavizWarningShape02$2 = "#FEE1C8";
	const ColorDatavizWarningShape03$2 = "#FEF1E6";
	const ColorDatavizPositiveText$2 = "#22723A";
	const ColorDatavizPositiveShape01$2 = "#2D954C";
	const ColorDatavizPositiveShape02$2 = "#C8EED3";
	const ColorDatavizPositiveShape03$2 = "#E8F8EC";
	const ColorDatavizCatAText$2 = "#9B18DC";
	const ColorDatavizCatAShape01$2 = "#B851EC";
	const ColorDatavizCatAShape02$2 = "#F2DFFB";
	const ColorDatavizCatAShape03$2 = "#F9F1FD";
	const ColorDatavizCatBText$2 = "#BA267B";
	const ColorDatavizCatBShape01$2 = "#DA499B";
	const ColorDatavizCatBShape02$2 = "#F8DDEC";
	const ColorDatavizCatBShape03$2 = "#FCF2F8";
	const ColorDatavizCatCText$2 = "#546E21";
	const ColorDatavizCatCShape01$2 = "#6C8D2B";
	const ColorDatavizCatCShape02$2 = "#DBEBBD";
	const ColorDatavizCatCShape03$2 = "#F0F7E4";
	const ColorDatavizCatDText$2 = "#0D735E";
	const ColorDatavizCatDShape01$2 = "#109379";
	const ColorDatavizCatDShape02$2 = "#BCF0E6";
	const ColorDatavizCatDShape03$2 = "#DFFBF6";
	const ColorDatavizInverseInfoText$2 = "#5C8FF5";
	const ColorDatavizInverseInfoShape01$2 = "#286BF1";
	const ColorDatavizInverseInfoShape02$2 = "#062560";
	const ColorDatavizInverseInfoShape03$2 = "#051B48";
	const ColorDatavizInverseNegativeText$2 = "#F55C6E";
	const ColorDatavizInverseNegativeShape01$2 = "#D83145";
	const ColorDatavizInverseNegativeShape02$2 = "#4F1119";
	const ColorDatavizInverseNegativeShape03$2 = "#3B0D12";
	const ColorDatavizInverseWarningText$2 = "#EB7005";
	const ColorDatavizInverseWarningShape01$2 = "#B95804";
	const ColorDatavizInverseWarningShape02$2 = "#462101";
	const ColorDatavizInverseWarningShape03$2 = "#321701";
	const ColorDatavizInversePositiveText$2 = "#32A454";
	const ColorDatavizInversePositiveShape01$2 = "#278142";
	const ColorDatavizInversePositiveShape02$2 = "#0E2F18";
	const ColorDatavizInversePositiveShape03$2 = "#0B2312";
	const ColorDatavizInverseCatAText$2 = "#C36CEF";
	const ColorDatavizInverseCatAShape01$2 = "#AD35E9";
	const ColorDatavizInverseCatAShape02$2 = "#440B60";
	const ColorDatavizInverseCatAShape03$2 = "#340849";
	const ColorDatavizInverseCatBText$2 = "#E067AB";
	const ColorDatavizInverseCatBShape01$2 = "#D42B8C";
	const ColorDatavizInverseCatBShape02$2 = "#4C1032";
	const ColorDatavizInverseCatBShape03$2 = "#3B0C27";
	const ColorDatavizInverseCatCText$2 = "#789D2F";
	const ColorDatavizInverseCatCShape01$2 = "#607E26";
	const ColorDatavizInverseCatCShape02$2 = "#212B0D";
	const ColorDatavizInverseCatCShape03$2 = "#1B230B";
	const ColorDatavizInverseCatDText$2 = "#12A588";
	const ColorDatavizInverseCatDShape01$2 = "#0F856D";
	const ColorDatavizInverseCatDShape02$2 = "#052E26";
	const ColorDatavizInverseCatDShape03$2 = "#04251E";
	const ColorInteractionBlend01$2 = "#1616160A";
	const ColorInteractionBlend02$2 = "#16161614";
	const ColorInteractionBlend03$2 = "#1616161F";
	const ColorInteractionBlend04$2 = "#1616163D";
	const ColorInteractionBlend05$2 = "#161616A3";
	const ColorInteractionBlend06$2 = "#161616B8";
	const ColorInteractionBlend07$2 = "#161616E0";
	const ColorInteractionBlend08$2 = "#161616";
	const ColorInteractionInverseBlend01$2 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$2 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$2 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$2 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$2 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$2 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$2 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$2 = "#FEFEFE";
	const ColorInteractionInverseAccent01$2 = "#809BFF";
	const ColorInteractionInverseAccent02$2 = "#99AFFF";
	const ColorInteractionInverseAccent03$2 = "#ADBFFF";
	const ColorInteractionInverseSubtle01$2 = "#5277FF1F";
	const ColorInteractionInverseSubtle02$2 = "#5277FF3D";
	const ColorInteractionInverseSubtle03$2 = "#5277FF52";
	const ColorInteractionInverseSelectDefault$2 = "#919191";
	const ColorInteractionInverseSelectFocus$2 = "#D4D4D4";
	const ColorInteractionInverseSelectActive$2 = "#809BFF";
	const ColorInteractionInverseDanger01$2 = "#F55C6E";
	const ColorInteractionInverseDanger02$2 = "#F77E8C";
	const ColorInteractionInverseDanger03$2 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01$2 = "#00229E";
	const ColorInteractionInverseOnBrandAccent02$2 = "#001A7A";
	const ColorInteractionInverseOnBrandAccent03$2 = "#001561";
	const ColorInteractionInverseOnBrandSubtle01$2 = "#0B278F14";
	const ColorInteractionInverseOnBrandSubtle02$2 = "#0B278F1F";
	const ColorInteractionInverseOnBrandSubtle03$2 = "#0B278F3D";
	const ColorInteractionInverseOnBrandSelectDefault$2 = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus$2 = "#363636";
	const ColorInteractionInverseOnBrandSelectActive$2 = "#00229E";
	const ColorInteractionInverseOnBrandBlend01$2 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$2 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$2 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$2 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$2 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$2 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$2 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$2 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$2 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02$2 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03$2 = "#7E1B27";
	const ColorInteractionAccent01$2 = "#0037FF";
	const ColorInteractionAccent02$2 = "#002FDB";
	const ColorInteractionAccent03$2 = "#0029BD";
	const ColorInteractionSubtle01$2 = "#0037FF1F";
	const ColorInteractionSubtle02$2 = "#0037FF3D";
	const ColorInteractionSubtle03$2 = "#0037FF52";
	const ColorInteractionSelectDefault$2 = "#666666";
	const ColorInteractionSelectFocus$2 = "#363636";
	const ColorInteractionSelectActive$2 = "#0037FF";
	const ColorInteractionDanger01$2 = "#BC293A";
	const ColorInteractionDanger02$2 = "#A72534";
	const ColorInteractionDanger03$2 = "#92202E";
	const ColorInteractionOnBrandAccent01$2 = "#FEFEFE";
	const ColorInteractionOnBrandAccent02$2 = "#DBE3FF";
	const ColorInteractionOnBrandAccent03$2 = "#C7D3FF";
	const ColorInteractionOnBrandSubtle01$2 = "#FEFEFE1F";
	const ColorInteractionOnBrandSubtle02$2 = "#FEFEFE3D";
	const ColorInteractionOnBrandSubtle03$2 = "#FEFEFE52";
	const ColorInteractionOnBrandSelectDefault$2 = "#C7D3FF";
	const ColorInteractionOnBrandSelectFocus$2 = "#DBE3FF";
	const ColorInteractionOnBrandSelectActive$2 = "#FEFEFE";
	const ColorInteractionOnBrandBlend01$2 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$2 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$2 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$2 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$2 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$2 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$2 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$2 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$2 = "#FDDDE1";
	const ColorInteractionOnBrandDanger02$2 = "#FBC5CC";
	const ColorInteractionOnBrandDanger03$2 = "#FAAEB6";
	const ColorNeutral10$2 = "#F5F5F5";
	const ColorNeutral20$2 = "#E6E6E6";
	const ColorNeutral30$2 = "#1616163D";
	const ColorNeutral00$2 = "#FEFEFE";
	const ColorNeutralInverse10$2 = "#1F1F1F";
	const ColorNeutralInverse20$2 = "#292929";
	const ColorNeutralInverse30$2 = "#FEFEFE3D";
	const ColorNeutralInverse00$2 = "#161616";
	const ColorNeutralInverseOnBrand10$2 = "#DBE3FF";
	const ColorNeutralInverseOnBrand20$2 = "#C7D3FF";
	const ColorNeutralInverseOnBrand30$2 = "#0037FF7A";
	const ColorNeutralInverseOnBrand00$2 = "#F0F3FF";
	const ColorNeutralOnBrand10$2 = "#002FDB";
	const ColorNeutralOnBrand20$2 = "#0029BD";
	const ColorNeutralOnBrand30$2 = "#00229EE0";
	const ColorNeutralOnBrand00$2 = "#0037FF";
	const ColorPaletteBlack$2 = "#161616";
	const ColorPaletteWhite$2 = "#FEFEFE";
	const ColorPaletteGray10$2 = "#1F1F1F";
	const ColorPaletteGray20$2 = "#292929";
	const ColorPaletteGray30$2 = "#363636";
	const ColorPaletteGray40$2 = "#404040";
	const ColorPaletteGray50$2 = "#4C4C4C";
	const ColorPaletteGray60$2 = "#595959";
	const ColorPaletteGray70$2 = "#666666";
	const ColorPaletteGray80$2 = "#737373";
	const ColorPaletteGray90$2 = "#828282";
	const ColorPaletteGray100$2 = "#919191";
	const ColorPaletteGray110$2 = "#A1A1A1";
	const ColorPaletteGray120$2 = "#B0B0B0";
	const ColorPaletteGray130$2 = "#C2C2C2";
	const ColorPaletteGray140$2 = "#D4D4D4";
	const ColorPaletteGray150$2 = "#E6E6E6";
	const ColorPaletteGray160$2 = "#F5F5F5";
	const ColorPaletteRed10$2 = "#3B0D12";
	const ColorPaletteRed20$2 = "#4F1119";
	const ColorPaletteRed30$2 = "#691721";
	const ColorPaletteRed40$2 = "#7E1B27";
	const ColorPaletteRed50$2 = "#92202E";
	const ColorPaletteRed60$2 = "#A72534";
	const ColorPaletteRed70$2 = "#BC293A";
	const ColorPaletteRed80$2 = "#D83145";
	const ColorPaletteRed90$2 = "#EA4356";
	const ColorPaletteRed100$2 = "#F55C6E";
	const ColorPaletteRed110$2 = "#F77E8C";
	const ColorPaletteRed120$2 = "#F895A1";
	const ColorPaletteRed130$2 = "#FAAEB6";
	const ColorPaletteRed140$2 = "#FBC5CC";
	const ColorPaletteRed150$2 = "#FDDDE1";
	const ColorPaletteRed160$2 = "#FEF1F2";
	const ColorPaletteYellow10$2 = "#321701";
	const ColorPaletteYellow20$2 = "#462101";
	const ColorPaletteYellow30$2 = "#552802";
	const ColorPaletteYellow40$2 = "#693102";
	const ColorPaletteYellow50$2 = "#7D3B03";
	const ColorPaletteYellow60$2 = "#914503";
	const ColorPaletteYellow70$2 = "#A04C03";
	const ColorPaletteYellow80$2 = "#B95804";
	const ColorPaletteYellow90$2 = "#D26404";
	const ColorPaletteYellow100$2 = "#EB7005";
	const ColorPaletteYellow110$2 = "#FA8219";
	const ColorPaletteYellow120$2 = "#FB9B46";
	const ColorPaletteYellow130$2 = "#FCB06E";
	const ColorPaletteYellow140$2 = "#FDC99B";
	const ColorPaletteYellow150$2 = "#FEE1C8";
	const ColorPaletteYellow160$2 = "#FEF1E6";
	const ColorPaletteLime10$2 = "#1B230B";
	const ColorPaletteLime20$2 = "#212B0D";
	const ColorPaletteLime30$2 = "#2D3B12";
	const ColorPaletteLime40$2 = "#364616";
	const ColorPaletteLime50$2 = "#3F5219";
	const ColorPaletteLime60$2 = "#485E1D";
	const ColorPaletteLime70$2 = "#546E21";
	const ColorPaletteLime80$2 = "#607E26";
	const ColorPaletteLime90$2 = "#6C8D2B";
	const ColorPaletteLime100$2 = "#789D2F";
	const ColorPaletteLime110$2 = "#84AC34";
	const ColorPaletteLime120$2 = "#93BF3A";
	const ColorPaletteLime130$2 = "#A9CF5E";
	const ColorPaletteLime140$2 = "#C2DD8D";
	const ColorPaletteLime150$2 = "#DBEBBD";
	const ColorPaletteLime160$2 = "#F0F7E4";
	const ColorPaletteGreen10$2 = "#0B2312";
	const ColorPaletteGreen20$2 = "#0E2F18";
	const ColorPaletteGreen30$2 = "#133E20";
	const ColorPaletteGreen40$2 = "#174A26";
	const ColorPaletteGreen50$2 = "#1A562C";
	const ColorPaletteGreen60$2 = "#1F6634";
	const ColorPaletteGreen70$2 = "#22723A";
	const ColorPaletteGreen80$2 = "#278142";
	const ColorPaletteGreen90$2 = "#2D954C";
	const ColorPaletteGreen100$2 = "#32A454";
	const ColorPaletteGreen110$2 = "#38B85E";
	const ColorPaletteGreen120$2 = "#4BC870";
	const ColorPaletteGreen130$2 = "#76D692";
	const ColorPaletteGreen140$2 = "#9DE2B1";
	const ColorPaletteGreen150$2 = "#C8EED3";
	const ColorPaletteGreen160$2 = "#E8F8EC";
	const ColorPaletteAcqua10$2 = "#04251E";
	const ColorPaletteAcqua20$2 = "#052E26";
	const ColorPaletteAcqua30$2 = "#073C31";
	const ColorPaletteAcqua40$2 = "#08493C";
	const ColorPaletteAcqua50$2 = "#0A5748";
	const ColorPaletteAcqua60$2 = "#0B6553";
	const ColorPaletteAcqua70$2 = "#0D735E";
	const ColorPaletteAcqua80$2 = "#0F856D";
	const ColorPaletteAcqua90$2 = "#109379";
	const ColorPaletteAcqua100$2 = "#12A588";
	const ColorPaletteAcqua110$2 = "#14B897";
	const ColorPaletteAcqua120$2 = "#31C4A6";
	const ColorPaletteAcqua130$2 = "#68D4BF";
	const ColorPaletteAcqua140$2 = "#8DE2D1";
	const ColorPaletteAcqua150$2 = "#BCF0E6";
	const ColorPaletteAcqua160$2 = "#DFFBF6";
	const ColorPaletteBlue10$2 = "#051B48";
	const ColorPaletteBlue20$2 = "#062560";
	const ColorPaletteBlue30$2 = "#082F7D";
	const ColorPaletteBlue40$2 = "#0A3A9A";
	const ColorPaletteBlue50$2 = "#0B43B1";
	const ColorPaletteBlue60$2 = "#0D4ECE";
	const ColorPaletteBlue70$2 = "#0F58EA";
	const ColorPaletteBlue80$2 = "#286BF1";
	const ColorPaletteBlue90$2 = "#3F7BF2";
	const ColorPaletteBlue100$2 = "#5C8FF5";
	const ColorPaletteBlue110$2 = "#73A0F7";
	const ColorPaletteBlue120$2 = "#8CB0F8";
	const ColorPaletteBlue130$2 = "#A9C4F9";
	const ColorPaletteBlue140$2 = "#C1D4FB";
	const ColorPaletteBlue150$2 = "#D9E5FC";
	const ColorPaletteBlue160$2 = "#F1F5FE";
	const ColorPalettePurple10$2 = "#340849";
	const ColorPalettePurple20$2 = "#440B60";
	const ColorPalettePurple30$2 = "#540D78";
	const ColorPalettePurple40$2 = "#671093";
	const ColorPalettePurple50$2 = "#7713AA";
	const ColorPalettePurple60$2 = "#8B16C5";
	const ColorPalettePurple70$2 = "#9B18DC";
	const ColorPalettePurple80$2 = "#AD35E9";
	const ColorPalettePurple90$2 = "#B851EC";
	const ColorPalettePurple100$2 = "#C36CEF";
	const ColorPalettePurple110$2 = "#CC83F1";
	const ColorPalettePurple120$2 = "#D69AF4";
	const ColorPalettePurple130$2 = "#DFB1F6";
	const ColorPalettePurple140$2 = "#E8C8F9";
	const ColorPalettePurple150$2 = "#F2DFFB";
	const ColorPalettePurple160$2 = "#F9F1FD";
	const ColorPalettePink10$2 = "#3B0C27";
	const ColorPalettePink20$2 = "#4C1032";
	const ColorPalettePink30$2 = "#661543";
	const ColorPalettePink40$2 = "#77184E";
	const ColorPalettePink50$2 = "#8C1C5D";
	const ColorPalettePink60$2 = "#A12169";
	const ColorPalettePink70$2 = "#BA267B";
	const ColorPalettePink80$2 = "#D42B8C";
	const ColorPalettePink90$2 = "#DA499B";
	const ColorPalettePink100$2 = "#E067AB";
	const ColorPalettePink110$2 = "#E580B9";
	const ColorPalettePink120$2 = "#EA99C7";
	const ColorPalettePink130$2 = "#EFAFD3";
	const ColorPalettePink140$2 = "#F4C8E1";
	const ColorPalettePink150$2 = "#F8DDEC";
	const ColorPalettePink160$2 = "#FCF2F8";
	const ColorTypefaceStrong$2 = "#161616";
	const ColorTypefacePure$2 = "#363636";
	const ColorTypefaceSmooth$2 = "#666666";
	const ColorTypefaceMeld$2 = "#1616163D";
	const ColorTypefaceInverseStrong$2 = "#FEFEFE";
	const ColorTypefaceInversePure$2 = "#D4D4D4";
	const ColorTypefaceInverseSmooth$2 = "#919191";
	const ColorTypefaceInverseMeld$2 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$2 = "#161616";
	const ColorTypefaceInverseOnBrandPure$2 = "#363636";
	const ColorTypefaceInverseOnBrandSmooth$2 = "#595959";
	const ColorTypefaceInverseOnBrandMeld$2 = "#1616163D";
	const ColorTypefaceOnBrandStrong$2 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$2 = "#DBE3FF";
	const ColorTypefaceOnBrandSmooth$2 = "#C7D3FF";
	const ColorTypefaceOnBrandMeld$2 = "#FEFEFE52";
	const ColorBrandPrimary10$2 = "#001561";
	const ColorBrandPrimary20$2 = "#001A7A";
	const ColorBrandPrimary30$2 = "#00229E";
	const ColorBrandPrimary40$2 = "#0029BD";
	const ColorBrandPrimary50$2 = "#002FDB";
	const ColorBrandPrimary60$2 = "#0037FF";
	const ColorBrandPrimary70$2 = "#1F4FFF";
	const ColorBrandPrimary80$2 = "#3863FF";
	const ColorBrandPrimary90$2 = "#5277FF";
	const ColorBrandPrimary100$2 = "#6B8BFF";
	const ColorBrandPrimary110$2 = "#809BFF";
	const ColorBrandPrimary120$2 = "#99AFFF";
	const ColorBrandPrimary130$2 = "#ADBFFF";
	const ColorBrandPrimary140$2 = "#C7D3FF";
	const ColorBrandPrimary150$2 = "#DBE3FF";
	const ColorBrandPrimary160$2 = "#F0F3FF";
	const ColorBrandBase01$2 = "#0037FF";
	const ColorBrandBase02$2 = "#A6E1FF";
	const ColorBrandBase03$2 = "#FF4E33";
	const ColorBrandBase04$2 = "#E5FF00";
	const ColorBrandBase05$2 = "#000E40";
	const ColorBrandBase06$2 = "#D8BD97";
	const ColorBrandPalette0110$2 = "#001561";
	const ColorBrandPalette0120$2 = "#001A7A";
	const ColorBrandPalette0130$2 = "#00229E";
	const ColorBrandPalette0140$2 = "#0029BD";
	const ColorBrandPalette0150$2 = "#002FDB";
	const ColorBrandPalette0160$2 = "#0037FF";
	const ColorBrandPalette0170$2 = "#1F4FFF";
	const ColorBrandPalette0180$2 = "#3863FF";
	const ColorBrandPalette0190$2 = "#5277FF";
	const ColorBrandPalette01100$2 = "#6B8BFF";
	const ColorBrandPalette01110$2 = "#809BFF";
	const ColorBrandPalette01120$2 = "#99AFFF";
	const ColorBrandPalette01130$2 = "#ADBFFF";
	const ColorBrandPalette01140$2 = "#C7D3FF";
	const ColorBrandPalette01150$2 = "#DBE3FF";
	const ColorBrandPalette01160$2 = "#F0F3FF";
	const ColorBrandPalette0210$2 = "#002233";
	const ColorBrandPalette0220$2 = "#002C42";
	const ColorBrandPalette0230$2 = "#073B54";
	const ColorBrandPalette0240$2 = "#004466";
	const ColorBrandPalette0250$2 = "#00527A";
	const ColorBrandPalette0260$2 = "#005F8F";
	const ColorBrandPalette0270$2 = "#00699E";
	const ColorBrandPalette0280$2 = "#007AB8";
	const ColorBrandPalette0290$2 = "#0088CC";
	const ColorBrandPalette02100$2 = "#0099E5";
	const ColorBrandPalette02110$2 = "#00AAFF";
	const ColorBrandPalette02120$2 = "#38BDFF";
	const ColorBrandPalette02130$2 = "#6BCEFF";
	const ColorBrandPalette02140$2 = "#A6E1FF";
	const ColorBrandPalette02150$2 = "#C7ECFF";
	const ColorBrandPalette02160$2 = "#EBF8FF";
	const ColorBrandPalette0310$1 = "#420900";
	const ColorBrandPalette0320$1 = "#510F05";
	const ColorBrandPalette0330$1 = "#691407";
	const ColorBrandPalette0340$1 = "#7D1808";
	const ColorBrandPalette0350$1 = "#901B09";
	const ColorBrandPalette0360$1 = "#A8200B";
	const ColorBrandPalette0370$1 = "#BB230C";
	const ColorBrandPalette0380$1 = "#DD2A0E";
	const ColorBrandPalette0390$1 = "#F13E22";
	const ColorBrandPalette03100$1 = "#FF4E33";
	const ColorBrandPalette03110$1 = "#FF7661";
	const ColorBrandPalette03120$1 = "#FF9585";
	const ColorBrandPalette03130$1 = "#FFAB9E";
	const ColorBrandPalette03140$1 = "#FFC6BD";
	const ColorBrandPalette03150$1 = "#FFE0DB";
	const ColorBrandPalette03160$1 = "#FFF2F0";
	const ColorBrandPalette0410$2 = "#1C1F00";
	const ColorBrandPalette0420$2 = "#252900";
	const ColorBrandPalette0430$2 = "#323800";
	const ColorBrandPalette0440$2 = "#404700";
	const ColorBrandPalette0450$2 = "#495200";
	const ColorBrandPalette0460$2 = "#535C00";
	const ColorBrandPalette0470$2 = "#606B00";
	const ColorBrandPalette0480$2 = "#6E7A00";
	const ColorBrandPalette0490$2 = "#7C8A00";
	const ColorBrandPalette04100$2 = "#8A9900";
	const ColorBrandPalette04110$2 = "#97A800";
	const ColorBrandPalette04120$2 = "#AABD00";
	const ColorBrandPalette04130$2 = "#B8CC00";
	const ColorBrandPalette04140$2 = "#CAE000";
	const ColorBrandPalette04150$2 = "#DCF500";
	const ColorBrandPalette04160$2 = "#E5FF00";
	const ColorBrandPalette0510$2 = "#000E40";
	const ColorBrandPalette0520$2 = "#001A7A";
	const ColorBrandPalette0530$2 = "#00229E";
	const ColorBrandPalette0540$2 = "#0029BD";
	const ColorBrandPalette0550$2 = "#002FDB";
	const ColorBrandPalette0560$2 = "#0037FF";
	const ColorBrandPalette0570$2 = "#1F4FFF";
	const ColorBrandPalette0580$2 = "#3863FF";
	const ColorBrandPalette0590$2 = "#5277FF";
	const ColorBrandPalette05100$2 = "#6B8BFF";
	const ColorBrandPalette05110$2 = "#809BFF";
	const ColorBrandPalette05120$2 = "#99AFFF";
	const ColorBrandPalette05130$2 = "#ADBFFF";
	const ColorBrandPalette05140$2 = "#C7D3FF";
	const ColorBrandPalette05150$2 = "#DBE3FF";
	const ColorBrandPalette05160$2 = "#F0F3FF";
	const ColorBrandPalette0610$2 = "#251B0E";
	const ColorBrandPalette0620$2 = "#342614";
	const ColorBrandPalette0630$2 = "#433119";
	const ColorBrandPalette0640$2 = "#513C1F";
	const ColorBrandPalette0650$2 = "#604724";
	const ColorBrandPalette0660$2 = "#73552B";
	const ColorBrandPalette0670$2 = "#816031";
	const ColorBrandPalette0680$2 = "#946E38";
	const ColorBrandPalette0690$2 = "#A3793E";
	const ColorBrandPalette06100$2 = "#B98946";
	const ColorBrandPalette06110$2 = "#C39A60";
	const ColorBrandPalette06120$2 = "#CEAC7E";
	const ColorBrandPalette06130$2 = "#D8BD97";
	const ColorBrandPalette06140$2 = "#E3D0B5";
	const ColorBrandPalette06150$2 = "#EEE3D3";
	const ColorBrandPalette06160$2 = "#F8F3EC";
	const ColorFeedbackErrorText$2 = "#BC293A";
	const ColorFeedbackErrorShape$2 = "#EA4356";
	const ColorFeedbackSuccessText$2 = "#22723A";
	const ColorFeedbackSuccessShape$2 = "#2D954C";
	const ColorFeedbackOnBrandErrorText$2 = "#FBC5CC";
	const ColorFeedbackOnBrandErrorShape$2 = "#F895A1";
	const ColorFeedbackOnBrandSuccessText$2 = "#9DE2B1";
	const ColorFeedbackOnBrandSuccessShape$2 = "#4BC870";
	const ColorFeedbackInverseErrorText$2 = "#F55C6E";
	const ColorFeedbackInverseErrorShape$2 = "#D83145";
	const ColorFeedbackInverseSuccessText$2 = "#32A454";
	const ColorFeedbackInverseSuccessShape$2 = "#278142";
	const ColorFeedbackInverseOnBrandErrorText$2 = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape$2 = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText$2 = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape$2 = "#278142";
	const ColorIllustrationDeepBlue$1 = "#000F40";
	const ColorIllustrationNeonBlue$1 = "#0037FF";
	const ColorIllustrationNeonRed$1 = "#FF4F33";
	const ColorIllustrationClearBlue$1 = "#ABE6FF";
	const ColorIllustrationBiscuit$1 = "#D1B287";
	const ColorSupport01$2 = "#FF4E33";
	const ColorSupport02$2 = "#F13E22";
	const ColorSupportOnBrand01$2 = "#E5FF00";
	const ColorSupportOnBrand02$2 = "#E5FF00";
	const ColorSupportInverse01$2 = "#FF4E33";
	const ColorSupportInverse02$2 = "#FF4E33";
	const ColorSupportInverseOnBrand01$2 = "#0037FF";
	const ColorSupportInverseOnBrand02$2 = "#0037FF";
	const Opacity01$2 = "0.04";
	const Opacity02$2 = "0.08";
	const Opacity03$2 = "0.12";
	const Opacity04$2 = "0.24";
	const Opacity05$2 = "0.32";
	const Opacity06$2 = "0.56";
	const Opacity07$2 = "0.64";
	const Opacity08$2 = "0.72";
	const Opacity09$2 = "0.88";
	const Shadow01$2 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$2 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$2 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$2 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$2 = "4px";
	const SpacingInlineNano$2 = "8px";
	const SpacingInlineXxxs$2 = "16px";
	const SpacingInlineXxs$2 = "24px";
	const SpacingInlineXs$2 = "32px";
	const SpacingInlineSm$2 = "40px";
	const SpacingInlineMd$2 = "48px";
	const SpacingInlineLg$2 = "56px";
	const SpacingInlineXl$2 = "64px";
	const SpacingInlineXxl$2 = "80px";
	const SpacingInlineXxxl$2 = "120px";
	const SpacingInlineHuge$2 = "160px";
	const SpacingInlineGiant$2 = "200px";
	const SpacingInsetQuark$2 = "4px";
	const SpacingInsetNano$2 = "8px";
	const SpacingInsetXs$2 = "16px";
	const SpacingInsetSm$2 = "24px";
	const SpacingInsetMd$2 = "32px";
	const SpacingInsetLg$2 = "40px";
	const SpacingSquishQuark$2 = "4px 8px";
	const SpacingSquishNano$2 = "8px 16px";
	const SpacingSquishXs$2 = "16px 24px";
	const SpacingSquishSm$2 = "16px 32px";
	const SpacingStackQuark$2 = "4px";
	const SpacingStackNano$2 = "8px";
	const SpacingStackXxxs$2 = "16px";
	const SpacingStackXxs$2 = "24px";
	const SpacingStackXs$2 = "32px";
	const SpacingStackSm$2 = "40px";
	const SpacingStackMd$2 = "48px";
	const SpacingStackLg$2 = "56px";
	const SpacingStackXl$2 = "64px";
	const SpacingStackXxl$2 = "80px";
	const SpacingStackXxxl$2 = "120px";
	const SpacingStackHuge$2 = "160px";
	const SpacingStackGiant$2 = "200px";
	const FontFamilyBase$2 = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontSizeXxxs$2 = "0.75rem";
	const FontSizeXxs$2 = "0.875rem";
	const FontSizeXs$2 = "1rem";
	const FontSizeSm$2 = "1.25rem";
	const FontSizeMd$2 = "1.5rem";
	const FontSizeLg$2 = "2rem";
	const FontSizeXl$2 = "2.5rem";
	const FontSizeXxl$2 = "3rem";
	const FontSizeXxxl$2 = "4rem";
	const FontSizeDisplay$2 = "5rem";
	const FontSizeGiant$2 = "6rem";
	const FontWeightBold$2 = 700;
	const FontWeightSemibold$2 = 600;
	const FontWeightMedium$2 = 500;
	const FontWeightRegular$2 = 400;
	const FontWeightLight$2 = 300;
	const LetterSpacingStandard$2 = "0px";
	const LetterSpacingSmall$2 = "-1px";
	const LetterSpacingMedium$2 = "1.5px";
	const LineHeightStandard$2 = "100%";
	const LineHeightTiny$2 = "115%";
	const LineHeightMedium$2 = "120%";
	const LineHeightLarge$2 = "125%";
	const LineHeightDistant$2 = "133%";
	const LineHeightSuperdistant$2 = "150%";
	const LineHeightHuge$2 = "170%";
	const ZIndex0$2 = "0";
	const ZIndex100$2 = "100";
	const ZIndex200$2 = "200";
	const ZIndex300$2 = "300";
	const ZIndex400$2 = "400";
	const ZIndex500$2 = "500";
	const ZIndexAuto$2 = "auto";
	const ZIndexTop$2 = "99999";
	const ZIndexBottom$2 = "-100";

	var index$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$2,
		BorderRadiusXs: BorderRadiusXs$2,
		BorderRadiusSm: BorderRadiusSm$2,
		BorderRadiusMd: BorderRadiusMd$2,
		BorderRadiusLg: BorderRadiusLg$2,
		BorderRadiusPill: BorderRadiusPill$2,
		BorderRadiusCircle: BorderRadiusCircle$2,
		BorderWidthNone: BorderWidthNone$2,
		BorderWidthHairline: BorderWidthHairline$2,
		BorderWidthThin: BorderWidthThin$2,
		BorderWidthThick: BorderWidthThick$2,
		BorderWidthHeavy: BorderWidthHeavy$2,
		ColorDatavizInfoText: ColorDatavizInfoText$2,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01$2,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02$2,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03$2,
		ColorDatavizNegativeText: ColorDatavizNegativeText$2,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$2,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$2,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$2,
		ColorDatavizWarningText: ColorDatavizWarningText$2,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01$2,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02$2,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03$2,
		ColorDatavizPositiveText: ColorDatavizPositiveText$2,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$2,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$2,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$2,
		ColorDatavizCatAText: ColorDatavizCatAText$2,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01$2,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02$2,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03$2,
		ColorDatavizCatBText: ColorDatavizCatBText$2,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01$2,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02$2,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03$2,
		ColorDatavizCatCText: ColorDatavizCatCText$2,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01$2,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02$2,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03$2,
		ColorDatavizCatDText: ColorDatavizCatDText$2,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01$2,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02$2,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03$2,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$2,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$2,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$2,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$2,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$2,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$2,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$2,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$2,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$2,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$2,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$2,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$2,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$2,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$2,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$2,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$2,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$2,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$2,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$2,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$2,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$2,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$2,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$2,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$2,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$2,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$2,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$2,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$2,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$2,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$2,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$2,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$2,
		ColorInteractionBlend01: ColorInteractionBlend01$2,
		ColorInteractionBlend02: ColorInteractionBlend02$2,
		ColorInteractionBlend03: ColorInteractionBlend03$2,
		ColorInteractionBlend04: ColorInteractionBlend04$2,
		ColorInteractionBlend05: ColorInteractionBlend05$2,
		ColorInteractionBlend06: ColorInteractionBlend06$2,
		ColorInteractionBlend07: ColorInteractionBlend07$2,
		ColorInteractionBlend08: ColorInteractionBlend08$2,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$2,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$2,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$2,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$2,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$2,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$2,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$2,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$2,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$2,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$2,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$2,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$2,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$2,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$2,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$2,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$2,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$2,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$2,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$2,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$2,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$2,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$2,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$2,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$2,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$2,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$2,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$2,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$2,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$2,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$2,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$2,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$2,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$2,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$2,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$2,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$2,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$2,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$2,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$2,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$2,
		ColorInteractionAccent01: ColorInteractionAccent01$2,
		ColorInteractionAccent02: ColorInteractionAccent02$2,
		ColorInteractionAccent03: ColorInteractionAccent03$2,
		ColorInteractionSubtle01: ColorInteractionSubtle01$2,
		ColorInteractionSubtle02: ColorInteractionSubtle02$2,
		ColorInteractionSubtle03: ColorInteractionSubtle03$2,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$2,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$2,
		ColorInteractionSelectActive: ColorInteractionSelectActive$2,
		ColorInteractionDanger01: ColorInteractionDanger01$2,
		ColorInteractionDanger02: ColorInteractionDanger02$2,
		ColorInteractionDanger03: ColorInteractionDanger03$2,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$2,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$2,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$2,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$2,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$2,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$2,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$2,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$2,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$2,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$2,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$2,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$2,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$2,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$2,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$2,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$2,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$2,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$2,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$2,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$2,
		ColorNeutral10: ColorNeutral10$2,
		ColorNeutral20: ColorNeutral20$2,
		ColorNeutral30: ColorNeutral30$2,
		ColorNeutral00: ColorNeutral00$2,
		ColorNeutralInverse10: ColorNeutralInverse10$2,
		ColorNeutralInverse20: ColorNeutralInverse20$2,
		ColorNeutralInverse30: ColorNeutralInverse30$2,
		ColorNeutralInverse00: ColorNeutralInverse00$2,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$2,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$2,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$2,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$2,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$2,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$2,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$2,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$2,
		ColorPaletteBlack: ColorPaletteBlack$2,
		ColorPaletteWhite: ColorPaletteWhite$2,
		ColorPaletteGray10: ColorPaletteGray10$2,
		ColorPaletteGray20: ColorPaletteGray20$2,
		ColorPaletteGray30: ColorPaletteGray30$2,
		ColorPaletteGray40: ColorPaletteGray40$2,
		ColorPaletteGray50: ColorPaletteGray50$2,
		ColorPaletteGray60: ColorPaletteGray60$2,
		ColorPaletteGray70: ColorPaletteGray70$2,
		ColorPaletteGray80: ColorPaletteGray80$2,
		ColorPaletteGray90: ColorPaletteGray90$2,
		ColorPaletteGray100: ColorPaletteGray100$2,
		ColorPaletteGray110: ColorPaletteGray110$2,
		ColorPaletteGray120: ColorPaletteGray120$2,
		ColorPaletteGray130: ColorPaletteGray130$2,
		ColorPaletteGray140: ColorPaletteGray140$2,
		ColorPaletteGray150: ColorPaletteGray150$2,
		ColorPaletteGray160: ColorPaletteGray160$2,
		ColorPaletteRed10: ColorPaletteRed10$2,
		ColorPaletteRed20: ColorPaletteRed20$2,
		ColorPaletteRed30: ColorPaletteRed30$2,
		ColorPaletteRed40: ColorPaletteRed40$2,
		ColorPaletteRed50: ColorPaletteRed50$2,
		ColorPaletteRed60: ColorPaletteRed60$2,
		ColorPaletteRed70: ColorPaletteRed70$2,
		ColorPaletteRed80: ColorPaletteRed80$2,
		ColorPaletteRed90: ColorPaletteRed90$2,
		ColorPaletteRed100: ColorPaletteRed100$2,
		ColorPaletteRed110: ColorPaletteRed110$2,
		ColorPaletteRed120: ColorPaletteRed120$2,
		ColorPaletteRed130: ColorPaletteRed130$2,
		ColorPaletteRed140: ColorPaletteRed140$2,
		ColorPaletteRed150: ColorPaletteRed150$2,
		ColorPaletteRed160: ColorPaletteRed160$2,
		ColorPaletteYellow10: ColorPaletteYellow10$2,
		ColorPaletteYellow20: ColorPaletteYellow20$2,
		ColorPaletteYellow30: ColorPaletteYellow30$2,
		ColorPaletteYellow40: ColorPaletteYellow40$2,
		ColorPaletteYellow50: ColorPaletteYellow50$2,
		ColorPaletteYellow60: ColorPaletteYellow60$2,
		ColorPaletteYellow70: ColorPaletteYellow70$2,
		ColorPaletteYellow80: ColorPaletteYellow80$2,
		ColorPaletteYellow90: ColorPaletteYellow90$2,
		ColorPaletteYellow100: ColorPaletteYellow100$2,
		ColorPaletteYellow110: ColorPaletteYellow110$2,
		ColorPaletteYellow120: ColorPaletteYellow120$2,
		ColorPaletteYellow130: ColorPaletteYellow130$2,
		ColorPaletteYellow140: ColorPaletteYellow140$2,
		ColorPaletteYellow150: ColorPaletteYellow150$2,
		ColorPaletteYellow160: ColorPaletteYellow160$2,
		ColorPaletteLime10: ColorPaletteLime10$2,
		ColorPaletteLime20: ColorPaletteLime20$2,
		ColorPaletteLime30: ColorPaletteLime30$2,
		ColorPaletteLime40: ColorPaletteLime40$2,
		ColorPaletteLime50: ColorPaletteLime50$2,
		ColorPaletteLime60: ColorPaletteLime60$2,
		ColorPaletteLime70: ColorPaletteLime70$2,
		ColorPaletteLime80: ColorPaletteLime80$2,
		ColorPaletteLime90: ColorPaletteLime90$2,
		ColorPaletteLime100: ColorPaletteLime100$2,
		ColorPaletteLime110: ColorPaletteLime110$2,
		ColorPaletteLime120: ColorPaletteLime120$2,
		ColorPaletteLime130: ColorPaletteLime130$2,
		ColorPaletteLime140: ColorPaletteLime140$2,
		ColorPaletteLime150: ColorPaletteLime150$2,
		ColorPaletteLime160: ColorPaletteLime160$2,
		ColorPaletteGreen10: ColorPaletteGreen10$2,
		ColorPaletteGreen20: ColorPaletteGreen20$2,
		ColorPaletteGreen30: ColorPaletteGreen30$2,
		ColorPaletteGreen40: ColorPaletteGreen40$2,
		ColorPaletteGreen50: ColorPaletteGreen50$2,
		ColorPaletteGreen60: ColorPaletteGreen60$2,
		ColorPaletteGreen70: ColorPaletteGreen70$2,
		ColorPaletteGreen80: ColorPaletteGreen80$2,
		ColorPaletteGreen90: ColorPaletteGreen90$2,
		ColorPaletteGreen100: ColorPaletteGreen100$2,
		ColorPaletteGreen110: ColorPaletteGreen110$2,
		ColorPaletteGreen120: ColorPaletteGreen120$2,
		ColorPaletteGreen130: ColorPaletteGreen130$2,
		ColorPaletteGreen140: ColorPaletteGreen140$2,
		ColorPaletteGreen150: ColorPaletteGreen150$2,
		ColorPaletteGreen160: ColorPaletteGreen160$2,
		ColorPaletteAcqua10: ColorPaletteAcqua10$2,
		ColorPaletteAcqua20: ColorPaletteAcqua20$2,
		ColorPaletteAcqua30: ColorPaletteAcqua30$2,
		ColorPaletteAcqua40: ColorPaletteAcqua40$2,
		ColorPaletteAcqua50: ColorPaletteAcqua50$2,
		ColorPaletteAcqua60: ColorPaletteAcqua60$2,
		ColorPaletteAcqua70: ColorPaletteAcqua70$2,
		ColorPaletteAcqua80: ColorPaletteAcqua80$2,
		ColorPaletteAcqua90: ColorPaletteAcqua90$2,
		ColorPaletteAcqua100: ColorPaletteAcqua100$2,
		ColorPaletteAcqua110: ColorPaletteAcqua110$2,
		ColorPaletteAcqua120: ColorPaletteAcqua120$2,
		ColorPaletteAcqua130: ColorPaletteAcqua130$2,
		ColorPaletteAcqua140: ColorPaletteAcqua140$2,
		ColorPaletteAcqua150: ColorPaletteAcqua150$2,
		ColorPaletteAcqua160: ColorPaletteAcqua160$2,
		ColorPaletteBlue10: ColorPaletteBlue10$2,
		ColorPaletteBlue20: ColorPaletteBlue20$2,
		ColorPaletteBlue30: ColorPaletteBlue30$2,
		ColorPaletteBlue40: ColorPaletteBlue40$2,
		ColorPaletteBlue50: ColorPaletteBlue50$2,
		ColorPaletteBlue60: ColorPaletteBlue60$2,
		ColorPaletteBlue70: ColorPaletteBlue70$2,
		ColorPaletteBlue80: ColorPaletteBlue80$2,
		ColorPaletteBlue90: ColorPaletteBlue90$2,
		ColorPaletteBlue100: ColorPaletteBlue100$2,
		ColorPaletteBlue110: ColorPaletteBlue110$2,
		ColorPaletteBlue120: ColorPaletteBlue120$2,
		ColorPaletteBlue130: ColorPaletteBlue130$2,
		ColorPaletteBlue140: ColorPaletteBlue140$2,
		ColorPaletteBlue150: ColorPaletteBlue150$2,
		ColorPaletteBlue160: ColorPaletteBlue160$2,
		ColorPalettePurple10: ColorPalettePurple10$2,
		ColorPalettePurple20: ColorPalettePurple20$2,
		ColorPalettePurple30: ColorPalettePurple30$2,
		ColorPalettePurple40: ColorPalettePurple40$2,
		ColorPalettePurple50: ColorPalettePurple50$2,
		ColorPalettePurple60: ColorPalettePurple60$2,
		ColorPalettePurple70: ColorPalettePurple70$2,
		ColorPalettePurple80: ColorPalettePurple80$2,
		ColorPalettePurple90: ColorPalettePurple90$2,
		ColorPalettePurple100: ColorPalettePurple100$2,
		ColorPalettePurple110: ColorPalettePurple110$2,
		ColorPalettePurple120: ColorPalettePurple120$2,
		ColorPalettePurple130: ColorPalettePurple130$2,
		ColorPalettePurple140: ColorPalettePurple140$2,
		ColorPalettePurple150: ColorPalettePurple150$2,
		ColorPalettePurple160: ColorPalettePurple160$2,
		ColorPalettePink10: ColorPalettePink10$2,
		ColorPalettePink20: ColorPalettePink20$2,
		ColorPalettePink30: ColorPalettePink30$2,
		ColorPalettePink40: ColorPalettePink40$2,
		ColorPalettePink50: ColorPalettePink50$2,
		ColorPalettePink60: ColorPalettePink60$2,
		ColorPalettePink70: ColorPalettePink70$2,
		ColorPalettePink80: ColorPalettePink80$2,
		ColorPalettePink90: ColorPalettePink90$2,
		ColorPalettePink100: ColorPalettePink100$2,
		ColorPalettePink110: ColorPalettePink110$2,
		ColorPalettePink120: ColorPalettePink120$2,
		ColorPalettePink130: ColorPalettePink130$2,
		ColorPalettePink140: ColorPalettePink140$2,
		ColorPalettePink150: ColorPalettePink150$2,
		ColorPalettePink160: ColorPalettePink160$2,
		ColorTypefaceStrong: ColorTypefaceStrong$2,
		ColorTypefacePure: ColorTypefacePure$2,
		ColorTypefaceSmooth: ColorTypefaceSmooth$2,
		ColorTypefaceMeld: ColorTypefaceMeld$2,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$2,
		ColorTypefaceInversePure: ColorTypefaceInversePure$2,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$2,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$2,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$2,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$2,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$2,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$2,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$2,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$2,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$2,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$2,
		ColorBrandPrimary10: ColorBrandPrimary10$2,
		ColorBrandPrimary20: ColorBrandPrimary20$2,
		ColorBrandPrimary30: ColorBrandPrimary30$2,
		ColorBrandPrimary40: ColorBrandPrimary40$2,
		ColorBrandPrimary50: ColorBrandPrimary50$2,
		ColorBrandPrimary60: ColorBrandPrimary60$2,
		ColorBrandPrimary70: ColorBrandPrimary70$2,
		ColorBrandPrimary80: ColorBrandPrimary80$2,
		ColorBrandPrimary90: ColorBrandPrimary90$2,
		ColorBrandPrimary100: ColorBrandPrimary100$2,
		ColorBrandPrimary110: ColorBrandPrimary110$2,
		ColorBrandPrimary120: ColorBrandPrimary120$2,
		ColorBrandPrimary130: ColorBrandPrimary130$2,
		ColorBrandPrimary140: ColorBrandPrimary140$2,
		ColorBrandPrimary150: ColorBrandPrimary150$2,
		ColorBrandPrimary160: ColorBrandPrimary160$2,
		ColorBrandBase01: ColorBrandBase01$2,
		ColorBrandBase02: ColorBrandBase02$2,
		ColorBrandBase03: ColorBrandBase03$2,
		ColorBrandBase04: ColorBrandBase04$2,
		ColorBrandBase05: ColorBrandBase05$2,
		ColorBrandBase06: ColorBrandBase06$2,
		ColorBrandPalette0110: ColorBrandPalette0110$2,
		ColorBrandPalette0120: ColorBrandPalette0120$2,
		ColorBrandPalette0130: ColorBrandPalette0130$2,
		ColorBrandPalette0140: ColorBrandPalette0140$2,
		ColorBrandPalette0150: ColorBrandPalette0150$2,
		ColorBrandPalette0160: ColorBrandPalette0160$2,
		ColorBrandPalette0170: ColorBrandPalette0170$2,
		ColorBrandPalette0180: ColorBrandPalette0180$2,
		ColorBrandPalette0190: ColorBrandPalette0190$2,
		ColorBrandPalette01100: ColorBrandPalette01100$2,
		ColorBrandPalette01110: ColorBrandPalette01110$2,
		ColorBrandPalette01120: ColorBrandPalette01120$2,
		ColorBrandPalette01130: ColorBrandPalette01130$2,
		ColorBrandPalette01140: ColorBrandPalette01140$2,
		ColorBrandPalette01150: ColorBrandPalette01150$2,
		ColorBrandPalette01160: ColorBrandPalette01160$2,
		ColorBrandPalette0210: ColorBrandPalette0210$2,
		ColorBrandPalette0220: ColorBrandPalette0220$2,
		ColorBrandPalette0230: ColorBrandPalette0230$2,
		ColorBrandPalette0240: ColorBrandPalette0240$2,
		ColorBrandPalette0250: ColorBrandPalette0250$2,
		ColorBrandPalette0260: ColorBrandPalette0260$2,
		ColorBrandPalette0270: ColorBrandPalette0270$2,
		ColorBrandPalette0280: ColorBrandPalette0280$2,
		ColorBrandPalette0290: ColorBrandPalette0290$2,
		ColorBrandPalette02100: ColorBrandPalette02100$2,
		ColorBrandPalette02110: ColorBrandPalette02110$2,
		ColorBrandPalette02120: ColorBrandPalette02120$2,
		ColorBrandPalette02130: ColorBrandPalette02130$2,
		ColorBrandPalette02140: ColorBrandPalette02140$2,
		ColorBrandPalette02150: ColorBrandPalette02150$2,
		ColorBrandPalette02160: ColorBrandPalette02160$2,
		ColorBrandPalette0310: ColorBrandPalette0310$1,
		ColorBrandPalette0320: ColorBrandPalette0320$1,
		ColorBrandPalette0330: ColorBrandPalette0330$1,
		ColorBrandPalette0340: ColorBrandPalette0340$1,
		ColorBrandPalette0350: ColorBrandPalette0350$1,
		ColorBrandPalette0360: ColorBrandPalette0360$1,
		ColorBrandPalette0370: ColorBrandPalette0370$1,
		ColorBrandPalette0380: ColorBrandPalette0380$1,
		ColorBrandPalette0390: ColorBrandPalette0390$1,
		ColorBrandPalette03100: ColorBrandPalette03100$1,
		ColorBrandPalette03110: ColorBrandPalette03110$1,
		ColorBrandPalette03120: ColorBrandPalette03120$1,
		ColorBrandPalette03130: ColorBrandPalette03130$1,
		ColorBrandPalette03140: ColorBrandPalette03140$1,
		ColorBrandPalette03150: ColorBrandPalette03150$1,
		ColorBrandPalette03160: ColorBrandPalette03160$1,
		ColorBrandPalette0410: ColorBrandPalette0410$2,
		ColorBrandPalette0420: ColorBrandPalette0420$2,
		ColorBrandPalette0430: ColorBrandPalette0430$2,
		ColorBrandPalette0440: ColorBrandPalette0440$2,
		ColorBrandPalette0450: ColorBrandPalette0450$2,
		ColorBrandPalette0460: ColorBrandPalette0460$2,
		ColorBrandPalette0470: ColorBrandPalette0470$2,
		ColorBrandPalette0480: ColorBrandPalette0480$2,
		ColorBrandPalette0490: ColorBrandPalette0490$2,
		ColorBrandPalette04100: ColorBrandPalette04100$2,
		ColorBrandPalette04110: ColorBrandPalette04110$2,
		ColorBrandPalette04120: ColorBrandPalette04120$2,
		ColorBrandPalette04130: ColorBrandPalette04130$2,
		ColorBrandPalette04140: ColorBrandPalette04140$2,
		ColorBrandPalette04150: ColorBrandPalette04150$2,
		ColorBrandPalette04160: ColorBrandPalette04160$2,
		ColorBrandPalette0510: ColorBrandPalette0510$2,
		ColorBrandPalette0520: ColorBrandPalette0520$2,
		ColorBrandPalette0530: ColorBrandPalette0530$2,
		ColorBrandPalette0540: ColorBrandPalette0540$2,
		ColorBrandPalette0550: ColorBrandPalette0550$2,
		ColorBrandPalette0560: ColorBrandPalette0560$2,
		ColorBrandPalette0570: ColorBrandPalette0570$2,
		ColorBrandPalette0580: ColorBrandPalette0580$2,
		ColorBrandPalette0590: ColorBrandPalette0590$2,
		ColorBrandPalette05100: ColorBrandPalette05100$2,
		ColorBrandPalette05110: ColorBrandPalette05110$2,
		ColorBrandPalette05120: ColorBrandPalette05120$2,
		ColorBrandPalette05130: ColorBrandPalette05130$2,
		ColorBrandPalette05140: ColorBrandPalette05140$2,
		ColorBrandPalette05150: ColorBrandPalette05150$2,
		ColorBrandPalette05160: ColorBrandPalette05160$2,
		ColorBrandPalette0610: ColorBrandPalette0610$2,
		ColorBrandPalette0620: ColorBrandPalette0620$2,
		ColorBrandPalette0630: ColorBrandPalette0630$2,
		ColorBrandPalette0640: ColorBrandPalette0640$2,
		ColorBrandPalette0650: ColorBrandPalette0650$2,
		ColorBrandPalette0660: ColorBrandPalette0660$2,
		ColorBrandPalette0670: ColorBrandPalette0670$2,
		ColorBrandPalette0680: ColorBrandPalette0680$2,
		ColorBrandPalette0690: ColorBrandPalette0690$2,
		ColorBrandPalette06100: ColorBrandPalette06100$2,
		ColorBrandPalette06110: ColorBrandPalette06110$2,
		ColorBrandPalette06120: ColorBrandPalette06120$2,
		ColorBrandPalette06130: ColorBrandPalette06130$2,
		ColorBrandPalette06140: ColorBrandPalette06140$2,
		ColorBrandPalette06150: ColorBrandPalette06150$2,
		ColorBrandPalette06160: ColorBrandPalette06160$2,
		ColorFeedbackErrorText: ColorFeedbackErrorText$2,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$2,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$2,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$2,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$2,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$2,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$2,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$2,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$2,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$2,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$2,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$2,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$2,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$2,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$2,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$2,
		ColorIllustrationDeepBlue: ColorIllustrationDeepBlue$1,
		ColorIllustrationNeonBlue: ColorIllustrationNeonBlue$1,
		ColorIllustrationNeonRed: ColorIllustrationNeonRed$1,
		ColorIllustrationClearBlue: ColorIllustrationClearBlue$1,
		ColorIllustrationBiscuit: ColorIllustrationBiscuit$1,
		ColorSupport01: ColorSupport01$2,
		ColorSupport02: ColorSupport02$2,
		ColorSupportOnBrand01: ColorSupportOnBrand01$2,
		ColorSupportOnBrand02: ColorSupportOnBrand02$2,
		ColorSupportInverse01: ColorSupportInverse01$2,
		ColorSupportInverse02: ColorSupportInverse02$2,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$2,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$2,
		Opacity01: Opacity01$2,
		Opacity02: Opacity02$2,
		Opacity03: Opacity03$2,
		Opacity04: Opacity04$2,
		Opacity05: Opacity05$2,
		Opacity06: Opacity06$2,
		Opacity07: Opacity07$2,
		Opacity08: Opacity08$2,
		Opacity09: Opacity09$2,
		Shadow01: Shadow01$2,
		Shadow02: Shadow02$2,
		Shadow03: Shadow03$2,
		Shadow04: Shadow04$2,
		SpacingInlineQuark: SpacingInlineQuark$2,
		SpacingInlineNano: SpacingInlineNano$2,
		SpacingInlineXxxs: SpacingInlineXxxs$2,
		SpacingInlineXxs: SpacingInlineXxs$2,
		SpacingInlineXs: SpacingInlineXs$2,
		SpacingInlineSm: SpacingInlineSm$2,
		SpacingInlineMd: SpacingInlineMd$2,
		SpacingInlineLg: SpacingInlineLg$2,
		SpacingInlineXl: SpacingInlineXl$2,
		SpacingInlineXxl: SpacingInlineXxl$2,
		SpacingInlineXxxl: SpacingInlineXxxl$2,
		SpacingInlineHuge: SpacingInlineHuge$2,
		SpacingInlineGiant: SpacingInlineGiant$2,
		SpacingInsetQuark: SpacingInsetQuark$2,
		SpacingInsetNano: SpacingInsetNano$2,
		SpacingInsetXs: SpacingInsetXs$2,
		SpacingInsetSm: SpacingInsetSm$2,
		SpacingInsetMd: SpacingInsetMd$2,
		SpacingInsetLg: SpacingInsetLg$2,
		SpacingSquishQuark: SpacingSquishQuark$2,
		SpacingSquishNano: SpacingSquishNano$2,
		SpacingSquishXs: SpacingSquishXs$2,
		SpacingSquishSm: SpacingSquishSm$2,
		SpacingStackQuark: SpacingStackQuark$2,
		SpacingStackNano: SpacingStackNano$2,
		SpacingStackXxxs: SpacingStackXxxs$2,
		SpacingStackXxs: SpacingStackXxs$2,
		SpacingStackXs: SpacingStackXs$2,
		SpacingStackSm: SpacingStackSm$2,
		SpacingStackMd: SpacingStackMd$2,
		SpacingStackLg: SpacingStackLg$2,
		SpacingStackXl: SpacingStackXl$2,
		SpacingStackXxl: SpacingStackXxl$2,
		SpacingStackXxxl: SpacingStackXxxl$2,
		SpacingStackHuge: SpacingStackHuge$2,
		SpacingStackGiant: SpacingStackGiant$2,
		FontFamilyBase: FontFamilyBase$2,
		FontSizeXxxs: FontSizeXxxs$2,
		FontSizeXxs: FontSizeXxs$2,
		FontSizeXs: FontSizeXs$2,
		FontSizeSm: FontSizeSm$2,
		FontSizeMd: FontSizeMd$2,
		FontSizeLg: FontSizeLg$2,
		FontSizeXl: FontSizeXl$2,
		FontSizeXxl: FontSizeXxl$2,
		FontSizeXxxl: FontSizeXxxl$2,
		FontSizeDisplay: FontSizeDisplay$2,
		FontSizeGiant: FontSizeGiant$2,
		FontWeightBold: FontWeightBold$2,
		FontWeightSemibold: FontWeightSemibold$2,
		FontWeightMedium: FontWeightMedium$2,
		FontWeightRegular: FontWeightRegular$2,
		FontWeightLight: FontWeightLight$2,
		LetterSpacingStandard: LetterSpacingStandard$2,
		LetterSpacingSmall: LetterSpacingSmall$2,
		LetterSpacingMedium: LetterSpacingMedium$2,
		LineHeightStandard: LineHeightStandard$2,
		LineHeightTiny: LineHeightTiny$2,
		LineHeightMedium: LineHeightMedium$2,
		LineHeightLarge: LineHeightLarge$2,
		LineHeightDistant: LineHeightDistant$2,
		LineHeightSuperdistant: LineHeightSuperdistant$2,
		LineHeightHuge: LineHeightHuge$2,
		ZIndex0: ZIndex0$2,
		ZIndex100: ZIndex100$2,
		ZIndex200: ZIndex200$2,
		ZIndex300: ZIndex300$2,
		ZIndex400: ZIndex400$2,
		ZIndex500: ZIndex500$2,
		ZIndexAuto: ZIndexAuto$2,
		ZIndexTop: ZIndexTop$2,
		ZIndexBottom: ZIndexBottom$2
	});

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:01 GMT
	 */

	const BorderRadiusNone$1 = "0px";
	const BorderRadiusXs$1 = "4px";
	const BorderRadiusSm$1 = "8px";
	const BorderRadiusMd$1 = "16px";
	const BorderRadiusLg$1 = "24px";
	const BorderRadiusPill$1 = "960px";
	const BorderRadiusCircle$1 = "50%";
	const BorderWidthNone$1 = "0px";
	const BorderWidthHairline$1 = "1px";
	const BorderWidthThin$1 = "2px";
	const BorderWidthThick$1 = "4px";
	const BorderWidthHeavy$1 = "8px";
	const ColorDatavizInfoText$1 = "#0F58EA";
	const ColorDatavizInfoShape01$1 = "#3F7BF2";
	const ColorDatavizInfoShape02$1 = "#D9E5FC";
	const ColorDatavizInfoShape03$1 = "#F1F5FE";
	const ColorDatavizNegativeText$1 = "#BC293A";
	const ColorDatavizNegativeShape01$1 = "#EA4356";
	const ColorDatavizNegativeShape02$1 = "#FDDDE1";
	const ColorDatavizNegativeShape03$1 = "#FEF1F2";
	const ColorDatavizWarningText$1 = "#A04C03";
	const ColorDatavizWarningShape01$1 = "#D26404";
	const ColorDatavizWarningShape02$1 = "#FEE1C8";
	const ColorDatavizWarningShape03$1 = "#FEF1E6";
	const ColorDatavizPositiveText$1 = "#22723A";
	const ColorDatavizPositiveShape01$1 = "#2D954C";
	const ColorDatavizPositiveShape02$1 = "#C8EED3";
	const ColorDatavizPositiveShape03$1 = "#E8F8EC";
	const ColorDatavizCatAText$1 = "#9B18DC";
	const ColorDatavizCatAShape01$1 = "#B851EC";
	const ColorDatavizCatAShape02$1 = "#F2DFFB";
	const ColorDatavizCatAShape03$1 = "#F9F1FD";
	const ColorDatavizCatBText$1 = "#BA267B";
	const ColorDatavizCatBShape01$1 = "#DA499B";
	const ColorDatavizCatBShape02$1 = "#F8DDEC";
	const ColorDatavizCatBShape03$1 = "#FCF2F8";
	const ColorDatavizCatCText$1 = "#546E21";
	const ColorDatavizCatCShape01$1 = "#6C8D2B";
	const ColorDatavizCatCShape02$1 = "#DBEBBD";
	const ColorDatavizCatCShape03$1 = "#F0F7E4";
	const ColorDatavizCatDText$1 = "#0D735E";
	const ColorDatavizCatDShape01$1 = "#109379";
	const ColorDatavizCatDShape02$1 = "#BCF0E6";
	const ColorDatavizCatDShape03$1 = "#DFFBF6";
	const ColorDatavizInverseInfoText$1 = "#5C8FF5";
	const ColorDatavizInverseInfoShape01$1 = "#286BF1";
	const ColorDatavizInverseInfoShape02$1 = "#062560";
	const ColorDatavizInverseInfoShape03$1 = "#051B48";
	const ColorDatavizInverseNegativeText$1 = "#F55C6E";
	const ColorDatavizInverseNegativeShape01$1 = "#D83145";
	const ColorDatavizInverseNegativeShape02$1 = "#4F1119";
	const ColorDatavizInverseNegativeShape03$1 = "#3B0D12";
	const ColorDatavizInverseWarningText$1 = "#EB7005";
	const ColorDatavizInverseWarningShape01$1 = "#B95804";
	const ColorDatavizInverseWarningShape02$1 = "#462101";
	const ColorDatavizInverseWarningShape03$1 = "#321701";
	const ColorDatavizInversePositiveText$1 = "#32A454";
	const ColorDatavizInversePositiveShape01$1 = "#278142";
	const ColorDatavizInversePositiveShape02$1 = "#0E2F18";
	const ColorDatavizInversePositiveShape03$1 = "#0B2312";
	const ColorDatavizInverseCatAText$1 = "#C36CEF";
	const ColorDatavizInverseCatAShape01$1 = "#AD35E9";
	const ColorDatavizInverseCatAShape02$1 = "#440B60";
	const ColorDatavizInverseCatAShape03$1 = "#340849";
	const ColorDatavizInverseCatBText$1 = "#E067AB";
	const ColorDatavizInverseCatBShape01$1 = "#D42B8C";
	const ColorDatavizInverseCatBShape02$1 = "#4C1032";
	const ColorDatavizInverseCatBShape03$1 = "#3B0C27";
	const ColorDatavizInverseCatCText$1 = "#789D2F";
	const ColorDatavizInverseCatCShape01$1 = "#607E26";
	const ColorDatavizInverseCatCShape02$1 = "#212B0D";
	const ColorDatavizInverseCatCShape03$1 = "#1B230B";
	const ColorDatavizInverseCatDText$1 = "#12A588";
	const ColorDatavizInverseCatDShape01$1 = "#0F856D";
	const ColorDatavizInverseCatDShape02$1 = "#052E26";
	const ColorDatavizInverseCatDShape03$1 = "#04251E";
	const ColorInteractionBlend01$1 = "#1616160A";
	const ColorInteractionBlend02$1 = "#16161614";
	const ColorInteractionBlend03$1 = "#1616161F";
	const ColorInteractionBlend04$1 = "#1616163D";
	const ColorInteractionBlend05$1 = "#161616A3";
	const ColorInteractionBlend06$1 = "#161616B8";
	const ColorInteractionBlend07$1 = "#161616E0";
	const ColorInteractionBlend08$1 = "#161616";
	const ColorInteractionInverseBlend01$1 = "#FEFEFE14";
	const ColorInteractionInverseBlend02$1 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03$1 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04$1 = "#FEFEFE52";
	const ColorInteractionInverseBlend05$1 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06$1 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07$1 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08$1 = "#FEFEFE";
	const ColorInteractionInverseAccent01$1 = "#809BFF";
	const ColorInteractionInverseAccent02$1 = "#99AFFF";
	const ColorInteractionInverseAccent03$1 = "#ADBFFF";
	const ColorInteractionInverseSubtle01$1 = "#5277FF1F";
	const ColorInteractionInverseSubtle02$1 = "#5277FF3D";
	const ColorInteractionInverseSubtle03$1 = "#5277FF52";
	const ColorInteractionInverseSelectDefault$1 = "#919191";
	const ColorInteractionInverseSelectFocus$1 = "#D4D4D4";
	const ColorInteractionInverseSelectActive$1 = "#809BFF";
	const ColorInteractionInverseDanger01$1 = "#F55C6E";
	const ColorInteractionInverseDanger02$1 = "#F77E8C";
	const ColorInteractionInverseDanger03$1 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01$1 = "#00229E";
	const ColorInteractionInverseOnBrandAccent02$1 = "#001A7A";
	const ColorInteractionInverseOnBrandAccent03$1 = "#001561";
	const ColorInteractionInverseOnBrandSubtle01$1 = "#0B278F14";
	const ColorInteractionInverseOnBrandSubtle02$1 = "#0B278F1F";
	const ColorInteractionInverseOnBrandSubtle03$1 = "#0B278F3D";
	const ColorInteractionInverseOnBrandSelectDefault$1 = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus$1 = "#363636";
	const ColorInteractionInverseOnBrandSelectActive$1 = "#00229E";
	const ColorInteractionInverseOnBrandBlend01$1 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02$1 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03$1 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04$1 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05$1 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06$1 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07$1 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08$1 = "#161616";
	const ColorInteractionInverseOnBrandDanger01$1 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02$1 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03$1 = "#7E1B27";
	const ColorInteractionAccent01$1 = "#0037FF";
	const ColorInteractionAccent02$1 = "#002FDB";
	const ColorInteractionAccent03$1 = "#0029BD";
	const ColorInteractionSubtle01$1 = "#0037FF1F";
	const ColorInteractionSubtle02$1 = "#0037FF3D";
	const ColorInteractionSubtle03$1 = "#0037FF52";
	const ColorInteractionSelectDefault$1 = "#666666";
	const ColorInteractionSelectFocus$1 = "#363636";
	const ColorInteractionSelectActive$1 = "#0037FF";
	const ColorInteractionDanger01$1 = "#BC293A";
	const ColorInteractionDanger02$1 = "#A72534";
	const ColorInteractionDanger03$1 = "#92202E";
	const ColorInteractionOnBrandAccent01$1 = "#FEFEFE";
	const ColorInteractionOnBrandAccent02$1 = "#DBE3FF";
	const ColorInteractionOnBrandAccent03$1 = "#C7D3FF";
	const ColorInteractionOnBrandSubtle01$1 = "#FEFEFE1F";
	const ColorInteractionOnBrandSubtle02$1 = "#FEFEFE3D";
	const ColorInteractionOnBrandSubtle03$1 = "#FEFEFE52";
	const ColorInteractionOnBrandSelectDefault$1 = "#C7D3FF";
	const ColorInteractionOnBrandSelectFocus$1 = "#DBE3FF";
	const ColorInteractionOnBrandSelectActive$1 = "#FEFEFE";
	const ColorInteractionOnBrandBlend01$1 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02$1 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03$1 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04$1 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05$1 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06$1 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07$1 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08$1 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01$1 = "#FDDDE1";
	const ColorInteractionOnBrandDanger02$1 = "#FBC5CC";
	const ColorInteractionOnBrandDanger03$1 = "#FAAEB6";
	const ColorNeutral10$1 = "#F5F5F5";
	const ColorNeutral20$1 = "#E6E6E6";
	const ColorNeutral30$1 = "#1616163D";
	const ColorNeutral00$1 = "#FEFEFE";
	const ColorNeutralInverse10$1 = "#1F1F1F";
	const ColorNeutralInverse20$1 = "#292929";
	const ColorNeutralInverse30$1 = "#FEFEFE3D";
	const ColorNeutralInverse00$1 = "#161616";
	const ColorNeutralInverseOnBrand10$1 = "#DBE3FF";
	const ColorNeutralInverseOnBrand20$1 = "#C7D3FF";
	const ColorNeutralInverseOnBrand30$1 = "#0037FF7A";
	const ColorNeutralInverseOnBrand00$1 = "#F0F3FF";
	const ColorNeutralOnBrand10$1 = "#002FDB";
	const ColorNeutralOnBrand20$1 = "#0029BD";
	const ColorNeutralOnBrand30$1 = "#00229EE0";
	const ColorNeutralOnBrand00$1 = "#0037FF";
	const ColorPaletteBlack$1 = "#161616";
	const ColorPaletteWhite$1 = "#FEFEFE";
	const ColorPaletteGray10$1 = "#1F1F1F";
	const ColorPaletteGray20$1 = "#292929";
	const ColorPaletteGray30$1 = "#363636";
	const ColorPaletteGray40$1 = "#404040";
	const ColorPaletteGray50$1 = "#4C4C4C";
	const ColorPaletteGray60$1 = "#595959";
	const ColorPaletteGray70$1 = "#666666";
	const ColorPaletteGray80$1 = "#737373";
	const ColorPaletteGray90$1 = "#828282";
	const ColorPaletteGray100$1 = "#919191";
	const ColorPaletteGray110$1 = "#A1A1A1";
	const ColorPaletteGray120$1 = "#B0B0B0";
	const ColorPaletteGray130$1 = "#C2C2C2";
	const ColorPaletteGray140$1 = "#D4D4D4";
	const ColorPaletteGray150$1 = "#E6E6E6";
	const ColorPaletteGray160$1 = "#F5F5F5";
	const ColorPaletteRed10$1 = "#3B0D12";
	const ColorPaletteRed20$1 = "#4F1119";
	const ColorPaletteRed30$1 = "#691721";
	const ColorPaletteRed40$1 = "#7E1B27";
	const ColorPaletteRed50$1 = "#92202E";
	const ColorPaletteRed60$1 = "#A72534";
	const ColorPaletteRed70$1 = "#BC293A";
	const ColorPaletteRed80$1 = "#D83145";
	const ColorPaletteRed90$1 = "#EA4356";
	const ColorPaletteRed100$1 = "#F55C6E";
	const ColorPaletteRed110$1 = "#F77E8C";
	const ColorPaletteRed120$1 = "#F895A1";
	const ColorPaletteRed130$1 = "#FAAEB6";
	const ColorPaletteRed140$1 = "#FBC5CC";
	const ColorPaletteRed150$1 = "#FDDDE1";
	const ColorPaletteRed160$1 = "#FEF1F2";
	const ColorPaletteYellow10$1 = "#321701";
	const ColorPaletteYellow20$1 = "#462101";
	const ColorPaletteYellow30$1 = "#552802";
	const ColorPaletteYellow40$1 = "#693102";
	const ColorPaletteYellow50$1 = "#7D3B03";
	const ColorPaletteYellow60$1 = "#914503";
	const ColorPaletteYellow70$1 = "#A04C03";
	const ColorPaletteYellow80$1 = "#B95804";
	const ColorPaletteYellow90$1 = "#D26404";
	const ColorPaletteYellow100$1 = "#EB7005";
	const ColorPaletteYellow110$1 = "#FA8219";
	const ColorPaletteYellow120$1 = "#FB9B46";
	const ColorPaletteYellow130$1 = "#FCB06E";
	const ColorPaletteYellow140$1 = "#FDC99B";
	const ColorPaletteYellow150$1 = "#FEE1C8";
	const ColorPaletteYellow160$1 = "#FEF1E6";
	const ColorPaletteLime10$1 = "#1B230B";
	const ColorPaletteLime20$1 = "#212B0D";
	const ColorPaletteLime30$1 = "#2D3B12";
	const ColorPaletteLime40$1 = "#364616";
	const ColorPaletteLime50$1 = "#3F5219";
	const ColorPaletteLime60$1 = "#485E1D";
	const ColorPaletteLime70$1 = "#546E21";
	const ColorPaletteLime80$1 = "#607E26";
	const ColorPaletteLime90$1 = "#6C8D2B";
	const ColorPaletteLime100$1 = "#789D2F";
	const ColorPaletteLime110$1 = "#84AC34";
	const ColorPaletteLime120$1 = "#93BF3A";
	const ColorPaletteLime130$1 = "#A9CF5E";
	const ColorPaletteLime140$1 = "#C2DD8D";
	const ColorPaletteLime150$1 = "#DBEBBD";
	const ColorPaletteLime160$1 = "#F0F7E4";
	const ColorPaletteGreen10$1 = "#0B2312";
	const ColorPaletteGreen20$1 = "#0E2F18";
	const ColorPaletteGreen30$1 = "#133E20";
	const ColorPaletteGreen40$1 = "#174A26";
	const ColorPaletteGreen50$1 = "#1A562C";
	const ColorPaletteGreen60$1 = "#1F6634";
	const ColorPaletteGreen70$1 = "#22723A";
	const ColorPaletteGreen80$1 = "#278142";
	const ColorPaletteGreen90$1 = "#2D954C";
	const ColorPaletteGreen100$1 = "#32A454";
	const ColorPaletteGreen110$1 = "#38B85E";
	const ColorPaletteGreen120$1 = "#4BC870";
	const ColorPaletteGreen130$1 = "#76D692";
	const ColorPaletteGreen140$1 = "#9DE2B1";
	const ColorPaletteGreen150$1 = "#C8EED3";
	const ColorPaletteGreen160$1 = "#E8F8EC";
	const ColorPaletteAcqua10$1 = "#04251E";
	const ColorPaletteAcqua20$1 = "#052E26";
	const ColorPaletteAcqua30$1 = "#073C31";
	const ColorPaletteAcqua40$1 = "#08493C";
	const ColorPaletteAcqua50$1 = "#0A5748";
	const ColorPaletteAcqua60$1 = "#0B6553";
	const ColorPaletteAcqua70$1 = "#0D735E";
	const ColorPaletteAcqua80$1 = "#0F856D";
	const ColorPaletteAcqua90$1 = "#109379";
	const ColorPaletteAcqua100$1 = "#12A588";
	const ColorPaletteAcqua110$1 = "#14B897";
	const ColorPaletteAcqua120$1 = "#31C4A6";
	const ColorPaletteAcqua130$1 = "#68D4BF";
	const ColorPaletteAcqua140$1 = "#8DE2D1";
	const ColorPaletteAcqua150$1 = "#BCF0E6";
	const ColorPaletteAcqua160$1 = "#DFFBF6";
	const ColorPaletteBlue10$1 = "#051B48";
	const ColorPaletteBlue20$1 = "#062560";
	const ColorPaletteBlue30$1 = "#082F7D";
	const ColorPaletteBlue40$1 = "#0A3A9A";
	const ColorPaletteBlue50$1 = "#0B43B1";
	const ColorPaletteBlue60$1 = "#0D4ECE";
	const ColorPaletteBlue70$1 = "#0F58EA";
	const ColorPaletteBlue80$1 = "#286BF1";
	const ColorPaletteBlue90$1 = "#3F7BF2";
	const ColorPaletteBlue100$1 = "#5C8FF5";
	const ColorPaletteBlue110$1 = "#73A0F7";
	const ColorPaletteBlue120$1 = "#8CB0F8";
	const ColorPaletteBlue130$1 = "#A9C4F9";
	const ColorPaletteBlue140$1 = "#C1D4FB";
	const ColorPaletteBlue150$1 = "#D9E5FC";
	const ColorPaletteBlue160$1 = "#F1F5FE";
	const ColorPalettePurple10$1 = "#340849";
	const ColorPalettePurple20$1 = "#440B60";
	const ColorPalettePurple30$1 = "#540D78";
	const ColorPalettePurple40$1 = "#671093";
	const ColorPalettePurple50$1 = "#7713AA";
	const ColorPalettePurple60$1 = "#8B16C5";
	const ColorPalettePurple70$1 = "#9B18DC";
	const ColorPalettePurple80$1 = "#AD35E9";
	const ColorPalettePurple90$1 = "#B851EC";
	const ColorPalettePurple100$1 = "#C36CEF";
	const ColorPalettePurple110$1 = "#CC83F1";
	const ColorPalettePurple120$1 = "#D69AF4";
	const ColorPalettePurple130$1 = "#DFB1F6";
	const ColorPalettePurple140$1 = "#E8C8F9";
	const ColorPalettePurple150$1 = "#F2DFFB";
	const ColorPalettePurple160$1 = "#F9F1FD";
	const ColorPalettePink10$1 = "#3B0C27";
	const ColorPalettePink20$1 = "#4C1032";
	const ColorPalettePink30$1 = "#661543";
	const ColorPalettePink40$1 = "#77184E";
	const ColorPalettePink50$1 = "#8C1C5D";
	const ColorPalettePink60$1 = "#A12169";
	const ColorPalettePink70$1 = "#BA267B";
	const ColorPalettePink80$1 = "#D42B8C";
	const ColorPalettePink90$1 = "#DA499B";
	const ColorPalettePink100$1 = "#E067AB";
	const ColorPalettePink110$1 = "#E580B9";
	const ColorPalettePink120$1 = "#EA99C7";
	const ColorPalettePink130$1 = "#EFAFD3";
	const ColorPalettePink140$1 = "#F4C8E1";
	const ColorPalettePink150$1 = "#F8DDEC";
	const ColorPalettePink160$1 = "#FCF2F8";
	const ColorTypefaceStrong$1 = "#161616";
	const ColorTypefacePure$1 = "#363636";
	const ColorTypefaceSmooth$1 = "#666666";
	const ColorTypefaceMeld$1 = "#1616163D";
	const ColorTypefaceInverseStrong$1 = "#FEFEFE";
	const ColorTypefaceInversePure$1 = "#D4D4D4";
	const ColorTypefaceInverseSmooth$1 = "#919191";
	const ColorTypefaceInverseMeld$1 = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong$1 = "#161616";
	const ColorTypefaceInverseOnBrandPure$1 = "#363636";
	const ColorTypefaceInverseOnBrandSmooth$1 = "#595959";
	const ColorTypefaceInverseOnBrandMeld$1 = "#1616163D";
	const ColorTypefaceOnBrandStrong$1 = "#FEFEFE";
	const ColorTypefaceOnBrandPure$1 = "#DBE3FF";
	const ColorTypefaceOnBrandSmooth$1 = "#C7D3FF";
	const ColorTypefaceOnBrandMeld$1 = "#FEFEFE52";
	const ColorBrandPrimary10$1 = "#001561";
	const ColorBrandPrimary20$1 = "#001A7A";
	const ColorBrandPrimary30$1 = "#00229E";
	const ColorBrandPrimary40$1 = "#0029BD";
	const ColorBrandPrimary50$1 = "#002FDB";
	const ColorBrandPrimary60$1 = "#0037FF";
	const ColorBrandPrimary70$1 = "#1F4FFF";
	const ColorBrandPrimary80$1 = "#3863FF";
	const ColorBrandPrimary90$1 = "#5277FF";
	const ColorBrandPrimary100$1 = "#6B8BFF";
	const ColorBrandPrimary110$1 = "#809BFF";
	const ColorBrandPrimary120$1 = "#99AFFF";
	const ColorBrandPrimary130$1 = "#ADBFFF";
	const ColorBrandPrimary140$1 = "#C7D3FF";
	const ColorBrandPrimary150$1 = "#DBE3FF";
	const ColorBrandPrimary160$1 = "#F0F3FF";
	const ColorBrandBase01$1 = "#0037FF";
	const ColorBrandBase02$1 = "#A6E1FF";
	const ColorBrandBase03$1 = "#FF4E33";
	const ColorBrandBase04$1 = "#E5FF00";
	const ColorBrandBase05$1 = "#000E40";
	const ColorBrandBase06$1 = "#D8BD97";
	const ColorBrandPalette0110$1 = "#001561";
	const ColorBrandPalette0120$1 = "#001A7A";
	const ColorBrandPalette0130$1 = "#00229E";
	const ColorBrandPalette0140$1 = "#0029BD";
	const ColorBrandPalette0150$1 = "#002FDB";
	const ColorBrandPalette0160$1 = "#0037FF";
	const ColorBrandPalette0170$1 = "#1F4FFF";
	const ColorBrandPalette0180$1 = "#3863FF";
	const ColorBrandPalette0190$1 = "#5277FF";
	const ColorBrandPalette01100$1 = "#6B8BFF";
	const ColorBrandPalette01110$1 = "#809BFF";
	const ColorBrandPalette01120$1 = "#99AFFF";
	const ColorBrandPalette01130$1 = "#ADBFFF";
	const ColorBrandPalette01140$1 = "#C7D3FF";
	const ColorBrandPalette01150$1 = "#DBE3FF";
	const ColorBrandPalette01160$1 = "#F0F3FF";
	const ColorBrandPalette0210$1 = "#002233";
	const ColorBrandPalette0220$1 = "#002C42";
	const ColorBrandPalette0230$1 = "#073B54";
	const ColorBrandPalette0240$1 = "#004466";
	const ColorBrandPalette0250$1 = "#00527A";
	const ColorBrandPalette0260$1 = "#005F8F";
	const ColorBrandPalette0270$1 = "#00699E";
	const ColorBrandPalette0280$1 = "#007AB8";
	const ColorBrandPalette0290$1 = "#0088CC";
	const ColorBrandPalette02100$1 = "#0099E5";
	const ColorBrandPalette02110$1 = "#00AAFF";
	const ColorBrandPalette02120$1 = "#38BDFF";
	const ColorBrandPalette02130$1 = "#6BCEFF";
	const ColorBrandPalette02140$1 = "#A6E1FF";
	const ColorBrandPalette02150$1 = "#C7ECFF";
	const ColorBrandPalette02160$1 = "#EBF8FF";
	const ColorBrandPalette0310 = "#420900";
	const ColorBrandPalette0320 = "#510F05";
	const ColorBrandPalette0330 = "#691407";
	const ColorBrandPalette0340 = "#7D1808";
	const ColorBrandPalette0350 = "#901B09";
	const ColorBrandPalette0360 = "#A8200B";
	const ColorBrandPalette0370 = "#BB230C";
	const ColorBrandPalette0380 = "#DD2A0E";
	const ColorBrandPalette0390 = "#F13E22";
	const ColorBrandPalette03100 = "#FF4E33";
	const ColorBrandPalette03110 = "#FF7661";
	const ColorBrandPalette03120 = "#FF9585";
	const ColorBrandPalette03130 = "#FFAB9E";
	const ColorBrandPalette03140 = "#FFC6BD";
	const ColorBrandPalette03150 = "#FFE0DB";
	const ColorBrandPalette03160 = "#FFF2F0";
	const ColorBrandPalette0410$1 = "#1C1F00";
	const ColorBrandPalette0420$1 = "#252900";
	const ColorBrandPalette0430$1 = "#323800";
	const ColorBrandPalette0440$1 = "#404700";
	const ColorBrandPalette0450$1 = "#495200";
	const ColorBrandPalette0460$1 = "#535C00";
	const ColorBrandPalette0470$1 = "#606B00";
	const ColorBrandPalette0480$1 = "#6E7A00";
	const ColorBrandPalette0490$1 = "#7C8A00";
	const ColorBrandPalette04100$1 = "#8A9900";
	const ColorBrandPalette04110$1 = "#97A800";
	const ColorBrandPalette04120$1 = "#AABD00";
	const ColorBrandPalette04130$1 = "#B8CC00";
	const ColorBrandPalette04140$1 = "#CAE000";
	const ColorBrandPalette04150$1 = "#DCF500";
	const ColorBrandPalette04160$1 = "#E5FF00";
	const ColorBrandPalette0510$1 = "#000E40";
	const ColorBrandPalette0520$1 = "#001A7A";
	const ColorBrandPalette0530$1 = "#00229E";
	const ColorBrandPalette0540$1 = "#0029BD";
	const ColorBrandPalette0550$1 = "#002FDB";
	const ColorBrandPalette0560$1 = "#0037FF";
	const ColorBrandPalette0570$1 = "#1F4FFF";
	const ColorBrandPalette0580$1 = "#3863FF";
	const ColorBrandPalette0590$1 = "#5277FF";
	const ColorBrandPalette05100$1 = "#6B8BFF";
	const ColorBrandPalette05110$1 = "#809BFF";
	const ColorBrandPalette05120$1 = "#99AFFF";
	const ColorBrandPalette05130$1 = "#ADBFFF";
	const ColorBrandPalette05140$1 = "#C7D3FF";
	const ColorBrandPalette05150$1 = "#DBE3FF";
	const ColorBrandPalette05160$1 = "#F0F3FF";
	const ColorBrandPalette0610$1 = "#251B0E";
	const ColorBrandPalette0620$1 = "#342614";
	const ColorBrandPalette0630$1 = "#433119";
	const ColorBrandPalette0640$1 = "#513C1F";
	const ColorBrandPalette0650$1 = "#604724";
	const ColorBrandPalette0660$1 = "#73552B";
	const ColorBrandPalette0670$1 = "#816031";
	const ColorBrandPalette0680$1 = "#946E38";
	const ColorBrandPalette0690$1 = "#A3793E";
	const ColorBrandPalette06100$1 = "#B98946";
	const ColorBrandPalette06110$1 = "#C39A60";
	const ColorBrandPalette06120$1 = "#CEAC7E";
	const ColorBrandPalette06130$1 = "#D8BD97";
	const ColorBrandPalette06140$1 = "#E3D0B5";
	const ColorBrandPalette06150$1 = "#EEE3D3";
	const ColorBrandPalette06160$1 = "#F8F3EC";
	const ColorFeedbackErrorText$1 = "#BC293A";
	const ColorFeedbackErrorShape$1 = "#EA4356";
	const ColorFeedbackSuccessText$1 = "#22723A";
	const ColorFeedbackSuccessShape$1 = "#2D954C";
	const ColorFeedbackOnBrandErrorText$1 = "#FBC5CC";
	const ColorFeedbackOnBrandErrorShape$1 = "#F895A1";
	const ColorFeedbackOnBrandSuccessText$1 = "#9DE2B1";
	const ColorFeedbackOnBrandSuccessShape$1 = "#4BC870";
	const ColorFeedbackInverseErrorText$1 = "#F55C6E";
	const ColorFeedbackInverseErrorShape$1 = "#D83145";
	const ColorFeedbackInverseSuccessText$1 = "#32A454";
	const ColorFeedbackInverseSuccessShape$1 = "#278142";
	const ColorFeedbackInverseOnBrandErrorText$1 = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape$1 = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText$1 = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape$1 = "#278142";
	const ColorIllustrationDeepBlue = "#000F40";
	const ColorIllustrationNeonBlue = "#0037FF";
	const ColorIllustrationNeonRed = "#FF4F33";
	const ColorIllustrationClearBlue = "#ABE6FF";
	const ColorIllustrationBiscuit = "#D1B287";
	const ColorSupport01$1 = "#FF4E33";
	const ColorSupport02$1 = "#F13E22";
	const ColorSupportOnBrand01$1 = "#E5FF00";
	const ColorSupportOnBrand02$1 = "#E5FF00";
	const ColorSupportInverse01$1 = "#FF4E33";
	const ColorSupportInverse02$1 = "#FF4E33";
	const ColorSupportInverseOnBrand01$1 = "#0037FF";
	const ColorSupportInverseOnBrand02$1 = "#0037FF";
	const Opacity01$1 = "0.04";
	const Opacity02$1 = "0.08";
	const Opacity03$1 = "0.12";
	const Opacity04$1 = "0.24";
	const Opacity05$1 = "0.32";
	const Opacity06$1 = "0.56";
	const Opacity07$1 = "0.64";
	const Opacity08$1 = "0.72";
	const Opacity09$1 = "0.88";
	const Shadow01$1 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02$1 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03$1 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04$1 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark$1 = "4px";
	const SpacingInlineNano$1 = "8px";
	const SpacingInlineXxxs$1 = "16px";
	const SpacingInlineXxs$1 = "24px";
	const SpacingInlineXs$1 = "32px";
	const SpacingInlineSm$1 = "40px";
	const SpacingInlineMd$1 = "48px";
	const SpacingInlineLg$1 = "56px";
	const SpacingInlineXl$1 = "64px";
	const SpacingInlineXxl$1 = "80px";
	const SpacingInlineXxxl$1 = "120px";
	const SpacingInlineHuge$1 = "160px";
	const SpacingInlineGiant$1 = "200px";
	const SpacingInsetQuark$1 = "4px";
	const SpacingInsetNano$1 = "8px";
	const SpacingInsetXs$1 = "16px";
	const SpacingInsetSm$1 = "24px";
	const SpacingInsetMd$1 = "32px";
	const SpacingInsetLg$1 = "40px";
	const SpacingSquishQuark$1 = "4px 8px";
	const SpacingSquishNano$1 = "8px 16px";
	const SpacingSquishXs$1 = "16px 24px";
	const SpacingSquishSm$1 = "16px 32px";
	const SpacingStackQuark$1 = "4px";
	const SpacingStackNano$1 = "8px";
	const SpacingStackXxxs$1 = "16px";
	const SpacingStackXxs$1 = "24px";
	const SpacingStackXs$1 = "32px";
	const SpacingStackSm$1 = "40px";
	const SpacingStackMd$1 = "48px";
	const SpacingStackLg$1 = "56px";
	const SpacingStackXl$1 = "64px";
	const SpacingStackXxl$1 = "80px";
	const SpacingStackXxxl$1 = "120px";
	const SpacingStackHuge$1 = "160px";
	const SpacingStackGiant$1 = "200px";
	const FontFamilyBase$1 = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontFamilyBaseBold = "DasaSans-Bold";
	const FontFamilyBaseLight = "DasaSans-Light";
	const FontFamilyBaseMedium = "DasaSans-Medium";
	const FontFamilyBaseRegular = "DasaSans-Regular";
	const FontFamilyBaseSemibold = "DasaSans-Semibold";
	const FontSizeXxxs$1 = "12px";
	const FontSizeXxs$1 = "14px";
	const FontSizeXs$1 = "16px";
	const FontSizeSm$1 = "20px";
	const FontSizeMd$1 = "24px";
	const FontSizeLg$1 = "32px";
	const FontSizeXl$1 = "40px";
	const FontSizeXxl$1 = "48px";
	const FontSizeXxxl$1 = "64px";
	const FontSizeDisplay$1 = "80px";
	const FontSizeGiant$1 = "96px";
	const FontWeightBold$1 = 700;
	const FontWeightSemibold$1 = 600;
	const FontWeightMedium$1 = 500;
	const FontWeightRegular$1 = 400;
	const FontWeightLight$1 = 300;
	const LetterSpacingStandard$1 = "0px";
	const LetterSpacingSmall$1 = "-1px";
	const LetterSpacingMedium$1 = "1.5px";
	const LineHeightStandard$1 = "100%";
	const LineHeightTiny$1 = "115%";
	const LineHeightMedium$1 = "120%";
	const LineHeightLarge$1 = "125%";
	const LineHeightDistant$1 = "133%";
	const LineHeightSuperdistant$1 = "150%";
	const LineHeightHuge$1 = "170%";
	const LineHeightXxs = "12px";
	const LineHeightXs = "16px";
	const LineHeightSm = "24px";
	const LineHeightMd = "32px";
	const LineHeightLg = "40px";
	const LineHeightXl = "48px";
	const LineHeightXxl = "56px";
	const LineHeightXxxl = "64px";
	const ZIndex0$1 = "0";
	const ZIndex100$1 = "100";
	const ZIndex200$1 = "200";
	const ZIndex300$1 = "300";
	const ZIndex400$1 = "400";
	const ZIndex500$1 = "500";
	const ZIndexAuto$1 = "auto";
	const ZIndexTop$1 = "99999";
	const ZIndexBottom$1 = "-100";

	var index$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone$1,
		BorderRadiusXs: BorderRadiusXs$1,
		BorderRadiusSm: BorderRadiusSm$1,
		BorderRadiusMd: BorderRadiusMd$1,
		BorderRadiusLg: BorderRadiusLg$1,
		BorderRadiusPill: BorderRadiusPill$1,
		BorderRadiusCircle: BorderRadiusCircle$1,
		BorderWidthNone: BorderWidthNone$1,
		BorderWidthHairline: BorderWidthHairline$1,
		BorderWidthThin: BorderWidthThin$1,
		BorderWidthThick: BorderWidthThick$1,
		BorderWidthHeavy: BorderWidthHeavy$1,
		ColorDatavizInfoText: ColorDatavizInfoText$1,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01$1,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02$1,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03$1,
		ColorDatavizNegativeText: ColorDatavizNegativeText$1,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$1,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$1,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$1,
		ColorDatavizWarningText: ColorDatavizWarningText$1,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01$1,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02$1,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03$1,
		ColorDatavizPositiveText: ColorDatavizPositiveText$1,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$1,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$1,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$1,
		ColorDatavizCatAText: ColorDatavizCatAText$1,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01$1,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02$1,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03$1,
		ColorDatavizCatBText: ColorDatavizCatBText$1,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01$1,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02$1,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03$1,
		ColorDatavizCatCText: ColorDatavizCatCText$1,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01$1,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02$1,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03$1,
		ColorDatavizCatDText: ColorDatavizCatDText$1,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01$1,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02$1,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03$1,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$1,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$1,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$1,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$1,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$1,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$1,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$1,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$1,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$1,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$1,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$1,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$1,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$1,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$1,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$1,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$1,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$1,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$1,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$1,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$1,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$1,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$1,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$1,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$1,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$1,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$1,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$1,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$1,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$1,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$1,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$1,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$1,
		ColorInteractionBlend01: ColorInteractionBlend01$1,
		ColorInteractionBlend02: ColorInteractionBlend02$1,
		ColorInteractionBlend03: ColorInteractionBlend03$1,
		ColorInteractionBlend04: ColorInteractionBlend04$1,
		ColorInteractionBlend05: ColorInteractionBlend05$1,
		ColorInteractionBlend06: ColorInteractionBlend06$1,
		ColorInteractionBlend07: ColorInteractionBlend07$1,
		ColorInteractionBlend08: ColorInteractionBlend08$1,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$1,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$1,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$1,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$1,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$1,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$1,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$1,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$1,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$1,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$1,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$1,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$1,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$1,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$1,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$1,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$1,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$1,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$1,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$1,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$1,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$1,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$1,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$1,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$1,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$1,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$1,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$1,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$1,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$1,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$1,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$1,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$1,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$1,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$1,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$1,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$1,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$1,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$1,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$1,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$1,
		ColorInteractionAccent01: ColorInteractionAccent01$1,
		ColorInteractionAccent02: ColorInteractionAccent02$1,
		ColorInteractionAccent03: ColorInteractionAccent03$1,
		ColorInteractionSubtle01: ColorInteractionSubtle01$1,
		ColorInteractionSubtle02: ColorInteractionSubtle02$1,
		ColorInteractionSubtle03: ColorInteractionSubtle03$1,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault$1,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus$1,
		ColorInteractionSelectActive: ColorInteractionSelectActive$1,
		ColorInteractionDanger01: ColorInteractionDanger01$1,
		ColorInteractionDanger02: ColorInteractionDanger02$1,
		ColorInteractionDanger03: ColorInteractionDanger03$1,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$1,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$1,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$1,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$1,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$1,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$1,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$1,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$1,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$1,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$1,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$1,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$1,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$1,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$1,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$1,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$1,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$1,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$1,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$1,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$1,
		ColorNeutral10: ColorNeutral10$1,
		ColorNeutral20: ColorNeutral20$1,
		ColorNeutral30: ColorNeutral30$1,
		ColorNeutral00: ColorNeutral00$1,
		ColorNeutralInverse10: ColorNeutralInverse10$1,
		ColorNeutralInverse20: ColorNeutralInverse20$1,
		ColorNeutralInverse30: ColorNeutralInverse30$1,
		ColorNeutralInverse00: ColorNeutralInverse00$1,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$1,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$1,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$1,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$1,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10$1,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20$1,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30$1,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00$1,
		ColorPaletteBlack: ColorPaletteBlack$1,
		ColorPaletteWhite: ColorPaletteWhite$1,
		ColorPaletteGray10: ColorPaletteGray10$1,
		ColorPaletteGray20: ColorPaletteGray20$1,
		ColorPaletteGray30: ColorPaletteGray30$1,
		ColorPaletteGray40: ColorPaletteGray40$1,
		ColorPaletteGray50: ColorPaletteGray50$1,
		ColorPaletteGray60: ColorPaletteGray60$1,
		ColorPaletteGray70: ColorPaletteGray70$1,
		ColorPaletteGray80: ColorPaletteGray80$1,
		ColorPaletteGray90: ColorPaletteGray90$1,
		ColorPaletteGray100: ColorPaletteGray100$1,
		ColorPaletteGray110: ColorPaletteGray110$1,
		ColorPaletteGray120: ColorPaletteGray120$1,
		ColorPaletteGray130: ColorPaletteGray130$1,
		ColorPaletteGray140: ColorPaletteGray140$1,
		ColorPaletteGray150: ColorPaletteGray150$1,
		ColorPaletteGray160: ColorPaletteGray160$1,
		ColorPaletteRed10: ColorPaletteRed10$1,
		ColorPaletteRed20: ColorPaletteRed20$1,
		ColorPaletteRed30: ColorPaletteRed30$1,
		ColorPaletteRed40: ColorPaletteRed40$1,
		ColorPaletteRed50: ColorPaletteRed50$1,
		ColorPaletteRed60: ColorPaletteRed60$1,
		ColorPaletteRed70: ColorPaletteRed70$1,
		ColorPaletteRed80: ColorPaletteRed80$1,
		ColorPaletteRed90: ColorPaletteRed90$1,
		ColorPaletteRed100: ColorPaletteRed100$1,
		ColorPaletteRed110: ColorPaletteRed110$1,
		ColorPaletteRed120: ColorPaletteRed120$1,
		ColorPaletteRed130: ColorPaletteRed130$1,
		ColorPaletteRed140: ColorPaletteRed140$1,
		ColorPaletteRed150: ColorPaletteRed150$1,
		ColorPaletteRed160: ColorPaletteRed160$1,
		ColorPaletteYellow10: ColorPaletteYellow10$1,
		ColorPaletteYellow20: ColorPaletteYellow20$1,
		ColorPaletteYellow30: ColorPaletteYellow30$1,
		ColorPaletteYellow40: ColorPaletteYellow40$1,
		ColorPaletteYellow50: ColorPaletteYellow50$1,
		ColorPaletteYellow60: ColorPaletteYellow60$1,
		ColorPaletteYellow70: ColorPaletteYellow70$1,
		ColorPaletteYellow80: ColorPaletteYellow80$1,
		ColorPaletteYellow90: ColorPaletteYellow90$1,
		ColorPaletteYellow100: ColorPaletteYellow100$1,
		ColorPaletteYellow110: ColorPaletteYellow110$1,
		ColorPaletteYellow120: ColorPaletteYellow120$1,
		ColorPaletteYellow130: ColorPaletteYellow130$1,
		ColorPaletteYellow140: ColorPaletteYellow140$1,
		ColorPaletteYellow150: ColorPaletteYellow150$1,
		ColorPaletteYellow160: ColorPaletteYellow160$1,
		ColorPaletteLime10: ColorPaletteLime10$1,
		ColorPaletteLime20: ColorPaletteLime20$1,
		ColorPaletteLime30: ColorPaletteLime30$1,
		ColorPaletteLime40: ColorPaletteLime40$1,
		ColorPaletteLime50: ColorPaletteLime50$1,
		ColorPaletteLime60: ColorPaletteLime60$1,
		ColorPaletteLime70: ColorPaletteLime70$1,
		ColorPaletteLime80: ColorPaletteLime80$1,
		ColorPaletteLime90: ColorPaletteLime90$1,
		ColorPaletteLime100: ColorPaletteLime100$1,
		ColorPaletteLime110: ColorPaletteLime110$1,
		ColorPaletteLime120: ColorPaletteLime120$1,
		ColorPaletteLime130: ColorPaletteLime130$1,
		ColorPaletteLime140: ColorPaletteLime140$1,
		ColorPaletteLime150: ColorPaletteLime150$1,
		ColorPaletteLime160: ColorPaletteLime160$1,
		ColorPaletteGreen10: ColorPaletteGreen10$1,
		ColorPaletteGreen20: ColorPaletteGreen20$1,
		ColorPaletteGreen30: ColorPaletteGreen30$1,
		ColorPaletteGreen40: ColorPaletteGreen40$1,
		ColorPaletteGreen50: ColorPaletteGreen50$1,
		ColorPaletteGreen60: ColorPaletteGreen60$1,
		ColorPaletteGreen70: ColorPaletteGreen70$1,
		ColorPaletteGreen80: ColorPaletteGreen80$1,
		ColorPaletteGreen90: ColorPaletteGreen90$1,
		ColorPaletteGreen100: ColorPaletteGreen100$1,
		ColorPaletteGreen110: ColorPaletteGreen110$1,
		ColorPaletteGreen120: ColorPaletteGreen120$1,
		ColorPaletteGreen130: ColorPaletteGreen130$1,
		ColorPaletteGreen140: ColorPaletteGreen140$1,
		ColorPaletteGreen150: ColorPaletteGreen150$1,
		ColorPaletteGreen160: ColorPaletteGreen160$1,
		ColorPaletteAcqua10: ColorPaletteAcqua10$1,
		ColorPaletteAcqua20: ColorPaletteAcqua20$1,
		ColorPaletteAcqua30: ColorPaletteAcqua30$1,
		ColorPaletteAcqua40: ColorPaletteAcqua40$1,
		ColorPaletteAcqua50: ColorPaletteAcqua50$1,
		ColorPaletteAcqua60: ColorPaletteAcqua60$1,
		ColorPaletteAcqua70: ColorPaletteAcqua70$1,
		ColorPaletteAcqua80: ColorPaletteAcqua80$1,
		ColorPaletteAcqua90: ColorPaletteAcqua90$1,
		ColorPaletteAcqua100: ColorPaletteAcqua100$1,
		ColorPaletteAcqua110: ColorPaletteAcqua110$1,
		ColorPaletteAcqua120: ColorPaletteAcqua120$1,
		ColorPaletteAcqua130: ColorPaletteAcqua130$1,
		ColorPaletteAcqua140: ColorPaletteAcqua140$1,
		ColorPaletteAcqua150: ColorPaletteAcqua150$1,
		ColorPaletteAcqua160: ColorPaletteAcqua160$1,
		ColorPaletteBlue10: ColorPaletteBlue10$1,
		ColorPaletteBlue20: ColorPaletteBlue20$1,
		ColorPaletteBlue30: ColorPaletteBlue30$1,
		ColorPaletteBlue40: ColorPaletteBlue40$1,
		ColorPaletteBlue50: ColorPaletteBlue50$1,
		ColorPaletteBlue60: ColorPaletteBlue60$1,
		ColorPaletteBlue70: ColorPaletteBlue70$1,
		ColorPaletteBlue80: ColorPaletteBlue80$1,
		ColorPaletteBlue90: ColorPaletteBlue90$1,
		ColorPaletteBlue100: ColorPaletteBlue100$1,
		ColorPaletteBlue110: ColorPaletteBlue110$1,
		ColorPaletteBlue120: ColorPaletteBlue120$1,
		ColorPaletteBlue130: ColorPaletteBlue130$1,
		ColorPaletteBlue140: ColorPaletteBlue140$1,
		ColorPaletteBlue150: ColorPaletteBlue150$1,
		ColorPaletteBlue160: ColorPaletteBlue160$1,
		ColorPalettePurple10: ColorPalettePurple10$1,
		ColorPalettePurple20: ColorPalettePurple20$1,
		ColorPalettePurple30: ColorPalettePurple30$1,
		ColorPalettePurple40: ColorPalettePurple40$1,
		ColorPalettePurple50: ColorPalettePurple50$1,
		ColorPalettePurple60: ColorPalettePurple60$1,
		ColorPalettePurple70: ColorPalettePurple70$1,
		ColorPalettePurple80: ColorPalettePurple80$1,
		ColorPalettePurple90: ColorPalettePurple90$1,
		ColorPalettePurple100: ColorPalettePurple100$1,
		ColorPalettePurple110: ColorPalettePurple110$1,
		ColorPalettePurple120: ColorPalettePurple120$1,
		ColorPalettePurple130: ColorPalettePurple130$1,
		ColorPalettePurple140: ColorPalettePurple140$1,
		ColorPalettePurple150: ColorPalettePurple150$1,
		ColorPalettePurple160: ColorPalettePurple160$1,
		ColorPalettePink10: ColorPalettePink10$1,
		ColorPalettePink20: ColorPalettePink20$1,
		ColorPalettePink30: ColorPalettePink30$1,
		ColorPalettePink40: ColorPalettePink40$1,
		ColorPalettePink50: ColorPalettePink50$1,
		ColorPalettePink60: ColorPalettePink60$1,
		ColorPalettePink70: ColorPalettePink70$1,
		ColorPalettePink80: ColorPalettePink80$1,
		ColorPalettePink90: ColorPalettePink90$1,
		ColorPalettePink100: ColorPalettePink100$1,
		ColorPalettePink110: ColorPalettePink110$1,
		ColorPalettePink120: ColorPalettePink120$1,
		ColorPalettePink130: ColorPalettePink130$1,
		ColorPalettePink140: ColorPalettePink140$1,
		ColorPalettePink150: ColorPalettePink150$1,
		ColorPalettePink160: ColorPalettePink160$1,
		ColorTypefaceStrong: ColorTypefaceStrong$1,
		ColorTypefacePure: ColorTypefacePure$1,
		ColorTypefaceSmooth: ColorTypefaceSmooth$1,
		ColorTypefaceMeld: ColorTypefaceMeld$1,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$1,
		ColorTypefaceInversePure: ColorTypefaceInversePure$1,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$1,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$1,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$1,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$1,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$1,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$1,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$1,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$1,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$1,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$1,
		ColorBrandPrimary10: ColorBrandPrimary10$1,
		ColorBrandPrimary20: ColorBrandPrimary20$1,
		ColorBrandPrimary30: ColorBrandPrimary30$1,
		ColorBrandPrimary40: ColorBrandPrimary40$1,
		ColorBrandPrimary50: ColorBrandPrimary50$1,
		ColorBrandPrimary60: ColorBrandPrimary60$1,
		ColorBrandPrimary70: ColorBrandPrimary70$1,
		ColorBrandPrimary80: ColorBrandPrimary80$1,
		ColorBrandPrimary90: ColorBrandPrimary90$1,
		ColorBrandPrimary100: ColorBrandPrimary100$1,
		ColorBrandPrimary110: ColorBrandPrimary110$1,
		ColorBrandPrimary120: ColorBrandPrimary120$1,
		ColorBrandPrimary130: ColorBrandPrimary130$1,
		ColorBrandPrimary140: ColorBrandPrimary140$1,
		ColorBrandPrimary150: ColorBrandPrimary150$1,
		ColorBrandPrimary160: ColorBrandPrimary160$1,
		ColorBrandBase01: ColorBrandBase01$1,
		ColorBrandBase02: ColorBrandBase02$1,
		ColorBrandBase03: ColorBrandBase03$1,
		ColorBrandBase04: ColorBrandBase04$1,
		ColorBrandBase05: ColorBrandBase05$1,
		ColorBrandBase06: ColorBrandBase06$1,
		ColorBrandPalette0110: ColorBrandPalette0110$1,
		ColorBrandPalette0120: ColorBrandPalette0120$1,
		ColorBrandPalette0130: ColorBrandPalette0130$1,
		ColorBrandPalette0140: ColorBrandPalette0140$1,
		ColorBrandPalette0150: ColorBrandPalette0150$1,
		ColorBrandPalette0160: ColorBrandPalette0160$1,
		ColorBrandPalette0170: ColorBrandPalette0170$1,
		ColorBrandPalette0180: ColorBrandPalette0180$1,
		ColorBrandPalette0190: ColorBrandPalette0190$1,
		ColorBrandPalette01100: ColorBrandPalette01100$1,
		ColorBrandPalette01110: ColorBrandPalette01110$1,
		ColorBrandPalette01120: ColorBrandPalette01120$1,
		ColorBrandPalette01130: ColorBrandPalette01130$1,
		ColorBrandPalette01140: ColorBrandPalette01140$1,
		ColorBrandPalette01150: ColorBrandPalette01150$1,
		ColorBrandPalette01160: ColorBrandPalette01160$1,
		ColorBrandPalette0210: ColorBrandPalette0210$1,
		ColorBrandPalette0220: ColorBrandPalette0220$1,
		ColorBrandPalette0230: ColorBrandPalette0230$1,
		ColorBrandPalette0240: ColorBrandPalette0240$1,
		ColorBrandPalette0250: ColorBrandPalette0250$1,
		ColorBrandPalette0260: ColorBrandPalette0260$1,
		ColorBrandPalette0270: ColorBrandPalette0270$1,
		ColorBrandPalette0280: ColorBrandPalette0280$1,
		ColorBrandPalette0290: ColorBrandPalette0290$1,
		ColorBrandPalette02100: ColorBrandPalette02100$1,
		ColorBrandPalette02110: ColorBrandPalette02110$1,
		ColorBrandPalette02120: ColorBrandPalette02120$1,
		ColorBrandPalette02130: ColorBrandPalette02130$1,
		ColorBrandPalette02140: ColorBrandPalette02140$1,
		ColorBrandPalette02150: ColorBrandPalette02150$1,
		ColorBrandPalette02160: ColorBrandPalette02160$1,
		ColorBrandPalette0310: ColorBrandPalette0310,
		ColorBrandPalette0320: ColorBrandPalette0320,
		ColorBrandPalette0330: ColorBrandPalette0330,
		ColorBrandPalette0340: ColorBrandPalette0340,
		ColorBrandPalette0350: ColorBrandPalette0350,
		ColorBrandPalette0360: ColorBrandPalette0360,
		ColorBrandPalette0370: ColorBrandPalette0370,
		ColorBrandPalette0380: ColorBrandPalette0380,
		ColorBrandPalette0390: ColorBrandPalette0390,
		ColorBrandPalette03100: ColorBrandPalette03100,
		ColorBrandPalette03110: ColorBrandPalette03110,
		ColorBrandPalette03120: ColorBrandPalette03120,
		ColorBrandPalette03130: ColorBrandPalette03130,
		ColorBrandPalette03140: ColorBrandPalette03140,
		ColorBrandPalette03150: ColorBrandPalette03150,
		ColorBrandPalette03160: ColorBrandPalette03160,
		ColorBrandPalette0410: ColorBrandPalette0410$1,
		ColorBrandPalette0420: ColorBrandPalette0420$1,
		ColorBrandPalette0430: ColorBrandPalette0430$1,
		ColorBrandPalette0440: ColorBrandPalette0440$1,
		ColorBrandPalette0450: ColorBrandPalette0450$1,
		ColorBrandPalette0460: ColorBrandPalette0460$1,
		ColorBrandPalette0470: ColorBrandPalette0470$1,
		ColorBrandPalette0480: ColorBrandPalette0480$1,
		ColorBrandPalette0490: ColorBrandPalette0490$1,
		ColorBrandPalette04100: ColorBrandPalette04100$1,
		ColorBrandPalette04110: ColorBrandPalette04110$1,
		ColorBrandPalette04120: ColorBrandPalette04120$1,
		ColorBrandPalette04130: ColorBrandPalette04130$1,
		ColorBrandPalette04140: ColorBrandPalette04140$1,
		ColorBrandPalette04150: ColorBrandPalette04150$1,
		ColorBrandPalette04160: ColorBrandPalette04160$1,
		ColorBrandPalette0510: ColorBrandPalette0510$1,
		ColorBrandPalette0520: ColorBrandPalette0520$1,
		ColorBrandPalette0530: ColorBrandPalette0530$1,
		ColorBrandPalette0540: ColorBrandPalette0540$1,
		ColorBrandPalette0550: ColorBrandPalette0550$1,
		ColorBrandPalette0560: ColorBrandPalette0560$1,
		ColorBrandPalette0570: ColorBrandPalette0570$1,
		ColorBrandPalette0580: ColorBrandPalette0580$1,
		ColorBrandPalette0590: ColorBrandPalette0590$1,
		ColorBrandPalette05100: ColorBrandPalette05100$1,
		ColorBrandPalette05110: ColorBrandPalette05110$1,
		ColorBrandPalette05120: ColorBrandPalette05120$1,
		ColorBrandPalette05130: ColorBrandPalette05130$1,
		ColorBrandPalette05140: ColorBrandPalette05140$1,
		ColorBrandPalette05150: ColorBrandPalette05150$1,
		ColorBrandPalette05160: ColorBrandPalette05160$1,
		ColorBrandPalette0610: ColorBrandPalette0610$1,
		ColorBrandPalette0620: ColorBrandPalette0620$1,
		ColorBrandPalette0630: ColorBrandPalette0630$1,
		ColorBrandPalette0640: ColorBrandPalette0640$1,
		ColorBrandPalette0650: ColorBrandPalette0650$1,
		ColorBrandPalette0660: ColorBrandPalette0660$1,
		ColorBrandPalette0670: ColorBrandPalette0670$1,
		ColorBrandPalette0680: ColorBrandPalette0680$1,
		ColorBrandPalette0690: ColorBrandPalette0690$1,
		ColorBrandPalette06100: ColorBrandPalette06100$1,
		ColorBrandPalette06110: ColorBrandPalette06110$1,
		ColorBrandPalette06120: ColorBrandPalette06120$1,
		ColorBrandPalette06130: ColorBrandPalette06130$1,
		ColorBrandPalette06140: ColorBrandPalette06140$1,
		ColorBrandPalette06150: ColorBrandPalette06150$1,
		ColorBrandPalette06160: ColorBrandPalette06160$1,
		ColorFeedbackErrorText: ColorFeedbackErrorText$1,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape$1,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText$1,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$1,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$1,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$1,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$1,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$1,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$1,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$1,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$1,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$1,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$1,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$1,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$1,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$1,
		ColorIllustrationDeepBlue: ColorIllustrationDeepBlue,
		ColorIllustrationNeonBlue: ColorIllustrationNeonBlue,
		ColorIllustrationNeonRed: ColorIllustrationNeonRed,
		ColorIllustrationClearBlue: ColorIllustrationClearBlue,
		ColorIllustrationBiscuit: ColorIllustrationBiscuit,
		ColorSupport01: ColorSupport01$1,
		ColorSupport02: ColorSupport02$1,
		ColorSupportOnBrand01: ColorSupportOnBrand01$1,
		ColorSupportOnBrand02: ColorSupportOnBrand02$1,
		ColorSupportInverse01: ColorSupportInverse01$1,
		ColorSupportInverse02: ColorSupportInverse02$1,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$1,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$1,
		Opacity01: Opacity01$1,
		Opacity02: Opacity02$1,
		Opacity03: Opacity03$1,
		Opacity04: Opacity04$1,
		Opacity05: Opacity05$1,
		Opacity06: Opacity06$1,
		Opacity07: Opacity07$1,
		Opacity08: Opacity08$1,
		Opacity09: Opacity09$1,
		Shadow01: Shadow01$1,
		Shadow02: Shadow02$1,
		Shadow03: Shadow03$1,
		Shadow04: Shadow04$1,
		SpacingInlineQuark: SpacingInlineQuark$1,
		SpacingInlineNano: SpacingInlineNano$1,
		SpacingInlineXxxs: SpacingInlineXxxs$1,
		SpacingInlineXxs: SpacingInlineXxs$1,
		SpacingInlineXs: SpacingInlineXs$1,
		SpacingInlineSm: SpacingInlineSm$1,
		SpacingInlineMd: SpacingInlineMd$1,
		SpacingInlineLg: SpacingInlineLg$1,
		SpacingInlineXl: SpacingInlineXl$1,
		SpacingInlineXxl: SpacingInlineXxl$1,
		SpacingInlineXxxl: SpacingInlineXxxl$1,
		SpacingInlineHuge: SpacingInlineHuge$1,
		SpacingInlineGiant: SpacingInlineGiant$1,
		SpacingInsetQuark: SpacingInsetQuark$1,
		SpacingInsetNano: SpacingInsetNano$1,
		SpacingInsetXs: SpacingInsetXs$1,
		SpacingInsetSm: SpacingInsetSm$1,
		SpacingInsetMd: SpacingInsetMd$1,
		SpacingInsetLg: SpacingInsetLg$1,
		SpacingSquishQuark: SpacingSquishQuark$1,
		SpacingSquishNano: SpacingSquishNano$1,
		SpacingSquishXs: SpacingSquishXs$1,
		SpacingSquishSm: SpacingSquishSm$1,
		SpacingStackQuark: SpacingStackQuark$1,
		SpacingStackNano: SpacingStackNano$1,
		SpacingStackXxxs: SpacingStackXxxs$1,
		SpacingStackXxs: SpacingStackXxs$1,
		SpacingStackXs: SpacingStackXs$1,
		SpacingStackSm: SpacingStackSm$1,
		SpacingStackMd: SpacingStackMd$1,
		SpacingStackLg: SpacingStackLg$1,
		SpacingStackXl: SpacingStackXl$1,
		SpacingStackXxl: SpacingStackXxl$1,
		SpacingStackXxxl: SpacingStackXxxl$1,
		SpacingStackHuge: SpacingStackHuge$1,
		SpacingStackGiant: SpacingStackGiant$1,
		FontFamilyBase: FontFamilyBase$1,
		FontFamilyBaseBold: FontFamilyBaseBold,
		FontFamilyBaseLight: FontFamilyBaseLight,
		FontFamilyBaseMedium: FontFamilyBaseMedium,
		FontFamilyBaseRegular: FontFamilyBaseRegular,
		FontFamilyBaseSemibold: FontFamilyBaseSemibold,
		FontSizeXxxs: FontSizeXxxs$1,
		FontSizeXxs: FontSizeXxs$1,
		FontSizeXs: FontSizeXs$1,
		FontSizeSm: FontSizeSm$1,
		FontSizeMd: FontSizeMd$1,
		FontSizeLg: FontSizeLg$1,
		FontSizeXl: FontSizeXl$1,
		FontSizeXxl: FontSizeXxl$1,
		FontSizeXxxl: FontSizeXxxl$1,
		FontSizeDisplay: FontSizeDisplay$1,
		FontSizeGiant: FontSizeGiant$1,
		FontWeightBold: FontWeightBold$1,
		FontWeightSemibold: FontWeightSemibold$1,
		FontWeightMedium: FontWeightMedium$1,
		FontWeightRegular: FontWeightRegular$1,
		FontWeightLight: FontWeightLight$1,
		LetterSpacingStandard: LetterSpacingStandard$1,
		LetterSpacingSmall: LetterSpacingSmall$1,
		LetterSpacingMedium: LetterSpacingMedium$1,
		LineHeightStandard: LineHeightStandard$1,
		LineHeightTiny: LineHeightTiny$1,
		LineHeightMedium: LineHeightMedium$1,
		LineHeightLarge: LineHeightLarge$1,
		LineHeightDistant: LineHeightDistant$1,
		LineHeightSuperdistant: LineHeightSuperdistant$1,
		LineHeightHuge: LineHeightHuge$1,
		LineHeightXxs: LineHeightXxs,
		LineHeightXs: LineHeightXs,
		LineHeightSm: LineHeightSm,
		LineHeightMd: LineHeightMd,
		LineHeightLg: LineHeightLg,
		LineHeightXl: LineHeightXl,
		LineHeightXxl: LineHeightXxl,
		LineHeightXxxl: LineHeightXxxl,
		ZIndex0: ZIndex0$1,
		ZIndex100: ZIndex100$1,
		ZIndex200: ZIndex200$1,
		ZIndex300: ZIndex300$1,
		ZIndex400: ZIndex400$1,
		ZIndex500: ZIndex500$1,
		ZIndexAuto: ZIndexAuto$1,
		ZIndexTop: ZIndexTop$1,
		ZIndexBottom: ZIndexBottom$1
	});

	/**
	 * Do not edit directly
	 * Generated on Tue, 10 Jan 2023 15:44:01 GMT
	 */

	const BorderRadiusNone = "0px";
	const BorderRadiusXs = "4px";
	const BorderRadiusSm = "8px";
	const BorderRadiusMd = "16px";
	const BorderRadiusLg = "24px";
	const BorderRadiusPill = "960px";
	const BorderRadiusCircle = "50%";
	const BorderWidthNone = "0px";
	const BorderWidthHairline = "1px";
	const BorderWidthThin = "2px";
	const BorderWidthThick = "4px";
	const BorderWidthHeavy = "8px";
	const ColorDatavizInfoText = "#0F58EA";
	const ColorDatavizInfoShape01 = "#3F7BF2";
	const ColorDatavizInfoShape02 = "#D9E5FC";
	const ColorDatavizInfoShape03 = "#F1F5FE";
	const ColorDatavizNegativeText = "#BC293A";
	const ColorDatavizNegativeShape01 = "#EA4356";
	const ColorDatavizNegativeShape02 = "#FDDDE1";
	const ColorDatavizNegativeShape03 = "#FEF1F2";
	const ColorDatavizWarningText = "#A04C03";
	const ColorDatavizWarningShape01 = "#D26404";
	const ColorDatavizWarningShape02 = "#FEE1C8";
	const ColorDatavizWarningShape03 = "#FEF1E6";
	const ColorDatavizPositiveText = "#22723A";
	const ColorDatavizPositiveShape01 = "#2D954C";
	const ColorDatavizPositiveShape02 = "#C8EED3";
	const ColorDatavizPositiveShape03 = "#E8F8EC";
	const ColorDatavizCatAText = "#9B18DC";
	const ColorDatavizCatAShape01 = "#B851EC";
	const ColorDatavizCatAShape02 = "#F2DFFB";
	const ColorDatavizCatAShape03 = "#F9F1FD";
	const ColorDatavizCatBText = "#BA267B";
	const ColorDatavizCatBShape01 = "#DA499B";
	const ColorDatavizCatBShape02 = "#F8DDEC";
	const ColorDatavizCatBShape03 = "#FCF2F8";
	const ColorDatavizCatCText = "#546E21";
	const ColorDatavizCatCShape01 = "#6C8D2B";
	const ColorDatavizCatCShape02 = "#DBEBBD";
	const ColorDatavizCatCShape03 = "#F0F7E4";
	const ColorDatavizCatDText = "#0D735E";
	const ColorDatavizCatDShape01 = "#109379";
	const ColorDatavizCatDShape02 = "#BCF0E6";
	const ColorDatavizCatDShape03 = "#DFFBF6";
	const ColorDatavizInverseInfoText = "#5C8FF5";
	const ColorDatavizInverseInfoShape01 = "#286BF1";
	const ColorDatavizInverseInfoShape02 = "#062560";
	const ColorDatavizInverseInfoShape03 = "#051B48";
	const ColorDatavizInverseNegativeText = "#F55C6E";
	const ColorDatavizInverseNegativeShape01 = "#D83145";
	const ColorDatavizInverseNegativeShape02 = "#4F1119";
	const ColorDatavizInverseNegativeShape03 = "#3B0D12";
	const ColorDatavizInverseWarningText = "#EB7005";
	const ColorDatavizInverseWarningShape01 = "#B95804";
	const ColorDatavizInverseWarningShape02 = "#462101";
	const ColorDatavizInverseWarningShape03 = "#321701";
	const ColorDatavizInversePositiveText = "#32A454";
	const ColorDatavizInversePositiveShape01 = "#278142";
	const ColorDatavizInversePositiveShape02 = "#0E2F18";
	const ColorDatavizInversePositiveShape03 = "#0B2312";
	const ColorDatavizInverseCatAText = "#C36CEF";
	const ColorDatavizInverseCatAShape01 = "#AD35E9";
	const ColorDatavizInverseCatAShape02 = "#440B60";
	const ColorDatavizInverseCatAShape03 = "#340849";
	const ColorDatavizInverseCatBText = "#E067AB";
	const ColorDatavizInverseCatBShape01 = "#D42B8C";
	const ColorDatavizInverseCatBShape02 = "#4C1032";
	const ColorDatavizInverseCatBShape03 = "#3B0C27";
	const ColorDatavizInverseCatCText = "#789D2F";
	const ColorDatavizInverseCatCShape01 = "#607E26";
	const ColorDatavizInverseCatCShape02 = "#212B0D";
	const ColorDatavizInverseCatCShape03 = "#1B230B";
	const ColorDatavizInverseCatDText = "#12A588";
	const ColorDatavizInverseCatDShape01 = "#0F856D";
	const ColorDatavizInverseCatDShape02 = "#052E26";
	const ColorDatavizInverseCatDShape03 = "#04251E";
	const ColorInteractionBlend01 = "#1616160A";
	const ColorInteractionBlend02 = "#16161614";
	const ColorInteractionBlend03 = "#1616161F";
	const ColorInteractionBlend04 = "#1616163D";
	const ColorInteractionBlend05 = "#161616A3";
	const ColorInteractionBlend06 = "#161616B8";
	const ColorInteractionBlend07 = "#161616E0";
	const ColorInteractionBlend08 = "#161616";
	const ColorInteractionInverseBlend01 = "#FEFEFE14";
	const ColorInteractionInverseBlend02 = "#FEFEFE1F";
	const ColorInteractionInverseBlend03 = "#FEFEFE3D";
	const ColorInteractionInverseBlend04 = "#FEFEFE52";
	const ColorInteractionInverseBlend05 = "#FEFEFEA3";
	const ColorInteractionInverseBlend06 = "#FEFEFEB8";
	const ColorInteractionInverseBlend07 = "#FEFEFEE0";
	const ColorInteractionInverseBlend08 = "#FEFEFE";
	const ColorInteractionInverseAccent01 = "#6B8BFF";
	const ColorInteractionInverseAccent02 = "#809BFF";
	const ColorInteractionInverseAccent03 = "#99AFFF";
	const ColorInteractionInverseSubtle01 = "#5277FF1F";
	const ColorInteractionInverseSubtle02 = "#5277FF3D";
	const ColorInteractionInverseSubtle03 = "#5277FF52";
	const ColorInteractionInverseSelectDefault = "#919191";
	const ColorInteractionInverseSelectFocus = "#D4D4D4";
	const ColorInteractionInverseSelectActive = "#2BD6C4";
	const ColorInteractionInverseDanger01 = "#F55C6E";
	const ColorInteractionInverseDanger02 = "#F77E8C";
	const ColorInteractionInverseDanger03 = "#F895A1";
	const ColorInteractionInverseOnBrandAccent01 = "#000E40";
	const ColorInteractionInverseOnBrandAccent02 = "#001A7A";
	const ColorInteractionInverseOnBrandAccent03 = "#00229E";
	const ColorInteractionInverseOnBrandSubtle01 = "#002FDB14";
	const ColorInteractionInverseOnBrandSubtle02 = "#002FDB1F";
	const ColorInteractionInverseOnBrandSubtle03 = "#002FDB3D";
	const ColorInteractionInverseOnBrandSelectDefault = "#595959";
	const ColorInteractionInverseOnBrandSelectFocus = "#404040";
	const ColorInteractionInverseOnBrandSelectActive = "#603CCD";
	const ColorInteractionInverseOnBrandBlend01 = "#1616160A";
	const ColorInteractionInverseOnBrandBlend02 = "#16161614";
	const ColorInteractionInverseOnBrandBlend03 = "#1616161F";
	const ColorInteractionInverseOnBrandBlend04 = "#1616163D";
	const ColorInteractionInverseOnBrandBlend05 = "#161616A3";
	const ColorInteractionInverseOnBrandBlend06 = "#161616B8";
	const ColorInteractionInverseOnBrandBlend07 = "#161616E0";
	const ColorInteractionInverseOnBrandBlend08 = "#161616";
	const ColorInteractionInverseOnBrandDanger01 = "#A72534";
	const ColorInteractionInverseOnBrandDanger02 = "#92202E";
	const ColorInteractionInverseOnBrandDanger03 = "#7E1B27";
	const ColorInteractionAccent01 = "#000E40";
	const ColorInteractionAccent02 = "#001A7A";
	const ColorInteractionAccent03 = "#00229E";
	const ColorInteractionSubtle01 = "#0029BD1F";
	const ColorInteractionSubtle02 = "#0029BD3D";
	const ColorInteractionSubtle03 = "#0029BD52";
	const ColorInteractionSelectDefault = "#666666";
	const ColorInteractionSelectFocus = "#363636";
	const ColorInteractionSelectActive = "#603CCD";
	const ColorInteractionDanger01 = "#BC293A";
	const ColorInteractionDanger02 = "#A72534";
	const ColorInteractionDanger03 = "#92202E";
	const ColorInteractionOnBrandAccent01 = "#ADBFFF";
	const ColorInteractionOnBrandAccent02 = "#99AFFF";
	const ColorInteractionOnBrandAccent03 = "#809BFF";
	const ColorInteractionOnBrandSubtle01 = "#5277FF1F";
	const ColorInteractionOnBrandSubtle02 = "#5277FF3D";
	const ColorInteractionOnBrandSubtle03 = "#5277FF52";
	const ColorInteractionOnBrandSelectDefault = "#B0B0B0";
	const ColorInteractionOnBrandSelectFocus = "#D4D4D4";
	const ColorInteractionOnBrandSelectActive = "#2BD6C4";
	const ColorInteractionOnBrandBlend01 = "#FEFEFE14";
	const ColorInteractionOnBrandBlend02 = "#FEFEFE1F";
	const ColorInteractionOnBrandBlend03 = "#FEFEFE3D";
	const ColorInteractionOnBrandBlend04 = "#FEFEFE52";
	const ColorInteractionOnBrandBlend05 = "#FEFEFEA3";
	const ColorInteractionOnBrandBlend06 = "#FEFEFEB8";
	const ColorInteractionOnBrandBlend07 = "#FEFEFEE0";
	const ColorInteractionOnBrandBlend08 = "#FEFEFE";
	const ColorInteractionOnBrandDanger01 = "#F77E8C";
	const ColorInteractionOnBrandDanger02 = "#F895A1";
	const ColorInteractionOnBrandDanger03 = "#FAAEB6";
	const ColorNeutral10 = "#F5F5F5";
	const ColorNeutral20 = "#E6E6E6";
	const ColorNeutral30 = "#1616163D";
	const ColorNeutral00 = "#FEFEFE";
	const ColorNeutralInverse10 = "#1F1F1F";
	const ColorNeutralInverse20 = "#292929";
	const ColorNeutralInverse30 = "#FEFEFE3D";
	const ColorNeutralInverse00 = "#161616";
	const ColorNeutralInverseOnBrand10 = "#DBE3FF";
	const ColorNeutralInverseOnBrand20 = "#C7D3FF";
	const ColorNeutralInverseOnBrand30 = "#0029BD52";
	const ColorNeutralInverseOnBrand00 = "#F0F3FF";
	const ColorNeutralOnBrand10 = "#001A7A";
	const ColorNeutralOnBrand20 = "#00229E";
	const ColorNeutralOnBrand30 = "#5277FFA3";
	const ColorNeutralOnBrand00 = "#000E40";
	const ColorPaletteBlack = "#161616";
	const ColorPaletteWhite = "#FEFEFE";
	const ColorPaletteGray10 = "#1F1F1F";
	const ColorPaletteGray20 = "#292929";
	const ColorPaletteGray30 = "#363636";
	const ColorPaletteGray40 = "#404040";
	const ColorPaletteGray50 = "#4C4C4C";
	const ColorPaletteGray60 = "#595959";
	const ColorPaletteGray70 = "#666666";
	const ColorPaletteGray80 = "#737373";
	const ColorPaletteGray90 = "#828282";
	const ColorPaletteGray100 = "#919191";
	const ColorPaletteGray110 = "#A1A1A1";
	const ColorPaletteGray120 = "#B0B0B0";
	const ColorPaletteGray130 = "#C2C2C2";
	const ColorPaletteGray140 = "#D4D4D4";
	const ColorPaletteGray150 = "#E6E6E6";
	const ColorPaletteGray160 = "#F5F5F5";
	const ColorPaletteRed10 = "#3B0D12";
	const ColorPaletteRed20 = "#4F1119";
	const ColorPaletteRed30 = "#691721";
	const ColorPaletteRed40 = "#7E1B27";
	const ColorPaletteRed50 = "#92202E";
	const ColorPaletteRed60 = "#A72534";
	const ColorPaletteRed70 = "#BC293A";
	const ColorPaletteRed80 = "#D83145";
	const ColorPaletteRed90 = "#EA4356";
	const ColorPaletteRed100 = "#F55C6E";
	const ColorPaletteRed110 = "#F77E8C";
	const ColorPaletteRed120 = "#F895A1";
	const ColorPaletteRed130 = "#FAAEB6";
	const ColorPaletteRed140 = "#FBC5CC";
	const ColorPaletteRed150 = "#FDDDE1";
	const ColorPaletteRed160 = "#FEF1F2";
	const ColorPaletteYellow10 = "#321701";
	const ColorPaletteYellow20 = "#462101";
	const ColorPaletteYellow30 = "#552802";
	const ColorPaletteYellow40 = "#693102";
	const ColorPaletteYellow50 = "#7D3B03";
	const ColorPaletteYellow60 = "#914503";
	const ColorPaletteYellow70 = "#A04C03";
	const ColorPaletteYellow80 = "#B95804";
	const ColorPaletteYellow90 = "#D26404";
	const ColorPaletteYellow100 = "#EB7005";
	const ColorPaletteYellow110 = "#FA8219";
	const ColorPaletteYellow120 = "#FB9B46";
	const ColorPaletteYellow130 = "#FCB06E";
	const ColorPaletteYellow140 = "#FDC99B";
	const ColorPaletteYellow150 = "#FEE1C8";
	const ColorPaletteYellow160 = "#FEF1E6";
	const ColorPaletteLime10 = "#1B230B";
	const ColorPaletteLime20 = "#212B0D";
	const ColorPaletteLime30 = "#2D3B12";
	const ColorPaletteLime40 = "#364616";
	const ColorPaletteLime50 = "#3F5219";
	const ColorPaletteLime60 = "#485E1D";
	const ColorPaletteLime70 = "#546E21";
	const ColorPaletteLime80 = "#607E26";
	const ColorPaletteLime90 = "#6C8D2B";
	const ColorPaletteLime100 = "#789D2F";
	const ColorPaletteLime110 = "#84AC34";
	const ColorPaletteLime120 = "#93BF3A";
	const ColorPaletteLime130 = "#A9CF5E";
	const ColorPaletteLime140 = "#C2DD8D";
	const ColorPaletteLime150 = "#DBEBBD";
	const ColorPaletteLime160 = "#F0F7E4";
	const ColorPaletteGreen10 = "#0B2312";
	const ColorPaletteGreen20 = "#0E2F18";
	const ColorPaletteGreen30 = "#133E20";
	const ColorPaletteGreen40 = "#174A26";
	const ColorPaletteGreen50 = "#1A562C";
	const ColorPaletteGreen60 = "#1F6634";
	const ColorPaletteGreen70 = "#22723A";
	const ColorPaletteGreen80 = "#278142";
	const ColorPaletteGreen90 = "#2D954C";
	const ColorPaletteGreen100 = "#32A454";
	const ColorPaletteGreen110 = "#38B85E";
	const ColorPaletteGreen120 = "#4BC870";
	const ColorPaletteGreen130 = "#76D692";
	const ColorPaletteGreen140 = "#9DE2B1";
	const ColorPaletteGreen150 = "#C8EED3";
	const ColorPaletteGreen160 = "#E8F8EC";
	const ColorPaletteAcqua10 = "#04251E";
	const ColorPaletteAcqua20 = "#052E26";
	const ColorPaletteAcqua30 = "#073C31";
	const ColorPaletteAcqua40 = "#08493C";
	const ColorPaletteAcqua50 = "#0A5748";
	const ColorPaletteAcqua60 = "#0B6553";
	const ColorPaletteAcqua70 = "#0D735E";
	const ColorPaletteAcqua80 = "#0F856D";
	const ColorPaletteAcqua90 = "#109379";
	const ColorPaletteAcqua100 = "#12A588";
	const ColorPaletteAcqua110 = "#14B897";
	const ColorPaletteAcqua120 = "#31C4A6";
	const ColorPaletteAcqua130 = "#68D4BF";
	const ColorPaletteAcqua140 = "#8DE2D1";
	const ColorPaletteAcqua150 = "#BCF0E6";
	const ColorPaletteAcqua160 = "#DFFBF6";
	const ColorPaletteBlue10 = "#051B48";
	const ColorPaletteBlue20 = "#062560";
	const ColorPaletteBlue30 = "#082F7D";
	const ColorPaletteBlue40 = "#0A3A9A";
	const ColorPaletteBlue50 = "#0B43B1";
	const ColorPaletteBlue60 = "#0D4ECE";
	const ColorPaletteBlue70 = "#0F58EA";
	const ColorPaletteBlue80 = "#286BF1";
	const ColorPaletteBlue90 = "#3F7BF2";
	const ColorPaletteBlue100 = "#5C8FF5";
	const ColorPaletteBlue110 = "#73A0F7";
	const ColorPaletteBlue120 = "#8CB0F8";
	const ColorPaletteBlue130 = "#A9C4F9";
	const ColorPaletteBlue140 = "#C1D4FB";
	const ColorPaletteBlue150 = "#D9E5FC";
	const ColorPaletteBlue160 = "#F1F5FE";
	const ColorPalettePurple10 = "#340849";
	const ColorPalettePurple20 = "#440B60";
	const ColorPalettePurple30 = "#540D78";
	const ColorPalettePurple40 = "#671093";
	const ColorPalettePurple50 = "#7713AA";
	const ColorPalettePurple60 = "#8B16C5";
	const ColorPalettePurple70 = "#9B18DC";
	const ColorPalettePurple80 = "#AD35E9";
	const ColorPalettePurple90 = "#B851EC";
	const ColorPalettePurple100 = "#C36CEF";
	const ColorPalettePurple110 = "#CC83F1";
	const ColorPalettePurple120 = "#D69AF4";
	const ColorPalettePurple130 = "#DFB1F6";
	const ColorPalettePurple140 = "#E8C8F9";
	const ColorPalettePurple150 = "#F2DFFB";
	const ColorPalettePurple160 = "#F9F1FD";
	const ColorPalettePink10 = "#3B0C27";
	const ColorPalettePink20 = "#4C1032";
	const ColorPalettePink30 = "#661543";
	const ColorPalettePink40 = "#77184E";
	const ColorPalettePink50 = "#8C1C5D";
	const ColorPalettePink60 = "#A12169";
	const ColorPalettePink70 = "#BA267B";
	const ColorPalettePink80 = "#D42B8C";
	const ColorPalettePink90 = "#DA499B";
	const ColorPalettePink100 = "#E067AB";
	const ColorPalettePink110 = "#E580B9";
	const ColorPalettePink120 = "#EA99C7";
	const ColorPalettePink130 = "#EFAFD3";
	const ColorPalettePink140 = "#F4C8E1";
	const ColorPalettePink150 = "#F8DDEC";
	const ColorPalettePink160 = "#FCF2F8";
	const ColorTypefaceStrong = "#161616";
	const ColorTypefacePure = "#363636";
	const ColorTypefaceSmooth = "#666666";
	const ColorTypefaceMeld = "#1616163D";
	const ColorTypefaceInverseStrong = "#FEFEFE";
	const ColorTypefaceInversePure = "#D4D4D4";
	const ColorTypefaceInverseSmooth = "#919191";
	const ColorTypefaceInverseMeld = "#FEFEFE52";
	const ColorTypefaceInverseOnBrandStrong = "#161616";
	const ColorTypefaceInverseOnBrandPure = "#363636";
	const ColorTypefaceInverseOnBrandSmooth = "#595959";
	const ColorTypefaceInverseOnBrandMeld = "#1616163D";
	const ColorTypefaceOnBrandStrong = "#FEFEFE";
	const ColorTypefaceOnBrandPure = "#DBE3FF";
	const ColorTypefaceOnBrandSmooth = "#C7D3FF";
	const ColorTypefaceOnBrandMeld = "#FEFEFE52";
	const ColorBrandPrimary10 = "#000E40";
	const ColorBrandPrimary20 = "#001A7A";
	const ColorBrandPrimary30 = "#00229E";
	const ColorBrandPrimary40 = "#0029BD";
	const ColorBrandPrimary50 = "#002FDB";
	const ColorBrandPrimary60 = "#0037FF";
	const ColorBrandPrimary70 = "#1F4FFF";
	const ColorBrandPrimary80 = "#3863FF";
	const ColorBrandPrimary90 = "#5277FF";
	const ColorBrandPrimary100 = "#6B8BFF";
	const ColorBrandPrimary110 = "#809BFF";
	const ColorBrandPrimary120 = "#99AFFF";
	const ColorBrandPrimary130 = "#ADBFFF";
	const ColorBrandPrimary140 = "#C7D3FF";
	const ColorBrandPrimary150 = "#DBE3FF";
	const ColorBrandPrimary160 = "#F0F3FF";
	const ColorBrandBase01 = "#000E40";
	const ColorBrandBase02 = "#2BD6C4";
	const ColorBrandBase03 = "#B2DFD8";
	const ColorBrandBase04 = "#9C86E0";
	const ColorBrandBase05 = "#D8BD97";
	const ColorBrandBase06 = "#F6F4F4";
	const ColorBrandPalette0110 = "#000E40";
	const ColorBrandPalette0120 = "#001A7A";
	const ColorBrandPalette0130 = "#00229E";
	const ColorBrandPalette0140 = "#0029BD";
	const ColorBrandPalette0150 = "#002FDB";
	const ColorBrandPalette0160 = "#0037FF";
	const ColorBrandPalette0170 = "#1F4FFF";
	const ColorBrandPalette0180 = "#3863FF";
	const ColorBrandPalette0190 = "#5277FF";
	const ColorBrandPalette01100 = "#6B8BFF";
	const ColorBrandPalette01110 = "#809BFF";
	const ColorBrandPalette01120 = "#99AFFF";
	const ColorBrandPalette01130 = "#ADBFFF";
	const ColorBrandPalette01140 = "#C7D3FF";
	const ColorBrandPalette01150 = "#DBE3FF";
	const ColorBrandPalette01160 = "#F0F3FF";
	const ColorBrandPalette0210 = "#07221F";
	const ColorBrandPalette0220 = "#092F2B";
	const ColorBrandPalette0230 = "#0B3C37";
	const ColorBrandPalette0240 = "#0E4943";
	const ColorBrandPalette0250 = "#10564F";
	const ColorBrandPalette0260 = "#13635B";
	const ColorBrandPalette0270 = "#16746A";
	const ColorBrandPalette0280 = "#188176";
	const ColorBrandPalette0290 = "#1C9286";
	const ColorBrandPalette02100 = "#1FA396";
	const ColorBrandPalette02110 = "#22B4A5";
	const ColorBrandPalette02120 = "#26C5B5";
	const ColorBrandPalette02130 = "#2BD6C4";
	const ColorBrandPalette02140 = "#B2DFD8";
	const ColorBrandPalette02150 = "#D0EBE7";
	const ColorBrandPalette02160 = "#E9F6F4";
	const ColorBrandPalette0410 = "#22144D";
	const ColorBrandPalette0420 = "#2D1A65";
	const ColorBrandPalette0430 = "#3A2182";
	const ColorBrandPalette0440 = "#46299E";
	const ColorBrandPalette0450 = "#5330BB";
	const ColorBrandPalette0460 = "#603CCD";
	const ColorBrandPalette0470 = "#6E4DD1";
	const ColorBrandPalette0480 = "#7E61D6";
	const ColorBrandPalette0490 = "#8B71DA";
	const ColorBrandPalette04100 = "#9C86E0";
	const ColorBrandPalette04110 = "#A996E4";
	const ColorBrandPalette04120 = "#BAAAE9";
	const ColorBrandPalette04130 = "#C7BAED";
	const ColorBrandPalette04140 = "#D7CEF2";
	const ColorBrandPalette04150 = "#E8E3F8";
	const ColorBrandPalette04160 = "#F5F3FC";
	const ColorBrandPalette0510 = "#251B0E";
	const ColorBrandPalette0520 = "#342614";
	const ColorBrandPalette0530 = "#433119";
	const ColorBrandPalette0540 = "#513C1F";
	const ColorBrandPalette0550 = "#604724";
	const ColorBrandPalette0560 = "#73552B";
	const ColorBrandPalette0570 = "#816031";
	const ColorBrandPalette0580 = "#946E38";
	const ColorBrandPalette0590 = "#A3793E";
	const ColorBrandPalette05100 = "#B98946";
	const ColorBrandPalette05110 = "#C39A60";
	const ColorBrandPalette05120 = "#CEAC7E";
	const ColorBrandPalette05130 = "#D8BD97";
	const ColorBrandPalette05140 = "#E3D0B5";
	const ColorBrandPalette05150 = "#EEE3D3";
	const ColorBrandPalette05160 = "#F8F3EC";
	const ColorBrandPalette0610 = "#1A1514";
	const ColorBrandPalette0620 = "#312826";
	const ColorBrandPalette0630 = "#3F3431";
	const ColorBrandPalette0640 = "#4A3D3A";
	const ColorBrandPalette0650 = "#594946";
	const ColorBrandPalette0660 = "#675451";
	const ColorBrandPalette0670 = "#75605C";
	const ColorBrandPalette0680 = "#866E69";
	const ColorBrandPalette0690 = "#967E79";
	const ColorBrandPalette06100 = "#A38E8A";
	const ColorBrandPalette06110 = "#AE9C98";
	const ColorBrandPalette06120 = "#BEAFAC";
	const ColorBrandPalette06130 = "#CBC0BD";
	const ColorBrandPalette06140 = "#D9D0CE";
	const ColorBrandPalette06150 = "#E9E4E3";
	const ColorBrandPalette06160 = "#F6F4F4";
	const ColorFeedbackErrorText = "#BC293A";
	const ColorFeedbackErrorShape = "#EA4356";
	const ColorFeedbackSuccessText = "#22723A";
	const ColorFeedbackSuccessShape = "#2D954C";
	const ColorFeedbackOnBrandErrorText = "#F77E8C";
	const ColorFeedbackOnBrandErrorShape = "#EA4356";
	const ColorFeedbackOnBrandSuccessText = "#38B85E";
	const ColorFeedbackOnBrandSuccessShape = "#2D954C";
	const ColorFeedbackInverseErrorText = "#F55C6E";
	const ColorFeedbackInverseErrorShape = "#D83145";
	const ColorFeedbackInverseSuccessText = "#32A454";
	const ColorFeedbackInverseSuccessShape = "#278142";
	const ColorFeedbackInverseOnBrandErrorText = "#A72534";
	const ColorFeedbackInverseOnBrandErrorShape = "#D83145";
	const ColorFeedbackInverseOnBrandSuccessText = "#1F6634";
	const ColorFeedbackInverseOnBrandSuccessShape = "#278142";
	const ColorSupport01 = "#8B71DA";
	const ColorSupport02 = "#8B71DA";
	const ColorSupportOnBrand01 = "#2BD6C4";
	const ColorSupportOnBrand02 = "#2BD6C4";
	const ColorSupportInverse01 = "#2BD6C4";
	const ColorSupportInverse02 = "#2BD6C4";
	const ColorSupportInverseOnBrand01 = "#7E61D6";
	const ColorSupportInverseOnBrand02 = "#7E61D6";
	const Opacity01 = "0.04";
	const Opacity02 = "0.08";
	const Opacity03 = "0.12";
	const Opacity04 = "0.24";
	const Opacity05 = "0.32";
	const Opacity06 = "0.56";
	const Opacity07 = "0.64";
	const Opacity08 = "0.72";
	const Opacity09 = "0.88";
	const Shadow01 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
	const Shadow02 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
	const Shadow03 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
	const Shadow04 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
	const SpacingInlineQuark = "4px";
	const SpacingInlineNano = "8px";
	const SpacingInlineXxxs = "16px";
	const SpacingInlineXxs = "24px";
	const SpacingInlineXs = "32px";
	const SpacingInlineSm = "40px";
	const SpacingInlineMd = "48px";
	const SpacingInlineLg = "56px";
	const SpacingInlineXl = "64px";
	const SpacingInlineXxl = "80px";
	const SpacingInlineXxxl = "120px";
	const SpacingInlineHuge = "160px";
	const SpacingInlineGiant = "200px";
	const SpacingInsetQuark = "4px";
	const SpacingInsetNano = "8px";
	const SpacingInsetXs = "16px";
	const SpacingInsetSm = "24px";
	const SpacingInsetMd = "32px";
	const SpacingInsetLg = "40px";
	const SpacingSquishQuark = "4px 8px";
	const SpacingSquishNano = "8px 16px";
	const SpacingSquishXs = "16px 24px";
	const SpacingSquishSm = "16px 32px";
	const SpacingStackQuark = "4px";
	const SpacingStackNano = "8px";
	const SpacingStackXxxs = "16px";
	const SpacingStackXxs = "24px";
	const SpacingStackXs = "32px";
	const SpacingStackSm = "40px";
	const SpacingStackMd = "48px";
	const SpacingStackLg = "56px";
	const SpacingStackXl = "64px";
	const SpacingStackXxl = "80px";
	const SpacingStackXxxl = "120px";
	const SpacingStackHuge = "160px";
	const SpacingStackGiant = "200px";
	const FontFamilyBase = "'Dasa Sans', Arial, 'Lato', sans-serif";
	const FontSizeXxxs = "0.75rem";
	const FontSizeXxs = "0.875rem";
	const FontSizeXs = "1rem";
	const FontSizeSm = "1.25rem";
	const FontSizeMd = "1.5rem";
	const FontSizeLg = "2rem";
	const FontSizeXl = "2.5rem";
	const FontSizeXxl = "3rem";
	const FontSizeXxxl = "4rem";
	const FontSizeDisplay = "5rem";
	const FontSizeGiant = "6rem";
	const FontWeightBold = 700;
	const FontWeightSemibold = 600;
	const FontWeightMedium = 500;
	const FontWeightRegular = 400;
	const FontWeightLight = 300;
	const LetterSpacingStandard = "0px";
	const LetterSpacingSmall = "-1px";
	const LetterSpacingMedium = "1.5px";
	const LineHeightStandard = "100%";
	const LineHeightTiny = "115%";
	const LineHeightMedium = "120%";
	const LineHeightLarge = "125%";
	const LineHeightDistant = "133%";
	const LineHeightSuperdistant = "150%";
	const LineHeightHuge = "170%";
	const ZIndex0 = "0";
	const ZIndex100 = "100";
	const ZIndex200 = "200";
	const ZIndex300 = "300";
	const ZIndex400 = "400";
	const ZIndex500 = "500";
	const ZIndexAuto = "auto";
	const ZIndexTop = "99999";
	const ZIndexBottom = "-100";

	var index = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BorderRadiusNone: BorderRadiusNone,
		BorderRadiusXs: BorderRadiusXs,
		BorderRadiusSm: BorderRadiusSm,
		BorderRadiusMd: BorderRadiusMd,
		BorderRadiusLg: BorderRadiusLg,
		BorderRadiusPill: BorderRadiusPill,
		BorderRadiusCircle: BorderRadiusCircle,
		BorderWidthNone: BorderWidthNone,
		BorderWidthHairline: BorderWidthHairline,
		BorderWidthThin: BorderWidthThin,
		BorderWidthThick: BorderWidthThick,
		BorderWidthHeavy: BorderWidthHeavy,
		ColorDatavizInfoText: ColorDatavizInfoText,
		ColorDatavizInfoShape01: ColorDatavizInfoShape01,
		ColorDatavizInfoShape02: ColorDatavizInfoShape02,
		ColorDatavizInfoShape03: ColorDatavizInfoShape03,
		ColorDatavizNegativeText: ColorDatavizNegativeText,
		ColorDatavizNegativeShape01: ColorDatavizNegativeShape01,
		ColorDatavizNegativeShape02: ColorDatavizNegativeShape02,
		ColorDatavizNegativeShape03: ColorDatavizNegativeShape03,
		ColorDatavizWarningText: ColorDatavizWarningText,
		ColorDatavizWarningShape01: ColorDatavizWarningShape01,
		ColorDatavizWarningShape02: ColorDatavizWarningShape02,
		ColorDatavizWarningShape03: ColorDatavizWarningShape03,
		ColorDatavizPositiveText: ColorDatavizPositiveText,
		ColorDatavizPositiveShape01: ColorDatavizPositiveShape01,
		ColorDatavizPositiveShape02: ColorDatavizPositiveShape02,
		ColorDatavizPositiveShape03: ColorDatavizPositiveShape03,
		ColorDatavizCatAText: ColorDatavizCatAText,
		ColorDatavizCatAShape01: ColorDatavizCatAShape01,
		ColorDatavizCatAShape02: ColorDatavizCatAShape02,
		ColorDatavizCatAShape03: ColorDatavizCatAShape03,
		ColorDatavizCatBText: ColorDatavizCatBText,
		ColorDatavizCatBShape01: ColorDatavizCatBShape01,
		ColorDatavizCatBShape02: ColorDatavizCatBShape02,
		ColorDatavizCatBShape03: ColorDatavizCatBShape03,
		ColorDatavizCatCText: ColorDatavizCatCText,
		ColorDatavizCatCShape01: ColorDatavizCatCShape01,
		ColorDatavizCatCShape02: ColorDatavizCatCShape02,
		ColorDatavizCatCShape03: ColorDatavizCatCShape03,
		ColorDatavizCatDText: ColorDatavizCatDText,
		ColorDatavizCatDShape01: ColorDatavizCatDShape01,
		ColorDatavizCatDShape02: ColorDatavizCatDShape02,
		ColorDatavizCatDShape03: ColorDatavizCatDShape03,
		ColorDatavizInverseInfoText: ColorDatavizInverseInfoText,
		ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01,
		ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02,
		ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03,
		ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText,
		ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01,
		ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02,
		ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03,
		ColorDatavizInverseWarningText: ColorDatavizInverseWarningText,
		ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01,
		ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02,
		ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03,
		ColorDatavizInversePositiveText: ColorDatavizInversePositiveText,
		ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01,
		ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02,
		ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03,
		ColorDatavizInverseCatAText: ColorDatavizInverseCatAText,
		ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01,
		ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02,
		ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03,
		ColorDatavizInverseCatBText: ColorDatavizInverseCatBText,
		ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01,
		ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02,
		ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03,
		ColorDatavizInverseCatCText: ColorDatavizInverseCatCText,
		ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01,
		ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02,
		ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03,
		ColorDatavizInverseCatDText: ColorDatavizInverseCatDText,
		ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01,
		ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02,
		ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03,
		ColorInteractionBlend01: ColorInteractionBlend01,
		ColorInteractionBlend02: ColorInteractionBlend02,
		ColorInteractionBlend03: ColorInteractionBlend03,
		ColorInteractionBlend04: ColorInteractionBlend04,
		ColorInteractionBlend05: ColorInteractionBlend05,
		ColorInteractionBlend06: ColorInteractionBlend06,
		ColorInteractionBlend07: ColorInteractionBlend07,
		ColorInteractionBlend08: ColorInteractionBlend08,
		ColorInteractionInverseBlend01: ColorInteractionInverseBlend01,
		ColorInteractionInverseBlend02: ColorInteractionInverseBlend02,
		ColorInteractionInverseBlend03: ColorInteractionInverseBlend03,
		ColorInteractionInverseBlend04: ColorInteractionInverseBlend04,
		ColorInteractionInverseBlend05: ColorInteractionInverseBlend05,
		ColorInteractionInverseBlend06: ColorInteractionInverseBlend06,
		ColorInteractionInverseBlend07: ColorInteractionInverseBlend07,
		ColorInteractionInverseBlend08: ColorInteractionInverseBlend08,
		ColorInteractionInverseAccent01: ColorInteractionInverseAccent01,
		ColorInteractionInverseAccent02: ColorInteractionInverseAccent02,
		ColorInteractionInverseAccent03: ColorInteractionInverseAccent03,
		ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01,
		ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02,
		ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03,
		ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault,
		ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus,
		ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive,
		ColorInteractionInverseDanger01: ColorInteractionInverseDanger01,
		ColorInteractionInverseDanger02: ColorInteractionInverseDanger02,
		ColorInteractionInverseDanger03: ColorInteractionInverseDanger03,
		ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01,
		ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02,
		ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03,
		ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01,
		ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02,
		ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03,
		ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault,
		ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus,
		ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive,
		ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01,
		ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02,
		ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03,
		ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04,
		ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05,
		ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06,
		ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07,
		ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08,
		ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01,
		ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02,
		ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03,
		ColorInteractionAccent01: ColorInteractionAccent01,
		ColorInteractionAccent02: ColorInteractionAccent02,
		ColorInteractionAccent03: ColorInteractionAccent03,
		ColorInteractionSubtle01: ColorInteractionSubtle01,
		ColorInteractionSubtle02: ColorInteractionSubtle02,
		ColorInteractionSubtle03: ColorInteractionSubtle03,
		ColorInteractionSelectDefault: ColorInteractionSelectDefault,
		ColorInteractionSelectFocus: ColorInteractionSelectFocus,
		ColorInteractionSelectActive: ColorInteractionSelectActive,
		ColorInteractionDanger01: ColorInteractionDanger01,
		ColorInteractionDanger02: ColorInteractionDanger02,
		ColorInteractionDanger03: ColorInteractionDanger03,
		ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01,
		ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02,
		ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03,
		ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01,
		ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02,
		ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03,
		ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault,
		ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus,
		ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive,
		ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01,
		ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02,
		ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03,
		ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04,
		ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05,
		ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06,
		ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07,
		ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08,
		ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01,
		ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02,
		ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03,
		ColorNeutral10: ColorNeutral10,
		ColorNeutral20: ColorNeutral20,
		ColorNeutral30: ColorNeutral30,
		ColorNeutral00: ColorNeutral00,
		ColorNeutralInverse10: ColorNeutralInverse10,
		ColorNeutralInverse20: ColorNeutralInverse20,
		ColorNeutralInverse30: ColorNeutralInverse30,
		ColorNeutralInverse00: ColorNeutralInverse00,
		ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10,
		ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20,
		ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30,
		ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00,
		ColorNeutralOnBrand10: ColorNeutralOnBrand10,
		ColorNeutralOnBrand20: ColorNeutralOnBrand20,
		ColorNeutralOnBrand30: ColorNeutralOnBrand30,
		ColorNeutralOnBrand00: ColorNeutralOnBrand00,
		ColorPaletteBlack: ColorPaletteBlack,
		ColorPaletteWhite: ColorPaletteWhite,
		ColorPaletteGray10: ColorPaletteGray10,
		ColorPaletteGray20: ColorPaletteGray20,
		ColorPaletteGray30: ColorPaletteGray30,
		ColorPaletteGray40: ColorPaletteGray40,
		ColorPaletteGray50: ColorPaletteGray50,
		ColorPaletteGray60: ColorPaletteGray60,
		ColorPaletteGray70: ColorPaletteGray70,
		ColorPaletteGray80: ColorPaletteGray80,
		ColorPaletteGray90: ColorPaletteGray90,
		ColorPaletteGray100: ColorPaletteGray100,
		ColorPaletteGray110: ColorPaletteGray110,
		ColorPaletteGray120: ColorPaletteGray120,
		ColorPaletteGray130: ColorPaletteGray130,
		ColorPaletteGray140: ColorPaletteGray140,
		ColorPaletteGray150: ColorPaletteGray150,
		ColorPaletteGray160: ColorPaletteGray160,
		ColorPaletteRed10: ColorPaletteRed10,
		ColorPaletteRed20: ColorPaletteRed20,
		ColorPaletteRed30: ColorPaletteRed30,
		ColorPaletteRed40: ColorPaletteRed40,
		ColorPaletteRed50: ColorPaletteRed50,
		ColorPaletteRed60: ColorPaletteRed60,
		ColorPaletteRed70: ColorPaletteRed70,
		ColorPaletteRed80: ColorPaletteRed80,
		ColorPaletteRed90: ColorPaletteRed90,
		ColorPaletteRed100: ColorPaletteRed100,
		ColorPaletteRed110: ColorPaletteRed110,
		ColorPaletteRed120: ColorPaletteRed120,
		ColorPaletteRed130: ColorPaletteRed130,
		ColorPaletteRed140: ColorPaletteRed140,
		ColorPaletteRed150: ColorPaletteRed150,
		ColorPaletteRed160: ColorPaletteRed160,
		ColorPaletteYellow10: ColorPaletteYellow10,
		ColorPaletteYellow20: ColorPaletteYellow20,
		ColorPaletteYellow30: ColorPaletteYellow30,
		ColorPaletteYellow40: ColorPaletteYellow40,
		ColorPaletteYellow50: ColorPaletteYellow50,
		ColorPaletteYellow60: ColorPaletteYellow60,
		ColorPaletteYellow70: ColorPaletteYellow70,
		ColorPaletteYellow80: ColorPaletteYellow80,
		ColorPaletteYellow90: ColorPaletteYellow90,
		ColorPaletteYellow100: ColorPaletteYellow100,
		ColorPaletteYellow110: ColorPaletteYellow110,
		ColorPaletteYellow120: ColorPaletteYellow120,
		ColorPaletteYellow130: ColorPaletteYellow130,
		ColorPaletteYellow140: ColorPaletteYellow140,
		ColorPaletteYellow150: ColorPaletteYellow150,
		ColorPaletteYellow160: ColorPaletteYellow160,
		ColorPaletteLime10: ColorPaletteLime10,
		ColorPaletteLime20: ColorPaletteLime20,
		ColorPaletteLime30: ColorPaletteLime30,
		ColorPaletteLime40: ColorPaletteLime40,
		ColorPaletteLime50: ColorPaletteLime50,
		ColorPaletteLime60: ColorPaletteLime60,
		ColorPaletteLime70: ColorPaletteLime70,
		ColorPaletteLime80: ColorPaletteLime80,
		ColorPaletteLime90: ColorPaletteLime90,
		ColorPaletteLime100: ColorPaletteLime100,
		ColorPaletteLime110: ColorPaletteLime110,
		ColorPaletteLime120: ColorPaletteLime120,
		ColorPaletteLime130: ColorPaletteLime130,
		ColorPaletteLime140: ColorPaletteLime140,
		ColorPaletteLime150: ColorPaletteLime150,
		ColorPaletteLime160: ColorPaletteLime160,
		ColorPaletteGreen10: ColorPaletteGreen10,
		ColorPaletteGreen20: ColorPaletteGreen20,
		ColorPaletteGreen30: ColorPaletteGreen30,
		ColorPaletteGreen40: ColorPaletteGreen40,
		ColorPaletteGreen50: ColorPaletteGreen50,
		ColorPaletteGreen60: ColorPaletteGreen60,
		ColorPaletteGreen70: ColorPaletteGreen70,
		ColorPaletteGreen80: ColorPaletteGreen80,
		ColorPaletteGreen90: ColorPaletteGreen90,
		ColorPaletteGreen100: ColorPaletteGreen100,
		ColorPaletteGreen110: ColorPaletteGreen110,
		ColorPaletteGreen120: ColorPaletteGreen120,
		ColorPaletteGreen130: ColorPaletteGreen130,
		ColorPaletteGreen140: ColorPaletteGreen140,
		ColorPaletteGreen150: ColorPaletteGreen150,
		ColorPaletteGreen160: ColorPaletteGreen160,
		ColorPaletteAcqua10: ColorPaletteAcqua10,
		ColorPaletteAcqua20: ColorPaletteAcqua20,
		ColorPaletteAcqua30: ColorPaletteAcqua30,
		ColorPaletteAcqua40: ColorPaletteAcqua40,
		ColorPaletteAcqua50: ColorPaletteAcqua50,
		ColorPaletteAcqua60: ColorPaletteAcqua60,
		ColorPaletteAcqua70: ColorPaletteAcqua70,
		ColorPaletteAcqua80: ColorPaletteAcqua80,
		ColorPaletteAcqua90: ColorPaletteAcqua90,
		ColorPaletteAcqua100: ColorPaletteAcqua100,
		ColorPaletteAcqua110: ColorPaletteAcqua110,
		ColorPaletteAcqua120: ColorPaletteAcqua120,
		ColorPaletteAcqua130: ColorPaletteAcqua130,
		ColorPaletteAcqua140: ColorPaletteAcqua140,
		ColorPaletteAcqua150: ColorPaletteAcqua150,
		ColorPaletteAcqua160: ColorPaletteAcqua160,
		ColorPaletteBlue10: ColorPaletteBlue10,
		ColorPaletteBlue20: ColorPaletteBlue20,
		ColorPaletteBlue30: ColorPaletteBlue30,
		ColorPaletteBlue40: ColorPaletteBlue40,
		ColorPaletteBlue50: ColorPaletteBlue50,
		ColorPaletteBlue60: ColorPaletteBlue60,
		ColorPaletteBlue70: ColorPaletteBlue70,
		ColorPaletteBlue80: ColorPaletteBlue80,
		ColorPaletteBlue90: ColorPaletteBlue90,
		ColorPaletteBlue100: ColorPaletteBlue100,
		ColorPaletteBlue110: ColorPaletteBlue110,
		ColorPaletteBlue120: ColorPaletteBlue120,
		ColorPaletteBlue130: ColorPaletteBlue130,
		ColorPaletteBlue140: ColorPaletteBlue140,
		ColorPaletteBlue150: ColorPaletteBlue150,
		ColorPaletteBlue160: ColorPaletteBlue160,
		ColorPalettePurple10: ColorPalettePurple10,
		ColorPalettePurple20: ColorPalettePurple20,
		ColorPalettePurple30: ColorPalettePurple30,
		ColorPalettePurple40: ColorPalettePurple40,
		ColorPalettePurple50: ColorPalettePurple50,
		ColorPalettePurple60: ColorPalettePurple60,
		ColorPalettePurple70: ColorPalettePurple70,
		ColorPalettePurple80: ColorPalettePurple80,
		ColorPalettePurple90: ColorPalettePurple90,
		ColorPalettePurple100: ColorPalettePurple100,
		ColorPalettePurple110: ColorPalettePurple110,
		ColorPalettePurple120: ColorPalettePurple120,
		ColorPalettePurple130: ColorPalettePurple130,
		ColorPalettePurple140: ColorPalettePurple140,
		ColorPalettePurple150: ColorPalettePurple150,
		ColorPalettePurple160: ColorPalettePurple160,
		ColorPalettePink10: ColorPalettePink10,
		ColorPalettePink20: ColorPalettePink20,
		ColorPalettePink30: ColorPalettePink30,
		ColorPalettePink40: ColorPalettePink40,
		ColorPalettePink50: ColorPalettePink50,
		ColorPalettePink60: ColorPalettePink60,
		ColorPalettePink70: ColorPalettePink70,
		ColorPalettePink80: ColorPalettePink80,
		ColorPalettePink90: ColorPalettePink90,
		ColorPalettePink100: ColorPalettePink100,
		ColorPalettePink110: ColorPalettePink110,
		ColorPalettePink120: ColorPalettePink120,
		ColorPalettePink130: ColorPalettePink130,
		ColorPalettePink140: ColorPalettePink140,
		ColorPalettePink150: ColorPalettePink150,
		ColorPalettePink160: ColorPalettePink160,
		ColorTypefaceStrong: ColorTypefaceStrong,
		ColorTypefacePure: ColorTypefacePure,
		ColorTypefaceSmooth: ColorTypefaceSmooth,
		ColorTypefaceMeld: ColorTypefaceMeld,
		ColorTypefaceInverseStrong: ColorTypefaceInverseStrong,
		ColorTypefaceInversePure: ColorTypefaceInversePure,
		ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth,
		ColorTypefaceInverseMeld: ColorTypefaceInverseMeld,
		ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong,
		ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure,
		ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth,
		ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld,
		ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong,
		ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure,
		ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth,
		ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld,
		ColorBrandPrimary10: ColorBrandPrimary10,
		ColorBrandPrimary20: ColorBrandPrimary20,
		ColorBrandPrimary30: ColorBrandPrimary30,
		ColorBrandPrimary40: ColorBrandPrimary40,
		ColorBrandPrimary50: ColorBrandPrimary50,
		ColorBrandPrimary60: ColorBrandPrimary60,
		ColorBrandPrimary70: ColorBrandPrimary70,
		ColorBrandPrimary80: ColorBrandPrimary80,
		ColorBrandPrimary90: ColorBrandPrimary90,
		ColorBrandPrimary100: ColorBrandPrimary100,
		ColorBrandPrimary110: ColorBrandPrimary110,
		ColorBrandPrimary120: ColorBrandPrimary120,
		ColorBrandPrimary130: ColorBrandPrimary130,
		ColorBrandPrimary140: ColorBrandPrimary140,
		ColorBrandPrimary150: ColorBrandPrimary150,
		ColorBrandPrimary160: ColorBrandPrimary160,
		ColorBrandBase01: ColorBrandBase01,
		ColorBrandBase02: ColorBrandBase02,
		ColorBrandBase03: ColorBrandBase03,
		ColorBrandBase04: ColorBrandBase04,
		ColorBrandBase05: ColorBrandBase05,
		ColorBrandBase06: ColorBrandBase06,
		ColorBrandPalette0110: ColorBrandPalette0110,
		ColorBrandPalette0120: ColorBrandPalette0120,
		ColorBrandPalette0130: ColorBrandPalette0130,
		ColorBrandPalette0140: ColorBrandPalette0140,
		ColorBrandPalette0150: ColorBrandPalette0150,
		ColorBrandPalette0160: ColorBrandPalette0160,
		ColorBrandPalette0170: ColorBrandPalette0170,
		ColorBrandPalette0180: ColorBrandPalette0180,
		ColorBrandPalette0190: ColorBrandPalette0190,
		ColorBrandPalette01100: ColorBrandPalette01100,
		ColorBrandPalette01110: ColorBrandPalette01110,
		ColorBrandPalette01120: ColorBrandPalette01120,
		ColorBrandPalette01130: ColorBrandPalette01130,
		ColorBrandPalette01140: ColorBrandPalette01140,
		ColorBrandPalette01150: ColorBrandPalette01150,
		ColorBrandPalette01160: ColorBrandPalette01160,
		ColorBrandPalette0210: ColorBrandPalette0210,
		ColorBrandPalette0220: ColorBrandPalette0220,
		ColorBrandPalette0230: ColorBrandPalette0230,
		ColorBrandPalette0240: ColorBrandPalette0240,
		ColorBrandPalette0250: ColorBrandPalette0250,
		ColorBrandPalette0260: ColorBrandPalette0260,
		ColorBrandPalette0270: ColorBrandPalette0270,
		ColorBrandPalette0280: ColorBrandPalette0280,
		ColorBrandPalette0290: ColorBrandPalette0290,
		ColorBrandPalette02100: ColorBrandPalette02100,
		ColorBrandPalette02110: ColorBrandPalette02110,
		ColorBrandPalette02120: ColorBrandPalette02120,
		ColorBrandPalette02130: ColorBrandPalette02130,
		ColorBrandPalette02140: ColorBrandPalette02140,
		ColorBrandPalette02150: ColorBrandPalette02150,
		ColorBrandPalette02160: ColorBrandPalette02160,
		ColorBrandPalette0410: ColorBrandPalette0410,
		ColorBrandPalette0420: ColorBrandPalette0420,
		ColorBrandPalette0430: ColorBrandPalette0430,
		ColorBrandPalette0440: ColorBrandPalette0440,
		ColorBrandPalette0450: ColorBrandPalette0450,
		ColorBrandPalette0460: ColorBrandPalette0460,
		ColorBrandPalette0470: ColorBrandPalette0470,
		ColorBrandPalette0480: ColorBrandPalette0480,
		ColorBrandPalette0490: ColorBrandPalette0490,
		ColorBrandPalette04100: ColorBrandPalette04100,
		ColorBrandPalette04110: ColorBrandPalette04110,
		ColorBrandPalette04120: ColorBrandPalette04120,
		ColorBrandPalette04130: ColorBrandPalette04130,
		ColorBrandPalette04140: ColorBrandPalette04140,
		ColorBrandPalette04150: ColorBrandPalette04150,
		ColorBrandPalette04160: ColorBrandPalette04160,
		ColorBrandPalette0510: ColorBrandPalette0510,
		ColorBrandPalette0520: ColorBrandPalette0520,
		ColorBrandPalette0530: ColorBrandPalette0530,
		ColorBrandPalette0540: ColorBrandPalette0540,
		ColorBrandPalette0550: ColorBrandPalette0550,
		ColorBrandPalette0560: ColorBrandPalette0560,
		ColorBrandPalette0570: ColorBrandPalette0570,
		ColorBrandPalette0580: ColorBrandPalette0580,
		ColorBrandPalette0590: ColorBrandPalette0590,
		ColorBrandPalette05100: ColorBrandPalette05100,
		ColorBrandPalette05110: ColorBrandPalette05110,
		ColorBrandPalette05120: ColorBrandPalette05120,
		ColorBrandPalette05130: ColorBrandPalette05130,
		ColorBrandPalette05140: ColorBrandPalette05140,
		ColorBrandPalette05150: ColorBrandPalette05150,
		ColorBrandPalette05160: ColorBrandPalette05160,
		ColorBrandPalette0610: ColorBrandPalette0610,
		ColorBrandPalette0620: ColorBrandPalette0620,
		ColorBrandPalette0630: ColorBrandPalette0630,
		ColorBrandPalette0640: ColorBrandPalette0640,
		ColorBrandPalette0650: ColorBrandPalette0650,
		ColorBrandPalette0660: ColorBrandPalette0660,
		ColorBrandPalette0670: ColorBrandPalette0670,
		ColorBrandPalette0680: ColorBrandPalette0680,
		ColorBrandPalette0690: ColorBrandPalette0690,
		ColorBrandPalette06100: ColorBrandPalette06100,
		ColorBrandPalette06110: ColorBrandPalette06110,
		ColorBrandPalette06120: ColorBrandPalette06120,
		ColorBrandPalette06130: ColorBrandPalette06130,
		ColorBrandPalette06140: ColorBrandPalette06140,
		ColorBrandPalette06150: ColorBrandPalette06150,
		ColorBrandPalette06160: ColorBrandPalette06160,
		ColorFeedbackErrorText: ColorFeedbackErrorText,
		ColorFeedbackErrorShape: ColorFeedbackErrorShape,
		ColorFeedbackSuccessText: ColorFeedbackSuccessText,
		ColorFeedbackSuccessShape: ColorFeedbackSuccessShape,
		ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText,
		ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape,
		ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText,
		ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape,
		ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText,
		ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape,
		ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText,
		ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape,
		ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText,
		ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape,
		ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText,
		ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape,
		ColorSupport01: ColorSupport01,
		ColorSupport02: ColorSupport02,
		ColorSupportOnBrand01: ColorSupportOnBrand01,
		ColorSupportOnBrand02: ColorSupportOnBrand02,
		ColorSupportInverse01: ColorSupportInverse01,
		ColorSupportInverse02: ColorSupportInverse02,
		ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01,
		ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02,
		Opacity01: Opacity01,
		Opacity02: Opacity02,
		Opacity03: Opacity03,
		Opacity04: Opacity04,
		Opacity05: Opacity05,
		Opacity06: Opacity06,
		Opacity07: Opacity07,
		Opacity08: Opacity08,
		Opacity09: Opacity09,
		Shadow01: Shadow01,
		Shadow02: Shadow02,
		Shadow03: Shadow03,
		Shadow04: Shadow04,
		SpacingInlineQuark: SpacingInlineQuark,
		SpacingInlineNano: SpacingInlineNano,
		SpacingInlineXxxs: SpacingInlineXxxs,
		SpacingInlineXxs: SpacingInlineXxs,
		SpacingInlineXs: SpacingInlineXs,
		SpacingInlineSm: SpacingInlineSm,
		SpacingInlineMd: SpacingInlineMd,
		SpacingInlineLg: SpacingInlineLg,
		SpacingInlineXl: SpacingInlineXl,
		SpacingInlineXxl: SpacingInlineXxl,
		SpacingInlineXxxl: SpacingInlineXxxl,
		SpacingInlineHuge: SpacingInlineHuge,
		SpacingInlineGiant: SpacingInlineGiant,
		SpacingInsetQuark: SpacingInsetQuark,
		SpacingInsetNano: SpacingInsetNano,
		SpacingInsetXs: SpacingInsetXs,
		SpacingInsetSm: SpacingInsetSm,
		SpacingInsetMd: SpacingInsetMd,
		SpacingInsetLg: SpacingInsetLg,
		SpacingSquishQuark: SpacingSquishQuark,
		SpacingSquishNano: SpacingSquishNano,
		SpacingSquishXs: SpacingSquishXs,
		SpacingSquishSm: SpacingSquishSm,
		SpacingStackQuark: SpacingStackQuark,
		SpacingStackNano: SpacingStackNano,
		SpacingStackXxxs: SpacingStackXxxs,
		SpacingStackXxs: SpacingStackXxs,
		SpacingStackXs: SpacingStackXs,
		SpacingStackSm: SpacingStackSm,
		SpacingStackMd: SpacingStackMd,
		SpacingStackLg: SpacingStackLg,
		SpacingStackXl: SpacingStackXl,
		SpacingStackXxl: SpacingStackXxl,
		SpacingStackXxxl: SpacingStackXxxl,
		SpacingStackHuge: SpacingStackHuge,
		SpacingStackGiant: SpacingStackGiant,
		FontFamilyBase: FontFamilyBase,
		FontSizeXxxs: FontSizeXxxs,
		FontSizeXxs: FontSizeXxs,
		FontSizeXs: FontSizeXs,
		FontSizeSm: FontSizeSm,
		FontSizeMd: FontSizeMd,
		FontSizeLg: FontSizeLg,
		FontSizeXl: FontSizeXl,
		FontSizeXxl: FontSizeXxl,
		FontSizeXxxl: FontSizeXxxl,
		FontSizeDisplay: FontSizeDisplay,
		FontSizeGiant: FontSizeGiant,
		FontWeightBold: FontWeightBold,
		FontWeightSemibold: FontWeightSemibold,
		FontWeightMedium: FontWeightMedium,
		FontWeightRegular: FontWeightRegular,
		FontWeightLight: FontWeightLight,
		LetterSpacingStandard: LetterSpacingStandard,
		LetterSpacingSmall: LetterSpacingSmall,
		LetterSpacingMedium: LetterSpacingMedium,
		LineHeightStandard: LineHeightStandard,
		LineHeightTiny: LineHeightTiny,
		LineHeightMedium: LineHeightMedium,
		LineHeightLarge: LineHeightLarge,
		LineHeightDistant: LineHeightDistant,
		LineHeightSuperdistant: LineHeightSuperdistant,
		LineHeightHuge: LineHeightHuge,
		ZIndex0: ZIndex0,
		ZIndex100: ZIndex100,
		ZIndex200: ZIndex200,
		ZIndex300: ZIndex300,
		ZIndex400: ZIndex400,
		ZIndex500: ZIndex500,
		ZIndexAuto: ZIndexAuto,
		ZIndexTop: ZIndexTop,
		ZIndexBottom: ZIndexBottom
	});

	exports.alvTokens = index$8;
	exports.dasTokens = index$7;
	exports.dbnTokens = index$6;
	exports.exmTokens = index$5;
	exports.genTokens = index$4;
	exports.mpuTokens = index$3;
	exports.navMobTokens = index$1;
	exports.navTokens = index$2;
	exports.slzTokens = index;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map
